(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3BFBP", function(module, exports) {
var $2a051a86cb6e4743$var$vg = Object.defineProperty;
var $2a051a86cb6e4743$var$Sg = (e, t, n)=>t in e ? $2a051a86cb6e4743$var$vg(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n;
var $2a051a86cb6e4743$var$bn = (e, t, n)=>($2a051a86cb6e4743$var$Sg(e, typeof t != "symbol" ? t + "" : t, n), n), $2a051a86cb6e4743$var$ta = (e, t, n)=>{
    if (!t.has(e)) throw TypeError("Cannot " + n);
};
var $2a051a86cb6e4743$var$w = (e, t, n)=>($2a051a86cb6e4743$var$ta(e, t, "read from private field"), n ? n.call(e) : t.get(e)), $2a051a86cb6e4743$var$V = (e, t, n)=>{
    if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
    t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, $2a051a86cb6e4743$var$U = (e, t, n, r)=>($2a051a86cb6e4743$var$ta(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
var $2a051a86cb6e4743$var$ps = (e, t, n, r)=>({
        set _ (i){
            $2a051a86cb6e4743$var$U(e, t, i, n);
        },
        get _ () {
            return $2a051a86cb6e4743$var$w(e, t, r);
        }
    }), $2a051a86cb6e4743$var$X = (e, t, n)=>($2a051a86cb6e4743$var$ta(e, t, "access private method"), n);
function $2a051a86cb6e4743$var$wg(e, t) {
    for(var n = 0; n < t.length; n++){
        const r = t[n];
        if (typeof r != "string" && !Array.isArray(r)) {
            for(const i1 in r)if (i1 !== "default" && !(i1 in e)) {
                const s = Object.getOwnPropertyDescriptor(r, i1);
                s && Object.defineProperty(e, i1, s.get ? s : {
                    enumerable: !0,
                    get: ()=>r[i1]
                });
            }
        }
    }
    return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
    }));
}
(function() {
    const t = document.createElement("link").relList;
    if (t && t.supports && t.supports("modulepreload")) return;
    for (const i1 of document.querySelectorAll('link[rel="modulepreload"]'))r(i1);
    new MutationObserver((i1)=>{
        for (const s of i1)if (s.type === "childList") for (const o of s.addedNodes)o.tagName === "LINK" && o.rel === "modulepreload" && r(o);
    }).observe(document, {
        childList: !0,
        subtree: !0
    });
    function n(i1) {
        const s = {};
        return i1.integrity && (s.integrity = i1.integrity), i1.referrerPolicy && (s.referrerPolicy = i1.referrerPolicy), i1.crossOrigin === "use-credentials" ? s.credentials = "include" : i1.crossOrigin === "anonymous" ? s.credentials = "omit" : s.credentials = "same-origin", s;
    }
    function r(i1) {
        if (i1.ep) return;
        i1.ep = !0;
        const s = n(i1);
        fetch(i1.href, s);
    }
})();
var $2a051a86cb6e4743$var$mr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $2a051a86cb6e4743$var$Oo(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $2a051a86cb6e4743$var$cd = {
    exports: {}
}, $2a051a86cb6e4743$var$No = {}, $2a051a86cb6e4743$var$fd = {
    exports: {}
}, $2a051a86cb6e4743$var$G = {}; /**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2a051a86cb6e4743$var$is = Symbol.for("react.element"), $2a051a86cb6e4743$var$xg = Symbol.for("react.portal"), $2a051a86cb6e4743$var$Cg = Symbol.for("react.fragment"), $2a051a86cb6e4743$var$Eg = Symbol.for("react.strict_mode"), $2a051a86cb6e4743$var$kg = Symbol.for("react.profiler"), $2a051a86cb6e4743$var$Pg = Symbol.for("react.provider"), $2a051a86cb6e4743$var$_g = Symbol.for("react.context"), $2a051a86cb6e4743$var$bg = Symbol.for("react.forward_ref"), $2a051a86cb6e4743$var$Og = Symbol.for("react.suspense"), $2a051a86cb6e4743$var$Ng = Symbol.for("react.memo"), $2a051a86cb6e4743$var$Tg = Symbol.for("react.lazy"), $2a051a86cb6e4743$var$Gu = Symbol.iterator;
function $2a051a86cb6e4743$var$Lg(e) {
    return e === null || typeof e != "object" ? null : (e = $2a051a86cb6e4743$var$Gu && e[$2a051a86cb6e4743$var$Gu] || e["@@iterator"], typeof e == "function" ? e : null);
}
var $2a051a86cb6e4743$var$dd = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2a051a86cb6e4743$var$hd = Object.assign, $2a051a86cb6e4743$var$pd = {};
function $2a051a86cb6e4743$var$Kr(e, t, n) {
    this.props = e, this.context = t, this.refs = $2a051a86cb6e4743$var$pd, this.updater = n || $2a051a86cb6e4743$var$dd;
}
$2a051a86cb6e4743$var$Kr.prototype.isReactComponent = {};
$2a051a86cb6e4743$var$Kr.prototype.setState = function(e, t) {
    if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, e, t, "setState");
};
$2a051a86cb6e4743$var$Kr.prototype.forceUpdate = function(e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function $2a051a86cb6e4743$var$gd() {}
$2a051a86cb6e4743$var$gd.prototype = $2a051a86cb6e4743$var$Kr.prototype;
function $2a051a86cb6e4743$var$Kl(e, t, n) {
    this.props = e, this.context = t, this.refs = $2a051a86cb6e4743$var$pd, this.updater = n || $2a051a86cb6e4743$var$dd;
}
var $2a051a86cb6e4743$var$Wl = $2a051a86cb6e4743$var$Kl.prototype = new $2a051a86cb6e4743$var$gd;
$2a051a86cb6e4743$var$Wl.constructor = $2a051a86cb6e4743$var$Kl;
$2a051a86cb6e4743$var$hd($2a051a86cb6e4743$var$Wl, $2a051a86cb6e4743$var$Kr.prototype);
$2a051a86cb6e4743$var$Wl.isPureReactComponent = !0;
var $2a051a86cb6e4743$var$Xu = Array.isArray, $2a051a86cb6e4743$var$md = Object.prototype.hasOwnProperty, $2a051a86cb6e4743$var$Yl = {
    current: null
}, $2a051a86cb6e4743$var$yd = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2a051a86cb6e4743$var$vd(e, t, n) {
    var r, i1 = {}, s = null, o = null;
    if (t != null) for(r in t.ref !== void 0 && (o = t.ref), t.key !== void 0 && (s = "" + t.key), t)$2a051a86cb6e4743$var$md.call(t, r) && !$2a051a86cb6e4743$var$yd.hasOwnProperty(r) && (i1[r] = t[r]);
    var a = arguments.length - 2;
    if (a === 1) i1.children = n;
    else if (1 < a) {
        for(var l = Array(a), u = 0; u < a; u++)l[u] = arguments[u + 2];
        i1.children = l;
    }
    if (e && e.defaultProps) for(r in a = e.defaultProps, a)i1[r] === void 0 && (i1[r] = a[r]);
    return {
        $$typeof: $2a051a86cb6e4743$var$is,
        type: e,
        key: s,
        ref: o,
        props: i1,
        _owner: $2a051a86cb6e4743$var$Yl.current
    };
}
function $2a051a86cb6e4743$var$Rg(e, t) {
    return {
        $$typeof: $2a051a86cb6e4743$var$is,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
    };
}
function $2a051a86cb6e4743$var$ql(e) {
    return typeof e == "object" && e !== null && e.$$typeof === $2a051a86cb6e4743$var$is;
}
function $2a051a86cb6e4743$var$jg(e) {
    var t = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + e.replace(/[=:]/g, function(n) {
        return t[n];
    });
}
var $2a051a86cb6e4743$var$Ju = /\/+/g;
function $2a051a86cb6e4743$var$na(e, t) {
    return typeof e == "object" && e !== null && e.key != null ? $2a051a86cb6e4743$var$jg("" + e.key) : t.toString(36);
}
function $2a051a86cb6e4743$var$Fs(e, t, n, r, i1) {
    var s = typeof e;
    (s === "undefined" || s === "boolean") && (e = null);
    var o = !1;
    if (e === null) o = !0;
    else switch(s){
        case "string":
        case "number":
            o = !0;
            break;
        case "object":
            switch(e.$$typeof){
                case $2a051a86cb6e4743$var$is:
                case $2a051a86cb6e4743$var$xg:
                    o = !0;
            }
    }
    if (o) return o = e, i1 = i1(o), e = r === "" ? "." + $2a051a86cb6e4743$var$na(o, 0) : r, $2a051a86cb6e4743$var$Xu(i1) ? (n = "", e != null && (n = e.replace($2a051a86cb6e4743$var$Ju, "$&/") + "/"), $2a051a86cb6e4743$var$Fs(i1, t, n, "", function(u) {
        return u;
    })) : i1 != null && ($2a051a86cb6e4743$var$ql(i1) && (i1 = $2a051a86cb6e4743$var$Rg(i1, n + (!i1.key || o && o.key === i1.key ? "" : ("" + i1.key).replace($2a051a86cb6e4743$var$Ju, "$&/") + "/") + e)), t.push(i1)), 1;
    if (o = 0, r = r === "" ? "." : r + ":", $2a051a86cb6e4743$var$Xu(e)) for(var a = 0; a < e.length; a++){
        s = e[a];
        var l = r + $2a051a86cb6e4743$var$na(s, a);
        o += $2a051a86cb6e4743$var$Fs(s, t, n, l, i1);
    }
    else if (l = $2a051a86cb6e4743$var$Lg(e), typeof l == "function") for(e = l.call(e), a = 0; !(s = e.next()).done;)s = s.value, l = r + $2a051a86cb6e4743$var$na(s, a++), o += $2a051a86cb6e4743$var$Fs(s, t, n, l, i1);
    else if (s === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
    return o;
}
function $2a051a86cb6e4743$var$gs(e, t, n) {
    if (e == null) return e;
    var r = [], i1 = 0;
    return $2a051a86cb6e4743$var$Fs(e, r, "", "", function(s) {
        return t.call(n, s, i1++);
    }), r;
}
function $2a051a86cb6e4743$var$Ig(e) {
    if (e._status === -1) {
        var t = e._result;
        t = t(), t.then(function(n) {
            (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
        }, function(n) {
            (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
        }), e._status === -1 && (e._status = 0, e._result = t);
    }
    if (e._status === 1) return e._result.default;
    throw e._result;
}
var $2a051a86cb6e4743$var$Fe = {
    current: null
}, $2a051a86cb6e4743$var$Ds = {
    transition: null
}, $2a051a86cb6e4743$var$Fg = {
    ReactCurrentDispatcher: $2a051a86cb6e4743$var$Fe,
    ReactCurrentBatchConfig: $2a051a86cb6e4743$var$Ds,
    ReactCurrentOwner: $2a051a86cb6e4743$var$Yl
};
function $2a051a86cb6e4743$var$Sd() {
    throw Error("act(...) is not supported in production builds of React.");
}
$2a051a86cb6e4743$var$G.Children = {
    map: $2a051a86cb6e4743$var$gs,
    forEach: function(e, t, n) {
        $2a051a86cb6e4743$var$gs(e, function() {
            t.apply(this, arguments);
        }, n);
    },
    count: function(e) {
        var t = 0;
        return $2a051a86cb6e4743$var$gs(e, function() {
            t++;
        }), t;
    },
    toArray: function(e) {
        return $2a051a86cb6e4743$var$gs(e, function(t) {
            return t;
        }) || [];
    },
    only: function(e) {
        if (!$2a051a86cb6e4743$var$ql(e)) throw Error("React.Children.only expected to receive a single React element child.");
        return e;
    }
};
$2a051a86cb6e4743$var$G.Component = $2a051a86cb6e4743$var$Kr;
$2a051a86cb6e4743$var$G.Fragment = $2a051a86cb6e4743$var$Cg;
$2a051a86cb6e4743$var$G.Profiler = $2a051a86cb6e4743$var$kg;
$2a051a86cb6e4743$var$G.PureComponent = $2a051a86cb6e4743$var$Kl;
$2a051a86cb6e4743$var$G.StrictMode = $2a051a86cb6e4743$var$Eg;
$2a051a86cb6e4743$var$G.Suspense = $2a051a86cb6e4743$var$Og;
$2a051a86cb6e4743$var$G.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $2a051a86cb6e4743$var$Fg;
$2a051a86cb6e4743$var$G.act = $2a051a86cb6e4743$var$Sd;
$2a051a86cb6e4743$var$G.cloneElement = function(e, t, n) {
    if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
    var r = $2a051a86cb6e4743$var$hd({}, e.props), i1 = e.key, s = e.ref, o = e._owner;
    if (t != null) {
        if (t.ref !== void 0 && (s = t.ref, o = $2a051a86cb6e4743$var$Yl.current), t.key !== void 0 && (i1 = "" + t.key), e.type && e.type.defaultProps) var a = e.type.defaultProps;
        for(l in t)$2a051a86cb6e4743$var$md.call(t, l) && !$2a051a86cb6e4743$var$yd.hasOwnProperty(l) && (r[l] = t[l] === void 0 && a !== void 0 ? a[l] : t[l]);
    }
    var l = arguments.length - 2;
    if (l === 1) r.children = n;
    else if (1 < l) {
        a = Array(l);
        for(var u = 0; u < l; u++)a[u] = arguments[u + 2];
        r.children = a;
    }
    return {
        $$typeof: $2a051a86cb6e4743$var$is,
        type: e.type,
        key: i1,
        ref: s,
        props: r,
        _owner: o
    };
};
$2a051a86cb6e4743$var$G.createContext = function(e) {
    return e = {
        $$typeof: $2a051a86cb6e4743$var$_g,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    }, e.Provider = {
        $$typeof: $2a051a86cb6e4743$var$Pg,
        _context: e
    }, e.Consumer = e;
};
$2a051a86cb6e4743$var$G.createElement = $2a051a86cb6e4743$var$vd;
$2a051a86cb6e4743$var$G.createFactory = function(e) {
    var t = $2a051a86cb6e4743$var$vd.bind(null, e);
    return t.type = e, t;
};
$2a051a86cb6e4743$var$G.createRef = function() {
    return {
        current: null
    };
};
$2a051a86cb6e4743$var$G.forwardRef = function(e) {
    return {
        $$typeof: $2a051a86cb6e4743$var$bg,
        render: e
    };
};
$2a051a86cb6e4743$var$G.isValidElement = $2a051a86cb6e4743$var$ql;
$2a051a86cb6e4743$var$G.lazy = function(e) {
    return {
        $$typeof: $2a051a86cb6e4743$var$Tg,
        _payload: {
            _status: -1,
            _result: e
        },
        _init: $2a051a86cb6e4743$var$Ig
    };
};
$2a051a86cb6e4743$var$G.memo = function(e, t) {
    return {
        $$typeof: $2a051a86cb6e4743$var$Ng,
        type: e,
        compare: t === void 0 ? null : t
    };
};
$2a051a86cb6e4743$var$G.startTransition = function(e) {
    var t = $2a051a86cb6e4743$var$Ds.transition;
    $2a051a86cb6e4743$var$Ds.transition = {};
    try {
        e();
    } finally{
        $2a051a86cb6e4743$var$Ds.transition = t;
    }
};
$2a051a86cb6e4743$var$G.unstable_act = $2a051a86cb6e4743$var$Sd;
$2a051a86cb6e4743$var$G.useCallback = function(e, t) {
    return $2a051a86cb6e4743$var$Fe.current.useCallback(e, t);
};
$2a051a86cb6e4743$var$G.useContext = function(e) {
    return $2a051a86cb6e4743$var$Fe.current.useContext(e);
};
$2a051a86cb6e4743$var$G.useDebugValue = function() {};
$2a051a86cb6e4743$var$G.useDeferredValue = function(e) {
    return $2a051a86cb6e4743$var$Fe.current.useDeferredValue(e);
};
$2a051a86cb6e4743$var$G.useEffect = function(e, t) {
    return $2a051a86cb6e4743$var$Fe.current.useEffect(e, t);
};
$2a051a86cb6e4743$var$G.useId = function() {
    return $2a051a86cb6e4743$var$Fe.current.useId();
};
$2a051a86cb6e4743$var$G.useImperativeHandle = function(e, t, n) {
    return $2a051a86cb6e4743$var$Fe.current.useImperativeHandle(e, t, n);
};
$2a051a86cb6e4743$var$G.useInsertionEffect = function(e, t) {
    return $2a051a86cb6e4743$var$Fe.current.useInsertionEffect(e, t);
};
$2a051a86cb6e4743$var$G.useLayoutEffect = function(e, t) {
    return $2a051a86cb6e4743$var$Fe.current.useLayoutEffect(e, t);
};
$2a051a86cb6e4743$var$G.useMemo = function(e, t) {
    return $2a051a86cb6e4743$var$Fe.current.useMemo(e, t);
};
$2a051a86cb6e4743$var$G.useReducer = function(e, t, n) {
    return $2a051a86cb6e4743$var$Fe.current.useReducer(e, t, n);
};
$2a051a86cb6e4743$var$G.useRef = function(e) {
    return $2a051a86cb6e4743$var$Fe.current.useRef(e);
};
$2a051a86cb6e4743$var$G.useState = function(e) {
    return $2a051a86cb6e4743$var$Fe.current.useState(e);
};
$2a051a86cb6e4743$var$G.useSyncExternalStore = function(e, t, n) {
    return $2a051a86cb6e4743$var$Fe.current.useSyncExternalStore(e, t, n);
};
$2a051a86cb6e4743$var$G.useTransition = function() {
    return $2a051a86cb6e4743$var$Fe.current.useTransition();
};
$2a051a86cb6e4743$var$G.version = "18.3.1";
$2a051a86cb6e4743$var$fd.exports = $2a051a86cb6e4743$var$G;
var $2a051a86cb6e4743$var$I = $2a051a86cb6e4743$var$fd.exports;
const $2a051a86cb6e4743$var$Dg = $2a051a86cb6e4743$var$Oo($2a051a86cb6e4743$var$I); /**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2a051a86cb6e4743$var$Ag = $2a051a86cb6e4743$var$I, $2a051a86cb6e4743$var$Mg = Symbol.for("react.element"), $2a051a86cb6e4743$var$Ug = Symbol.for("react.fragment"), $2a051a86cb6e4743$var$$g = Object.prototype.hasOwnProperty, $2a051a86cb6e4743$var$zg = $2a051a86cb6e4743$var$Ag.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2a051a86cb6e4743$var$Bg = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2a051a86cb6e4743$var$wd(e, t, n) {
    var r, i1 = {}, s = null, o = null;
    n !== void 0 && (s = "" + n), t.key !== void 0 && (s = "" + t.key), t.ref !== void 0 && (o = t.ref);
    for(r in t)$2a051a86cb6e4743$var$$g.call(t, r) && !$2a051a86cb6e4743$var$Bg.hasOwnProperty(r) && (i1[r] = t[r]);
    if (e && e.defaultProps) for(r in t = e.defaultProps, t)i1[r] === void 0 && (i1[r] = t[r]);
    return {
        $$typeof: $2a051a86cb6e4743$var$Mg,
        type: e,
        key: s,
        ref: o,
        props: i1,
        _owner: $2a051a86cb6e4743$var$zg.current
    };
}
$2a051a86cb6e4743$var$No.Fragment = $2a051a86cb6e4743$var$Ug;
$2a051a86cb6e4743$var$No.jsx = $2a051a86cb6e4743$var$wd;
$2a051a86cb6e4743$var$No.jsxs = $2a051a86cb6e4743$var$wd;
$2a051a86cb6e4743$var$cd.exports = $2a051a86cb6e4743$var$No;
var $2a051a86cb6e4743$var$S = $2a051a86cb6e4743$var$cd.exports;
function $2a051a86cb6e4743$var$To(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $2a051a86cb6e4743$var$Ei(e) {
    "@babel/helpers - typeof";
    return $2a051a86cb6e4743$var$Ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
        return typeof t;
    } : function(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $2a051a86cb6e4743$var$Ei(e);
}
function $2a051a86cb6e4743$var$Hg(e, t) {
    if ($2a051a86cb6e4743$var$Ei(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
        var r = n.call(e, t || "default");
        if ($2a051a86cb6e4743$var$Ei(r) != "object") return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
}
function $2a051a86cb6e4743$var$xd(e) {
    var t = $2a051a86cb6e4743$var$Hg(e, "string");
    return $2a051a86cb6e4743$var$Ei(t) == "symbol" ? t : t + "";
}
function $2a051a86cb6e4743$var$Zu(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, $2a051a86cb6e4743$var$xd(r.key), r);
    }
}
function $2a051a86cb6e4743$var$Lo(e, t, n) {
    return t && $2a051a86cb6e4743$var$Zu(e.prototype, t), n && $2a051a86cb6e4743$var$Zu(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
var $2a051a86cb6e4743$var$Cd = [], $2a051a86cb6e4743$var$Vg = $2a051a86cb6e4743$var$Cd.forEach, $2a051a86cb6e4743$var$Qg = $2a051a86cb6e4743$var$Cd.slice;
function $2a051a86cb6e4743$var$Kg(e) {
    return $2a051a86cb6e4743$var$Vg.call($2a051a86cb6e4743$var$Qg.call(arguments, 1), function(t) {
        if (t) for(var n in t)e[n] === void 0 && (e[n] = t[n]);
    }), e;
}
function $2a051a86cb6e4743$var$Wg(e) {
    return e ? typeof e == "function" ? new e : e : null;
}
function $2a051a86cb6e4743$var$Yg() {
    return {
        handleEmptyResourcesAsFailed: !0,
        cacheHitMode: "none"
    };
}
function $2a051a86cb6e4743$var$ec(e, t, n, r) {
    var i1 = e.read.bind(e);
    if (i1.length === 2) {
        try {
            var s = i1(t, n);
            s && typeof s.then == "function" ? s.then(function(o) {
                return r(null, o);
            }).catch(r) : r(null, s);
        } catch (o) {
            r(o);
        }
        return;
    }
    i1(t, n, r);
}
var $2a051a86cb6e4743$var$Ed = function() {
    function e(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        $2a051a86cb6e4743$var$To(this, e), this.backends = [], this.type = "backend", this.allOptions = r, this.init(t, n);
    }
    return $2a051a86cb6e4743$var$Lo(e, [
        {
            key: "init",
            value: function(n) {
                var r = this, i1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.services = n, this.options = $2a051a86cb6e4743$var$Kg(i1, this.options || {}, $2a051a86cb6e4743$var$Yg()), this.allOptions = s, this.options.backends && this.options.backends.forEach(function(o, a) {
                    r.backends[a] = r.backends[a] || $2a051a86cb6e4743$var$Wg(o), r.backends[a].init(n, r.options.backendOptions && r.options.backendOptions[a] || {}, s);
                }), this.services && this.options.reloadInterval && setInterval(function() {
                    return r.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "read",
            value: function(n, r, i1) {
                var s = this, o = this.backends.length, a = function u(c) {
                    if (c >= o) return i1(new Error("non of the backend loaded data", !0));
                    var d = c === o - 1, f = s.options.handleEmptyResourcesAsFailed && !d ? 0 : -1, m = s.backends[c];
                    m.read ? $2a051a86cb6e4743$var$ec(m, n, r, function(v, y, k) {
                        if (!v && y && Object.keys(y).length > f) {
                            if (i1(null, y, c), l(c - 1, y), m.save && s.options.cacheHitMode && [
                                "refresh",
                                "refreshAndUpdateStore"
                            ].indexOf(s.options.cacheHitMode) > -1) {
                                if (k && s.options.refreshExpirationTime && k + s.options.refreshExpirationTime > Date.now()) return;
                                var p = s.backends[c + 1];
                                p && p.read && $2a051a86cb6e4743$var$ec(p, n, r, function(h, g) {
                                    h || g && (Object.keys(g).length <= f || (l(c, g), s.options.cacheHitMode === "refreshAndUpdateStore" && s.services && s.services.resourceStore && s.services.resourceStore.addResourceBundle(n, r, g)));
                                });
                            }
                        } else u(c + 1);
                    }) : u(c + 1);
                }, l = function u(c, d) {
                    if (!(c < 0)) {
                        var f = s.backends[c];
                        f.save && f.save(n, r, d), u(c - 1, d);
                    }
                };
                a(0);
            }
        },
        {
            key: "create",
            value: function(n, r, i1, s) {
                var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {}, a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                this.backends.forEach(function(l) {
                    if (l.create) {
                        var u = l.create.bind(l);
                        if (u.length < 6) {
                            try {
                                var c;
                                u.length === 5 ? c = u(n, r, i1, s, a) : c = u(n, r, i1, s), c && typeof c.then == "function" ? c.then(function(d) {
                                    return o(null, d);
                                }).catch(o) : o(null, c);
                            } catch (d) {
                                o(d);
                            }
                            return;
                        }
                        u(n, r, i1, s, o, a);
                    }
                });
            }
        },
        {
            key: "reload",
            value: function() {
                var n = this, r = this.services, i1 = r.backendConnector, s = r.languageUtils, o = r.logger, a = i1.language;
                if (!(a && a.toLowerCase() === "cimode")) {
                    var l = [], u = function(d) {
                        var f = s.toResolveHierarchy(d);
                        f.forEach(function(m) {
                            l.indexOf(m) < 0 && l.push(m);
                        });
                    };
                    u(a), this.allOptions.preload && this.allOptions.preload.forEach(function(c) {
                        return u(c);
                    }), l.forEach(function(c) {
                        n.allOptions.ns.forEach(function(d) {
                            i1.read(c, d, "read", null, null, function(f, m) {
                                f && o.warn("loading namespace ".concat(d, " for language ").concat(c, " failed"), f), !f && m && o.log("loaded namespace ".concat(d, " for language ").concat(c), m), i1.loaded("".concat(c, "|").concat(d), f, m);
                            });
                        });
                    });
                }
            }
        }
    ]), e;
}();
$2a051a86cb6e4743$var$Ed.type = "backend";
function $2a051a86cb6e4743$var$Ia(e) {
    "@babel/helpers - typeof";
    return $2a051a86cb6e4743$var$Ia = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
        return typeof t;
    } : function(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $2a051a86cb6e4743$var$Ia(e);
}
function $2a051a86cb6e4743$var$kd() {
    return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : $2a051a86cb6e4743$var$Ia(XMLHttpRequest)) === "object";
}
function $2a051a86cb6e4743$var$qg(e) {
    return !!e && typeof e.then == "function";
}
function $2a051a86cb6e4743$var$Gg(e) {
    return $2a051a86cb6e4743$var$qg(e) ? e : Promise.resolve(e);
}
function $2a051a86cb6e4743$var$Xg(e) {
    throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $2a051a86cb6e4743$var$Fa = {
    exports: {}
}, $2a051a86cb6e4743$var$ms = {
    exports: {}
}, $2a051a86cb6e4743$var$tc;
function $2a051a86cb6e4743$var$Jg() {
    return $2a051a86cb6e4743$var$tc || ($2a051a86cb6e4743$var$tc = 1, function(e, t) {
        var n = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof $2a051a86cb6e4743$var$mr < "u" && $2a051a86cb6e4743$var$mr, r = function() {
            function s() {
                this.fetch = !1, this.DOMException = n.DOMException;
            }
            return s.prototype = n, new s;
        }();
        (function(s) {
            (function(o) {
                var a = typeof s < "u" && s || typeof self < "u" && self || typeof a < "u" && a, l = {
                    searchParams: "URLSearchParams" in a,
                    iterable: "Symbol" in a && "iterator" in Symbol,
                    blob: "FileReader" in a && "Blob" in a && function() {
                        try {
                            return new Blob, !0;
                        } catch  {
                            return !1;
                        }
                    }(),
                    formData: "FormData" in a,
                    arrayBuffer: "ArrayBuffer" in a
                };
                function u(x) {
                    return x && DataView.prototype.isPrototypeOf(x);
                }
                if (l.arrayBuffer) var c = [
                    "[object Int8Array]",
                    "[object Uint8Array]",
                    "[object Uint8ClampedArray]",
                    "[object Int16Array]",
                    "[object Uint16Array]",
                    "[object Int32Array]",
                    "[object Uint32Array]",
                    "[object Float32Array]",
                    "[object Float64Array]"
                ], d = ArrayBuffer.isView || function(x) {
                    return x && c.indexOf(Object.prototype.toString.call(x)) > -1;
                };
                function f(x) {
                    if (typeof x != "string" && (x = String(x)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(x) || x === "") throw new TypeError('Invalid character in header field name: "' + x + '"');
                    return x.toLowerCase();
                }
                function m(x) {
                    return typeof x != "string" && (x = String(x)), x;
                }
                function v(x) {
                    var T = {
                        next: function() {
                            var Q = x.shift();
                            return {
                                done: Q === void 0,
                                value: Q
                            };
                        }
                    };
                    return l.iterable && (T[Symbol.iterator] = function() {
                        return T;
                    }), T;
                }
                function y(x) {
                    this.map = {}, x instanceof y ? x.forEach(function(T, Q) {
                        this.append(Q, T);
                    }, this) : Array.isArray(x) ? x.forEach(function(T) {
                        this.append(T[0], T[1]);
                    }, this) : x && Object.getOwnPropertyNames(x).forEach(function(T) {
                        this.append(T, x[T]);
                    }, this);
                }
                y.prototype.append = function(x, T) {
                    x = f(x), T = m(T);
                    var Q = this.map[x];
                    this.map[x] = Q ? Q + ", " + T : T;
                }, y.prototype.delete = function(x) {
                    delete this.map[f(x)];
                }, y.prototype.get = function(x) {
                    return x = f(x), this.has(x) ? this.map[x] : null;
                }, y.prototype.has = function(x) {
                    return this.map.hasOwnProperty(f(x));
                }, y.prototype.set = function(x, T) {
                    this.map[f(x)] = m(T);
                }, y.prototype.forEach = function(x, T) {
                    for(var Q in this.map)this.map.hasOwnProperty(Q) && x.call(T, this.map[Q], Q, this);
                }, y.prototype.keys = function() {
                    var x = [];
                    return this.forEach(function(T, Q) {
                        x.push(Q);
                    }), v(x);
                }, y.prototype.values = function() {
                    var x = [];
                    return this.forEach(function(T) {
                        x.push(T);
                    }), v(x);
                }, y.prototype.entries = function() {
                    var x = [];
                    return this.forEach(function(T, Q) {
                        x.push([
                            Q,
                            T
                        ]);
                    }), v(x);
                }, l.iterable && (y.prototype[Symbol.iterator] = y.prototype.entries);
                function k(x) {
                    if (x.bodyUsed) return Promise.reject(new TypeError("Already read"));
                    x.bodyUsed = !0;
                }
                function p(x) {
                    return new Promise(function(T, Q) {
                        x.onload = function() {
                            T(x.result);
                        }, x.onerror = function() {
                            Q(x.error);
                        };
                    });
                }
                function h(x) {
                    var T = new FileReader, Q = p(T);
                    return T.readAsArrayBuffer(x), Q;
                }
                function g(x) {
                    var T = new FileReader, Q = p(T);
                    return T.readAsText(x), Q;
                }
                function E(x) {
                    for(var T = new Uint8Array(x), Q = new Array(T.length), O = 0; O < T.length; O++)Q[O] = String.fromCharCode(T[O]);
                    return Q.join("");
                }
                function P(x) {
                    if (x.slice) return x.slice(0);
                    var T = new Uint8Array(x.byteLength);
                    return T.set(new Uint8Array(x)), T.buffer;
                }
                function N() {
                    return this.bodyUsed = !1, this._initBody = function(x) {
                        this.bodyUsed = this.bodyUsed, this._bodyInit = x, x ? typeof x == "string" ? this._bodyText = x : l.blob && Blob.prototype.isPrototypeOf(x) ? this._bodyBlob = x : l.formData && FormData.prototype.isPrototypeOf(x) ? this._bodyFormData = x : l.searchParams && URLSearchParams.prototype.isPrototypeOf(x) ? this._bodyText = x.toString() : l.arrayBuffer && l.blob && u(x) ? (this._bodyArrayBuffer = P(x.buffer), this._bodyInit = new Blob([
                            this._bodyArrayBuffer
                        ])) : l.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(x) || d(x)) ? this._bodyArrayBuffer = P(x) : this._bodyText = x = Object.prototype.toString.call(x) : this._bodyText = "", this.headers.get("content-type") || (typeof x == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : l.searchParams && URLSearchParams.prototype.isPrototypeOf(x) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                    }, l.blob && (this.blob = function() {
                        var x = k(this);
                        if (x) return x;
                        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                            this._bodyArrayBuffer
                        ]));
                        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                        return Promise.resolve(new Blob([
                            this._bodyText
                        ]));
                    }, this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) {
                            var x = k(this);
                            return x || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
                        } else return this.blob().then(h);
                    }), this.text = function() {
                        var x = k(this);
                        if (x) return x;
                        if (this._bodyBlob) return g(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(E(this._bodyArrayBuffer));
                        if (this._bodyFormData) throw new Error("could not read FormData body as text");
                        return Promise.resolve(this._bodyText);
                    }, l.formData && (this.formData = function() {
                        return this.text().then(H);
                    }), this.json = function() {
                        return this.text().then(JSON.parse);
                    }, this;
                }
                var b = [
                    "DELETE",
                    "GET",
                    "HEAD",
                    "OPTIONS",
                    "POST",
                    "PUT"
                ];
                function R(x) {
                    var T = x.toUpperCase();
                    return b.indexOf(T) > -1 ? T : x;
                }
                function D(x, T) {
                    if (!(this instanceof D)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    T = T || {};
                    var Q = T.body;
                    if (x instanceof D) {
                        if (x.bodyUsed) throw new TypeError("Already read");
                        this.url = x.url, this.credentials = x.credentials, T.headers || (this.headers = new y(x.headers)), this.method = x.method, this.mode = x.mode, this.signal = x.signal, !Q && x._bodyInit != null && (Q = x._bodyInit, x.bodyUsed = !0);
                    } else this.url = String(x);
                    if (this.credentials = T.credentials || this.credentials || "same-origin", (T.headers || !this.headers) && (this.headers = new y(T.headers)), this.method = R(T.method || this.method || "GET"), this.mode = T.mode || this.mode || null, this.signal = T.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && Q) throw new TypeError("Body not allowed for GET or HEAD requests");
                    if (this._initBody(Q), (this.method === "GET" || this.method === "HEAD") && (T.cache === "no-store" || T.cache === "no-cache")) {
                        var O = /([?&])_=[^&]*/;
                        if (O.test(this.url)) this.url = this.url.replace(O, "$1_=" + new Date().getTime());
                        else {
                            var _ = /\?/;
                            this.url += (_.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                        }
                    }
                }
                D.prototype.clone = function() {
                    return new D(this, {
                        body: this._bodyInit
                    });
                };
                function H(x) {
                    var T = new FormData;
                    return x.trim().split("&").forEach(function(Q) {
                        if (Q) {
                            var O = Q.split("="), _ = O.shift().replace(/\+/g, " "), C = O.join("=").replace(/\+/g, " ");
                            T.append(decodeURIComponent(_), decodeURIComponent(C));
                        }
                    }), T;
                }
                function M(x) {
                    var T = new y, Q = x.replace(/\r?\n[\t ]+/g, " ");
                    return Q.split("\r").map(function(O) {
                        return O.indexOf(`
`) === 0 ? O.substr(1, O.length) : O;
                    }).forEach(function(O) {
                        var _ = O.split(":"), C = _.shift().trim();
                        if (C) {
                            var z = _.join(":").trim();
                            T.append(C, z);
                        }
                    }), T;
                }
                N.call(D.prototype);
                function L(x, T) {
                    if (!(this instanceof L)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    T || (T = {}), this.type = "default", this.status = T.status === void 0 ? 200 : T.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = T.statusText === void 0 ? "" : "" + T.statusText, this.headers = new y(T.headers), this.url = T.url || "", this._initBody(x);
                }
                N.call(L.prototype), L.prototype.clone = function() {
                    return new L(this._bodyInit, {
                        status: this.status,
                        statusText: this.statusText,
                        headers: new y(this.headers),
                        url: this.url
                    });
                }, L.error = function() {
                    var x = new L(null, {
                        status: 0,
                        statusText: ""
                    });
                    return x.type = "error", x;
                };
                var F = [
                    301,
                    302,
                    303,
                    307,
                    308
                ];
                L.redirect = function(x, T) {
                    if (F.indexOf(T) === -1) throw new RangeError("Invalid status code");
                    return new L(null, {
                        status: T,
                        headers: {
                            location: x
                        }
                    });
                }, o.DOMException = a.DOMException;
                try {
                    new o.DOMException;
                } catch  {
                    o.DOMException = function(T, Q) {
                        this.message = T, this.name = Q;
                        var O = Error(T);
                        this.stack = O.stack;
                    }, o.DOMException.prototype = Object.create(Error.prototype), o.DOMException.prototype.constructor = o.DOMException;
                }
                function W(x, T) {
                    return new Promise(function(Q, O) {
                        var _ = new D(x, T);
                        if (_.signal && _.signal.aborted) return O(new o.DOMException("Aborted", "AbortError"));
                        var C = new XMLHttpRequest;
                        function z() {
                            C.abort();
                        }
                        C.onload = function() {
                            var B = {
                                status: C.status,
                                statusText: C.statusText,
                                headers: M(C.getAllResponseHeaders() || "")
                            };
                            B.url = "responseURL" in C ? C.responseURL : B.headers.get("X-Request-URL");
                            var q = "response" in C ? C.response : C.responseText;
                            setTimeout(function() {
                                Q(new L(q, B));
                            }, 0);
                        }, C.onerror = function() {
                            setTimeout(function() {
                                O(new TypeError("Network request failed"));
                            }, 0);
                        }, C.ontimeout = function() {
                            setTimeout(function() {
                                O(new TypeError("Network request failed"));
                            }, 0);
                        }, C.onabort = function() {
                            setTimeout(function() {
                                O(new o.DOMException("Aborted", "AbortError"));
                            }, 0);
                        };
                        function A(B) {
                            try {
                                return B === "" && a.location.href ? a.location.href : B;
                            } catch  {
                                return B;
                            }
                        }
                        C.open(_.method, A(_.url), !0), _.credentials === "include" ? C.withCredentials = !0 : _.credentials === "omit" && (C.withCredentials = !1), "responseType" in C && (l.blob ? C.responseType = "blob" : l.arrayBuffer && _.headers.get("Content-Type") && _.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (C.responseType = "arraybuffer")), T && typeof T.headers == "object" && !(T.headers instanceof y) ? Object.getOwnPropertyNames(T.headers).forEach(function(B) {
                            C.setRequestHeader(B, m(T.headers[B]));
                        }) : _.headers.forEach(function(B, q) {
                            C.setRequestHeader(q, B);
                        }), _.signal && (_.signal.addEventListener("abort", z), C.onreadystatechange = function() {
                            C.readyState === 4 && _.signal.removeEventListener("abort", z);
                        }), C.send(typeof _._bodyInit > "u" ? null : _._bodyInit);
                    });
                }
                return W.polyfill = !0, a.fetch || (a.fetch = W, a.Headers = y, a.Request = D, a.Response = L), o.Headers = y, o.Request = D, o.Response = L, o.fetch = W, o;
            })({});
        })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
        var i1 = n.fetch ? n : r;
        t = i1.fetch, t.default = i1.fetch, t.fetch = i1.fetch, t.Headers = i1.Headers, t.Request = i1.Request, t.Response = i1.Response, e.exports = t;
    }($2a051a86cb6e4743$var$ms, $2a051a86cb6e4743$var$ms.exports)), $2a051a86cb6e4743$var$ms.exports;
}
(function(e, t) {
    var n = typeof fetch == "function" ? fetch : void 0;
    if (typeof $2a051a86cb6e4743$var$mr < "u" && $2a051a86cb6e4743$var$mr.fetch ? n = $2a051a86cb6e4743$var$mr.fetch : typeof window < "u" && window.fetch && (n = window.fetch), typeof $2a051a86cb6e4743$var$Xg < "u" && typeof window > "u") {
        var r = n || $2a051a86cb6e4743$var$Jg();
        r.default && (r = r.default), t.default = r, e.exports = t.default;
    }
})($2a051a86cb6e4743$var$Fa, $2a051a86cb6e4743$var$Fa.exports);
var $2a051a86cb6e4743$var$Pd = $2a051a86cb6e4743$var$Fa.exports;
const $2a051a86cb6e4743$var$_d = $2a051a86cb6e4743$var$Oo($2a051a86cb6e4743$var$Pd), $2a051a86cb6e4743$var$nc = $2a051a86cb6e4743$var$wg({
    __proto__: null,
    default: $2a051a86cb6e4743$var$_d
}, [
    $2a051a86cb6e4743$var$Pd
]);
function $2a051a86cb6e4743$var$rc(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(i1) {
            return Object.getOwnPropertyDescriptor(e, i1).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $2a051a86cb6e4743$var$ic(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t] != null ? arguments[t] : {};
        t % 2 ? $2a051a86cb6e4743$var$rc(Object(n), !0).forEach(function(r) {
            $2a051a86cb6e4743$var$Zg(e, r, n[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $2a051a86cb6e4743$var$rc(Object(n)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
        });
    }
    return e;
}
function $2a051a86cb6e4743$var$Zg(e, t, n) {
    return (t = $2a051a86cb6e4743$var$em(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $2a051a86cb6e4743$var$em(e) {
    var t = $2a051a86cb6e4743$var$tm(e, "string");
    return $2a051a86cb6e4743$var$Qn(t) == "symbol" ? t : t + "";
}
function $2a051a86cb6e4743$var$tm(e, t) {
    if ($2a051a86cb6e4743$var$Qn(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
        var r = n.call(e, t || "default");
        if ($2a051a86cb6e4743$var$Qn(r) != "object") return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
}
function $2a051a86cb6e4743$var$Qn(e) {
    "@babel/helpers - typeof";
    return $2a051a86cb6e4743$var$Qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
        return typeof t;
    } : function(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $2a051a86cb6e4743$var$Qn(e);
}
var $2a051a86cb6e4743$var$wn = typeof fetch == "function" ? fetch : void 0;
typeof $parcel$global < "u" && $parcel$global.fetch ? $2a051a86cb6e4743$var$wn = $parcel$global.fetch : typeof window < "u" && window.fetch && ($2a051a86cb6e4743$var$wn = window.fetch);
var $2a051a86cb6e4743$var$ki;
$2a051a86cb6e4743$var$kd() && (typeof $parcel$global < "u" && $parcel$global.XMLHttpRequest ? $2a051a86cb6e4743$var$ki = $parcel$global.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && ($2a051a86cb6e4743$var$ki = window.XMLHttpRequest));
var $2a051a86cb6e4743$var$Gs;
typeof ActiveXObject == "function" && (typeof $parcel$global < "u" && $parcel$global.ActiveXObject ? $2a051a86cb6e4743$var$Gs = $parcel$global.ActiveXObject : typeof window < "u" && window.ActiveXObject && ($2a051a86cb6e4743$var$Gs = window.ActiveXObject));
!$2a051a86cb6e4743$var$wn && $2a051a86cb6e4743$var$nc && !$2a051a86cb6e4743$var$ki && !$2a051a86cb6e4743$var$Gs && ($2a051a86cb6e4743$var$wn = $2a051a86cb6e4743$var$_d || $2a051a86cb6e4743$var$nc);
typeof $2a051a86cb6e4743$var$wn != "function" && ($2a051a86cb6e4743$var$wn = void 0);
var $2a051a86cb6e4743$var$Da = function(t, n) {
    if (n && $2a051a86cb6e4743$var$Qn(n) === "object") {
        var r = "";
        for(var i1 in n)r += "&" + encodeURIComponent(i1) + "=" + encodeURIComponent(n[i1]);
        if (!r) return t;
        t = t + (t.indexOf("?") !== -1 ? "&" : "?") + r.slice(1);
    }
    return t;
}, $2a051a86cb6e4743$var$sc = function(t, n, r, i1) {
    var s = function(l) {
        if (!l.ok) return r(l.statusText || "Error", {
            status: l.status
        });
        l.text().then(function(u) {
            r(null, {
                status: l.status,
                data: u
            });
        }).catch(r);
    };
    if (i1) {
        var o = i1(t, n);
        if (o instanceof Promise) {
            o.then(s).catch(r);
            return;
        }
    }
    typeof fetch == "function" ? fetch(t, n).then(s).catch(r) : $2a051a86cb6e4743$var$wn(t, n).then(s).catch(r);
}, $2a051a86cb6e4743$var$oc = !1, $2a051a86cb6e4743$var$nm = function(t, n, r, i1) {
    t.queryStringParams && (n = $2a051a86cb6e4743$var$Da(n, t.queryStringParams));
    var s = $2a051a86cb6e4743$var$ic({}, typeof t.customHeaders == "function" ? t.customHeaders() : t.customHeaders);
    typeof window > "u" && typeof $parcel$global < "u" && typeof $parcel$global.process < "u" && $parcel$global.process.versions && $parcel$global.process.versions.node && (s["User-Agent"] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")")), r && (s["Content-Type"] = "application/json");
    var o = typeof t.requestOptions == "function" ? t.requestOptions(r) : t.requestOptions, a = $2a051a86cb6e4743$var$ic({
        method: r ? "POST" : "GET",
        body: r ? t.stringify(r) : void 0,
        headers: s
    }, $2a051a86cb6e4743$var$oc ? {} : o), l = typeof t.alternateFetch == "function" && t.alternateFetch.length >= 1 ? t.alternateFetch : void 0;
    try {
        $2a051a86cb6e4743$var$sc(n, a, i1, l);
    } catch (u) {
        if (!o || Object.keys(o).length === 0 || !u.message || u.message.indexOf("not implemented") < 0) return i1(u);
        try {
            Object.keys(o).forEach(function(c) {
                delete a[c];
            }), $2a051a86cb6e4743$var$sc(n, a, i1, l), $2a051a86cb6e4743$var$oc = !0;
        } catch (c) {
            i1(c);
        }
    }
}, $2a051a86cb6e4743$var$rm = function(t, n, r, i1) {
    r && $2a051a86cb6e4743$var$Qn(r) === "object" && (r = $2a051a86cb6e4743$var$Da("", r).slice(1)), t.queryStringParams && (n = $2a051a86cb6e4743$var$Da(n, t.queryStringParams));
    try {
        var s;
        $2a051a86cb6e4743$var$ki ? s = new $2a051a86cb6e4743$var$ki : s = new $2a051a86cb6e4743$var$Gs("MSXML2.XMLHTTP.3.0"), s.open(r ? "POST" : "GET", n, 1), t.crossDomain || s.setRequestHeader("X-Requested-With", "XMLHttpRequest"), s.withCredentials = !!t.withCredentials, r && s.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), s.overrideMimeType && s.overrideMimeType("application/json");
        var o = t.customHeaders;
        if (o = typeof o == "function" ? o() : o, o) for(var a in o)s.setRequestHeader(a, o[a]);
        s.onreadystatechange = function() {
            s.readyState > 3 && i1(s.status >= 400 ? s.statusText : null, {
                status: s.status,
                data: s.responseText
            });
        }, s.send(r);
    } catch (l) {
        console && console.log(l);
    }
}, $2a051a86cb6e4743$var$im = function(t, n, r, i1) {
    if (typeof r == "function" && (i1 = r, r = void 0), i1 = i1 || function() {}, $2a051a86cb6e4743$var$wn && n.indexOf("file:") !== 0) return $2a051a86cb6e4743$var$nm(t, n, r, i1);
    if ($2a051a86cb6e4743$var$kd() || typeof ActiveXObject == "function") return $2a051a86cb6e4743$var$rm(t, n, r, i1);
    i1(new Error("No fetch and no xhr implementation found!"));
};
function $2a051a86cb6e4743$var$Ar(e) {
    "@babel/helpers - typeof";
    return $2a051a86cb6e4743$var$Ar = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
        return typeof t;
    } : function(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $2a051a86cb6e4743$var$Ar(e);
}
function $2a051a86cb6e4743$var$ac(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(i1) {
            return Object.getOwnPropertyDescriptor(e, i1).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $2a051a86cb6e4743$var$ra(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t] != null ? arguments[t] : {};
        t % 2 ? $2a051a86cb6e4743$var$ac(Object(n), !0).forEach(function(r) {
            $2a051a86cb6e4743$var$bd(e, r, n[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $2a051a86cb6e4743$var$ac(Object(n)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
        });
    }
    return e;
}
function $2a051a86cb6e4743$var$sm(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $2a051a86cb6e4743$var$lc(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, $2a051a86cb6e4743$var$Od(r.key), r);
    }
}
function $2a051a86cb6e4743$var$om(e, t, n) {
    return t && $2a051a86cb6e4743$var$lc(e.prototype, t), n && $2a051a86cb6e4743$var$lc(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $2a051a86cb6e4743$var$bd(e, t, n) {
    return (t = $2a051a86cb6e4743$var$Od(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $2a051a86cb6e4743$var$Od(e) {
    var t = $2a051a86cb6e4743$var$am(e, "string");
    return $2a051a86cb6e4743$var$Ar(t) == "symbol" ? t : t + "";
}
function $2a051a86cb6e4743$var$am(e, t) {
    if ($2a051a86cb6e4743$var$Ar(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
        var r = n.call(e, t || "default");
        if ($2a051a86cb6e4743$var$Ar(r) != "object") return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
}
var $2a051a86cb6e4743$var$lm = function() {
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        parse: function(n) {
            return JSON.parse(n);
        },
        stringify: JSON.stringify,
        parsePayload: function(n, r, i1) {
            return $2a051a86cb6e4743$var$bd({}, r, i1 || "");
        },
        parseLoadPayload: function(n, r) {},
        request: $2a051a86cb6e4743$var$im,
        reloadInterval: typeof window < "u" ? !1 : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: !1,
        withCredentials: !1,
        overrideMimeType: !1,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
}, $2a051a86cb6e4743$var$Aa = function() {
    function e(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        $2a051a86cb6e4743$var$sm(this, e), this.services = t, this.options = n, this.allOptions = r, this.type = "backend", this.init(t, n, r);
    }
    return $2a051a86cb6e4743$var$om(e, [
        {
            key: "init",
            value: function(n) {
                var r = this, i1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                if (this.services = n, this.options = $2a051a86cb6e4743$var$ra($2a051a86cb6e4743$var$ra($2a051a86cb6e4743$var$ra({}, $2a051a86cb6e4743$var$lm()), this.options || {}), i1), this.allOptions = s, this.services && this.options.reloadInterval) {
                    var o = setInterval(function() {
                        return r.reload();
                    }, this.options.reloadInterval);
                    $2a051a86cb6e4743$var$Ar(o) === "object" && typeof o.unref == "function" && o.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function(n, r, i1) {
                this._readAny(n, n, r, r, i1);
            }
        },
        {
            key: "read",
            value: function(n, r, i1) {
                this._readAny([
                    n
                ], n, [
                    r
                ], r, i1);
            }
        },
        {
            key: "_readAny",
            value: function(n, r, i1, s, o) {
                var a = this, l = this.options.loadPath;
                typeof this.options.loadPath == "function" && (l = this.options.loadPath(n, i1)), l = $2a051a86cb6e4743$var$Gg(l), l.then(function(u) {
                    if (!u) return o(null, {});
                    var c = a.services.interpolator.interpolate(u, {
                        lng: n.join("+"),
                        ns: i1.join("+")
                    });
                    a.loadUrl(c, o, r, s);
                });
            }
        },
        {
            key: "loadUrl",
            value: function(n, r, i1, s) {
                var o = this, a = typeof i1 == "string" ? [
                    i1
                ] : i1, l = typeof s == "string" ? [
                    s
                ] : s, u = this.options.parseLoadPayload(a, l);
                this.options.request(this.options, n, u, function(c, d) {
                    if (d && (d.status >= 500 && d.status < 600 || !d.status)) return r("failed loading " + n + "; status code: " + d.status, !0);
                    if (d && d.status >= 400 && d.status < 500) return r("failed loading " + n + "; status code: " + d.status, !1);
                    if (!d && c && c.message) {
                        var f = c.message.toLowerCase(), m = [
                            "failed",
                            "fetch",
                            "network",
                            "load"
                        ].find(function(k) {
                            return f.indexOf(k) > -1;
                        });
                        if (m) return r("failed loading " + n + ": " + c.message, !0);
                    }
                    if (c) return r(c, !1);
                    var v, y;
                    try {
                        typeof d.data == "string" ? v = o.options.parse(d.data, i1, s) : v = d.data;
                    } catch  {
                        y = "failed parsing " + n + " to json";
                    }
                    if (y) return r(y, !1);
                    r(null, v);
                });
            }
        },
        {
            key: "create",
            value: function(n, r, i1, s, o) {
                var a = this;
                if (this.options.addPath) {
                    typeof n == "string" && (n = [
                        n
                    ]);
                    var l = this.options.parsePayload(r, i1, s), u = 0, c = [], d = [];
                    n.forEach(function(f) {
                        var m = a.options.addPath;
                        typeof a.options.addPath == "function" && (m = a.options.addPath(f, r));
                        var v = a.services.interpolator.interpolate(m, {
                            lng: f,
                            ns: r
                        });
                        a.options.request(a.options, v, l, function(y, k) {
                            u += 1, c.push(y), d.push(k), u === n.length && typeof o == "function" && o(c, d);
                        });
                    });
                }
            }
        },
        {
            key: "reload",
            value: function() {
                var n = this, r = this.services, i1 = r.backendConnector, s = r.languageUtils, o = r.logger, a = i1.language;
                if (!(a && a.toLowerCase() === "cimode")) {
                    var l = [], u = function(d) {
                        var f = s.toResolveHierarchy(d);
                        f.forEach(function(m) {
                            l.indexOf(m) < 0 && l.push(m);
                        });
                    };
                    u(a), this.allOptions.preload && this.allOptions.preload.forEach(function(c) {
                        return u(c);
                    }), l.forEach(function(c) {
                        n.allOptions.ns.forEach(function(d) {
                            i1.read(c, d, "read", null, null, function(f, m) {
                                f && o.warn("loading namespace ".concat(d, " for language ").concat(c, " failed"), f), !f && m && o.log("loaded namespace ".concat(d, " for language ").concat(c), m), i1.loaded("".concat(c, "|").concat(d), f, m);
                            });
                        });
                    });
                }
            }
        }
    ]);
}();
$2a051a86cb6e4743$var$Aa.type = "backend";
var $2a051a86cb6e4743$var$Nd = [], $2a051a86cb6e4743$var$um = $2a051a86cb6e4743$var$Nd.forEach, $2a051a86cb6e4743$var$cm = $2a051a86cb6e4743$var$Nd.slice;
function $2a051a86cb6e4743$var$fm(e) {
    return $2a051a86cb6e4743$var$um.call($2a051a86cb6e4743$var$cm.call(arguments, 1), function(t) {
        if (t) for(var n in t)e[n] === void 0 && (e[n] = t[n]);
    }), e;
}
var $2a051a86cb6e4743$var$uc = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, $2a051a86cb6e4743$var$dm = function(t, n, r) {
    var i1 = r || {};
    i1.path = i1.path || "/";
    var s = encodeURIComponent(n), o = "".concat(t, "=").concat(s);
    if (i1.maxAge > 0) {
        var a = i1.maxAge - 0;
        if (Number.isNaN(a)) throw new Error("maxAge should be a Number");
        o += "; Max-Age=".concat(Math.floor(a));
    }
    if (i1.domain) {
        if (!$2a051a86cb6e4743$var$uc.test(i1.domain)) throw new TypeError("option domain is invalid");
        o += "; Domain=".concat(i1.domain);
    }
    if (i1.path) {
        if (!$2a051a86cb6e4743$var$uc.test(i1.path)) throw new TypeError("option path is invalid");
        o += "; Path=".concat(i1.path);
    }
    if (i1.expires) {
        if (typeof i1.expires.toUTCString != "function") throw new TypeError("option expires is invalid");
        o += "; Expires=".concat(i1.expires.toUTCString());
    }
    if (i1.httpOnly && (o += "; HttpOnly"), i1.secure && (o += "; Secure"), i1.sameSite) {
        var l = typeof i1.sameSite == "string" ? i1.sameSite.toLowerCase() : i1.sameSite;
        switch(l){
            case !0:
                o += "; SameSite=Strict";
                break;
            case "lax":
                o += "; SameSite=Lax";
                break;
            case "strict":
                o += "; SameSite=Strict";
                break;
            case "none":
                o += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return o;
}, $2a051a86cb6e4743$var$cc = {
    create: function(t, n, r, i1) {
        var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        r && (s.expires = new Date, s.expires.setTime(s.expires.getTime() + r * 60000)), i1 && (s.domain = i1), document.cookie = $2a051a86cb6e4743$var$dm(t, encodeURIComponent(n), s);
    },
    read: function(t) {
        for(var n = "".concat(t, "="), r = document.cookie.split(";"), i1 = 0; i1 < r.length; i1++){
            for(var s = r[i1]; s.charAt(0) === " ";)s = s.substring(1, s.length);
            if (s.indexOf(n) === 0) return s.substring(n.length, s.length);
        }
        return null;
    },
    remove: function(t) {
        this.create(t, "", -1);
    }
}, $2a051a86cb6e4743$var$hm = {
    name: "cookie",
    lookup: function(t) {
        var n;
        if (t.lookupCookie && typeof document < "u") {
            var r = $2a051a86cb6e4743$var$cc.read(t.lookupCookie);
            r && (n = r);
        }
        return n;
    },
    cacheUserLanguage: function(t, n) {
        n.lookupCookie && typeof document < "u" && $2a051a86cb6e4743$var$cc.create(n.lookupCookie, t, n.cookieMinutes, n.cookieDomain, n.cookieOptions);
    }
}, $2a051a86cb6e4743$var$pm = {
    name: "querystring",
    lookup: function(t) {
        var n;
        if (typeof window < "u") {
            var r = window.location.search;
            !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (r = window.location.hash.substring(window.location.hash.indexOf("?")));
            for(var i1 = r.substring(1), s = i1.split("&"), o = 0; o < s.length; o++){
                var a = s[o].indexOf("=");
                if (a > 0) {
                    var l = s[o].substring(0, a);
                    l === t.lookupQuerystring && (n = s[o].substring(a + 1));
                }
            }
        }
        return n;
    }
}, $2a051a86cb6e4743$var$Gr = null, $2a051a86cb6e4743$var$fc = function() {
    if ($2a051a86cb6e4743$var$Gr !== null) return $2a051a86cb6e4743$var$Gr;
    try {
        $2a051a86cb6e4743$var$Gr = window !== "undefined" && window.localStorage !== null;
        var t = "i18next.translate.boo";
        window.localStorage.setItem(t, "foo"), window.localStorage.removeItem(t);
    } catch  {
        $2a051a86cb6e4743$var$Gr = !1;
    }
    return $2a051a86cb6e4743$var$Gr;
}, $2a051a86cb6e4743$var$gm = {
    name: "localStorage",
    lookup: function(t) {
        var n;
        if (t.lookupLocalStorage && $2a051a86cb6e4743$var$fc()) {
            var r = window.localStorage.getItem(t.lookupLocalStorage);
            r && (n = r);
        }
        return n;
    },
    cacheUserLanguage: function(t, n) {
        n.lookupLocalStorage && $2a051a86cb6e4743$var$fc() && window.localStorage.setItem(n.lookupLocalStorage, t);
    }
}, $2a051a86cb6e4743$var$Xr = null, $2a051a86cb6e4743$var$dc = function() {
    if ($2a051a86cb6e4743$var$Xr !== null) return $2a051a86cb6e4743$var$Xr;
    try {
        $2a051a86cb6e4743$var$Xr = window !== "undefined" && window.sessionStorage !== null;
        var t = "i18next.translate.boo";
        window.sessionStorage.setItem(t, "foo"), window.sessionStorage.removeItem(t);
    } catch  {
        $2a051a86cb6e4743$var$Xr = !1;
    }
    return $2a051a86cb6e4743$var$Xr;
}, $2a051a86cb6e4743$var$mm = {
    name: "sessionStorage",
    lookup: function(t) {
        var n;
        if (t.lookupSessionStorage && $2a051a86cb6e4743$var$dc()) {
            var r = window.sessionStorage.getItem(t.lookupSessionStorage);
            r && (n = r);
        }
        return n;
    },
    cacheUserLanguage: function(t, n) {
        n.lookupSessionStorage && $2a051a86cb6e4743$var$dc() && window.sessionStorage.setItem(n.lookupSessionStorage, t);
    }
}, $2a051a86cb6e4743$var$ym = {
    name: "navigator",
    lookup: function(t) {
        var n = [];
        if (typeof navigator < "u") {
            if (navigator.languages) for(var r = 0; r < navigator.languages.length; r++)n.push(navigator.languages[r]);
            navigator.userLanguage && n.push(navigator.userLanguage), navigator.language && n.push(navigator.language);
        }
        return n.length > 0 ? n : void 0;
    }
}, $2a051a86cb6e4743$var$vm = {
    name: "htmlTag",
    lookup: function(t) {
        var n, r = t.htmlTag || (typeof document < "u" ? document.documentElement : null);
        return r && typeof r.getAttribute == "function" && (n = r.getAttribute("lang")), n;
    }
}, $2a051a86cb6e4743$var$Sm = {
    name: "path",
    lookup: function(t) {
        var n;
        if (typeof window < "u") {
            var r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (r instanceof Array) {
                if (typeof t.lookupFromPathIndex == "number") {
                    if (typeof r[t.lookupFromPathIndex] != "string") return;
                    n = r[t.lookupFromPathIndex].replace("/", "");
                } else n = r[0].replace("/", "");
            }
        }
        return n;
    }
}, $2a051a86cb6e4743$var$wm = {
    name: "subdomain",
    lookup: function(t) {
        var n = typeof t.lookupFromSubdomainIndex == "number" ? t.lookupFromSubdomainIndex + 1 : 1, r = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        if (r) return r[n];
    }
}, $2a051a86cb6e4743$var$Td = !1;
try {
    document.cookie, $2a051a86cb6e4743$var$Td = !0;
} catch  {}
var $2a051a86cb6e4743$var$Ld = [
    "querystring",
    "cookie",
    "localStorage",
    "sessionStorage",
    "navigator",
    "htmlTag"
];
$2a051a86cb6e4743$var$Td || $2a051a86cb6e4743$var$Ld.splice(1, 1);
function $2a051a86cb6e4743$var$xm() {
    return {
        order: $2a051a86cb6e4743$var$Ld,
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ],
        convertDetectedLanguage: function(t) {
            return t;
        }
    };
}
var $2a051a86cb6e4743$var$Rd = function() {
    function e(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        $2a051a86cb6e4743$var$To(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, n);
    }
    return $2a051a86cb6e4743$var$Lo(e, [
        {
            key: "init",
            value: function(n) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.services = n || {
                    languageUtils: {}
                }, this.options = $2a051a86cb6e4743$var$fm(r, this.options || {}, $2a051a86cb6e4743$var$xm()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(s) {
                    return s.replace("-", "_");
                }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = i1, this.addDetector($2a051a86cb6e4743$var$hm), this.addDetector($2a051a86cb6e4743$var$pm), this.addDetector($2a051a86cb6e4743$var$gm), this.addDetector($2a051a86cb6e4743$var$mm), this.addDetector($2a051a86cb6e4743$var$ym), this.addDetector($2a051a86cb6e4743$var$vm), this.addDetector($2a051a86cb6e4743$var$Sm), this.addDetector($2a051a86cb6e4743$var$wm);
            }
        },
        {
            key: "addDetector",
            value: function(n) {
                return this.detectors[n.name] = n, this;
            }
        },
        {
            key: "detect",
            value: function(n) {
                var r = this;
                n || (n = this.options.order);
                var i1 = [];
                return n.forEach(function(s) {
                    if (r.detectors[s]) {
                        var o = r.detectors[s].lookup(r.options);
                        o && typeof o == "string" && (o = [
                            o
                        ]), o && (i1 = i1.concat(o));
                    }
                }), i1 = i1.map(function(s) {
                    return r.options.convertDetectedLanguage(s);
                }), this.services.languageUtils.getBestMatchFromCodes ? i1 : i1.length > 0 ? i1[0] : null;
            }
        },
        {
            key: "cacheUserLanguage",
            value: function(n, r) {
                var i1 = this;
                r || (r = this.options.caches), r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(n) > -1 || r.forEach(function(s) {
                    i1.detectors[s] && i1.detectors[s].cacheUserLanguage(n, i1.options);
                }));
            }
        }
    ]);
}();
$2a051a86cb6e4743$var$Rd.type = "languageDetector";
function $2a051a86cb6e4743$var$Cm(e, t, n) {
    return (t = $2a051a86cb6e4743$var$xd(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $2a051a86cb6e4743$var$hc(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(i1) {
            return Object.getOwnPropertyDescriptor(e, i1).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $2a051a86cb6e4743$var$ia(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t] != null ? arguments[t] : {};
        t % 2 ? $2a051a86cb6e4743$var$hc(Object(n), !0).forEach(function(r) {
            $2a051a86cb6e4743$var$Cm(e, r, n[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $2a051a86cb6e4743$var$hc(Object(n)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
        });
    }
    return e;
}
var $2a051a86cb6e4743$var$Em = function() {
    function e(t) {
        $2a051a86cb6e4743$var$To(this, e), this.store = t.store;
    }
    return $2a051a86cb6e4743$var$Lo(e, [
        {
            key: "setItem",
            value: function(n, r) {
                if (this.store) try {
                    this.store.setItem(n, r);
                } catch  {}
            }
        },
        {
            key: "getItem",
            value: function(n, r) {
                if (this.store) try {
                    return this.store.getItem(n, r);
                } catch  {}
            }
        }
    ]), e;
}();
function $2a051a86cb6e4743$var$km() {
    var e = null;
    try {
        e = window.localStorage;
    } catch (t) {
        typeof window < "u" && console.log("Failed to load local storage.", t);
    }
    return {
        prefix: "i18next_res_",
        expirationTime: 604800000,
        defaultVersion: void 0,
        versions: {},
        store: e
    };
}
var $2a051a86cb6e4743$var$jd = function() {
    function e(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        $2a051a86cb6e4743$var$To(this, e), this.init(t, n), this.type = "backend";
    }
    return $2a051a86cb6e4743$var$Lo(e, [
        {
            key: "init",
            value: function(n) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.services = n, this.options = $2a051a86cb6e4743$var$ia($2a051a86cb6e4743$var$ia($2a051a86cb6e4743$var$ia({}, $2a051a86cb6e4743$var$km()), this.options), r), this.storage = new $2a051a86cb6e4743$var$Em(this.options);
            }
        },
        {
            key: "read",
            value: function(n, r, i1) {
                var s = Date.now();
                if (!this.storage.store) return i1(null, null);
                var o = this.storage.getItem("".concat(this.options.prefix).concat(n, "-").concat(r));
                if (o) {
                    o = JSON.parse(o);
                    var a = this.getVersion(n);
                    if (o.i18nStamp && o.i18nStamp + this.options.expirationTime > s && a === o.i18nVersion) {
                        var l = o.i18nStamp;
                        return delete o.i18nVersion, delete o.i18nStamp, i1(null, o, l);
                    }
                }
                return i1(null, null);
            }
        },
        {
            key: "save",
            value: function(n, r, i1) {
                if (this.storage.store) {
                    i1.i18nStamp = Date.now();
                    var s = this.getVersion(n);
                    s && (i1.i18nVersion = s), this.storage.setItem("".concat(this.options.prefix).concat(n, "-").concat(r), JSON.stringify(i1));
                }
            }
        },
        {
            key: "getVersion",
            value: function(n) {
                return this.options.versions[n] || this.options.defaultVersion;
            }
        }
    ]), e;
}();
$2a051a86cb6e4743$var$jd.type = "backend";
const $2a051a86cb6e4743$var$Y = (e)=>typeof e == "string", $2a051a86cb6e4743$var$Jr = ()=>{
    let e, t;
    const n = new Promise((r, i1)=>{
        e = r, t = i1;
    });
    return n.resolve = e, n.reject = t, n;
}, $2a051a86cb6e4743$var$pc = (e)=>e == null ? "" : "" + e, $2a051a86cb6e4743$var$Pm = (e, t, n)=>{
    e.forEach((r)=>{
        t[r] && (n[r] = t[r]);
    });
}, $2a051a86cb6e4743$var$_m = /###/g, $2a051a86cb6e4743$var$gc = (e)=>e && e.indexOf("###") > -1 ? e.replace($2a051a86cb6e4743$var$_m, ".") : e, $2a051a86cb6e4743$var$mc = (e)=>!e || $2a051a86cb6e4743$var$Y(e), $2a051a86cb6e4743$var$hi = (e, t, n)=>{
    const r = $2a051a86cb6e4743$var$Y(t) ? t.split(".") : t;
    let i1 = 0;
    for(; i1 < r.length - 1;){
        if ($2a051a86cb6e4743$var$mc(e)) return {};
        const s = $2a051a86cb6e4743$var$gc(r[i1]);
        !e[s] && n && (e[s] = new n), Object.prototype.hasOwnProperty.call(e, s) ? e = e[s] : e = {}, ++i1;
    }
    return $2a051a86cb6e4743$var$mc(e) ? {} : {
        obj: e,
        k: $2a051a86cb6e4743$var$gc(r[i1])
    };
}, $2a051a86cb6e4743$var$yc = (e, t, n)=>{
    const { obj: r, k: i1 } = $2a051a86cb6e4743$var$hi(e, t, Object);
    if (r !== void 0 || t.length === 1) {
        r[i1] = n;
        return;
    }
    let s = t[t.length - 1], o = t.slice(0, t.length - 1), a = $2a051a86cb6e4743$var$hi(e, o, Object);
    for(; a.obj === void 0 && o.length;)s = `${o[o.length - 1]}.${s}`, o = o.slice(0, o.length - 1), a = $2a051a86cb6e4743$var$hi(e, o, Object), a && a.obj && typeof a.obj[`${a.k}.${s}`] < "u" && (a.obj = void 0);
    a.obj[`${a.k}.${s}`] = n;
}, $2a051a86cb6e4743$var$bm = (e, t, n, r)=>{
    const { obj: i1, k: s } = $2a051a86cb6e4743$var$hi(e, t, Object);
    i1[s] = i1[s] || [], i1[s].push(n);
}, $2a051a86cb6e4743$var$Xs = (e, t)=>{
    const { obj: n, k: r } = $2a051a86cb6e4743$var$hi(e, t);
    if (n) return n[r];
}, $2a051a86cb6e4743$var$Om = (e, t, n)=>{
    const r = $2a051a86cb6e4743$var$Xs(e, n);
    return r !== void 0 ? r : $2a051a86cb6e4743$var$Xs(t, n);
}, $2a051a86cb6e4743$var$Id = (e, t, n)=>{
    for(const r in t)r !== "__proto__" && r !== "constructor" && (r in e ? $2a051a86cb6e4743$var$Y(e[r]) || e[r] instanceof String || $2a051a86cb6e4743$var$Y(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : $2a051a86cb6e4743$var$Id(e[r], t[r], n) : e[r] = t[r]);
    return e;
}, $2a051a86cb6e4743$var$tr = (e)=>e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var $2a051a86cb6e4743$var$Nm = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
const $2a051a86cb6e4743$var$Tm = (e)=>$2a051a86cb6e4743$var$Y(e) ? e.replace(/[&<>"'\/]/g, (t)=>$2a051a86cb6e4743$var$Nm[t]) : e;
class $2a051a86cb6e4743$var$Lm {
    constructor(t){
        this.capacity = t, this.regExpMap = new Map, this.regExpQueue = [];
    }
    getRegExp(t) {
        const n = this.regExpMap.get(t);
        if (n !== void 0) return n;
        const r = new RegExp(t);
        return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
    }
}
const $2a051a86cb6e4743$var$Rm = [
    " ",
    ",",
    "?",
    "!",
    ";"
], $2a051a86cb6e4743$var$jm = new $2a051a86cb6e4743$var$Lm(20), $2a051a86cb6e4743$var$Im = (e, t, n)=>{
    t = t || "", n = n || "";
    const r = $2a051a86cb6e4743$var$Rm.filter((o)=>t.indexOf(o) < 0 && n.indexOf(o) < 0);
    if (r.length === 0) return !0;
    const i1 = $2a051a86cb6e4743$var$jm.getRegExp(`(${r.map((o)=>o === "?" ? "\\?" : o).join("|")})`);
    let s = !i1.test(e);
    if (!s) {
        const o = e.indexOf(n);
        o > 0 && !i1.test(e.substring(0, o)) && (s = !0);
    }
    return s;
}, $2a051a86cb6e4743$var$Ma = function(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
    if (!e) return;
    if (e[t]) return e[t];
    const r = t.split(n);
    let i1 = e;
    for(let s = 0; s < r.length;){
        if (!i1 || typeof i1 != "object") return;
        let o, a = "";
        for(let l = s; l < r.length; ++l)if (l !== s && (a += n), a += r[l], o = i1[a], o !== void 0) {
            if ([
                "string",
                "number",
                "boolean"
            ].indexOf(typeof o) > -1 && l < r.length - 1) continue;
            s += l - s + 1;
            break;
        }
        i1 = o;
    }
    return i1;
}, $2a051a86cb6e4743$var$Js = (e)=>e && e.replace("_", "-"), $2a051a86cb6e4743$var$Fm = {
    type: "logger",
    log (e) {
        this.output("log", e);
    },
    warn (e) {
        this.output("warn", e);
    },
    error (e) {
        this.output("error", e);
    },
    output (e, t) {
        console && console[e] && console[e].apply(console, t);
    }
};
class $2a051a86cb6e4743$var$Zs {
    constructor(t){
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.init(t, n);
    }
    init(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.prefix = n.prefix || "i18next:", this.logger = t || $2a051a86cb6e4743$var$Fm, this.options = n, this.debug = n.debug;
    }
    log() {
        for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        return this.forward(n, "log", "", !0);
    }
    warn() {
        for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        return this.forward(n, "warn", "", !0);
    }
    error() {
        for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        return this.forward(n, "error", "");
    }
    deprecate() {
        for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
    }
    forward(t, n, r, i1) {
        return i1 && !this.debug ? null : ($2a051a86cb6e4743$var$Y(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
    }
    create(t) {
        return new $2a051a86cb6e4743$var$Zs(this.logger, {
            prefix: `${this.prefix}:${t}:`,
            ...this.options
        });
    }
    clone(t) {
        return t = t || this.options, t.prefix = t.prefix || this.prefix, new $2a051a86cb6e4743$var$Zs(this.logger, t);
    }
}
var $2a051a86cb6e4743$var$Pt = new $2a051a86cb6e4743$var$Zs;
class $2a051a86cb6e4743$var$Ro {
    constructor(){
        this.observers = {};
    }
    on(t, n) {
        return t.split(" ").forEach((r)=>{
            this.observers[r] || (this.observers[r] = new Map);
            const i1 = this.observers[r].get(n) || 0;
            this.observers[r].set(n, i1 + 1);
        }), this;
    }
    off(t, n) {
        if (this.observers[t]) {
            if (!n) {
                delete this.observers[t];
                return;
            }
            this.observers[t].delete(n);
        }
    }
    emit(t) {
        for(var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i1 = 1; i1 < n; i1++)r[i1 - 1] = arguments[i1];
        this.observers[t] && Array.from(this.observers[t].entries()).forEach((o)=>{
            let [a, l] = o;
            for(let u = 0; u < l; u++)a(...r);
        }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o)=>{
            let [a, l] = o;
            for(let u = 0; u < l; u++)a.apply(a, [
                t,
                ...r
            ]);
        });
    }
}
class $2a051a86cb6e4743$var$vc extends $2a051a86cb6e4743$var$Ro {
    constructor(t){
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
    }
    addNamespaces(t) {
        this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
    }
    removeNamespaces(t) {
        const n = this.options.ns.indexOf(t);
        n > -1 && this.options.ns.splice(n, 1);
    }
    getResource(t, n, r) {
        let i1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        const s = i1.keySeparator !== void 0 ? i1.keySeparator : this.options.keySeparator, o = i1.ignoreJSONStructure !== void 0 ? i1.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let a;
        t.indexOf(".") > -1 ? a = t.split(".") : (a = [
            t,
            n
        ], r && (Array.isArray(r) ? a.push(...r) : $2a051a86cb6e4743$var$Y(r) && s ? a.push(...r.split(s)) : a.push(r)));
        const l = $2a051a86cb6e4743$var$Xs(this.data, a);
        return !l && !n && !r && t.indexOf(".") > -1 && (t = a[0], n = a[1], r = a.slice(2).join(".")), l || !o || !$2a051a86cb6e4743$var$Y(r) ? l : $2a051a86cb6e4743$var$Ma(this.data && this.data[t] && this.data[t][n], r, s);
    }
    addResource(t, n, r, i1) {
        let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
            silent: !1
        };
        const o = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator;
        let a = [
            t,
            n
        ];
        r && (a = a.concat(o ? r.split(o) : r)), t.indexOf(".") > -1 && (a = t.split("."), i1 = n, n = a[1]), this.addNamespaces(n), $2a051a86cb6e4743$var$yc(this.data, a, i1), s.silent || this.emit("added", t, n, r, i1);
    }
    addResources(t, n, r) {
        let i1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
            silent: !1
        };
        for(const s in r)($2a051a86cb6e4743$var$Y(r[s]) || Array.isArray(r[s])) && this.addResource(t, n, s, r[s], {
            silent: !0
        });
        i1.silent || this.emit("added", t, n, r);
    }
    addResourceBundle(t, n, r, i1, s) {
        let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
            silent: !1,
            skipCopy: !1
        }, a = [
            t,
            n
        ];
        t.indexOf(".") > -1 && (a = t.split("."), i1 = r, r = n, n = a[1]), this.addNamespaces(n);
        let l = $2a051a86cb6e4743$var$Xs(this.data, a) || {};
        o.skipCopy || (r = JSON.parse(JSON.stringify(r))), i1 ? $2a051a86cb6e4743$var$Id(l, r, s) : l = {
            ...l,
            ...r
        }, $2a051a86cb6e4743$var$yc(this.data, a, l), o.silent || this.emit("added", t, n, r);
    }
    removeResourceBundle(t, n) {
        this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
    }
    hasResourceBundle(t, n) {
        return this.getResource(t, n) !== void 0;
    }
    getResourceBundle(t, n) {
        return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
            ...this.getResource(t, n)
        } : this.getResource(t, n);
    }
    getDataByLanguage(t) {
        return this.data[t];
    }
    hasLanguageSomeTranslations(t) {
        const n = this.getDataByLanguage(t);
        return !!(n && Object.keys(n) || []).find((i1)=>n[i1] && Object.keys(n[i1]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $2a051a86cb6e4743$var$Fd = {
    processors: {},
    addPostProcessor (e) {
        this.processors[e.name] = e;
    },
    handle (e, t, n, r, i1) {
        return e.forEach((s)=>{
            this.processors[s] && (t = this.processors[s].process(t, n, r, i1));
        }), t;
    }
};
const $2a051a86cb6e4743$var$Sc = {};
class $2a051a86cb6e4743$var$eo extends $2a051a86cb6e4743$var$Ro {
    constructor(t){
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        super(), $2a051a86cb6e4743$var$Pm([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = $2a051a86cb6e4743$var$Pt.create("translator");
    }
    changeLanguage(t) {
        t && (this.language = t);
    }
    exists(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            interpolation: {}
        };
        if (t == null) return !1;
        const r = this.resolve(t, n);
        return r && r.res !== void 0;
    }
    extractFromKey(t, n) {
        let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
        r === void 0 && (r = ":");
        const i1 = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
        let s = n.ns || this.options.defaultNS || [];
        const o = r && t.indexOf(r) > -1, a = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !$2a051a86cb6e4743$var$Im(t, r, i1);
        if (o && !a) {
            const l = t.match(this.interpolator.nestingRegexp);
            if (l && l.length > 0) return {
                key: t,
                namespaces: $2a051a86cb6e4743$var$Y(s) ? [
                    s
                ] : s
            };
            const u = t.split(r);
            (r !== i1 || r === i1 && this.options.ns.indexOf(u[0]) > -1) && (s = u.shift()), t = u.join(i1);
        }
        return {
            key: t,
            namespaces: $2a051a86cb6e4743$var$Y(s) ? [
                s
            ] : s
        };
    }
    translate(t, n, r) {
        if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
            ...n
        }), n || (n = {}), t == null) return "";
        Array.isArray(t) || (t = [
            String(t)
        ]);
        const i1 = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, s = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, { key: o, namespaces: a } = this.extractFromKey(t[t.length - 1], n), l = a[a.length - 1], u = n.lng || this.language, c = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (u && u.toLowerCase() === "cimode") {
            if (c) {
                const E = n.nsSeparator || this.options.nsSeparator;
                return i1 ? {
                    res: `${l}${E}${o}`,
                    usedKey: o,
                    exactUsedKey: o,
                    usedLng: u,
                    usedNS: l,
                    usedParams: this.getUsedParamsDetails(n)
                } : `${l}${E}${o}`;
            }
            return i1 ? {
                res: o,
                usedKey: o,
                exactUsedKey: o,
                usedLng: u,
                usedNS: l,
                usedParams: this.getUsedParamsDetails(n)
            } : o;
        }
        const d = this.resolve(t, n);
        let f = d && d.res;
        const m = d && d.usedKey || o, v = d && d.exactUsedKey || o, y = Object.prototype.toString.apply(f), k = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ], p = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, h = !this.i18nFormat || this.i18nFormat.handleAsObject, g = !$2a051a86cb6e4743$var$Y(f) && typeof f != "boolean" && typeof f != "number";
        if (h && f && g && k.indexOf(y) < 0 && !($2a051a86cb6e4743$var$Y(p) && Array.isArray(f))) {
            if (!n.returnObjects && !this.options.returnObjects) {
                this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const E = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, f, {
                    ...n,
                    ns: a
                }) : `key '${o} (${this.language})' returned an object instead of string.`;
                return i1 ? (d.res = E, d.usedParams = this.getUsedParamsDetails(n), d) : E;
            }
            if (s) {
                const E = Array.isArray(f), P = E ? [] : {}, N = E ? v : m;
                for(const b in f)if (Object.prototype.hasOwnProperty.call(f, b)) {
                    const R = `${N}${s}${b}`;
                    P[b] = this.translate(R, {
                        ...n,
                        joinArrays: !1,
                        ns: a
                    }), P[b] === R && (P[b] = f[b]);
                }
                f = P;
            }
        } else if (h && $2a051a86cb6e4743$var$Y(p) && Array.isArray(f)) f = f.join(p), f && (f = this.extendTranslation(f, t, n, r));
        else {
            let E = !1, P = !1;
            const N = n.count !== void 0 && !$2a051a86cb6e4743$var$Y(n.count), b = $2a051a86cb6e4743$var$eo.hasDefaultValue(n), R = N ? this.pluralResolver.getSuffix(u, n.count, n) : "", D = n.ordinal && N ? this.pluralResolver.getSuffix(u, n.count, {
                ordinal: !1
            }) : "", H = N && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), M = H && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${R}`] || n[`defaultValue${D}`] || n.defaultValue;
            !this.isValidLookup(f) && b && (E = !0, f = M), this.isValidLookup(f) || (P = !0, f = o);
            const F = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && P ? void 0 : f, W = b && M !== f && this.options.updateMissing;
            if (P || E || W) {
                if (this.logger.log(W ? "updateKey" : "missingKey", u, l, o, W ? M : f), s) {
                    const O = this.resolve(o, {
                        ...n,
                        keySeparator: !1
                    });
                    O && O.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let x = [];
                const T = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && T && T[0]) for(let O = 0; O < T.length; O++)x.push(T[O]);
                else this.options.saveMissingTo === "all" ? x = this.languageUtils.toResolveHierarchy(n.lng || this.language) : x.push(n.lng || this.language);
                const Q = (O, _, C)=>{
                    const z = b && C !== f ? C : F;
                    this.options.missingKeyHandler ? this.options.missingKeyHandler(O, l, _, z, W, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(O, l, _, z, W, n), this.emit("missingKey", O, l, _, f);
                };
                this.options.saveMissing && (this.options.saveMissingPlurals && N ? x.forEach((O)=>{
                    const _ = this.pluralResolver.getSuffixes(O, n);
                    H && n[`defaultValue${this.options.pluralSeparator}zero`] && _.indexOf(`${this.options.pluralSeparator}zero`) < 0 && _.push(`${this.options.pluralSeparator}zero`), _.forEach((C)=>{
                        Q([
                            O
                        ], o + C, n[`defaultValue${C}`] || M);
                    });
                }) : Q(x, o, M));
            }
            f = this.extendTranslation(f, t, n, d, r), P && f === o && this.options.appendNamespaceToMissingKey && (f = `${l}:${o}`), (P || E) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, E ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
        }
        return i1 ? (d.res = f, d.usedParams = this.getUsedParamsDetails(n), d) : f;
    }
    extendTranslation(t, n, r, i1, s) {
        var o = this;
        if (this.i18nFormat && this.i18nFormat.parse) t = this.i18nFormat.parse(t, {
            ...this.options.interpolation.defaultVariables,
            ...r
        }, r.lng || this.language || i1.usedLng, i1.usedNS, i1.usedKey, {
            resolved: i1
        });
        else if (!r.skipInterpolation) {
            r.interpolation && this.interpolator.init({
                ...r,
                interpolation: {
                    ...this.options.interpolation,
                    ...r.interpolation
                }
            });
            const u = $2a051a86cb6e4743$var$Y(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let c;
            if (u) {
                const f = t.match(this.interpolator.nestingRegexp);
                c = f && f.length;
            }
            let d = r.replace && !$2a051a86cb6e4743$var$Y(r.replace) ? r.replace : r;
            if (this.options.interpolation.defaultVariables && (d = {
                ...this.options.interpolation.defaultVariables,
                ...d
            }), t = this.interpolator.interpolate(t, d, r.lng || this.language || i1.usedLng, r), u) {
                const f = t.match(this.interpolator.nestingRegexp), m = f && f.length;
                c < m && (r.nest = !1);
            }
            !r.lng && this.options.compatibilityAPI !== "v1" && i1 && i1.res && (r.lng = this.language || i1.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
                for(var f = arguments.length, m = new Array(f), v = 0; v < f; v++)m[v] = arguments[v];
                return s && s[0] === m[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${m[0]} in key: ${n[0]}`), null) : o.translate(...m, n);
            }, r)), r.interpolation && this.interpolator.reset();
        }
        const a = r.postProcess || this.options.postProcess, l = $2a051a86cb6e4743$var$Y(a) ? [
            a
        ] : a;
        return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = $2a051a86cb6e4743$var$Fd.handle(l, t, n, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...i1,
                usedParams: this.getUsedParamsDetails(r)
            },
            ...r
        } : r, this)), t;
    }
    resolve(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, i1, s, o, a;
        return $2a051a86cb6e4743$var$Y(t) && (t = [
            t
        ]), t.forEach((l)=>{
            if (this.isValidLookup(r)) return;
            const u = this.extractFromKey(l, n), c = u.key;
            i1 = c;
            let d = u.namespaces;
            this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
            const f = n.count !== void 0 && !$2a051a86cb6e4743$var$Y(n.count), m = f && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), v = n.context !== void 0 && ($2a051a86cb6e4743$var$Y(n.context) || typeof n.context == "number") && n.context !== "", y = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
            d.forEach((k)=>{
                this.isValidLookup(r) || (a = k, !$2a051a86cb6e4743$var$Sc[`${y[0]}-${k}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(a) && ($2a051a86cb6e4743$var$Sc[`${y[0]}-${k}`] = !0, this.logger.warn(`key "${i1}" for languages "${y.join(", ")}" won't get resolved as namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach((p)=>{
                    if (this.isValidLookup(r)) return;
                    o = p;
                    const h = [
                        c
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(h, c, p, k, n);
                    else {
                        let E;
                        f && (E = this.pluralResolver.getSuffix(p, n.count, n));
                        const P = `${this.options.pluralSeparator}zero`, N = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (f && (h.push(c + E), n.ordinal && E.indexOf(N) === 0 && h.push(c + E.replace(N, this.options.pluralSeparator)), m && h.push(c + P)), v) {
                            const b = `${c}${this.options.contextSeparator}${n.context}`;
                            h.push(b), f && (h.push(b + E), n.ordinal && E.indexOf(N) === 0 && h.push(b + E.replace(N, this.options.pluralSeparator)), m && h.push(b + P));
                        }
                    }
                    let g;
                    for(; g = h.pop();)this.isValidLookup(r) || (s = g, r = this.getResource(p, k, g, n));
                }));
            });
        }), {
            res: r,
            usedKey: i1,
            exactUsedKey: s,
            usedLng: o,
            usedNS: a
        };
    }
    isValidLookup(t) {
        return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
    }
    getResource(t, n, r) {
        let i1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, i1) : this.resourceStore.getResource(t, n, r, i1);
    }
    getUsedParamsDetails() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const n = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ], r = t.replace && !$2a051a86cb6e4743$var$Y(t.replace);
        let i1 = r ? t.replace : t;
        if (r && typeof t.count < "u" && (i1.count = t.count), this.options.interpolation.defaultVariables && (i1 = {
            ...this.options.interpolation.defaultVariables,
            ...i1
        }), !r) {
            i1 = {
                ...i1
            };
            for (const s of n)delete i1[s];
        }
        return i1;
    }
    static hasDefaultValue(t) {
        const n = "defaultValue";
        for(const r in t)if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0) return !0;
        return !1;
    }
}
const $2a051a86cb6e4743$var$sa = (e)=>e.charAt(0).toUpperCase() + e.slice(1);
class $2a051a86cb6e4743$var$wc {
    constructor(t){
        this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = $2a051a86cb6e4743$var$Pt.create("languageUtils");
    }
    getScriptPartFromCode(t) {
        if (t = $2a051a86cb6e4743$var$Js(t), !t || t.indexOf("-") < 0) return null;
        const n = t.split("-");
        return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
    }
    getLanguagePartFromCode(t) {
        if (t = $2a051a86cb6e4743$var$Js(t), !t || t.indexOf("-") < 0) return t;
        const n = t.split("-");
        return this.formatLanguageCode(n[0]);
    }
    formatLanguageCode(t) {
        if ($2a051a86cb6e4743$var$Y(t) && t.indexOf("-") > -1) {
            if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u") try {
                let i1 = Intl.getCanonicalLocales(t)[0];
                if (i1 && this.options.lowerCaseLng && (i1 = i1.toLowerCase()), i1) return i1;
            } catch  {}
            const n = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let r = t.split("-");
            return this.options.lowerCaseLng ? r = r.map((i1)=>i1.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $2a051a86cb6e4743$var$sa(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $2a051a86cb6e4743$var$sa(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = $2a051a86cb6e4743$var$sa(r[2].toLowerCase()))), r.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
    }
    isSupportedCode(t) {
        return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
    }
    getBestMatchFromCodes(t) {
        if (!t) return null;
        let n;
        return t.forEach((r)=>{
            if (n) return;
            const i1 = this.formatLanguageCode(r);
            (!this.options.supportedLngs || this.isSupportedCode(i1)) && (n = i1);
        }), !n && this.options.supportedLngs && t.forEach((r)=>{
            if (n) return;
            const i1 = this.getLanguagePartFromCode(r);
            if (this.isSupportedCode(i1)) return n = i1;
            n = this.options.supportedLngs.find((s)=>{
                if (s === i1) return s;
                if (!(s.indexOf("-") < 0 && i1.indexOf("-") < 0) && (s.indexOf("-") > 0 && i1.indexOf("-") < 0 && s.substring(0, s.indexOf("-")) === i1 || s.indexOf(i1) === 0 && i1.length > 1)) return s;
            });
        }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
    }
    getFallbackCodes(t, n) {
        if (!t) return [];
        if (typeof t == "function" && (t = t(n)), $2a051a86cb6e4743$var$Y(t) && (t = [
            t
        ]), Array.isArray(t)) return t;
        if (!n) return t.default || [];
        let r = t[n];
        return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
    }
    toResolveHierarchy(t, n) {
        const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), i1 = [], s = (o)=>{
            o && (this.isSupportedCode(o) ? i1.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
        };
        return $2a051a86cb6e4743$var$Y(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(t))) : $2a051a86cb6e4743$var$Y(t) && s(this.formatLanguageCode(t)), r.forEach((o)=>{
            i1.indexOf(o) < 0 && s(this.formatLanguageCode(o));
        }), i1;
    }
}
let $2a051a86cb6e4743$var$Dm = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
], $2a051a86cb6e4743$var$Am = {
    1: (e)=>+(e > 1),
    2: (e)=>+(e != 1),
    3: (e)=>0,
    4: (e)=>e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
    5: (e)=>e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
    6: (e)=>e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
    7: (e)=>e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
    8: (e)=>e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
    9: (e)=>+(e >= 2),
    10: (e)=>e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
    11: (e)=>e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
    12: (e)=>+(e % 10 != 1 || e % 100 == 11),
    13: (e)=>+(e !== 0),
    14: (e)=>e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
    15: (e)=>e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
    16: (e)=>e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
    17: (e)=>e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
    18: (e)=>e == 0 ? 0 : e == 1 ? 1 : 2,
    19: (e)=>e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
    20: (e)=>e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
    21: (e)=>e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
    22: (e)=>e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const $2a051a86cb6e4743$var$Mm = [
    "v1",
    "v2",
    "v3"
], $2a051a86cb6e4743$var$Um = [
    "v4"
], $2a051a86cb6e4743$var$xc = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
}, $2a051a86cb6e4743$var$$m = ()=>{
    const e = {};
    return $2a051a86cb6e4743$var$Dm.forEach((t)=>{
        t.lngs.forEach((n)=>{
            e[n] = {
                numbers: t.nr,
                plurals: $2a051a86cb6e4743$var$Am[t.fc]
            };
        });
    }), e;
};
class $2a051a86cb6e4743$var$zm {
    constructor(t){
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.languageUtils = t, this.options = n, this.logger = $2a051a86cb6e4743$var$Pt.create("pluralResolver"), (!this.options.compatibilityJSON || $2a051a86cb6e4743$var$Um.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = $2a051a86cb6e4743$var$$m(), this.pluralRulesCache = {};
    }
    addRule(t, n) {
        this.rules[t] = n;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (this.shouldUseIntlApi()) {
            const r = $2a051a86cb6e4743$var$Js(t === "dev" ? "en" : t), i1 = n.ordinal ? "ordinal" : "cardinal", s = JSON.stringify({
                cleanedCode: r,
                type: i1
            });
            if (s in this.pluralRulesCache) return this.pluralRulesCache[s];
            let o;
            try {
                o = new Intl.PluralRules(r, {
                    type: i1
                });
            } catch  {
                if (!t.match(/-|_/)) return;
                const l = this.languageUtils.getLanguagePartFromCode(t);
                o = this.getRule(l, n);
            }
            return this.pluralRulesCache[s] = o, o;
        }
        return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
    }
    needsPlural(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const r = this.getRule(t, n);
        return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
    }
    getPluralFormsOfKey(t, n) {
        let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return this.getSuffixes(t, r).map((i1)=>`${n}${i1}`);
    }
    getSuffixes(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const r = this.getRule(t, n);
        return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((i1, s)=>$2a051a86cb6e4743$var$xc[i1] - $2a051a86cb6e4743$var$xc[s]).map((i1)=>`${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${i1}`) : r.numbers.map((i1)=>this.getSuffix(t, i1, n)) : [];
    }
    getSuffix(t, n) {
        let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        const i1 = this.getRule(t, r);
        return i1 ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${i1.select(n)}` : this.getSuffixRetroCompatible(i1, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
    }
    getSuffixRetroCompatible(t, n) {
        const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
        let i1 = t.numbers[r];
        this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (i1 === 2 ? i1 = "plural" : i1 === 1 && (i1 = ""));
        const s = ()=>this.options.prepend && i1.toString() ? this.options.prepend + i1.toString() : i1.toString();
        return this.options.compatibilityJSON === "v1" ? i1 === 1 ? "" : typeof i1 == "number" ? `_plural_${i1.toString()}` : s() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? s() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
    }
    shouldUseIntlApi() {
        return !$2a051a86cb6e4743$var$Mm.includes(this.options.compatibilityJSON);
    }
}
const $2a051a86cb6e4743$var$Cc = function(e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", i1 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, s = $2a051a86cb6e4743$var$Om(e, t, n);
    return !s && i1 && $2a051a86cb6e4743$var$Y(n) && (s = $2a051a86cb6e4743$var$Ma(e, n, r), s === void 0 && (s = $2a051a86cb6e4743$var$Ma(t, n, r))), s;
}, $2a051a86cb6e4743$var$oa = (e)=>e.replace(/\$/g, "$$$$");
class $2a051a86cb6e4743$var$Bm {
    constructor(){
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        this.logger = $2a051a86cb6e4743$var$Pt.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n)=>n), this.init(t);
    }
    init() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        t.interpolation || (t.interpolation = {
            escapeValue: !0
        });
        const { escape: n, escapeValue: r, useRawValueToEscape: i1, prefix: s, prefixEscaped: o, suffix: a, suffixEscaped: l, formatSeparator: u, unescapeSuffix: c, unescapePrefix: d, nestingPrefix: f, nestingPrefixEscaped: m, nestingSuffix: v, nestingSuffixEscaped: y, nestingOptionsSeparator: k, maxReplaces: p, alwaysFormat: h } = t.interpolation;
        this.escape = n !== void 0 ? n : $2a051a86cb6e4743$var$Tm, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = i1 !== void 0 ? i1 : !1, this.prefix = s ? $2a051a86cb6e4743$var$tr(s) : o || "{{", this.suffix = a ? $2a051a86cb6e4743$var$tr(a) : l || "}}", this.formatSeparator = u || ",", this.unescapePrefix = c ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : c || "", this.nestingPrefix = f ? $2a051a86cb6e4743$var$tr(f) : m || $2a051a86cb6e4743$var$tr("$t("), this.nestingSuffix = v ? $2a051a86cb6e4743$var$tr(v) : y || $2a051a86cb6e4743$var$tr(")"), this.nestingOptionsSeparator = k || ",", this.maxReplaces = p || 1e3, this.alwaysFormat = h !== void 0 ? h : !1, this.resetRegExp();
    }
    reset() {
        this.options && this.init(this.options);
    }
    resetRegExp() {
        const t = (n, r)=>n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
        this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(t, n, r, i1) {
        let s, o, a;
        const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (m)=>{
            if (m.indexOf(this.formatSeparator) < 0) {
                const p = $2a051a86cb6e4743$var$Cc(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(p, void 0, r, {
                    ...i1,
                    ...n,
                    interpolationkey: m
                }) : p;
            }
            const v = m.split(this.formatSeparator), y = v.shift().trim(), k = v.join(this.formatSeparator).trim();
            return this.format($2a051a86cb6e4743$var$Cc(n, l, y, this.options.keySeparator, this.options.ignoreJSONStructure), k, r, {
                ...i1,
                ...n,
                interpolationkey: y
            });
        };
        this.resetRegExp();
        const c = i1 && i1.missingInterpolationHandler || this.options.missingInterpolationHandler, d = i1 && i1.interpolation && i1.interpolation.skipOnVariables !== void 0 ? i1.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        return [
            {
                regex: this.regexpUnescape,
                safeValue: (m)=>$2a051a86cb6e4743$var$oa(m)
            },
            {
                regex: this.regexp,
                safeValue: (m)=>this.escapeValue ? $2a051a86cb6e4743$var$oa(this.escape(m)) : $2a051a86cb6e4743$var$oa(m)
            }
        ].forEach((m)=>{
            for(a = 0; s = m.regex.exec(t);){
                const v = s[1].trim();
                if (o = u(v), o === void 0) {
                    if (typeof c == "function") {
                        const k = c(t, s, i1);
                        o = $2a051a86cb6e4743$var$Y(k) ? k : "";
                    } else if (i1 && Object.prototype.hasOwnProperty.call(i1, v)) o = "";
                    else if (d) {
                        o = s[0];
                        continue;
                    } else this.logger.warn(`missed to pass in variable ${v} for interpolating ${t}`), o = "";
                } else !$2a051a86cb6e4743$var$Y(o) && !this.useRawValueToEscape && (o = $2a051a86cb6e4743$var$pc(o));
                const y = m.safeValue(o);
                if (t = t.replace(s[0], y), d ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= s[0].length) : m.regex.lastIndex = 0, a++, a >= this.maxReplaces) break;
            }
        }), t;
    }
    nest(t, n) {
        let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i1, s, o;
        const a = (l, u)=>{
            const c = this.nestingOptionsSeparator;
            if (l.indexOf(c) < 0) return l;
            const d = l.split(new RegExp(`${c}[ ]*{`));
            let f = `{${d[1]}`;
            l = d[0], f = this.interpolate(f, o);
            const m = f.match(/'/g), v = f.match(/"/g);
            (m && m.length % 2 === 0 && !v || v.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
            try {
                o = JSON.parse(f), u && (o = {
                    ...u,
                    ...o
                });
            } catch (y) {
                return this.logger.warn(`failed parsing options string in nesting for key ${l}`, y), `${l}${c}${f}`;
            }
            return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
        };
        for(; i1 = this.nestingRegexp.exec(t);){
            let l = [];
            o = {
                ...r
            }, o = o.replace && !$2a051a86cb6e4743$var$Y(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
            let u = !1;
            if (i1[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(i1[1])) {
                const c = i1[1].split(this.formatSeparator).map((d)=>d.trim());
                i1[1] = c.shift(), l = c, u = !0;
            }
            if (s = n(a.call(this, i1[1].trim(), o), o), s && i1[0] === t && !$2a051a86cb6e4743$var$Y(s)) return s;
            $2a051a86cb6e4743$var$Y(s) || (s = $2a051a86cb6e4743$var$pc(s)), s || (this.logger.warn(`missed to resolve ${i1[1]} for nesting ${t}`), s = ""), u && (s = l.reduce((c, d)=>this.format(c, d, r.lng, {
                    ...r,
                    interpolationkey: i1[1].trim()
                }), s.trim())), t = t.replace(i1[0], s), this.regexp.lastIndex = 0;
        }
        return t;
    }
}
const $2a051a86cb6e4743$var$Hm = (e)=>{
    let t = e.toLowerCase().trim();
    const n = {};
    if (e.indexOf("(") > -1) {
        const r = e.split("(");
        t = r[0].toLowerCase().trim();
        const i1 = r[1].substring(0, r[1].length - 1);
        t === "currency" && i1.indexOf(":") < 0 ? n.currency || (n.currency = i1.trim()) : t === "relativetime" && i1.indexOf(":") < 0 ? n.range || (n.range = i1.trim()) : i1.split(";").forEach((o)=>{
            if (o) {
                const [a, ...l] = o.split(":"), u = l.join(":").trim().replace(/^'+|'+$/g, ""), c = a.trim();
                n[c] || (n[c] = u), u === "false" && (n[c] = !1), u === "true" && (n[c] = !0), isNaN(u) || (n[c] = parseInt(u, 10));
            }
        });
    }
    return {
        formatName: t,
        formatOptions: n
    };
}, $2a051a86cb6e4743$var$nr = (e)=>{
    const t = {};
    return (n, r, i1)=>{
        let s = i1;
        i1 && i1.interpolationkey && i1.formatParams && i1.formatParams[i1.interpolationkey] && i1[i1.interpolationkey] && (s = {
            ...s,
            [i1.interpolationkey]: void 0
        });
        const o = r + JSON.stringify(s);
        let a = t[o];
        return a || (a = e($2a051a86cb6e4743$var$Js(r), i1), t[o] = a), a(n);
    };
};
class $2a051a86cb6e4743$var$Vm {
    constructor(){
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        this.logger = $2a051a86cb6e4743$var$Pt.create("formatter"), this.options = t, this.formats = {
            number: $2a051a86cb6e4743$var$nr((n, r)=>{
                const i1 = new Intl.NumberFormat(n, {
                    ...r
                });
                return (s)=>i1.format(s);
            }),
            currency: $2a051a86cb6e4743$var$nr((n, r)=>{
                const i1 = new Intl.NumberFormat(n, {
                    ...r,
                    style: "currency"
                });
                return (s)=>i1.format(s);
            }),
            datetime: $2a051a86cb6e4743$var$nr((n, r)=>{
                const i1 = new Intl.DateTimeFormat(n, {
                    ...r
                });
                return (s)=>i1.format(s);
            }),
            relativetime: $2a051a86cb6e4743$var$nr((n, r)=>{
                const i1 = new Intl.RelativeTimeFormat(n, {
                    ...r
                });
                return (s)=>i1.format(s, r.range || "day");
            }),
            list: $2a051a86cb6e4743$var$nr((n, r)=>{
                const i1 = new Intl.ListFormat(n, {
                    ...r
                });
                return (s)=>i1.format(s);
            })
        }, this.init(t);
    }
    init(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = n.interpolation.formatSeparator || ",";
    }
    add(t, n) {
        this.formats[t.toLowerCase().trim()] = n;
    }
    addCached(t, n) {
        this.formats[t.toLowerCase().trim()] = $2a051a86cb6e4743$var$nr(n);
    }
    format(t, n, r) {
        let i1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        const s = n.split(this.formatSeparator);
        if (s.length > 1 && s[0].indexOf("(") > 1 && s[0].indexOf(")") < 0 && s.find((a)=>a.indexOf(")") > -1)) {
            const a = s.findIndex((l)=>l.indexOf(")") > -1);
            s[0] = [
                s[0],
                ...s.splice(1, a)
            ].join(this.formatSeparator);
        }
        return s.reduce((a, l)=>{
            const { formatName: u, formatOptions: c } = $2a051a86cb6e4743$var$Hm(l);
            if (this.formats[u]) {
                let d = a;
                try {
                    const f = i1 && i1.formatParams && i1.formatParams[i1.interpolationkey] || {}, m = f.locale || f.lng || i1.locale || i1.lng || r;
                    d = this.formats[u](a, m, {
                        ...c,
                        ...i1,
                        ...f
                    });
                } catch (f) {
                    this.logger.warn(f);
                }
                return d;
            } else this.logger.warn(`there was no format function for ${u}`);
            return a;
        }, t);
    }
}
const $2a051a86cb6e4743$var$Qm = (e, t)=>{
    e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class $2a051a86cb6e4743$var$Km extends $2a051a86cb6e4743$var$Ro {
    constructor(t, n, r){
        let i1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = i1, this.logger = $2a051a86cb6e4743$var$Pt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = i1.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = i1.maxRetries >= 0 ? i1.maxRetries : 5, this.retryTimeout = i1.retryTimeout >= 1 ? i1.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, i1.backend, i1);
    }
    queueLoad(t, n, r, i1) {
        const s = {}, o = {}, a = {}, l = {};
        return t.forEach((u)=>{
            let c = !0;
            n.forEach((d)=>{
                const f = `${u}|${d}`;
                !r.reload && this.store.hasResourceBundle(u, d) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? o[f] === void 0 && (o[f] = !0) : (this.state[f] = 1, c = !1, o[f] === void 0 && (o[f] = !0), s[f] === void 0 && (s[f] = !0), l[d] === void 0 && (l[d] = !0)));
            }), c || (a[u] = !0);
        }), (Object.keys(s).length || Object.keys(o).length) && this.queue.push({
            pending: o,
            pendingCount: Object.keys(o).length,
            loaded: {},
            errors: [],
            callback: i1
        }), {
            toLoad: Object.keys(s),
            pending: Object.keys(o),
            toLoadLanguages: Object.keys(a),
            toLoadNamespaces: Object.keys(l)
        };
    }
    loaded(t, n, r) {
        const i1 = t.split("|"), s = i1[0], o = i1[1];
        n && this.emit("failedLoading", s, o, n), !n && r && this.store.addResourceBundle(s, o, r, void 0, void 0, {
            skipCopy: !0
        }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
        const a = {};
        this.queue.forEach((l)=>{
            $2a051a86cb6e4743$var$bm(l.loaded, [
                s
            ], o), $2a051a86cb6e4743$var$Qm(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((u)=>{
                a[u] || (a[u] = {});
                const c = l.loaded[u];
                c.length && c.forEach((d)=>{
                    a[u][d] === void 0 && (a[u][d] = !0);
                });
            }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
        }), this.emit("loaded", a), this.queue = this.queue.filter((l)=>!l.done);
    }
    read(t, n, r) {
        let i1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
        if (!t.length) return o(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: t,
                ns: n,
                fcName: r,
                tried: i1,
                wait: s,
                callback: o
            });
            return;
        }
        this.readingCalls++;
        const a = (u, c)=>{
            if (this.readingCalls--, this.waitingReads.length > 0) {
                const d = this.waitingReads.shift();
                this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
            }
            if (u && c && i1 < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, t, n, r, i1 + 1, s * 2, o);
                }, s);
                return;
            }
            o(u, c);
        }, l = this.backend[r].bind(this.backend);
        if (l.length === 2) {
            try {
                const u = l(t, n);
                u && typeof u.then == "function" ? u.then((c)=>a(null, c)).catch(a) : a(null, u);
            } catch (u) {
                a(u);
            }
            return;
        }
        return l(t, n, a);
    }
    prepareLoading(t, n) {
        let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i1 = arguments.length > 3 ? arguments[3] : void 0;
        if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i1 && i1();
        $2a051a86cb6e4743$var$Y(t) && (t = this.languageUtils.toResolveHierarchy(t)), $2a051a86cb6e4743$var$Y(n) && (n = [
            n
        ]);
        const s = this.queueLoad(t, n, r, i1);
        if (!s.toLoad.length) return s.pending.length || i1(), null;
        s.toLoad.forEach((o)=>{
            this.loadOne(o);
        });
    }
    load(t, n, r) {
        this.prepareLoading(t, n, {}, r);
    }
    reload(t, n, r) {
        this.prepareLoading(t, n, {
            reload: !0
        }, r);
    }
    loadOne(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const r = t.split("|"), i1 = r[0], s = r[1];
        this.read(i1, s, "read", void 0, void 0, (o, a)=>{
            o && this.logger.warn(`${n}loading namespace ${s} for language ${i1} failed`, o), !o && a && this.logger.log(`${n}loaded namespace ${s} for language ${i1}`, a), this.loaded(t, o, a);
        });
    }
    saveMissing(t, n, r, i1, s) {
        let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
            this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (!(r == null || r === "")) {
            if (this.backend && this.backend.create) {
                const l = {
                    ...o,
                    isUpdate: s
                }, u = this.backend.create.bind(this.backend);
                if (u.length < 6) try {
                    let c;
                    u.length === 5 ? c = u(t, n, r, i1, l) : c = u(t, n, r, i1), c && typeof c.then == "function" ? c.then((d)=>a(null, d)).catch(a) : a(null, c);
                } catch (c) {
                    a(c);
                }
                else u(t, n, r, i1, a, l);
            }
            !t || !t[0] || this.store.addResource(t[0], n, r, i1);
        }
    }
}
const $2a051a86cb6e4743$var$Ec = ()=>({
        debug: !1,
        initImmediate: !0,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: !1,
        supportedLngs: !1,
        nonExplicitSupportedLngs: !1,
        load: "all",
        preload: !1,
        simplifyPluralSuffix: !0,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: !1,
        saveMissing: !1,
        updateMissing: !1,
        saveMissingTo: "fallback",
        saveMissingPlurals: !0,
        missingKeyHandler: !1,
        missingInterpolationHandler: !1,
        postProcess: !1,
        postProcessPassResolved: !1,
        returnNull: !1,
        returnEmptyString: !0,
        returnObjects: !1,
        joinArrays: !1,
        returnedObjectHandler: !1,
        parseMissingKeyHandler: !1,
        appendNamespaceToMissingKey: !1,
        appendNamespaceToCIMode: !1,
        overloadTranslationOptionHandler: (e)=>{
            let t = {};
            if (typeof e[1] == "object" && (t = e[1]), $2a051a86cb6e4743$var$Y(e[1]) && (t.defaultValue = e[1]), $2a051a86cb6e4743$var$Y(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
                const n = e[3] || e[2];
                Object.keys(n).forEach((r)=>{
                    t[r] = n[r];
                });
            }
            return t;
        },
        interpolation: {
            escapeValue: !0,
            format: (e)=>e,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1e3,
            skipOnVariables: !0
        }
    }), $2a051a86cb6e4743$var$kc = (e)=>($2a051a86cb6e4743$var$Y(e.ns) && (e.ns = [
        e.ns
    ]), $2a051a86cb6e4743$var$Y(e.fallbackLng) && (e.fallbackLng = [
        e.fallbackLng
    ]), $2a051a86cb6e4743$var$Y(e.fallbackNS) && (e.fallbackNS = [
        e.fallbackNS
    ]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat([
        "cimode"
    ])), e), $2a051a86cb6e4743$var$ys = ()=>{}, $2a051a86cb6e4743$var$Wm = (e)=>{
    Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n)=>{
        typeof e[n] == "function" && (e[n] = e[n].bind(e));
    });
};
class $2a051a86cb6e4743$var$Pi extends $2a051a86cb6e4743$var$Ro {
    constructor(){
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
        if (super(), this.options = $2a051a86cb6e4743$var$kc(t), this.services = {}, this.logger = $2a051a86cb6e4743$var$Pt, this.modules = {
            external: []
        }, $2a051a86cb6e4743$var$Wm(this), n && !this.isInitialized && !t.isClone) {
            if (!this.options.initImmediate) return this.init(t, n), this;
            setTimeout(()=>{
                this.init(t, n);
            }, 0);
        }
    }
    init() {
        var t = this;
        let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
        this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && ($2a051a86cb6e4743$var$Y(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
        const i1 = $2a051a86cb6e4743$var$Ec();
        this.options = {
            ...i1,
            ...this.options,
            ...$2a051a86cb6e4743$var$kc(n)
        }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
            ...i1.interpolation,
            ...this.options.interpolation
        }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
        const s = (c)=>c ? typeof c == "function" ? new c : c : null;
        if (!this.options.isClone) {
            this.modules.logger ? $2a051a86cb6e4743$var$Pt.init(s(this.modules.logger), this.options) : $2a051a86cb6e4743$var$Pt.init(null, this.options);
            let c;
            this.modules.formatter ? c = this.modules.formatter : typeof Intl < "u" && (c = $2a051a86cb6e4743$var$Vm);
            const d = new $2a051a86cb6e4743$var$wc(this.options);
            this.store = new $2a051a86cb6e4743$var$vc(this.options.resources, this.options);
            const f = this.services;
            f.logger = $2a051a86cb6e4743$var$Pt, f.resourceStore = this.store, f.languageUtils = d, f.pluralResolver = new $2a051a86cb6e4743$var$zm(d, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            }), c && (!this.options.interpolation.format || this.options.interpolation.format === i1.interpolation.format) && (f.formatter = s(c), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new $2a051a86cb6e4743$var$Bm(this.options), f.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            }, f.backendConnector = new $2a051a86cb6e4743$var$Km(s(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(m) {
                for(var v = arguments.length, y = new Array(v > 1 ? v - 1 : 0), k = 1; k < v; k++)y[k - 1] = arguments[k];
                t.emit(m, ...y);
            }), this.modules.languageDetector && (f.languageDetector = s(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = s(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new $2a051a86cb6e4743$var$eo(this.services, this.options), this.translator.on("*", function(m) {
                for(var v = arguments.length, y = new Array(v > 1 ? v - 1 : 0), k = 1; k < v; k++)y[k - 1] = arguments[k];
                t.emit(m, ...y);
            }), this.modules.external.forEach((m)=>{
                m.init && m.init(this);
            });
        }
        if (this.format = this.options.interpolation.format, r || (r = $2a051a86cb6e4743$var$ys), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
        }
        !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ].forEach((c)=>{
            this[c] = function() {
                return t.store[c](...arguments);
            };
        }), [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ].forEach((c)=>{
            this[c] = function() {
                return t.store[c](...arguments), t;
            };
        });
        const l = $2a051a86cb6e4743$var$Jr(), u = ()=>{
            const c = (d, f)=>{
                this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(f), r(d, f);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return c(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, c);
        };
        return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), l;
    }
    loadResources(t) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2a051a86cb6e4743$var$ys;
        const i1 = $2a051a86cb6e4743$var$Y(t) ? t : this.language;
        if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
            if (i1 && i1.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
            const s = [], o = (a)=>{
                if (!a || a === "cimode") return;
                this.services.languageUtils.toResolveHierarchy(a).forEach((u)=>{
                    u !== "cimode" && s.indexOf(u) < 0 && s.push(u);
                });
            };
            i1 ? o(i1) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l)=>o(l)), this.options.preload && this.options.preload.forEach((a)=>o(a)), this.services.backendConnector.load(s, this.options.ns, (a)=>{
                !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(a);
            });
        } else r(null);
    }
    reloadResources(t, n, r) {
        const i1 = $2a051a86cb6e4743$var$Jr();
        return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = $2a051a86cb6e4743$var$ys), this.services.backendConnector.reload(t, n, (s)=>{
            i1.resolve(), r(s);
        }), i1;
    }
    use(t) {
        if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && $2a051a86cb6e4743$var$Fd.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
    }
    setResolvedLanguage(t) {
        if (!(!t || !this.languages) && !([
            "cimode",
            "dev"
        ].indexOf(t) > -1)) for(let n = 0; n < this.languages.length; n++){
            const r = this.languages[n];
            if (!([
                "cimode",
                "dev"
            ].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
                this.resolvedLanguage = r;
                break;
            }
        }
    }
    changeLanguage(t, n) {
        var r = this;
        this.isLanguageChangingTo = t;
        const i1 = $2a051a86cb6e4743$var$Jr();
        this.emit("languageChanging", t);
        const s = (l)=>{
            this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
        }, o = (l, u)=>{
            u ? (s(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, i1.resolve(function() {
                return r.t(...arguments);
            }), n && n(l, function() {
                return r.t(...arguments);
            });
        }, a = (l)=>{
            !t && !l && this.services.languageDetector && (l = []);
            const u = $2a051a86cb6e4743$var$Y(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
            u && (this.language || s(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (c)=>{
                o(c, u);
            });
        };
        return !t && this.services.languageDetector && !this.services.languageDetector.async ? a(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(a) : this.services.languageDetector.detect(a) : a(t), i1;
    }
    getFixedT(t, n, r) {
        var i1 = this;
        const s = function(o, a) {
            let l;
            if (typeof a != "object") {
                for(var u = arguments.length, c = new Array(u > 2 ? u - 2 : 0), d = 2; d < u; d++)c[d - 2] = arguments[d];
                l = i1.options.overloadTranslationOptionHandler([
                    o,
                    a
                ].concat(c));
            } else l = {
                ...a
            };
            l.lng = l.lng || s.lng, l.lngs = l.lngs || s.lngs, l.ns = l.ns || s.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || s.keyPrefix);
            const f = i1.options.keySeparator || ".";
            let m;
            return l.keyPrefix && Array.isArray(o) ? m = o.map((v)=>`${l.keyPrefix}${f}${v}`) : m = l.keyPrefix ? `${l.keyPrefix}${f}${o}` : o, i1.t(m, l);
        };
        return $2a051a86cb6e4743$var$Y(t) ? s.lng = t : s.lngs = t, s.ns = n, s.keyPrefix = r, s;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(t) {
        this.options.defaultNS = t;
    }
    hasLoadedNamespace(t) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
        if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
        const r = n.lng || this.resolvedLanguage || this.languages[0], i1 = this.options ? this.options.fallbackLng : !1, s = this.languages[this.languages.length - 1];
        if (r.toLowerCase() === "cimode") return !0;
        const o = (a, l)=>{
            const u = this.services.backendConnector.state[`${a}|${l}`];
            return u === -1 || u === 0 || u === 2;
        };
        if (n.precheck) {
            const a = n.precheck(this, o);
            if (a !== void 0) return a;
        }
        return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, t) && (!i1 || o(s, t)));
    }
    loadNamespaces(t, n) {
        const r = $2a051a86cb6e4743$var$Jr();
        return this.options.ns ? ($2a051a86cb6e4743$var$Y(t) && (t = [
            t
        ]), t.forEach((i1)=>{
            this.options.ns.indexOf(i1) < 0 && this.options.ns.push(i1);
        }), this.loadResources((i1)=>{
            r.resolve(), n && n(i1);
        }), r) : (n && n(), Promise.resolve());
    }
    loadLanguages(t, n) {
        const r = $2a051a86cb6e4743$var$Jr();
        $2a051a86cb6e4743$var$Y(t) && (t = [
            t
        ]);
        const i1 = this.options.preload || [], s = t.filter((o)=>i1.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
        return s.length ? (this.options.preload = i1.concat(s), this.loadResources((o)=>{
            r.resolve(), n && n(o);
        }), r) : (n && n(), Promise.resolve());
    }
    dir(t) {
        if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
        const n = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ], r = this.services && this.services.languageUtils || new $2a051a86cb6e4743$var$wc($2a051a86cb6e4743$var$Ec());
        return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
        return new $2a051a86cb6e4743$var$Pi(t, n);
    }
    cloneInstance() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2a051a86cb6e4743$var$ys;
        const r = t.forkResourceStore;
        r && delete t.forkResourceStore;
        const i1 = {
            ...this.options,
            ...t,
            isClone: !0
        }, s = new $2a051a86cb6e4743$var$Pi(i1);
        return (t.debug !== void 0 || t.prefix !== void 0) && (s.logger = s.logger.clone(t)), [
            "store",
            "services",
            "language"
        ].forEach((a)=>{
            s[a] = this[a];
        }), s.services = {
            ...this.services
        }, s.services.utils = {
            hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
        }, r && (s.store = new $2a051a86cb6e4743$var$vc(this.store.data, i1), s.services.resourceStore = s.store), s.translator = new $2a051a86cb6e4743$var$eo(s.services, i1), s.translator.on("*", function(a) {
            for(var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)u[c - 1] = arguments[c];
            s.emit(a, ...u);
        }), s.init(i1, n), s.translator.options = i1, s.translator.backendConnector.services.utils = {
            hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
        }, s;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $2a051a86cb6e4743$var$le = $2a051a86cb6e4743$var$Pi.createInstance();
$2a051a86cb6e4743$var$le.createInstance = $2a051a86cb6e4743$var$Pi.createInstance;
$2a051a86cb6e4743$var$le.createInstance;
$2a051a86cb6e4743$var$le.dir;
$2a051a86cb6e4743$var$le.init;
$2a051a86cb6e4743$var$le.loadResources;
$2a051a86cb6e4743$var$le.reloadResources;
$2a051a86cb6e4743$var$le.use;
$2a051a86cb6e4743$var$le.changeLanguage;
$2a051a86cb6e4743$var$le.getFixedT;
$2a051a86cb6e4743$var$le.t;
$2a051a86cb6e4743$var$le.exists;
$2a051a86cb6e4743$var$le.setDefaultNamespace;
$2a051a86cb6e4743$var$le.hasLoadedNamespace;
$2a051a86cb6e4743$var$le.loadNamespaces;
$2a051a86cb6e4743$var$le.loadLanguages;
function $2a051a86cb6e4743$var$Ym() {
    if (console && console.warn) {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $2a051a86cb6e4743$var$Bn(t[0]) && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
    }
}
const $2a051a86cb6e4743$var$Pc = {};
function $2a051a86cb6e4743$var$Ua() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    $2a051a86cb6e4743$var$Bn(t[0]) && $2a051a86cb6e4743$var$Pc[t[0]] || ($2a051a86cb6e4743$var$Bn(t[0]) && ($2a051a86cb6e4743$var$Pc[t[0]] = new Date), $2a051a86cb6e4743$var$Ym(...t));
}
const $2a051a86cb6e4743$var$Dd = (e, t)=>()=>{
        if (e.isInitialized) t();
        else {
            const n = ()=>{
                setTimeout(()=>{
                    e.off("initialized", n);
                }, 0), t();
            };
            e.on("initialized", n);
        }
    }, $2a051a86cb6e4743$var$_c = (e, t, n)=>{
    e.loadNamespaces(t, $2a051a86cb6e4743$var$Dd(e, n));
}, $2a051a86cb6e4743$var$bc = (e, t, n, r)=>{
    $2a051a86cb6e4743$var$Bn(n) && (n = [
        n
    ]), n.forEach((i1)=>{
        e.options.ns.indexOf(i1) < 0 && e.options.ns.push(i1);
    }), e.loadLanguages(t, $2a051a86cb6e4743$var$Dd(e, r));
}, $2a051a86cb6e4743$var$qm = function(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const r = t.languages[0], i1 = t.options ? t.options.fallbackLng : !1, s = t.languages[t.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const o = (a, l)=>{
        const u = t.services.backendConnector.state[`${a}|${l}`];
        return u === -1 || u === 2;
    };
    return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !o(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || o(r, e) && (!i1 || o(s, e)));
}, $2a051a86cb6e4743$var$Gm = function(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return !t.languages || !t.languages.length ? ($2a051a86cb6e4743$var$Ua("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
        lng: n.lng,
        precheck: (i1, s)=>{
            if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && i1.services.backendConnector.backend && i1.isLanguageChangingTo && !s(i1.isLanguageChangingTo, e)) return !1;
        }
    }) : $2a051a86cb6e4743$var$qm(e, t, n);
}, $2a051a86cb6e4743$var$Bn = (e)=>typeof e == "string", $2a051a86cb6e4743$var$Xm = (e)=>typeof e == "object" && e !== null, $2a051a86cb6e4743$var$Jm = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, $2a051a86cb6e4743$var$Zm = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
}, $2a051a86cb6e4743$var$ey = (e)=>$2a051a86cb6e4743$var$Zm[e], $2a051a86cb6e4743$var$ty = (e)=>e.replace($2a051a86cb6e4743$var$Jm, $2a051a86cb6e4743$var$ey);
let $2a051a86cb6e4743$var$$a = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: !0,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: !0,
    unescape: $2a051a86cb6e4743$var$ty
};
const $2a051a86cb6e4743$var$ny = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $2a051a86cb6e4743$var$$a = {
        ...$2a051a86cb6e4743$var$$a,
        ...e
    };
}, $2a051a86cb6e4743$var$ry = ()=>$2a051a86cb6e4743$var$$a;
let $2a051a86cb6e4743$var$Ad;
const $2a051a86cb6e4743$var$iy = (e)=>{
    $2a051a86cb6e4743$var$Ad = e;
}, $2a051a86cb6e4743$var$sy = ()=>$2a051a86cb6e4743$var$Ad, $2a051a86cb6e4743$var$oy = {
    type: "3rdParty",
    init (e) {
        $2a051a86cb6e4743$var$ny(e.options.react), $2a051a86cb6e4743$var$iy(e);
    }
}, $2a051a86cb6e4743$var$ay = $2a051a86cb6e4743$var$I.createContext();
class $2a051a86cb6e4743$var$ly {
    constructor(){
        $2a051a86cb6e4743$var$bn(this, "getUsedNamespaces", ()=>Object.keys(this.usedNamespaces));
        this.usedNamespaces = {};
    }
    addUsedNamespaces(t) {
        t.forEach((n)=>{
            this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
        });
    }
}
const $2a051a86cb6e4743$var$uy = (e, t)=>{
    const n = $2a051a86cb6e4743$var$I.useRef();
    return $2a051a86cb6e4743$var$I.useEffect(()=>{
        n.current = t ? n.current : e;
    }, [
        e,
        t
    ]), n.current;
}, $2a051a86cb6e4743$var$Md = (e, t, n, r)=>e.getFixedT(t, n, r), $2a051a86cb6e4743$var$cy = (e, t, n, r)=>$2a051a86cb6e4743$var$I.useCallback($2a051a86cb6e4743$var$Md(e, t, n, r), [
        e,
        t,
        n,
        r
    ]), $2a051a86cb6e4743$var$Nt = function(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { i18n: n } = t, { i18n: r, defaultNS: i1 } = $2a051a86cb6e4743$var$I.useContext($2a051a86cb6e4743$var$ay) || {}, s = n || r || $2a051a86cb6e4743$var$sy();
    if (s && !s.reportNamespaces && (s.reportNamespaces = new $2a051a86cb6e4743$var$ly), !s) {
        $2a051a86cb6e4743$var$Ua("You will need to pass in an i18next instance by using initReactI18next");
        const E = (N, b)=>$2a051a86cb6e4743$var$Bn(b) ? b : $2a051a86cb6e4743$var$Xm(b) && $2a051a86cb6e4743$var$Bn(b.defaultValue) ? b.defaultValue : Array.isArray(N) ? N[N.length - 1] : N, P = [
            E,
            {},
            !1
        ];
        return P.t = E, P.i18n = {}, P.ready = !1, P;
    }
    s.options.react && s.options.react.wait !== void 0 && $2a051a86cb6e4743$var$Ua("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const o = {
        ...$2a051a86cb6e4743$var$ry(),
        ...s.options.react,
        ...t
    }, { useSuspense: a, keyPrefix: l } = o;
    let u = e || i1 || s.options && s.options.defaultNS;
    u = $2a051a86cb6e4743$var$Bn(u) ? [
        u
    ] : u || [
        "translation"
    ], s.reportNamespaces.addUsedNamespaces && s.reportNamespaces.addUsedNamespaces(u);
    const c = (s.isInitialized || s.initializedStoreOnce) && u.every((E)=>$2a051a86cb6e4743$var$Gm(E, s, o)), d = $2a051a86cb6e4743$var$cy(s, t.lng || null, o.nsMode === "fallback" ? u : u[0], l), f = ()=>d, m = ()=>$2a051a86cb6e4743$var$Md(s, t.lng || null, o.nsMode === "fallback" ? u : u[0], l), [v, y] = $2a051a86cb6e4743$var$I.useState(f);
    let k = u.join();
    t.lng && (k = `${t.lng}${k}`);
    const p = $2a051a86cb6e4743$var$uy(k), h = $2a051a86cb6e4743$var$I.useRef(!0);
    $2a051a86cb6e4743$var$I.useEffect(()=>{
        const { bindI18n: E, bindI18nStore: P } = o;
        h.current = !0, !c && !a && (t.lng ? $2a051a86cb6e4743$var$bc(s, t.lng, u, ()=>{
            h.current && y(m);
        }) : $2a051a86cb6e4743$var$_c(s, u, ()=>{
            h.current && y(m);
        })), c && p && p !== k && h.current && y(m);
        const N = ()=>{
            h.current && y(m);
        };
        return E && s && s.on(E, N), P && s && s.store.on(P, N), ()=>{
            h.current = !1, E && s && E.split(" ").forEach((b)=>s.off(b, N)), P && s && P.split(" ").forEach((b)=>s.store.off(b, N));
        };
    }, [
        s,
        k
    ]), $2a051a86cb6e4743$var$I.useEffect(()=>{
        h.current && c && y(f);
    }, [
        s,
        l,
        c
    ]);
    const g = [
        v,
        s,
        c
    ];
    if (g.t = v, g.i18n = s, g.ready = c, c || !c && !a) return g;
    throw new Promise((E)=>{
        t.lng ? $2a051a86cb6e4743$var$bc(s, t.lng, u, ()=>E()) : $2a051a86cb6e4743$var$_c(s, u, ()=>E());
    });
}, $2a051a86cb6e4743$var$fy = 36e5;
$2a051a86cb6e4743$var$le.use($2a051a86cb6e4743$var$Aa).use($2a051a86cb6e4743$var$Ed).use($2a051a86cb6e4743$var$Rd).use($2a051a86cb6e4743$var$oy).init({
    debug: !1,
    fallbackLng: "en",
    interpolation: {
        escapeValue: !1
    },
    react: {
        useSuspense: !0
    },
    backend: {
        backends: [
            $2a051a86cb6e4743$var$jd,
            $2a051a86cb6e4743$var$Aa
        ],
        backendOptions: [
            {
                store: typeof window < "u" ? window.localStorage : null,
                expirationTime: $2a051a86cb6e4743$var$fy
            },
            {
                loadPath: "/libs/cq/i18n/dict.{{lng}}.json"
            }
        ]
    },
    detection: {
        order: [
            "htmlTag"
        ]
    },
    initImmediate: !1
});
var $2a051a86cb6e4743$var$ss = class {
    constructor(){
        this.listeners = new Set, this.subscribe = this.subscribe.bind(this);
    }
    subscribe(e) {
        return this.listeners.add(e), this.onSubscribe(), ()=>{
            this.listeners.delete(e), this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}, $2a051a86cb6e4743$var$Kn = typeof window > "u" || "Deno" in globalThis;
function $2a051a86cb6e4743$var$Ze() {}
function $2a051a86cb6e4743$var$dy(e, t) {
    return typeof e == "function" ? e(t) : e;
}
function $2a051a86cb6e4743$var$za(e) {
    return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function $2a051a86cb6e4743$var$Ud(e, t) {
    return Math.max(e + (t || 0) - Date.now(), 0);
}
function $2a051a86cb6e4743$var$yr(e, t) {
    return typeof e == "function" ? e(t) : e;
}
function $2a051a86cb6e4743$var$dt(e, t) {
    return typeof e == "function" ? e(t) : e;
}
function $2a051a86cb6e4743$var$Oc(e, t) {
    const { type: n = "all", exact: r, fetchStatus: i1, predicate: s, queryKey: o, stale: a } = e;
    if (o) {
        if (r) {
            if (t.queryHash !== $2a051a86cb6e4743$var$Gl(o, t.options)) return !1;
        } else if (!$2a051a86cb6e4743$var$bi(t.queryKey, o)) return !1;
    }
    if (n !== "all") {
        const l = t.isActive();
        if (n === "active" && !l || n === "inactive" && l) return !1;
    }
    return !(typeof a == "boolean" && t.isStale() !== a || i1 && i1 !== t.state.fetchStatus || s && !s(t));
}
function $2a051a86cb6e4743$var$Nc(e, t) {
    const { exact: n, status: r, predicate: i1, mutationKey: s } = e;
    if (s) {
        if (!t.options.mutationKey) return !1;
        if (n) {
            if ($2a051a86cb6e4743$var$_i(t.options.mutationKey) !== $2a051a86cb6e4743$var$_i(s)) return !1;
        } else if (!$2a051a86cb6e4743$var$bi(t.options.mutationKey, s)) return !1;
    }
    return !(r && t.state.status !== r || i1 && !i1(t));
}
function $2a051a86cb6e4743$var$Gl(e, t) {
    return ((t == null ? void 0 : t.queryKeyHashFn) || $2a051a86cb6e4743$var$_i)(e);
}
function $2a051a86cb6e4743$var$_i(e) {
    return JSON.stringify(e, (t, n)=>$2a051a86cb6e4743$var$Ha(n) ? Object.keys(n).sort().reduce((r, i1)=>(r[i1] = n[i1], r), {}) : n);
}
function $2a051a86cb6e4743$var$bi(e, t) {
    return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n)=>!$2a051a86cb6e4743$var$bi(e[n], t[n])) : !1;
}
function $2a051a86cb6e4743$var$$d(e, t) {
    if (e === t) return e;
    const n = $2a051a86cb6e4743$var$Tc(e) && $2a051a86cb6e4743$var$Tc(t);
    if (n || $2a051a86cb6e4743$var$Ha(e) && $2a051a86cb6e4743$var$Ha(t)) {
        const r = n ? e : Object.keys(e), i1 = r.length, s = n ? t : Object.keys(t), o = s.length, a = n ? [] : {};
        let l = 0;
        for(let u = 0; u < o; u++){
            const c = n ? u : s[u];
            (!n && r.includes(c) || n) && e[c] === void 0 && t[c] === void 0 ? (a[c] = void 0, l++) : (a[c] = $2a051a86cb6e4743$var$$d(e[c], t[c]), a[c] === e[c] && e[c] !== void 0 && l++);
        }
        return i1 === o && l === i1 ? e : a;
    }
    return t;
}
function $2a051a86cb6e4743$var$Ba(e, t) {
    if (!t || Object.keys(e).length !== Object.keys(t).length) return !1;
    for(const n in e)if (e[n] !== t[n]) return !1;
    return !0;
}
function $2a051a86cb6e4743$var$Tc(e) {
    return Array.isArray(e) && e.length === Object.keys(e).length;
}
function $2a051a86cb6e4743$var$Ha(e) {
    if (!$2a051a86cb6e4743$var$Lc(e)) return !1;
    const t = e.constructor;
    if (t === void 0) return !0;
    const n = t.prototype;
    return !(!$2a051a86cb6e4743$var$Lc(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function $2a051a86cb6e4743$var$Lc(e) {
    return Object.prototype.toString.call(e) === "[object Object]";
}
function $2a051a86cb6e4743$var$hy(e) {
    return new Promise((t)=>{
        setTimeout(t, e);
    });
}
function $2a051a86cb6e4743$var$Va(e, t, n) {
    return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? $2a051a86cb6e4743$var$$d(e, t) : t;
}
function $2a051a86cb6e4743$var$py(e, t, n = 0) {
    const r = [
        ...e,
        t
    ];
    return n && r.length > n ? r.slice(1) : r;
}
function $2a051a86cb6e4743$var$gy(e, t, n = 0) {
    const r = [
        t,
        ...e
    ];
    return n && r.length > n ? r.slice(0, -1) : r;
}
var $2a051a86cb6e4743$var$Xl = Symbol();
function $2a051a86cb6e4743$var$zd(e, t) {
    return !e.queryFn && t != null && t.initialPromise ? ()=>t.initialPromise : !e.queryFn || e.queryFn === $2a051a86cb6e4743$var$Xl ? ()=>Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var $2a051a86cb6e4743$var$jn, $2a051a86cb6e4743$var$nn, $2a051a86cb6e4743$var$kr, $2a051a86cb6e4743$var$Jf, $2a051a86cb6e4743$var$my = ($2a051a86cb6e4743$var$Jf = class extends $2a051a86cb6e4743$var$ss {
    constructor(){
        super();
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$jn, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$nn, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$kr, void 0);
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$kr, (t)=>{
            if (!$2a051a86cb6e4743$var$Kn && window.addEventListener) {
                const n = ()=>t();
                return window.addEventListener("visibilitychange", n, !1), ()=>{
                    window.removeEventListener("visibilitychange", n);
                };
            }
        });
    }
    onSubscribe() {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$nn) || this.setEventListener($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$kr));
    }
    onUnsubscribe() {
        var t;
        this.hasListeners() || ((t = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$nn)) == null || t.call(this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$nn, void 0));
    }
    setEventListener(t) {
        var n;
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$kr, t), (n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$nn)) == null || n.call(this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$nn, t((r)=>{
            typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
        }));
    }
    setFocused(t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$jn) !== t && ($2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$jn, t), this.onFocus());
    }
    onFocus() {
        const t = this.isFocused();
        this.listeners.forEach((n)=>{
            n(t);
        });
    }
    isFocused() {
        var t;
        return typeof $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$jn) == "boolean" ? $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$jn) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
    }
}, $2a051a86cb6e4743$var$jn = new WeakMap, $2a051a86cb6e4743$var$nn = new WeakMap, $2a051a86cb6e4743$var$kr = new WeakMap, $2a051a86cb6e4743$var$Jf), $2a051a86cb6e4743$var$Jl = new $2a051a86cb6e4743$var$my, $2a051a86cb6e4743$var$Pr, $2a051a86cb6e4743$var$rn, $2a051a86cb6e4743$var$_r, $2a051a86cb6e4743$var$Zf, $2a051a86cb6e4743$var$yy = ($2a051a86cb6e4743$var$Zf = class extends $2a051a86cb6e4743$var$ss {
    constructor(){
        super();
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Pr, !0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$rn, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$_r, void 0);
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$_r, (t)=>{
            if (!$2a051a86cb6e4743$var$Kn && window.addEventListener) {
                const n = ()=>t(!0), r = ()=>t(!1);
                return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), ()=>{
                    window.removeEventListener("online", n), window.removeEventListener("offline", r);
                };
            }
        });
    }
    onSubscribe() {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$rn) || this.setEventListener($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$_r));
    }
    onUnsubscribe() {
        var t;
        this.hasListeners() || ((t = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$rn)) == null || t.call(this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$rn, void 0));
    }
    setEventListener(t) {
        var n;
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$_r, t), (n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$rn)) == null || n.call(this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$rn, t(this.setOnline.bind(this)));
    }
    setOnline(t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Pr) !== t && ($2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Pr, t), this.listeners.forEach((r)=>{
            r(t);
        }));
    }
    isOnline() {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Pr);
    }
}, $2a051a86cb6e4743$var$Pr = new WeakMap, $2a051a86cb6e4743$var$rn = new WeakMap, $2a051a86cb6e4743$var$_r = new WeakMap, $2a051a86cb6e4743$var$Zf), $2a051a86cb6e4743$var$to = new $2a051a86cb6e4743$var$yy;
function $2a051a86cb6e4743$var$Qa() {
    let e, t;
    const n = new Promise((i1, s)=>{
        e = i1, t = s;
    });
    n.status = "pending", n.catch(()=>{});
    function r(i1) {
        Object.assign(n, i1), delete n.resolve, delete n.reject;
    }
    return n.resolve = (i1)=>{
        r({
            status: "fulfilled",
            value: i1
        }), e(i1);
    }, n.reject = (i1)=>{
        r({
            status: "rejected",
            reason: i1
        }), t(i1);
    }, n;
}
function $2a051a86cb6e4743$var$vy(e) {
    return Math.min(1e3 * 2 ** e, 3e4);
}
function $2a051a86cb6e4743$var$Bd(e) {
    return (e ?? "online") === "online" ? $2a051a86cb6e4743$var$to.isOnline() : !0;
}
var $2a051a86cb6e4743$var$Hd = class extends Error {
    constructor(e){
        super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
    }
};
function $2a051a86cb6e4743$var$aa(e) {
    return e instanceof $2a051a86cb6e4743$var$Hd;
}
function $2a051a86cb6e4743$var$Vd(e) {
    let t = !1, n = 0, r = !1, i1;
    const s = $2a051a86cb6e4743$var$Qa(), o = (y)=>{
        var k;
        r || (f(new $2a051a86cb6e4743$var$Hd(y)), (k = e.abort) == null || k.call(e));
    }, a = ()=>{
        t = !0;
    }, l = ()=>{
        t = !1;
    }, u = ()=>$2a051a86cb6e4743$var$Jl.isFocused() && (e.networkMode === "always" || $2a051a86cb6e4743$var$to.isOnline()) && e.canRun(), c = ()=>$2a051a86cb6e4743$var$Bd(e.networkMode) && e.canRun(), d = (y)=>{
        var k;
        r || (r = !0, (k = e.onSuccess) == null || k.call(e, y), i1 == null || i1(), s.resolve(y));
    }, f = (y)=>{
        var k;
        r || (r = !0, (k = e.onError) == null || k.call(e, y), i1 == null || i1(), s.reject(y));
    }, m = ()=>new Promise((y)=>{
            var k;
            i1 = (p)=>{
                (r || u()) && y(p);
            }, (k = e.onPause) == null || k.call(e);
        }).then(()=>{
            var y;
            i1 = void 0, r || (y = e.onContinue) == null || y.call(e);
        }), v = ()=>{
        if (r) return;
        let y;
        const k = n === 0 ? e.initialPromise : void 0;
        try {
            y = k ?? e.fn();
        } catch (p) {
            y = Promise.reject(p);
        }
        Promise.resolve(y).then(d).catch((p)=>{
            var N;
            if (r) return;
            const h = e.retry ?? ($2a051a86cb6e4743$var$Kn ? 0 : 3), g = e.retryDelay ?? $2a051a86cb6e4743$var$vy, E = typeof g == "function" ? g(n, p) : g, P = h === !0 || typeof h == "number" && n < h || typeof h == "function" && h(n, p);
            if (t || !P) {
                f(p);
                return;
            }
            n++, (N = e.onFail) == null || N.call(e, n, p), $2a051a86cb6e4743$var$hy(E).then(()=>u() ? void 0 : m()).then(()=>{
                t ? f(p) : v();
            });
        });
    };
    return {
        promise: s,
        cancel: o,
        continue: ()=>(i1 == null || i1(), s),
        cancelRetry: a,
        continueRetry: l,
        canStart: c,
        start: ()=>(c() ? v() : m().then(v), s)
    };
}
function $2a051a86cb6e4743$var$Sy() {
    let e = [], t = 0, n = (a)=>{
        a();
    }, r = (a)=>{
        a();
    }, i1 = (a)=>setTimeout(a, 0);
    const s = (a)=>{
        t ? e.push(a) : i1(()=>{
            n(a);
        });
    }, o = ()=>{
        const a = e;
        e = [], a.length && i1(()=>{
            r(()=>{
                a.forEach((l)=>{
                    n(l);
                });
            });
        });
    };
    return {
        batch: (a)=>{
            let l;
            t++;
            try {
                l = a();
            } finally{
                t--, t || o();
            }
            return l;
        },
        batchCalls: (a)=>(...l)=>{
                s(()=>{
                    a(...l);
                });
            },
        schedule: s,
        setNotifyFunction: (a)=>{
            n = a;
        },
        setBatchNotifyFunction: (a)=>{
            r = a;
        },
        setScheduler: (a)=>{
            i1 = a;
        }
    };
}
var $2a051a86cb6e4743$var$Ce = $2a051a86cb6e4743$var$Sy(), $2a051a86cb6e4743$var$In, $2a051a86cb6e4743$var$ed, $2a051a86cb6e4743$var$Qd = ($2a051a86cb6e4743$var$ed = class {
    constructor(){
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$In, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout(), $2a051a86cb6e4743$var$za(this.gcTime) && $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$In, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(e) {
        this.gcTime = Math.max(this.gcTime || 0, e ?? ($2a051a86cb6e4743$var$Kn ? 1 / 0 : 300000));
    }
    clearGcTimeout() {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$In) && (clearTimeout($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$In)), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$In, void 0));
    }
}, $2a051a86cb6e4743$var$In = new WeakMap, $2a051a86cb6e4743$var$ed), $2a051a86cb6e4743$var$br, $2a051a86cb6e4743$var$Or, $2a051a86cb6e4743$var$Je, $2a051a86cb6e4743$var$Fn, $2a051a86cb6e4743$var$be, $2a051a86cb6e4743$var$Wi, $2a051a86cb6e4743$var$Dn, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt, $2a051a86cb6e4743$var$td, $2a051a86cb6e4743$var$wy = ($2a051a86cb6e4743$var$td = class extends $2a051a86cb6e4743$var$Qd {
    constructor(t){
        super();
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$ut);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$br, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Or, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Je, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Fn, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$be, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Wi, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Dn, void 0);
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Dn, !1), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Wi, t.defaultOptions), this.setOptions(t.options), this.observers = [], $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Fn, t.client), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Je, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Fn).getQueryCache()), this.queryKey = t.queryKey, this.queryHash = t.queryHash, $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$br, $2a051a86cb6e4743$var$xy(this.options)), this.state = t.state ?? $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$br), this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var t;
        return (t = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be)) == null ? void 0 : t.promise;
    }
    setOptions(t) {
        this.options = {
            ...$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Wi),
            ...t
        }, this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        !this.observers.length && this.state.fetchStatus === "idle" && $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).remove(this);
    }
    setData(t, n) {
        const r = $2a051a86cb6e4743$var$Va(this.state.data, t, this.options);
        return $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
            data: r,
            type: "success",
            dataUpdatedAt: n == null ? void 0 : n.updatedAt,
            manual: n == null ? void 0 : n.manual
        }), r;
    }
    setState(t, n) {
        $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
            type: "setState",
            state: t,
            setStateOptions: n
        });
    }
    cancel(t) {
        var r, i1;
        const n = (r = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be)) == null ? void 0 : r.promise;
        return (i1 = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be)) == null || i1.cancel(t), n ? n.then($2a051a86cb6e4743$var$Ze).catch($2a051a86cb6e4743$var$Ze) : Promise.resolve();
    }
    destroy() {
        super.destroy(), this.cancel({
            silent: !0
        });
    }
    reset() {
        this.destroy(), this.setState($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$br));
    }
    isActive() {
        return this.observers.some((t)=>$2a051a86cb6e4743$var$dt(t.options.enabled, this) !== !1);
    }
    isDisabled() {
        return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === $2a051a86cb6e4743$var$Xl || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some((t)=>t.getCurrentResult().isStale) : this.state.data === void 0;
    }
    isStaleByTime(t = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !$2a051a86cb6e4743$var$Ud(this.state.dataUpdatedAt, t);
    }
    onFocus() {
        var n;
        const t = this.observers.find((r)=>r.shouldFetchOnWindowFocus());
        t == null || t.refetch({
            cancelRefetch: !1
        }), (n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be)) == null || n.continue();
    }
    onOnline() {
        var n;
        const t = this.observers.find((r)=>r.shouldFetchOnReconnect());
        t == null || t.refetch({
            cancelRefetch: !1
        }), (n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be)) == null || n.continue();
    }
    addObserver(t) {
        this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).notify({
            type: "observerAdded",
            query: this,
            observer: t
        }));
    }
    removeObserver(t) {
        this.observers.includes(t) && (this.observers = this.observers.filter((n)=>n !== t), this.observers.length || ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be) && ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Dn) ? $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be).cancel({
            revert: !0
        }) : $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be).cancelRetry()), this.scheduleGc()), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).notify({
            type: "observerRemoved",
            query: this,
            observer: t
        }));
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        this.state.isInvalidated || $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
            type: "invalidate"
        });
    }
    fetch(t, n) {
        var l, u, c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && n != null && n.cancelRefetch) this.cancel({
                silent: !0
            });
            else if ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be)) return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be).continueRetry(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be).promise;
        }
        if (t && this.setOptions(t), !this.options.queryFn) {
            const d = this.observers.find((f)=>f.options.queryFn);
            d && this.setOptions(d.options);
        }
        const r = new AbortController, i1 = (d)=>{
            Object.defineProperty(d, "signal", {
                enumerable: !0,
                get: ()=>($2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Dn, !0), r.signal)
            });
        }, s = ()=>{
            const d = $2a051a86cb6e4743$var$zd(this.options, n), f = {
                client: $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Fn),
                queryKey: this.queryKey,
                meta: this.meta
            };
            return i1(f), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Dn, !1), this.options.persister ? this.options.persister(d, f, this) : d(f);
        }, o = {
            fetchOptions: n,
            options: this.options,
            queryKey: this.queryKey,
            client: $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Fn),
            state: this.state,
            fetchFn: s
        };
        i1(o), (l = this.options.behavior) == null || l.onFetch(o, this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Or, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = o.fetchOptions) == null ? void 0 : u.meta)) && $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
            type: "fetch",
            meta: (c = o.fetchOptions) == null ? void 0 : c.meta
        });
        const a = (d)=>{
            var f, m, v, y;
            $2a051a86cb6e4743$var$aa(d) && d.silent || $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
                type: "error",
                error: d
            }), $2a051a86cb6e4743$var$aa(d) || ((m = (f = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).config).onError) == null || m.call(f, d, this), (y = (v = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).config).onSettled) == null || y.call(v, this.state.data, d, this)), this.scheduleGc();
        };
        return $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$be, $2a051a86cb6e4743$var$Vd({
            initialPromise: n == null ? void 0 : n.initialPromise,
            fn: o.fetchFn,
            abort: r.abort.bind(r),
            onSuccess: (d)=>{
                var f, m, v, y;
                if (d === void 0) {
                    a(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(d);
                } catch (k) {
                    a(k);
                    return;
                }
                (m = (f = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).config).onSuccess) == null || m.call(f, d, this), (y = (v = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).config).onSettled) == null || y.call(v, d, this.state.error, this), this.scheduleGc();
            },
            onError: a,
            onFail: (d, f)=>{
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
                    type: "failed",
                    failureCount: d,
                    error: f
                });
            },
            onPause: ()=>{
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ut, $2a051a86cb6e4743$var$Tt).call(this, {
                    type: "continue"
                });
            },
            retry: o.options.retry,
            retryDelay: o.options.retryDelay,
            networkMode: o.options.networkMode,
            canRun: ()=>!0
        })), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$be).start();
    }
}, $2a051a86cb6e4743$var$br = new WeakMap, $2a051a86cb6e4743$var$Or = new WeakMap, $2a051a86cb6e4743$var$Je = new WeakMap, $2a051a86cb6e4743$var$Fn = new WeakMap, $2a051a86cb6e4743$var$be = new WeakMap, $2a051a86cb6e4743$var$Wi = new WeakMap, $2a051a86cb6e4743$var$Dn = new WeakMap, $2a051a86cb6e4743$var$ut = new WeakSet, $2a051a86cb6e4743$var$Tt = function(t) {
    const n = (r)=>{
        switch(t.type){
            case "failed":
                return {
                    ...r,
                    fetchFailureCount: t.failureCount,
                    fetchFailureReason: t.error
                };
            case "pause":
                return {
                    ...r,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...r,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...r,
                    ...$2a051a86cb6e4743$var$Kd(r.data, this.options),
                    fetchMeta: t.meta ?? null
                };
            case "success":
                return {
                    ...r,
                    data: t.data,
                    dataUpdateCount: r.dataUpdateCount + 1,
                    dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: !1,
                    status: "success",
                    ...!t.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const i1 = t.error;
                return $2a051a86cb6e4743$var$aa(i1) && i1.revert && $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Or) ? {
                    ...$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Or),
                    fetchStatus: "idle"
                } : {
                    ...r,
                    error: i1,
                    errorUpdateCount: r.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: r.fetchFailureCount + 1,
                    fetchFailureReason: i1,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...r,
                    isInvalidated: !0
                };
            case "setState":
                return {
                    ...r,
                    ...t.state
                };
        }
    };
    this.state = n(this.state), $2a051a86cb6e4743$var$Ce.batch(()=>{
        this.observers.forEach((r)=>{
            r.onQueryUpdate();
        }), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Je).notify({
            query: this,
            type: "updated",
            action: t
        });
    });
}, $2a051a86cb6e4743$var$td);
function $2a051a86cb6e4743$var$Kd(e, t) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: $2a051a86cb6e4743$var$Bd(t.networkMode) ? "fetching" : "paused",
        ...e === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $2a051a86cb6e4743$var$xy(e) {
    const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
    return {
        data: t,
        dataUpdateCount: 0,
        dataUpdatedAt: n ? r ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: !1,
        status: n ? "success" : "pending",
        fetchStatus: "idle"
    };
}
var $2a051a86cb6e4743$var$wt, $2a051a86cb6e4743$var$nd, $2a051a86cb6e4743$var$Cy = ($2a051a86cb6e4743$var$nd = class extends $2a051a86cb6e4743$var$ss {
    constructor(t = {}){
        super();
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$wt, void 0);
        this.config = t, $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$wt, new Map);
    }
    build(t, n, r) {
        const i1 = n.queryKey, s = n.queryHash ?? $2a051a86cb6e4743$var$Gl(i1, n);
        let o = this.get(s);
        return o || (o = new $2a051a86cb6e4743$var$wy({
            client: t,
            queryKey: i1,
            queryHash: s,
            options: t.defaultQueryOptions(n),
            state: r,
            defaultOptions: t.getQueryDefaults(i1)
        }), this.add(o)), o;
    }
    add(t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$wt).has(t.queryHash) || ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$wt).set(t.queryHash, t), this.notify({
            type: "added",
            query: t
        }));
    }
    remove(t) {
        const n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$wt).get(t.queryHash);
        n && (t.destroy(), n === t && $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$wt).delete(t.queryHash), this.notify({
            type: "removed",
            query: t
        }));
    }
    clear() {
        $2a051a86cb6e4743$var$Ce.batch(()=>{
            this.getAll().forEach((t)=>{
                this.remove(t);
            });
        });
    }
    get(t) {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$wt).get(t);
    }
    getAll() {
        return [
            ...$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$wt).values()
        ];
    }
    find(t) {
        const n = {
            exact: !0,
            ...t
        };
        return this.getAll().find((r)=>$2a051a86cb6e4743$var$Oc(n, r));
    }
    findAll(t = {}) {
        const n = this.getAll();
        return Object.keys(t).length > 0 ? n.filter((r)=>$2a051a86cb6e4743$var$Oc(t, r)) : n;
    }
    notify(t) {
        $2a051a86cb6e4743$var$Ce.batch(()=>{
            this.listeners.forEach((n)=>{
                n(t);
            });
        });
    }
    onFocus() {
        $2a051a86cb6e4743$var$Ce.batch(()=>{
            this.getAll().forEach((t)=>{
                t.onFocus();
            });
        });
    }
    onOnline() {
        $2a051a86cb6e4743$var$Ce.batch(()=>{
            this.getAll().forEach((t)=>{
                t.onOnline();
            });
        });
    }
}, $2a051a86cb6e4743$var$wt = new WeakMap, $2a051a86cb6e4743$var$nd), $2a051a86cb6e4743$var$xt, $2a051a86cb6e4743$var$Le, $2a051a86cb6e4743$var$An, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt, $2a051a86cb6e4743$var$rd, $2a051a86cb6e4743$var$Ey = ($2a051a86cb6e4743$var$rd = class extends $2a051a86cb6e4743$var$Qd {
    constructor(t){
        super();
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Ct);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$xt, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Le, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$An, void 0);
        this.mutationId = t.mutationId, $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Le, t.mutationCache), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$xt, []), this.state = t.state || $2a051a86cb6e4743$var$ky(), this.setOptions(t.options), this.scheduleGc();
    }
    setOptions(t) {
        this.options = t, this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$xt).includes(t) || ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$xt).push(t), this.clearGcTimeout(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).notify({
            type: "observerAdded",
            mutation: this,
            observer: t
        }));
    }
    removeObserver(t) {
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$xt, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$xt).filter((n)=>n !== t)), this.scheduleGc(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).notify({
            type: "observerRemoved",
            mutation: this,
            observer: t
        });
    }
    optionalRemove() {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$xt).length || (this.state.status === "pending" ? this.scheduleGc() : $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).remove(this));
    }
    continue() {
        var t;
        return ((t = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$An)) == null ? void 0 : t.continue()) ?? this.execute(this.state.variables);
    }
    async execute(t) {
        var i1, s, o, a, l, u, c, d, f, m, v, y, k, p, h, g, E, P, N, b;
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$An, $2a051a86cb6e4743$var$Vd({
            fn: ()=>this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
            onFail: (R, D)=>{
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt).call(this, {
                    type: "failed",
                    failureCount: R,
                    error: D
                });
            },
            onPause: ()=>{
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).canRun(this)
        }));
        const n = this.state.status === "pending", r = !$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$An).canStart();
        try {
            if (!n) {
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt).call(this, {
                    type: "pending",
                    variables: t,
                    isPaused: r
                }), await ((s = (i1 = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).config).onMutate) == null ? void 0 : s.call(i1, t, this));
                const D = await ((a = (o = this.options).onMutate) == null ? void 0 : a.call(o, t));
                D !== this.state.context && $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt).call(this, {
                    type: "pending",
                    context: D,
                    variables: t,
                    isPaused: r
                });
            }
            const R = await $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$An).start();
            return await ((u = (l = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).config).onSuccess) == null ? void 0 : u.call(l, R, t, this.state.context, this)), await ((d = (c = this.options).onSuccess) == null ? void 0 : d.call(c, R, t, this.state.context)), await ((m = (f = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).config).onSettled) == null ? void 0 : m.call(f, R, null, this.state.variables, this.state.context, this)), await ((y = (v = this.options).onSettled) == null ? void 0 : y.call(v, R, null, t, this.state.context)), $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt).call(this, {
                type: "success",
                data: R
            }), R;
        } catch (R) {
            try {
                throw await ((p = (k = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).config).onError) == null ? void 0 : p.call(k, R, t, this.state.context, this)), await ((g = (h = this.options).onError) == null ? void 0 : g.call(h, R, t, this.state.context)), await ((P = (E = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).config).onSettled) == null ? void 0 : P.call(E, void 0, R, this.state.variables, this.state.context, this)), await ((b = (N = this.options).onSettled) == null ? void 0 : b.call(N, void 0, R, t, this.state.context)), R;
            } finally{
                $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ct, $2a051a86cb6e4743$var$Gt).call(this, {
                    type: "error",
                    error: R
                });
            }
        } finally{
            $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).runNext(this);
        }
    }
}, $2a051a86cb6e4743$var$xt = new WeakMap, $2a051a86cb6e4743$var$Le = new WeakMap, $2a051a86cb6e4743$var$An = new WeakMap, $2a051a86cb6e4743$var$Ct = new WeakSet, $2a051a86cb6e4743$var$Gt = function(t) {
    const n = (r)=>{
        switch(t.type){
            case "failed":
                return {
                    ...r,
                    failureCount: t.failureCount,
                    failureReason: t.error
                };
            case "pause":
                return {
                    ...r,
                    isPaused: !0
                };
            case "continue":
                return {
                    ...r,
                    isPaused: !1
                };
            case "pending":
                return {
                    ...r,
                    context: t.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: t.isPaused,
                    status: "pending",
                    variables: t.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...r,
                    data: t.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: !1
                };
            case "error":
                return {
                    ...r,
                    data: void 0,
                    error: t.error,
                    failureCount: r.failureCount + 1,
                    failureReason: t.error,
                    isPaused: !1,
                    status: "error"
                };
        }
    };
    this.state = n(this.state), $2a051a86cb6e4743$var$Ce.batch(()=>{
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$xt).forEach((r)=>{
            r.onMutationUpdate(t);
        }), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Le).notify({
            mutation: this,
            type: "updated",
            action: t
        });
    });
}, $2a051a86cb6e4743$var$rd);
function $2a051a86cb6e4743$var$ky() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: !1,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}
var $2a051a86cb6e4743$var$Ft, $2a051a86cb6e4743$var$ct, $2a051a86cb6e4743$var$Yi, $2a051a86cb6e4743$var$id, $2a051a86cb6e4743$var$Py = ($2a051a86cb6e4743$var$id = class extends $2a051a86cb6e4743$var$ss {
    constructor(t = {}){
        super();
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Ft, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$ct, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Yi, void 0);
        this.config = t, $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Ft, new Set), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$ct, new Map), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Yi, 0);
    }
    build(t, n, r) {
        const i1 = new $2a051a86cb6e4743$var$Ey({
            mutationCache: this,
            mutationId: ++$2a051a86cb6e4743$var$ps(this, $2a051a86cb6e4743$var$Yi)._,
            options: t.defaultMutationOptions(n),
            state: r
        });
        return this.add(i1), i1;
    }
    add(t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ft).add(t);
        const n = $2a051a86cb6e4743$var$vs(t);
        if (typeof n == "string") {
            const r = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ct).get(n);
            r ? r.push(t) : $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ct).set(n, [
                t
            ]);
        }
        this.notify({
            type: "added",
            mutation: t
        });
    }
    remove(t) {
        if ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ft).delete(t)) {
            const n = $2a051a86cb6e4743$var$vs(t);
            if (typeof n == "string") {
                const r = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ct).get(n);
                if (r) {
                    if (r.length > 1) {
                        const i1 = r.indexOf(t);
                        i1 !== -1 && r.splice(i1, 1);
                    } else r[0] === t && $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ct).delete(n);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: t
        });
    }
    canRun(t) {
        const n = $2a051a86cb6e4743$var$vs(t);
        if (typeof n == "string") {
            const r = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ct).get(n), i1 = r == null ? void 0 : r.find((s)=>s.state.status === "pending");
            return !i1 || i1 === t;
        } else return !0;
    }
    runNext(t) {
        var r;
        const n = $2a051a86cb6e4743$var$vs(t);
        if (typeof n == "string") {
            const i1 = (r = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ct).get(n)) == null ? void 0 : r.find((s)=>s !== t && s.state.isPaused);
            return (i1 == null ? void 0 : i1.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        $2a051a86cb6e4743$var$Ce.batch(()=>{
            $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ft).forEach((t)=>{
                this.notify({
                    type: "removed",
                    mutation: t
                });
            }), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ft).clear(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ct).clear();
        });
    }
    getAll() {
        return Array.from($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ft));
    }
    find(t) {
        const n = {
            exact: !0,
            ...t
        };
        return this.getAll().find((r)=>$2a051a86cb6e4743$var$Nc(n, r));
    }
    findAll(t = {}) {
        return this.getAll().filter((n)=>$2a051a86cb6e4743$var$Nc(t, n));
    }
    notify(t) {
        $2a051a86cb6e4743$var$Ce.batch(()=>{
            this.listeners.forEach((n)=>{
                n(t);
            });
        });
    }
    resumePausedMutations() {
        const t = this.getAll().filter((n)=>n.state.isPaused);
        return $2a051a86cb6e4743$var$Ce.batch(()=>Promise.all(t.map((n)=>n.continue().catch($2a051a86cb6e4743$var$Ze))));
    }
}, $2a051a86cb6e4743$var$Ft = new WeakMap, $2a051a86cb6e4743$var$ct = new WeakMap, $2a051a86cb6e4743$var$Yi = new WeakMap, $2a051a86cb6e4743$var$id);
function $2a051a86cb6e4743$var$vs(e) {
    var t;
    return (t = e.options.scope) == null ? void 0 : t.id;
}
function $2a051a86cb6e4743$var$Rc(e) {
    return {
        onFetch: (t, n)=>{
            var c, d, f, m, v;
            const r = t.options, i1 = (f = (d = (c = t.fetchOptions) == null ? void 0 : c.meta) == null ? void 0 : d.fetchMore) == null ? void 0 : f.direction, s = ((m = t.state.data) == null ? void 0 : m.pages) || [], o = ((v = t.state.data) == null ? void 0 : v.pageParams) || [];
            let a = {
                pages: [],
                pageParams: []
            }, l = 0;
            const u = async ()=>{
                let y = !1;
                const k = (g)=>{
                    Object.defineProperty(g, "signal", {
                        enumerable: !0,
                        get: ()=>(t.signal.aborted ? y = !0 : t.signal.addEventListener("abort", ()=>{
                                y = !0;
                            }), t.signal)
                    });
                }, p = $2a051a86cb6e4743$var$zd(t.options, t.fetchOptions), h = async (g, E, P)=>{
                    if (y) return Promise.reject();
                    if (E == null && g.pages.length) return Promise.resolve(g);
                    const N = {
                        client: t.client,
                        queryKey: t.queryKey,
                        pageParam: E,
                        direction: P ? "backward" : "forward",
                        meta: t.options.meta
                    };
                    k(N);
                    const b = await p(N), { maxPages: R } = t.options, D = P ? $2a051a86cb6e4743$var$gy : $2a051a86cb6e4743$var$py;
                    return {
                        pages: D(g.pages, b, R),
                        pageParams: D(g.pageParams, E, R)
                    };
                };
                if (i1 && s.length) {
                    const g = i1 === "backward", E = g ? $2a051a86cb6e4743$var$_y : $2a051a86cb6e4743$var$jc, P = {
                        pages: s,
                        pageParams: o
                    }, N = E(r, P);
                    a = await h(P, N, g);
                } else {
                    const g = e ?? s.length;
                    do {
                        const E = l === 0 ? o[0] ?? r.initialPageParam : $2a051a86cb6e4743$var$jc(r, a);
                        if (l > 0 && E == null) break;
                        a = await h(a, E), l++;
                    }while (l < g);
                }
                return a;
            };
            t.options.persister ? t.fetchFn = ()=>{
                var y, k;
                return (k = (y = t.options).persister) == null ? void 0 : k.call(y, u, {
                    client: t.client,
                    queryKey: t.queryKey,
                    meta: t.options.meta,
                    signal: t.signal
                }, n);
            } : t.fetchFn = u;
        }
    };
}
function $2a051a86cb6e4743$var$jc(e, { pages: t, pageParams: n }) {
    const r = t.length - 1;
    return t.length > 0 ? e.getNextPageParam(t[r], t, n[r], n) : void 0;
}
function $2a051a86cb6e4743$var$_y(e, { pages: t, pageParams: n }) {
    var r;
    return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var $2a051a86cb6e4743$var$fe, $2a051a86cb6e4743$var$sn, $2a051a86cb6e4743$var$on, $2a051a86cb6e4743$var$Nr, $2a051a86cb6e4743$var$Tr, $2a051a86cb6e4743$var$an, $2a051a86cb6e4743$var$Lr, $2a051a86cb6e4743$var$Rr, $2a051a86cb6e4743$var$sd, $2a051a86cb6e4743$var$jo = ($2a051a86cb6e4743$var$sd = class {
    constructor(e = {}){
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$fe, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$sn, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$on, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Nr, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Tr, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$an, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Lr, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Rr, void 0);
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$fe, e.queryCache || new $2a051a86cb6e4743$var$Cy), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$sn, e.mutationCache || new $2a051a86cb6e4743$var$Py), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$on, e.defaultOptions || {}), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Nr, new Map), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Tr, new Map), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$an, 0);
    }
    mount() {
        $2a051a86cb6e4743$var$ps(this, $2a051a86cb6e4743$var$an)._++, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$an) === 1 && ($2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Lr, $2a051a86cb6e4743$var$Jl.subscribe(async (e)=>{
            e && (await this.resumePausedMutations(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).onFocus());
        })), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Rr, $2a051a86cb6e4743$var$to.subscribe(async (e)=>{
            e && (await this.resumePausedMutations(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).onOnline());
        })));
    }
    unmount() {
        var e, t;
        $2a051a86cb6e4743$var$ps(this, $2a051a86cb6e4743$var$an)._--, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$an) === 0 && ((e = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Lr)) == null || e.call(this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Lr, void 0), (t = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Rr)) == null || t.call(this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Rr, void 0));
    }
    isFetching(e) {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).findAll({
            ...e,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(e) {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$sn).findAll({
            ...e,
            status: "pending"
        }).length;
    }
    getQueryData(e) {
        var n;
        const t = this.defaultQueryOptions({
            queryKey: e
        });
        return (n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).get(t.queryHash)) == null ? void 0 : n.state.data;
    }
    ensureQueryData(e) {
        const t = this.defaultQueryOptions(e), n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).build(this, t), r = n.state.data;
        return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime($2a051a86cb6e4743$var$yr(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
    }
    getQueriesData(e) {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).findAll(e).map(({ queryKey: t, state: n })=>{
            const r = n.data;
            return [
                t,
                r
            ];
        });
    }
    setQueryData(e, t, n) {
        const r = this.defaultQueryOptions({
            queryKey: e
        }), i1 = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).get(r.queryHash), s = i1 == null ? void 0 : i1.state.data, o = $2a051a86cb6e4743$var$dy(t, s);
        if (o !== void 0) return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).build(this, r).setData(o, {
            ...n,
            manual: !0
        });
    }
    setQueriesData(e, t, n) {
        return $2a051a86cb6e4743$var$Ce.batch(()=>$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).findAll(e).map(({ queryKey: r })=>[
                    r,
                    this.setQueryData(r, t, n)
                ]));
    }
    getQueryState(e) {
        var n;
        const t = this.defaultQueryOptions({
            queryKey: e
        });
        return (n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).get(t.queryHash)) == null ? void 0 : n.state;
    }
    removeQueries(e) {
        const t = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe);
        $2a051a86cb6e4743$var$Ce.batch(()=>{
            t.findAll(e).forEach((n)=>{
                t.remove(n);
            });
        });
    }
    resetQueries(e, t) {
        const n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe), r = {
            type: "active",
            ...e
        };
        return $2a051a86cb6e4743$var$Ce.batch(()=>(n.findAll(e).forEach((i1)=>{
                i1.reset();
            }), this.refetchQueries(r, t)));
    }
    cancelQueries(e, t = {}) {
        const n = {
            revert: !0,
            ...t
        }, r = $2a051a86cb6e4743$var$Ce.batch(()=>$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).findAll(e).map((i1)=>i1.cancel(n)));
        return Promise.all(r).then($2a051a86cb6e4743$var$Ze).catch($2a051a86cb6e4743$var$Ze);
    }
    invalidateQueries(e, t = {}) {
        return $2a051a86cb6e4743$var$Ce.batch(()=>{
            if ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).findAll(e).forEach((r)=>{
                r.invalidate();
            }), (e == null ? void 0 : e.refetchType) === "none") return Promise.resolve();
            const n = {
                ...e,
                type: (e == null ? void 0 : e.refetchType) ?? (e == null ? void 0 : e.type) ?? "active"
            };
            return this.refetchQueries(n, t);
        });
    }
    refetchQueries(e, t = {}) {
        const n = {
            ...t,
            cancelRefetch: t.cancelRefetch ?? !0
        }, r = $2a051a86cb6e4743$var$Ce.batch(()=>$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).findAll(e).filter((i1)=>!i1.isDisabled()).map((i1)=>{
                let s = i1.fetch(void 0, n);
                return n.throwOnError || (s = s.catch($2a051a86cb6e4743$var$Ze)), i1.state.fetchStatus === "paused" ? Promise.resolve() : s;
            }));
        return Promise.all(r).then($2a051a86cb6e4743$var$Ze);
    }
    fetchQuery(e) {
        const t = this.defaultQueryOptions(e);
        t.retry === void 0 && (t.retry = !1);
        const n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).build(this, t);
        return n.isStaleByTime($2a051a86cb6e4743$var$yr(t.staleTime, n)) ? n.fetch(t) : Promise.resolve(n.state.data);
    }
    prefetchQuery(e) {
        return this.fetchQuery(e).then($2a051a86cb6e4743$var$Ze).catch($2a051a86cb6e4743$var$Ze);
    }
    fetchInfiniteQuery(e) {
        return e.behavior = $2a051a86cb6e4743$var$Rc(e.pages), this.fetchQuery(e);
    }
    prefetchInfiniteQuery(e) {
        return this.fetchInfiniteQuery(e).then($2a051a86cb6e4743$var$Ze).catch($2a051a86cb6e4743$var$Ze);
    }
    ensureInfiniteQueryData(e) {
        return e.behavior = $2a051a86cb6e4743$var$Rc(e.pages), this.ensureQueryData(e);
    }
    resumePausedMutations() {
        return $2a051a86cb6e4743$var$to.isOnline() ? $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$sn).resumePausedMutations() : Promise.resolve();
    }
    getQueryCache() {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe);
    }
    getMutationCache() {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$sn);
    }
    getDefaultOptions() {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$on);
    }
    setDefaultOptions(e) {
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$on, e);
    }
    setQueryDefaults(e, t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Nr).set($2a051a86cb6e4743$var$_i(e), {
            queryKey: e,
            defaultOptions: t
        });
    }
    getQueryDefaults(e) {
        const t = [
            ...$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Nr).values()
        ], n = {};
        return t.forEach((r)=>{
            $2a051a86cb6e4743$var$bi(e, r.queryKey) && Object.assign(n, r.defaultOptions);
        }), n;
    }
    setMutationDefaults(e, t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Tr).set($2a051a86cb6e4743$var$_i(e), {
            mutationKey: e,
            defaultOptions: t
        });
    }
    getMutationDefaults(e) {
        const t = [
            ...$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Tr).values()
        ];
        let n = {};
        return t.forEach((r)=>{
            $2a051a86cb6e4743$var$bi(e, r.mutationKey) && (n = {
                ...n,
                ...r.defaultOptions
            });
        }), n;
    }
    defaultQueryOptions(e) {
        if (e._defaulted) return e;
        const t = {
            ...$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$on).queries,
            ...this.getQueryDefaults(e.queryKey),
            ...e,
            _defaulted: !0
        };
        return t.queryHash || (t.queryHash = $2a051a86cb6e4743$var$Gl(t.queryKey, t)), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === $2a051a86cb6e4743$var$Xl && (t.enabled = !1), t;
    }
    defaultMutationOptions(e) {
        return e != null && e._defaulted ? e : {
            ...$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$on).mutations,
            ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
            ...e,
            _defaulted: !0
        };
    }
    clear() {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$fe).clear(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$sn).clear();
    }
}, $2a051a86cb6e4743$var$fe = new WeakMap, $2a051a86cb6e4743$var$sn = new WeakMap, $2a051a86cb6e4743$var$on = new WeakMap, $2a051a86cb6e4743$var$Nr = new WeakMap, $2a051a86cb6e4743$var$Tr = new WeakMap, $2a051a86cb6e4743$var$an = new WeakMap, $2a051a86cb6e4743$var$Lr = new WeakMap, $2a051a86cb6e4743$var$Rr = new WeakMap, $2a051a86cb6e4743$var$sd), $2a051a86cb6e4743$var$Ae, $2a051a86cb6e4743$var$J, $2a051a86cb6e4743$var$qi, $2a051a86cb6e4743$var$Re, $2a051a86cb6e4743$var$Mn, $2a051a86cb6e4743$var$jr, $2a051a86cb6e4743$var$ln, $2a051a86cb6e4743$var$Et, $2a051a86cb6e4743$var$Gi, $2a051a86cb6e4743$var$Ir, $2a051a86cb6e4743$var$Fr, $2a051a86cb6e4743$var$Un, $2a051a86cb6e4743$var$$n, $2a051a86cb6e4743$var$un, $2a051a86cb6e4743$var$Dr, $2a051a86cb6e4743$var$zn, $2a051a86cb6e4743$var$ai, $2a051a86cb6e4743$var$Xi, $2a051a86cb6e4743$var$Ka, $2a051a86cb6e4743$var$Ji, $2a051a86cb6e4743$var$Wa, $2a051a86cb6e4743$var$Zi, $2a051a86cb6e4743$var$Ya, $2a051a86cb6e4743$var$es, $2a051a86cb6e4743$var$qa, $2a051a86cb6e4743$var$ts, $2a051a86cb6e4743$var$Ga, $2a051a86cb6e4743$var$ns, $2a051a86cb6e4743$var$Xa, $2a051a86cb6e4743$var$rs, $2a051a86cb6e4743$var$Ja, $2a051a86cb6e4743$var$bo, $2a051a86cb6e4743$var$Wd, $2a051a86cb6e4743$var$od, $2a051a86cb6e4743$var$by = ($2a051a86cb6e4743$var$od = class extends $2a051a86cb6e4743$var$ss {
    constructor(t, n){
        super();
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$zn);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Xi);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Ji);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Zi);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$es);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$ts);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$ns);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$rs);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$bo);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Ae, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$J, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$qi, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Re, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Mn, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$jr, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$ln, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Et, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Gi, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Ir, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Fr, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Un, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$$n, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$un, void 0);
        $2a051a86cb6e4743$var$V(this, $2a051a86cb6e4743$var$Dr, new Set);
        this.options = n, $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Ae, t), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Et, null), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$ln, $2a051a86cb6e4743$var$Qa()), this.options.experimental_prefetchInRender || $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ln).reject(new Error("experimental_prefetchInRender feature flag is not enabled")), this.bindMethods(), this.setOptions(n);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        this.listeners.size === 1 && ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J).addObserver(this), $2a051a86cb6e4743$var$Ic($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J), this.options) ? $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$zn, $2a051a86cb6e4743$var$ai).call(this) : this.updateResult(), $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$es, $2a051a86cb6e4743$var$qa).call(this));
    }
    onUnsubscribe() {
        this.hasListeners() || this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2a051a86cb6e4743$var$Za($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2a051a86cb6e4743$var$Za($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set, $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ts, $2a051a86cb6e4743$var$Ga).call(this), $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ns, $2a051a86cb6e4743$var$Xa).call(this), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J).removeObserver(this);
    }
    setOptions(t, n) {
        const r = this.options, i1 = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J);
        if (this.options = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof $2a051a86cb6e4743$var$dt(this.options.enabled, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) != "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$rs, $2a051a86cb6e4743$var$Ja).call(this), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J).setOptions(this.options), r._defaulted && !$2a051a86cb6e4743$var$Ba(this.options, r) && $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J),
            observer: this
        });
        const s = this.hasListeners();
        s && $2a051a86cb6e4743$var$Fc($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J), i1, this.options, r) && $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$zn, $2a051a86cb6e4743$var$ai).call(this), this.updateResult(n), s && ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J) !== i1 || $2a051a86cb6e4743$var$dt(this.options.enabled, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) !== $2a051a86cb6e4743$var$dt(r.enabled, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) || $2a051a86cb6e4743$var$yr(this.options.staleTime, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) !== $2a051a86cb6e4743$var$yr(r.staleTime, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J))) && $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Xi, $2a051a86cb6e4743$var$Ka).call(this);
        const o = $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ji, $2a051a86cb6e4743$var$Wa).call(this);
        s && ($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J) !== i1 || $2a051a86cb6e4743$var$dt(this.options.enabled, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) !== $2a051a86cb6e4743$var$dt(r.enabled, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) || o !== $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$un)) && $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Zi, $2a051a86cb6e4743$var$Ya).call(this, o);
    }
    getOptimisticResult(t) {
        const n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae).getQueryCache().build($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae), t), r = this.createResult(n, t);
        return $2a051a86cb6e4743$var$Ny(this, r) && ($2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Re, r), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$jr, this.options), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Mn, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J).state)), r;
    }
    getCurrentResult() {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re);
    }
    trackResult(t, n) {
        const r = {};
        return Object.keys(t).forEach((i1)=>{
            Object.defineProperty(r, i1, {
                configurable: !1,
                enumerable: !0,
                get: ()=>(this.trackProp(i1), n == null || n(i1), t[i1])
            });
        }), r;
    }
    trackProp(t) {
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Dr).add(t);
    }
    getCurrentQuery() {
        return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J);
    }
    refetch({ ...t } = {}) {
        return this.fetch({
            ...t
        });
    }
    fetchOptimistic(t) {
        const n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae).defaultQueryOptions(t), r = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae).getQueryCache().build($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae), n);
        return r.fetch().then(()=>this.createResult(r, n));
    }
    fetch(t) {
        return $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$zn, $2a051a86cb6e4743$var$ai).call(this, {
            ...t,
            cancelRefetch: t.cancelRefetch ?? !0
        }).then(()=>(this.updateResult(), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re)));
    }
    createResult(t, n) {
        var R;
        const r = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J), i1 = this.options, s = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re), o = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Mn), a = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$jr), u = t !== r ? t.state : $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$qi), { state: c } = t;
        let d = {
            ...c
        }, f = !1, m;
        if (n._optimisticResults) {
            const D = this.hasListeners(), H = !D && $2a051a86cb6e4743$var$Ic(t, n), M = D && $2a051a86cb6e4743$var$Fc(t, r, n, i1);
            (H || M) && (d = {
                ...d,
                ...$2a051a86cb6e4743$var$Kd(c.data, t.options)
            }), n._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
        }
        let { error: v, errorUpdatedAt: y, status: k } = d;
        if (n.select && d.data !== void 0) {
            if (s && d.data === (o == null ? void 0 : o.data) && n.select === $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Gi)) m = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ir);
            else try {
                $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Gi, n.select), m = n.select(d.data), m = $2a051a86cb6e4743$var$Va(s == null ? void 0 : s.data, m, n), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Ir, m), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Et, null);
            } catch (D) {
                $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Et, D);
            }
        } else m = d.data;
        if (n.placeholderData !== void 0 && m === void 0 && k === "pending") {
            let D;
            if (s != null && s.isPlaceholderData && n.placeholderData === (a == null ? void 0 : a.placeholderData)) D = s.data;
            else if (D = typeof n.placeholderData == "function" ? n.placeholderData((R = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Fr)) == null ? void 0 : R.state.data, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Fr)) : n.placeholderData, n.select && D !== void 0) try {
                D = n.select(D), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Et, null);
            } catch (H) {
                $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Et, H);
            }
            D !== void 0 && (k = "success", m = $2a051a86cb6e4743$var$Va(s == null ? void 0 : s.data, D, n), f = !0);
        }
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Et) && (v = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Et), m = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ir), y = Date.now(), k = "error");
        const p = d.fetchStatus === "fetching", h = k === "pending", g = k === "error", E = h && p, P = m !== void 0, b = {
            status: k,
            fetchStatus: d.fetchStatus,
            isPending: h,
            isSuccess: k === "success",
            isError: g,
            isInitialLoading: E,
            isLoading: E,
            data: m,
            dataUpdatedAt: d.dataUpdatedAt,
            error: v,
            errorUpdatedAt: y,
            failureCount: d.fetchFailureCount,
            failureReason: d.fetchFailureReason,
            errorUpdateCount: d.errorUpdateCount,
            isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
            isFetchedAfterMount: d.dataUpdateCount > u.dataUpdateCount || d.errorUpdateCount > u.errorUpdateCount,
            isFetching: p,
            isRefetching: p && !h,
            isLoadingError: g && !P,
            isPaused: d.fetchStatus === "paused",
            isPlaceholderData: f,
            isRefetchError: g && P,
            isStale: $2a051a86cb6e4743$var$Zl(t, n),
            refetch: this.refetch,
            promise: $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ln)
        };
        if (this.options.experimental_prefetchInRender) {
            const D = (L)=>{
                b.status === "error" ? L.reject(b.error) : b.data !== void 0 && L.resolve(b.data);
            }, H = ()=>{
                const L = $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$ln, b.promise = $2a051a86cb6e4743$var$Qa());
                D(L);
            }, M = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$ln);
            switch(M.status){
                case "pending":
                    t.queryHash === r.queryHash && D(M);
                    break;
                case "fulfilled":
                    (b.status === "error" || b.data !== M.value) && H();
                    break;
                case "rejected":
                    (b.status !== "error" || b.error !== M.reason) && H();
                    break;
            }
        }
        return b;
    }
    updateResult(t) {
        const n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re), r = this.createResult($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J), this.options);
        if ($2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Mn, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J).state), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$jr, this.options), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Mn).data !== void 0 && $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Fr, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)), $2a051a86cb6e4743$var$Ba(r, n)) return;
        $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Re, r);
        const i1 = {}, s = ()=>{
            if (!n) return !0;
            const { notifyOnChangeProps: o } = this.options, a = typeof o == "function" ? o() : o;
            if (a === "all" || !a && !$2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Dr).size) return !0;
            const l = new Set(a ?? $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Dr));
            return this.options.throwOnError && l.add("error"), Object.keys($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re)).some((u)=>{
                const c = u;
                return $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re)[c] !== n[c] && l.has(c);
            });
        };
        (t == null ? void 0 : t.listeners) !== !1 && s() && (i1.listeners = !0), $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$bo, $2a051a86cb6e4743$var$Wd).call(this, {
            ...i1,
            ...t
        });
    }
    onQueryUpdate() {
        this.updateResult(), this.hasListeners() && $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$es, $2a051a86cb6e4743$var$qa).call(this);
    }
}, $2a051a86cb6e4743$var$Ae = new WeakMap, $2a051a86cb6e4743$var$J = new WeakMap, $2a051a86cb6e4743$var$qi = new WeakMap, $2a051a86cb6e4743$var$Re = new WeakMap, $2a051a86cb6e4743$var$Mn = new WeakMap, $2a051a86cb6e4743$var$jr = new WeakMap, $2a051a86cb6e4743$var$ln = new WeakMap, $2a051a86cb6e4743$var$Et = new WeakMap, $2a051a86cb6e4743$var$Gi = new WeakMap, $2a051a86cb6e4743$var$Ir = new WeakMap, $2a051a86cb6e4743$var$Fr = new WeakMap, $2a051a86cb6e4743$var$Un = new WeakMap, $2a051a86cb6e4743$var$$n = new WeakMap, $2a051a86cb6e4743$var$un = new WeakMap, $2a051a86cb6e4743$var$Dr = new WeakMap, $2a051a86cb6e4743$var$zn = new WeakSet, $2a051a86cb6e4743$var$ai = function(t) {
    $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$rs, $2a051a86cb6e4743$var$Ja).call(this);
    let n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J).fetch(this.options, t);
    return t != null && t.throwOnError || (n = n.catch($2a051a86cb6e4743$var$Ze)), n;
}, $2a051a86cb6e4743$var$Xi = new WeakSet, $2a051a86cb6e4743$var$Ka = function() {
    $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ts, $2a051a86cb6e4743$var$Ga).call(this);
    const t = $2a051a86cb6e4743$var$yr(this.options.staleTime, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J));
    if ($2a051a86cb6e4743$var$Kn || $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re).isStale || !$2a051a86cb6e4743$var$za(t)) return;
    const r = $2a051a86cb6e4743$var$Ud($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re).dataUpdatedAt, t) + 1;
    $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Un, setTimeout(()=>{
        $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re).isStale || this.updateResult();
    }, r));
}, $2a051a86cb6e4743$var$Ji = new WeakSet, $2a051a86cb6e4743$var$Wa = function() {
    return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) : this.options.refetchInterval) ?? !1;
}, $2a051a86cb6e4743$var$Zi = new WeakSet, $2a051a86cb6e4743$var$Ya = function(t) {
    $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$ns, $2a051a86cb6e4743$var$Xa).call(this), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$un, t), !($2a051a86cb6e4743$var$Kn || $2a051a86cb6e4743$var$dt(this.options.enabled, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) === !1 || !$2a051a86cb6e4743$var$za($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$un)) || $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$un) === 0) && $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$$n, setInterval(()=>{
        (this.options.refetchIntervalInBackground || $2a051a86cb6e4743$var$Jl.isFocused()) && $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$zn, $2a051a86cb6e4743$var$ai).call(this);
    }, $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$un)));
}, $2a051a86cb6e4743$var$es = new WeakSet, $2a051a86cb6e4743$var$qa = function() {
    $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Xi, $2a051a86cb6e4743$var$Ka).call(this), $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Zi, $2a051a86cb6e4743$var$Ya).call(this, $2a051a86cb6e4743$var$X(this, $2a051a86cb6e4743$var$Ji, $2a051a86cb6e4743$var$Wa).call(this));
}, $2a051a86cb6e4743$var$ts = new WeakSet, $2a051a86cb6e4743$var$Ga = function() {
    $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Un) && (clearTimeout($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Un)), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$Un, void 0));
}, $2a051a86cb6e4743$var$ns = new WeakSet, $2a051a86cb6e4743$var$Xa = function() {
    $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$$n) && (clearInterval($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$$n)), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$$n, void 0));
}, $2a051a86cb6e4743$var$rs = new WeakSet, $2a051a86cb6e4743$var$Ja = function() {
    const t = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae).getQueryCache().build($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae), this.options);
    if (t === $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J)) return;
    const n = $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J);
    $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$J, t), $2a051a86cb6e4743$var$U(this, $2a051a86cb6e4743$var$qi, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, $2a051a86cb6e4743$var$bo = new WeakSet, $2a051a86cb6e4743$var$Wd = function(t) {
    $2a051a86cb6e4743$var$Ce.batch(()=>{
        t.listeners && this.listeners.forEach((n)=>{
            n($2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Re));
        }), $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$Ae).getQueryCache().notify({
            query: $2a051a86cb6e4743$var$w(this, $2a051a86cb6e4743$var$J),
            type: "observerResultsUpdated"
        });
    });
}, $2a051a86cb6e4743$var$od);
function $2a051a86cb6e4743$var$Oy(e, t) {
    return $2a051a86cb6e4743$var$dt(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function $2a051a86cb6e4743$var$Ic(e, t) {
    return $2a051a86cb6e4743$var$Oy(e, t) || e.state.data !== void 0 && $2a051a86cb6e4743$var$Za(e, t, t.refetchOnMount);
}
function $2a051a86cb6e4743$var$Za(e, t, n) {
    if ($2a051a86cb6e4743$var$dt(t.enabled, e) !== !1) {
        const r = typeof n == "function" ? n(e) : n;
        return r === "always" || r !== !1 && $2a051a86cb6e4743$var$Zl(e, t);
    }
    return !1;
}
function $2a051a86cb6e4743$var$Fc(e, t, n, r) {
    return (e !== t || $2a051a86cb6e4743$var$dt(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && $2a051a86cb6e4743$var$Zl(e, n);
}
function $2a051a86cb6e4743$var$Zl(e, t) {
    return $2a051a86cb6e4743$var$dt(t.enabled, e) !== !1 && e.isStaleByTime($2a051a86cb6e4743$var$yr(t.staleTime, e));
}
function $2a051a86cb6e4743$var$Ny(e, t) {
    return !$2a051a86cb6e4743$var$Ba(e.getCurrentResult(), t);
}
var $2a051a86cb6e4743$var$Yd = $2a051a86cb6e4743$var$I.createContext(void 0), $2a051a86cb6e4743$var$Ty = (e)=>{
    const t = $2a051a86cb6e4743$var$I.useContext($2a051a86cb6e4743$var$Yd);
    if (e) return e;
    if (!t) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return t;
}, $2a051a86cb6e4743$var$Io = ({ client: e, children: t })=>($2a051a86cb6e4743$var$I.useEffect(()=>(e.mount(), ()=>{
            e.unmount();
        }), [
        e
    ]), $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Yd.Provider, {
        value: e,
        children: t
    })), $2a051a86cb6e4743$var$qd = $2a051a86cb6e4743$var$I.createContext(!1), $2a051a86cb6e4743$var$Ly = ()=>$2a051a86cb6e4743$var$I.useContext($2a051a86cb6e4743$var$qd);
$2a051a86cb6e4743$var$qd.Provider;
function $2a051a86cb6e4743$var$Ry() {
    let e = !1;
    return {
        clearReset: ()=>{
            e = !1;
        },
        reset: ()=>{
            e = !0;
        },
        isReset: ()=>e
    };
}
var $2a051a86cb6e4743$var$jy = $2a051a86cb6e4743$var$I.createContext($2a051a86cb6e4743$var$Ry()), $2a051a86cb6e4743$var$Iy = ()=>$2a051a86cb6e4743$var$I.useContext($2a051a86cb6e4743$var$jy);
function $2a051a86cb6e4743$var$Fy(e, t) {
    return typeof e == "function" ? e(...t) : !!e;
}
function $2a051a86cb6e4743$var$Dc() {}
var $2a051a86cb6e4743$var$Dy = (e, t)=>{
    (e.suspense || e.throwOnError || e.experimental_prefetchInRender) && (t.isReset() || (e.retryOnMount = !1));
}, $2a051a86cb6e4743$var$Ay = (e)=>{
    $2a051a86cb6e4743$var$I.useEffect(()=>{
        e.clearReset();
    }, [
        e
    ]);
}, $2a051a86cb6e4743$var$My = ({ result: e, errorResetBoundary: t, throwOnError: n, query: r, suspense: i1 })=>e.isError && !t.isReset() && !e.isFetching && r && (i1 && e.data === void 0 || $2a051a86cb6e4743$var$Fy(n, [
        e.error,
        r
    ])), $2a051a86cb6e4743$var$Uy = (e)=>{
    const t = e.staleTime;
    e.suspense && (e.staleTime = typeof t == "function" ? (...n)=>Math.max(t(...n), 1e3) : Math.max(t ?? 1e3, 1e3), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3)));
}, $2a051a86cb6e4743$var$$y = (e, t)=>e.isLoading && e.isFetching && !t, $2a051a86cb6e4743$var$zy = (e, t)=>(e == null ? void 0 : e.suspense) && t.isPending, $2a051a86cb6e4743$var$Ac = (e, t, n)=>t.fetchOptimistic(e).catch(()=>{
        n.clearReset();
    });
function $2a051a86cb6e4743$var$By(e, t, n) {
    var d, f, m, v, y;
    const r = $2a051a86cb6e4743$var$Ty(n), i1 = $2a051a86cb6e4743$var$Ly(), s = $2a051a86cb6e4743$var$Iy(), o = r.defaultQueryOptions(e);
    (f = (d = r.getDefaultOptions().queries) == null ? void 0 : d._experimental_beforeQuery) == null || f.call(d, o), o._optimisticResults = i1 ? "isRestoring" : "optimistic", $2a051a86cb6e4743$var$Uy(o), $2a051a86cb6e4743$var$Dy(o, s), $2a051a86cb6e4743$var$Ay(s);
    const a = !r.getQueryCache().get(o.queryHash), [l] = $2a051a86cb6e4743$var$I.useState(()=>new t(r, o)), u = l.getOptimisticResult(o), c = !i1 && e.subscribed !== !1;
    if ($2a051a86cb6e4743$var$I.useSyncExternalStore($2a051a86cb6e4743$var$I.useCallback((k)=>{
        const p = c ? l.subscribe($2a051a86cb6e4743$var$Ce.batchCalls(k)) : $2a051a86cb6e4743$var$Dc;
        return l.updateResult(), p;
    }, [
        l,
        c
    ]), ()=>l.getCurrentResult(), ()=>l.getCurrentResult()), $2a051a86cb6e4743$var$I.useEffect(()=>{
        l.setOptions(o, {
            listeners: !1
        });
    }, [
        o,
        l
    ]), $2a051a86cb6e4743$var$zy(o, u)) throw $2a051a86cb6e4743$var$Ac(o, l, s);
    if ($2a051a86cb6e4743$var$My({
        result: u,
        errorResetBoundary: s,
        throwOnError: o.throwOnError,
        query: r.getQueryCache().get(o.queryHash),
        suspense: o.suspense
    })) throw u.error;
    if ((v = (m = r.getDefaultOptions().queries) == null ? void 0 : m._experimental_afterQuery) == null || v.call(m, o, u), o.experimental_prefetchInRender && !$2a051a86cb6e4743$var$Kn && $2a051a86cb6e4743$var$$y(u, i1)) {
        const k = a ? $2a051a86cb6e4743$var$Ac(o, l, s) : (y = r.getQueryCache().get(o.queryHash)) == null ? void 0 : y.promise;
        k == null || k.catch($2a051a86cb6e4743$var$Dc).finally(()=>{
            l.updateResult();
        });
    }
    return o.notifyOnChangeProps ? u : l.trackResult(u);
}
function $2a051a86cb6e4743$var$Hy(e, t) {
    return $2a051a86cb6e4743$var$By(e, $2a051a86cb6e4743$var$by, t);
}
const $2a051a86cb6e4743$var$As = {
    initialFacetTags: window.aemOecdSearchAppConfiguration.initialFacetTags || [],
    facetGroups: window.aemOecdSearchAppConfiguration.facetGroups || [],
    mobileModalIsActive: !1,
    toggleMobileDialogVisibility: ()=>{}
}, $2a051a86cb6e4743$var$Gd = $2a051a86cb6e4743$var$I.createContext($2a051a86cb6e4743$var$As), $2a051a86cb6e4743$var$Vy = ({ children: e })=>{
    const { facetGroups: t } = $2a051a86cb6e4743$var$As, [n, r] = $2a051a86cb6e4743$var$I.useState($2a051a86cb6e4743$var$As.mobileModalIsActive);
    Array.isArray(t) && t.sort((s, o)=>s.weight - o.weight);
    const i1 = ()=>{
        r(!n);
    };
    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Gd.Provider, {
        value: {
            initialFacetTags: $2a051a86cb6e4743$var$As.initialFacetTags,
            facetGroups: t,
            mobileModalIsActive: n,
            toggleMobileDialogVisibility: i1
        },
        children: e
    });
}, $2a051a86cb6e4743$var$Fo = ()=>{
    const e = $2a051a86cb6e4743$var$I.useContext($2a051a86cb6e4743$var$Gd);
    if (!e) throw new Error("useFacetRailContext must be used within a FacetRailContextProvider");
    return e;
};
function $2a051a86cb6e4743$var$Xd(e, t) {
    const [n, r] = $2a051a86cb6e4743$var$I.useState(e);
    return $2a051a86cb6e4743$var$I.useEffect(()=>{
        const i1 = setTimeout(()=>{
            r(e);
        }, t);
        return ()=>{
            clearTimeout(i1);
        };
    }, [
        e,
        t
    ]), n;
}
var $2a051a86cb6e4743$var$_t = ((e)=>(e.GRID = "grid", e.LIST = "list", e))($2a051a86cb6e4743$var$_t || {}), $2a051a86cb6e4743$var$eu = ((e)=>(e.RELEVANCY = "mostRelevant", e.RECENT = "mostRecent", e.RECENT_INVERSE = "oldest", e.ALPHABETICALLY = "AZ", e.ALPHABETICALLY_INVERSE = "ZA", e))($2a051a86cb6e4743$var$eu || {});
const $2a051a86cb6e4743$var$Zt = class Zt {
};
$2a051a86cb6e4743$var$bn($2a051a86cb6e4743$var$Zt, "getUrlQuery", ()=>window.location.search.slice(1)), $2a051a86cb6e4743$var$bn($2a051a86cb6e4743$var$Zt, "getSelectedTagsFromSearchParams", (t)=>{
    const n = $2a051a86cb6e4743$var$Zt.getSearchParametersFromUrl();
    return n.has(t) ? (n.get(t) || "").split(",") : [];
}), $2a051a86cb6e4743$var$bn($2a051a86cb6e4743$var$Zt, "getSearchParametersFromUrl", ()=>{
    const t = window.location.search.substring(1).split("&"), n = new Map;
    return t.forEach((r)=>{
        const [i1, s] = r.split("=");
        i1 === "q" ? n.set(decodeURIComponent(i1), s ? decodeURIComponent(s.replace(/\+/g, " ")) : "") : n.set(decodeURIComponent(i1), s ? decodeURIComponent(s) : "");
    }), n;
}), $2a051a86cb6e4743$var$bn($2a051a86cb6e4743$var$Zt, "getSearchParameterFromUrlByKey", (t)=>{
    const n = $2a051a86cb6e4743$var$Zt.getSearchParametersFromUrl();
    if (n.has(t) && n.get(t)) {
        const r = n.get(t);
        return decodeURIComponent(r);
    }
    return null;
});
let $2a051a86cb6e4743$var$St = $2a051a86cb6e4743$var$Zt;
const $2a051a86cb6e4743$var$Mc = (e)=>{
    let t;
    const n = new Set, r = (c, d)=>{
        const f = typeof c == "function" ? c(t) : c;
        if (!Object.is(f, t)) {
            const m = t;
            t = d ?? (typeof f != "object" || f === null) ? f : Object.assign({}, t, f), n.forEach((v)=>v(t, m));
        }
    }, i1 = ()=>t, l = {
        setState: r,
        getState: i1,
        getInitialState: ()=>u,
        subscribe: (c)=>(n.add(c), ()=>n.delete(c)),
        destroy: ()=>{
            n.clear();
        }
    }, u = t = e(r, i1, l);
    return l;
}, $2a051a86cb6e4743$var$Qy = (e)=>e ? $2a051a86cb6e4743$var$Mc(e) : $2a051a86cb6e4743$var$Mc;
var $2a051a86cb6e4743$var$Jd = {
    exports: {}
}, $2a051a86cb6e4743$var$Zd = {}, $2a051a86cb6e4743$var$eh = {
    exports: {}
}, $2a051a86cb6e4743$var$th = {}; /**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2a051a86cb6e4743$var$Mr = $2a051a86cb6e4743$var$I;
function $2a051a86cb6e4743$var$Ky(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var $2a051a86cb6e4743$var$Wy = typeof Object.is == "function" ? Object.is : $2a051a86cb6e4743$var$Ky, $2a051a86cb6e4743$var$Yy = $2a051a86cb6e4743$var$Mr.useState, $2a051a86cb6e4743$var$qy = $2a051a86cb6e4743$var$Mr.useEffect, $2a051a86cb6e4743$var$Gy = $2a051a86cb6e4743$var$Mr.useLayoutEffect, $2a051a86cb6e4743$var$Xy = $2a051a86cb6e4743$var$Mr.useDebugValue;
function $2a051a86cb6e4743$var$Jy(e, t) {
    var n = t(), r = $2a051a86cb6e4743$var$Yy({
        inst: {
            value: n,
            getSnapshot: t
        }
    }), i1 = r[0].inst, s = r[1];
    return $2a051a86cb6e4743$var$Gy(function() {
        i1.value = n, i1.getSnapshot = t, $2a051a86cb6e4743$var$la(i1) && s({
            inst: i1
        });
    }, [
        e,
        n,
        t
    ]), $2a051a86cb6e4743$var$qy(function() {
        return $2a051a86cb6e4743$var$la(i1) && s({
            inst: i1
        }), e(function() {
            $2a051a86cb6e4743$var$la(i1) && s({
                inst: i1
            });
        });
    }, [
        e
    ]), $2a051a86cb6e4743$var$Xy(n), n;
}
function $2a051a86cb6e4743$var$la(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
        var n = t();
        return !$2a051a86cb6e4743$var$Wy(e, n);
    } catch  {
        return !0;
    }
}
function $2a051a86cb6e4743$var$Zy(e, t) {
    return t();
}
var $2a051a86cb6e4743$var$ev = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? $2a051a86cb6e4743$var$Zy : $2a051a86cb6e4743$var$Jy;
$2a051a86cb6e4743$var$th.useSyncExternalStore = $2a051a86cb6e4743$var$Mr.useSyncExternalStore !== void 0 ? $2a051a86cb6e4743$var$Mr.useSyncExternalStore : $2a051a86cb6e4743$var$ev;
$2a051a86cb6e4743$var$eh.exports = $2a051a86cb6e4743$var$th;
var $2a051a86cb6e4743$var$tv = $2a051a86cb6e4743$var$eh.exports; /**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2a051a86cb6e4743$var$Do = $2a051a86cb6e4743$var$I, $2a051a86cb6e4743$var$nv = $2a051a86cb6e4743$var$tv;
function $2a051a86cb6e4743$var$rv(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var $2a051a86cb6e4743$var$iv = typeof Object.is == "function" ? Object.is : $2a051a86cb6e4743$var$rv, $2a051a86cb6e4743$var$sv = $2a051a86cb6e4743$var$nv.useSyncExternalStore, $2a051a86cb6e4743$var$ov = $2a051a86cb6e4743$var$Do.useRef, $2a051a86cb6e4743$var$av = $2a051a86cb6e4743$var$Do.useEffect, $2a051a86cb6e4743$var$lv = $2a051a86cb6e4743$var$Do.useMemo, $2a051a86cb6e4743$var$uv = $2a051a86cb6e4743$var$Do.useDebugValue;
$2a051a86cb6e4743$var$Zd.useSyncExternalStoreWithSelector = function(e, t, n, r, i1) {
    var s = $2a051a86cb6e4743$var$ov(null);
    if (s.current === null) {
        var o = {
            hasValue: !1,
            value: null
        };
        s.current = o;
    } else o = s.current;
    s = $2a051a86cb6e4743$var$lv(function() {
        function l(m) {
            if (!u) {
                if (u = !0, c = m, m = r(m), i1 !== void 0 && o.hasValue) {
                    var v = o.value;
                    if (i1(v, m)) return d = v;
                }
                return d = m;
            }
            if (v = d, $2a051a86cb6e4743$var$iv(c, m)) return v;
            var y = r(m);
            return i1 !== void 0 && i1(v, y) ? (c = m, v) : (c = m, d = y);
        }
        var u = !1, c, d, f = n === void 0 ? null : n;
        return [
            function() {
                return l(t());
            },
            f === null ? void 0 : function() {
                return l(f());
            }
        ];
    }, [
        t,
        n,
        r,
        i1
    ]);
    var a = $2a051a86cb6e4743$var$sv(e, s[0], s[1]);
    return $2a051a86cb6e4743$var$av(function() {
        o.hasValue = !0, o.value = a;
    }, [
        a
    ]), $2a051a86cb6e4743$var$uv(a), a;
};
$2a051a86cb6e4743$var$Jd.exports = $2a051a86cb6e4743$var$Zd;
var $2a051a86cb6e4743$var$cv = $2a051a86cb6e4743$var$Jd.exports;
const $2a051a86cb6e4743$var$fv = $2a051a86cb6e4743$var$Oo($2a051a86cb6e4743$var$cv), { useDebugValue: $2a051a86cb6e4743$var$dv } = $2a051a86cb6e4743$var$Dg, { useSyncExternalStoreWithSelector: $2a051a86cb6e4743$var$hv } = $2a051a86cb6e4743$var$fv;
const $2a051a86cb6e4743$var$pv = (e)=>e;
function $2a051a86cb6e4743$var$gv(e, t = $2a051a86cb6e4743$var$pv, n) {
    const r = $2a051a86cb6e4743$var$hv(e.subscribe, e.getState, e.getServerState || e.getInitialState, t, n);
    return $2a051a86cb6e4743$var$dv(r), r;
}
const $2a051a86cb6e4743$var$Uc = (e)=>{
    const t = typeof e == "function" ? $2a051a86cb6e4743$var$Qy(e) : e, n = (r, i1)=>$2a051a86cb6e4743$var$gv(t, r, i1);
    return Object.assign(n, t), n;
}, $2a051a86cb6e4743$var$mv = (e)=>e ? $2a051a86cb6e4743$var$Uc(e) : $2a051a86cb6e4743$var$Uc;
function $2a051a86cb6e4743$var$yv(e) {
    let t;
    try {
        t = e();
    } catch  {
        return;
    }
    return {
        getItem: (n)=>null,
        setItem: (n, r)=>{
            Object.entries(r.state).map(([i1, s])=>t.setUrlQueryParameter(i1, s));
        },
        removeItem: (n)=>{}
    };
}
function $2a051a86cb6e4743$var$vv(e, t) {
    let n;
    try {
        n = e();
    } catch  {
        return;
    }
    return {
        getItem: (i1)=>{
            var s;
            const o = (l)=>l === null ? null : JSON.parse(l, t == null ? void 0 : t.reviver), a = (s = n.getItem(i1)) != null ? s : null;
            return a instanceof Promise ? a.then(o) : o(a);
        },
        setItem: (i1, s)=>n.setItem(i1, JSON.stringify(s, t == null ? void 0 : t.replacer)),
        removeItem: (i1)=>n.removeItem(i1)
    };
}
const $2a051a86cb6e4743$var$Oi = (e)=>(t)=>{
        try {
            const n = e(t);
            return n instanceof Promise ? n : {
                then (r) {
                    return $2a051a86cb6e4743$var$Oi(r)(n);
                },
                catch (r) {
                    return this;
                }
            };
        } catch (n) {
            return {
                then (r) {
                    return this;
                },
                catch (r) {
                    return $2a051a86cb6e4743$var$Oi(r)(n);
                }
            };
        }
    }, $2a051a86cb6e4743$var$Sv = (e, t)=>(n, r, i1)=>{
        let s = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (k)=>k,
            version: 0,
            merge: (k, p)=>({
                    ...p,
                    ...k
                }),
            ...t
        }, o = !1;
        const a = new Set, l = new Set;
        let u;
        try {
            u = s.getStorage();
        } catch  {}
        if (!u) return e((...k)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${s.name}', the given storage is currently unavailable.`), n(...k);
        }, r, i1);
        const c = $2a051a86cb6e4743$var$Oi(s.serialize), d = ()=>{
            const k = s.partialize({
                ...r()
            });
            let p;
            const h = c({
                state: k,
                version: s.version
            }).then((g)=>u.setItem(s.name, g)).catch((g)=>{
                p = g;
            });
            if (p) throw p;
            return h;
        }, f = i1.setState;
        i1.setState = (k, p)=>{
            f(k, p), d();
        };
        const m = e((...k)=>{
            n(...k), d();
        }, r, i1);
        let v;
        const y = ()=>{
            var k;
            if (!u) return;
            o = !1, a.forEach((h)=>h(r()));
            const p = ((k = s.onRehydrateStorage) == null ? void 0 : k.call(s, r())) || void 0;
            return $2a051a86cb6e4743$var$Oi(u.getItem.bind(u))(s.name).then((h)=>{
                if (h) return s.deserialize(h);
            }).then((h)=>{
                if (h) {
                    if (typeof h.version == "number" && h.version !== s.version) {
                        if (s.migrate) return s.migrate(h.state, h.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return h.state;
                }
            }).then((h)=>{
                var g;
                return v = s.merge(h, (g = r()) != null ? g : m), n(v, !0), d();
            }).then(()=>{
                p == null || p(v, void 0), o = !0, l.forEach((h)=>h(v));
            }).catch((h)=>{
                p == null || p(void 0, h);
            });
        };
        return i1.persist = {
            setOptions: (k)=>{
                s = {
                    ...s,
                    ...k
                }, k.getStorage && (u = k.getStorage());
            },
            clearStorage: ()=>{
                u == null || u.removeItem(s.name);
            },
            getOptions: ()=>s,
            rehydrate: ()=>y(),
            hasHydrated: ()=>o,
            onHydrate: (k)=>(a.add(k), ()=>{
                    a.delete(k);
                }),
            onFinishHydration: (k)=>(l.add(k), ()=>{
                    l.delete(k);
                })
        }, y(), v || m;
    }, $2a051a86cb6e4743$var$wv = (e, t)=>(n, r, i1)=>{
        let s = {
            storage: $2a051a86cb6e4743$var$vv(()=>localStorage),
            partialize: (y)=>y,
            version: 0,
            merge: (y, k)=>({
                    ...k,
                    ...y
                }),
            ...t
        }, o = !1;
        const a = new Set, l = new Set;
        let u = s.storage;
        if (!u) return e((...y)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${s.name}', the given storage is currently unavailable.`), n(...y);
        }, r, i1);
        const c = ()=>{
            const y = s.partialize({
                ...r()
            });
            return u.setItem(s.name, {
                state: y,
                version: s.version
            });
        }, d = i1.setState;
        i1.setState = (y, k)=>{
            d(y, k), c();
        };
        const f = e((...y)=>{
            n(...y), c();
        }, r, i1);
        i1.getInitialState = ()=>f;
        let m;
        const v = ()=>{
            var y, k;
            if (!u) return;
            o = !1, a.forEach((h)=>{
                var g;
                return h((g = r()) != null ? g : f);
            });
            const p = ((k = s.onRehydrateStorage) == null ? void 0 : k.call(s, (y = r()) != null ? y : f)) || void 0;
            return $2a051a86cb6e4743$var$Oi(u.getItem.bind(u))(s.name).then((h)=>{
                if (h) {
                    if (typeof h.version == "number" && h.version !== s.version) {
                        if (s.migrate) return [
                            !0,
                            s.migrate(h.state, h.version)
                        ];
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return [
                        !1,
                        h.state
                    ];
                }
                return [
                    !1,
                    void 0
                ];
            }).then((h)=>{
                var g;
                const [E, P] = h;
                if (m = s.merge(P, (g = r()) != null ? g : f), n(m, !0), E) return c();
            }).then(()=>{
                p == null || p(m, void 0), m = r(), o = !0, l.forEach((h)=>h(m));
            }).catch((h)=>{
                p == null || p(void 0, h);
            });
        };
        return i1.persist = {
            setOptions: (y)=>{
                s = {
                    ...s,
                    ...y
                }, y.storage && (u = y.storage);
            },
            clearStorage: ()=>{
                u == null || u.removeItem(s.name);
            },
            getOptions: ()=>s,
            rehydrate: ()=>v(),
            hasHydrated: ()=>o,
            onHydrate: (y)=>(a.add(y), ()=>{
                    a.delete(y);
                }),
            onFinishHydration: (y)=>(l.add(y), ()=>{
                    l.delete(y);
                })
        }, s.skipHydration || v(), m || f;
    }, $2a051a86cb6e4743$var$xv = (e, t)=>"getStorage" in t || "serialize" in t || "deserialize" in t ? $2a051a86cb6e4743$var$Sv(e, t) : $2a051a86cb6e4743$var$wv(e, t), $2a051a86cb6e4743$var$Cv = $2a051a86cb6e4743$var$xv, $2a051a86cb6e4743$var$ot = {
    displayType: $2a051a86cb6e4743$var$_t.LIST,
    searchTerm: $2a051a86cb6e4743$var$St.getSearchParameterFromUrlByKey("q") || "",
    order: $2a051a86cb6e4743$var$St.getSearchParameterFromUrlByKey("orderBy") || $2a051a86cb6e4743$var$eu.RELEVANCY,
    page: Number($2a051a86cb6e4743$var$St.getSearchParameterFromUrlByKey("page")) || 0,
    path: $2a051a86cb6e4743$var$St.getSearchParameterFromUrlByKey("path") || null,
    facetTags: $2a051a86cb6e4743$var$St.getSelectedTagsFromSearchParams("facetTags") || [],
    facetedSearchResults: void 0,
    minPublicationYear: Number($2a051a86cb6e4743$var$St.getSearchParameterFromUrlByKey("minPublicationYear")) || 0,
    maxPublicationYear: Number($2a051a86cb6e4743$var$St.getSearchParameterFromUrlByKey("maxPublicationYear")) || 0
}, $2a051a86cb6e4743$var$Ev = {
    setUrlQueryParameter: (e, t)=>{
        const n = new URLSearchParams($2a051a86cb6e4743$var$St.getUrlQuery());
        let r = t;
        Array.isArray(r) && (r = r.join(",")), typeof r == "number" ? n.set(e, r) : r && r.length > 0 ? n.set(e, r.toString()) : n.delete(e), window.history.replaceState(null, "", `?${n.toString()}`);
    }
}, $2a051a86cb6e4743$var$K = $2a051a86cb6e4743$var$mv()($2a051a86cb6e4743$var$Cv((e, t)=>({
        displayType: $2a051a86cb6e4743$var$ot.displayType,
        setDisplayType: (n)=>e(()=>({
                    displayType: n
                })),
        searchTerm: $2a051a86cb6e4743$var$ot.searchTerm,
        setSearchTerm: (n)=>e(()=>({
                    searchTerm: n,
                    page: 0
                })),
        order: $2a051a86cb6e4743$var$ot.order,
        setOrder: (n)=>e(()=>({
                    order: n,
                    page: 0
                })),
        page: $2a051a86cb6e4743$var$ot.page,
        setPage: (n)=>e(()=>({
                    page: n
                })),
        path: $2a051a86cb6e4743$var$ot.path,
        resetPath: ()=>e(()=>({
                    path: null
                })),
        facetTags: $2a051a86cb6e4743$var$ot.facetTags,
        addFacetTag: (n)=>e(()=>({
                    facetTags: [
                        ...new Set([
                            ...t().facetTags,
                            n
                        ])
                    ],
                    page: 0
                })),
        removeFacetTag: (n)=>e(()=>({
                    facetTags: [
                        ...t().facetTags.filter((r)=>r !== n)
                    ],
                    page: 0
                })),
        facetedSearchResults: $2a051a86cb6e4743$var$ot.facetedSearchResults,
        setFacetedSearchResults: (n)=>e(()=>({
                    facetedSearchResults: n
                })),
        minPublicationYear: $2a051a86cb6e4743$var$ot.minPublicationYear,
        setMinPublicationYear: (n)=>e(()=>({
                    minPublicationYear: n,
                    page: 0
                })),
        maxPublicationYear: $2a051a86cb6e4743$var$ot.maxPublicationYear,
        setMaxPublicationYear: (n)=>e(()=>({
                    maxPublicationYear: n,
                    page: 0
                })),
        resetFilters: ()=>e(()=>({
                    facetTags: [],
                    minPublicationYear: $2a051a86cb6e4743$var$ot.minPublicationYear,
                    maxPublicationYear: $2a051a86cb6e4743$var$ot.maxPublicationYear,
                    page: 0
                }))
    }), {
    name: "search-app-store",
    storage: $2a051a86cb6e4743$var$yv(()=>$2a051a86cb6e4743$var$Ev),
    partialize: (e)=>({
            orderBy: e.order,
            page: e.page,
            path: e.path,
            q: e.searchTerm,
            ...e.facetTags && {
                facetTags: e.facetTags
            },
            ...e.minPublicationYear && {
                minPublicationYear: e.minPublicationYear
            },
            ...e.maxPublicationYear && {
                maxPublicationYear: e.maxPublicationYear
            }
        })
})), $2a051a86cb6e4743$var$kv = ({ label: e })=>{
    const r = $2a051a86cb6e4743$var$I.useId(), i1 = $2a051a86cb6e4743$var$I.useId(), s = $2a051a86cb6e4743$var$I.useId(), o = $2a051a86cb6e4743$var$I.useId(), a = $2a051a86cb6e4743$var$I.useId(), l = $2a051a86cb6e4743$var$I.useId(), u = $2a051a86cb6e4743$var$I.useRef(), [c, d] = $2a051a86cb6e4743$var$I.useState(!0), [f, m] = $2a051a86cb6e4743$var$I.useState(!1), v = $2a051a86cb6e4743$var$K((F)=>F.facetedSearchResults), y = $2a051a86cb6e4743$var$K((F)=>F.minPublicationYear), k = $2a051a86cb6e4743$var$K((F)=>F.setMinPublicationYear), p = $2a051a86cb6e4743$var$K((F)=>F.maxPublicationYear), h = $2a051a86cb6e4743$var$K((F)=>F.setMaxPublicationYear), [g, E] = $2a051a86cb6e4743$var$I.useState({
        min: y,
        max: p
    }), [P, N] = $2a051a86cb6e4743$var$I.useState(g), b = $2a051a86cb6e4743$var$Xd(g, 500), { t: R } = $2a051a86cb6e4743$var$Nt(), D = ()=>{
        var F, W;
        if (P) {
            const x = P.max - P.min, T = g.min - P.min, Q = g.max - P.min;
            (F = u.current) == null || F.style.setProperty("--range-track-min-percentage", `${T / x * 100}%`), (W = u.current) == null || W.style.setProperty("--range-track-max-percentage", `${Q / x * 100}%`);
        }
    }, H = (F)=>{
        f || m(!0), E({
            min: Math.min(Number(F.target.value), g.max),
            max: g.max
        });
    }, M = (F)=>{
        f || m(!0), E({
            min: g.min,
            max: Math.max(Number(F.target.value), g.min)
        });
    }, L = ()=>{
        d(!c);
    };
    return $2a051a86cb6e4743$var$I.useEffect(()=>{
        v != null && v.minPublicationYear && v != null && v.maxPublicationYear && ((!y || !p) && E({
            min: v.minPublicationYear,
            max: v.maxPublicationYear
        }), N({
            min: v.minPublicationYear,
            max: v.maxPublicationYear
        }));
    }, [
        v
    ]), $2a051a86cb6e4743$var$I.useEffect(()=>{
        D();
    }, [
        P,
        g
    ]), $2a051a86cb6e4743$var$I.useEffect(()=>{
        f && (k(Math.max(b.min, P.min)), h(Math.min(Math.max(b.max, P.min), P.max)));
    }, [
        b
    ]), P && g ? $2a051a86cb6e4743$var$S.jsxs("fieldset", {
        id: r,
        className: "cmp-facet-group",
        children: [
            $2a051a86cb6e4743$var$S.jsx("legend", {
                className: "cmp-facet-group__header",
                children: $2a051a86cb6e4743$var$S.jsxs("button", {
                    type: "button",
                    className: "cmp-facet-group__header-button",
                    "aria-expanded": c,
                    onClick: L,
                    children: [
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-title",
                            children: e
                        }),
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-icon"
                        })
                    ]
                })
            }),
            $2a051a86cb6e4743$var$S.jsx("div", {
                id: i1,
                className: `cmp-facet-group__content ${c ? "cmp-facet-group__content--expanded" : ""}`,
                "aria-hidden": "true",
                children: $2a051a86cb6e4743$var$S.jsxs("div", {
                    className: "cmp-facet-date-range",
                    ref: u,
                    children: [
                        $2a051a86cb6e4743$var$S.jsxs("div", {
                            className: "cmp-facet-date-range__range-wrapper",
                            children: [
                                $2a051a86cb6e4743$var$S.jsx("input", {
                                    id: "start-range",
                                    type: "range",
                                    "aria-labelledby": s,
                                    min: P.min,
                                    max: P.max,
                                    value: g.min,
                                    onChange: H
                                }),
                                $2a051a86cb6e4743$var$S.jsx("input", {
                                    id: "end-range",
                                    type: "range",
                                    "aria-labelledby": o,
                                    min: P.min,
                                    max: P.max,
                                    value: g.max,
                                    onChange: M
                                })
                            ]
                        }),
                        $2a051a86cb6e4743$var$S.jsxs("div", {
                            className: "cmp-facet-date-range__field-wrapper",
                            children: [
                                $2a051a86cb6e4743$var$S.jsxs("div", {
                                    className: "cmp-facet-date-range__field",
                                    children: [
                                        $2a051a86cb6e4743$var$S.jsx("label", {
                                            id: s,
                                            htmlFor: a,
                                            children: R("search-app-facet-rail-date-start-year")
                                        }),
                                        $2a051a86cb6e4743$var$S.jsx("input", {
                                            className: "cmp-facet-date-range__date-field",
                                            id: a,
                                            type: "number",
                                            min: P.min,
                                            max: P.max,
                                            value: g.min,
                                            onChange: H
                                        })
                                    ]
                                }),
                                $2a051a86cb6e4743$var$S.jsxs("div", {
                                    className: "cmp-facet-date-range__field",
                                    children: [
                                        $2a051a86cb6e4743$var$S.jsx("label", {
                                            id: o,
                                            htmlFor: l,
                                            children: R("search-app-facet-rail-date-end-year")
                                        }),
                                        $2a051a86cb6e4743$var$S.jsx("input", {
                                            className: "cmp-facet-date-range__date-field",
                                            id: l,
                                            type: "number",
                                            min: P.min,
                                            max: P.max,
                                            value: g.max,
                                            onChange: M
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }) : null;
}, $2a051a86cb6e4743$var$Ni = (e)=>{
    var s;
    const { checked: t, onChange: n, tag: r, disabled: i1 } = e;
    return $2a051a86cb6e4743$var$S.jsxs("label", {
        className: "cmp-form-options__field-label",
        children: [
            $2a051a86cb6e4743$var$S.jsx("input", {
                type: "checkbox",
                className: "cmp-form-options__field",
                name: r.id,
                value: r.id,
                onChange: n,
                checked: t,
                disabled: i1
            }, r.id),
            $2a051a86cb6e4743$var$S.jsxs("span", {
                className: "cmp-facet-group__input-description",
                children: [
                    r.title,
                    r.count && $2a051a86cb6e4743$var$S.jsxs("span", {
                        className: "cmp-facet-group__input-count",
                        children: [
                            "(",
                            (s = r.count) == null ? void 0 : s.toString(),
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
}, $2a051a86cb6e4743$var$Ao = (e, t)=>{
    if (e && e.facets && e.facets.length > 0) return e.facets.find((n)=>(n == null ? void 0 : n.id) === t);
}, $2a051a86cb6e4743$var$Pv = ({ id: e, label: t })=>{
    const n = $2a051a86cb6e4743$var$I.useId(), r = $2a051a86cb6e4743$var$I.useId(), [i1, s] = $2a051a86cb6e4743$var$I.useState(!0), [o, a] = $2a051a86cb6e4743$var$I.useState(), l = $2a051a86cb6e4743$var$K((v)=>v.facetTags), u = $2a051a86cb6e4743$var$K((v)=>v.facetedSearchResults), c = $2a051a86cb6e4743$var$K((v)=>v.addFacetTag), d = $2a051a86cb6e4743$var$K((v)=>v.removeFacetTag);
    $2a051a86cb6e4743$var$I.useEffect(()=>{
        const v = $2a051a86cb6e4743$var$Ao(u, e);
        v && a(v);
        const y = v == null ? void 0 : v.tags.map((p)=>p.id), k = y && o && l.filter((p)=>!y.includes(p) && p.startsWith(o.id));
        k && k.length > 0 && k.forEach((p)=>{
            d(p);
        });
    }, [
        u
    ]);
    const f = ()=>{
        s(!i1);
    }, m = (v)=>{
        v.currentTarget.checked ? c(v.currentTarget.value) : d(v.currentTarget.value);
    };
    return o && o.tags && o.tags.length > 0 ? $2a051a86cb6e4743$var$S.jsxs("fieldset", {
        id: n,
        className: "cmp-facet-group",
        children: [
            $2a051a86cb6e4743$var$S.jsx("legend", {
                className: "cmp-facet-group__header",
                children: $2a051a86cb6e4743$var$S.jsxs("button", {
                    type: "button",
                    className: "cmp-facet-group__header-button",
                    onClick: f,
                    "aria-controls": `content-${n}`,
                    "aria-expanded": i1,
                    children: [
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-title",
                            children: t
                        }),
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-icon"
                        })
                    ]
                })
            }),
            $2a051a86cb6e4743$var$S.jsx("div", {
                id: r,
                className: `cmp-facet-group__content ${i1 ? "cmp-facet-group__content--expanded" : ""} cmp-form-options cmp-form-options--checkbox`,
                "aria-hidden": !i1,
                children: $2a051a86cb6e4743$var$S.jsx("div", {
                    className: "cmp-facet-group__scroll-area",
                    children: o.tags.map((v, y)=>{
                        const k = l.includes(v.id);
                        return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Ni, {
                            checked: k,
                            tag: v,
                            onChange: m
                        }, `${v.id}--${y}`);
                    })
                })
            })
        ]
    }) : null;
};
var $2a051a86cb6e4743$var$Lt = ((e)=>(e.ARROW_DOWN = "ArrowDown", e.ARROW_UP = "ArrowUp", e.ENTER = "Enter", e.ESCAPE = "Escape", e))($2a051a86cb6e4743$var$Lt || {});
const $2a051a86cb6e4743$var$nh = ({ id: e, placeholder: t, exludeTags: n })=>{
    const i1 = $2a051a86cb6e4743$var$I.useId(), s = $2a051a86cb6e4743$var$I.useId(), [o, a] = $2a051a86cb6e4743$var$I.useState(), l = $2a051a86cb6e4743$var$K((M)=>M.facetTags), u = $2a051a86cb6e4743$var$K((M)=>M.facetedSearchResults), c = $2a051a86cb6e4743$var$K((M)=>M.addFacetTag), d = $2a051a86cb6e4743$var$K((M)=>M.removeFacetTag), [f, m] = $2a051a86cb6e4743$var$I.useState(""), [v, y] = $2a051a86cb6e4743$var$I.useState(!1), k = $2a051a86cb6e4743$var$I.useRef(null), { t: p } = $2a051a86cb6e4743$var$Nt(), h = (M)=>{
        var L, F;
        M ? (M.ariaSelected = "true", M.id && ((L = k.current) == null || L.setAttribute("aria-activedescendant", M.id))) : (F = k.current) == null || F.removeAttribute("aria-activedescendant");
    }, g = ()=>{
        y(!1), h(null);
    }, E = (M)=>{
        M.currentTarget.checked ? c(M.currentTarget.value) : d(M.currentTarget.value), g();
    }, P = (M)=>{
        setTimeout(()=>{
            var L;
            return m((L = M.target) == null ? void 0 : L.value);
        }, 300);
    }, N = (M)=>{
        y(!0);
    }, b = (M)=>{
        k.current && !k.current.contains(M.target) && g();
    }, R = (M)=>{
        switch(M.code){
            case $2a051a86cb6e4743$var$Lt.ENTER:
                M.preventDefault();
                break;
            case $2a051a86cb6e4743$var$Lt.ESCAPE:
                g();
                break;
            case $2a051a86cb6e4743$var$Lt.ARROW_DOWN:
                break;
            case $2a051a86cb6e4743$var$Lt.ARROW_UP:
                break;
        }
    }, D = (M)=>{
        switch(M.code){
            case $2a051a86cb6e4743$var$Lt.ARROW_DOWN:
            case $2a051a86cb6e4743$var$Lt.ARROW_UP:
            case $2a051a86cb6e4743$var$Lt.ENTER:
            case $2a051a86cb6e4743$var$Lt.ESCAPE:
                M.preventDefault();
        }
    }, H = (M)=>M.filter((L)=>L.title && L.title.toLowerCase().indexOf(f.toLowerCase()) >= 0);
    if ($2a051a86cb6e4743$var$I.useEffect(()=>(document.addEventListener("click", b, !v), ()=>{
            document.removeEventListener("click", b, !v);
        })), $2a051a86cb6e4743$var$I.useEffect(()=>{
        const M = $2a051a86cb6e4743$var$Ao(u, e);
        M && a(M);
    }, [
        u
    ]), o && o.tags && o.tags.length > 0) {
        const M = H(o.tags);
        return $2a051a86cb6e4743$var$S.jsxs("div", {
            className: `cmp-facets-search-combobox${v ? " cmp-facets-search-combobox--expanded" : ""}`,
            children: [
                $2a051a86cb6e4743$var$S.jsxs("form", {
                    children: [
                        $2a051a86cb6e4743$var$S.jsx("label", {
                            htmlFor: i1,
                            children: t
                        }),
                        $2a051a86cb6e4743$var$S.jsx("input", {
                            id: i1,
                            ref: k,
                            type: "search",
                            placeholder: t,
                            autoComplete: "off",
                            autoCorrect: "off",
                            autoCapitalize: "off",
                            spellCheck: "false",
                            role: "combobox",
                            "aria-autocomplete": "list",
                            "aria-expanded": v,
                            "aria-owns": s,
                            onChange: (L)=>P(L),
                            onFocus: (L)=>N(),
                            onKeyDown: R,
                            onKeyUp: D
                        })
                    ]
                }),
                $2a051a86cb6e4743$var$S.jsxs("aside", {
                    id: s,
                    className: "cmp-facets-search-combobox__options",
                    role: "listbox",
                    "aria-labelledby": i1,
                    children: [
                        M.length > 0 && M.map((L, F)=>l != null && l.includes(L.id) || n != null && n.includes(L.id) ? null : $2a051a86cb6e4743$var$S.jsx("div", {
                                className: "cmp-facets-search-combobox__option",
                                role: "option",
                                "aria-selected": "false",
                                children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Ni, {
                                    checked: !1,
                                    tag: L,
                                    onChange: E
                                })
                            }, `${L.id}--${F}`)),
                        M.length === 0 && $2a051a86cb6e4743$var$S.jsx("p", {
                            children: p("search-app-facet-rail-searchbox-no-results")
                        })
                    ]
                })
            ]
        });
    }
    return null;
}, $2a051a86cb6e4743$var$rh = ({ id: e, label: t, placeholder: n })=>{
    const r = $2a051a86cb6e4743$var$I.useId(), i1 = $2a051a86cb6e4743$var$I.useId(), [s, o] = $2a051a86cb6e4743$var$I.useState(!0), [a, l] = $2a051a86cb6e4743$var$I.useState(), u = $2a051a86cb6e4743$var$K((y)=>y.facetTags), c = $2a051a86cb6e4743$var$K((y)=>y.facetedSearchResults), d = $2a051a86cb6e4743$var$K((y)=>y.addFacetTag), f = $2a051a86cb6e4743$var$K((y)=>y.removeFacetTag);
    $2a051a86cb6e4743$var$I.useEffect(()=>{
        const y = $2a051a86cb6e4743$var$Ao(c, e);
        y && l(y);
    }, [
        c
    ]);
    const m = ()=>{
        o(!s);
    }, v = (y)=>{
        y.currentTarget.checked ? d(y.currentTarget.value) : f(y.currentTarget.value);
    };
    return a && a.tags && a.tags.length > 0 ? $2a051a86cb6e4743$var$S.jsxs("fieldset", {
        id: r,
        className: "cmp-facet-group",
        children: [
            $2a051a86cb6e4743$var$S.jsx("legend", {
                className: "cmp-facet-group__header",
                children: $2a051a86cb6e4743$var$S.jsxs("button", {
                    type: "button",
                    className: "cmp-facet-group__header-button",
                    onClick: m,
                    "aria-controls": i1,
                    "aria-expanded": s,
                    children: [
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-title",
                            children: t
                        }),
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-icon"
                        })
                    ]
                })
            }),
            $2a051a86cb6e4743$var$S.jsxs("div", {
                id: i1,
                className: `cmp-facet-group__content ${s ? "cmp-facet-group__content--expanded" : ""} cmp-form-options cmp-form-options--checkbox`,
                "aria-hidden": !s,
                children: [
                    $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$nh, {
                        id: e,
                        placeholder: n
                    }),
                    a.tags.map((y, k)=>{
                        const p = u.includes(y.id);
                        return p ? $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Ni, {
                            checked: p,
                            tag: y,
                            onChange: v
                        }, `${y.id}--${k}`) : null;
                    })
                ]
            })
        ]
    }) : null;
}, $2a051a86cb6e4743$var$_v = ({ id: e, label: t, subtitle: n, placeholder: r, promotedItems: i1 })=>{
    const s = $2a051a86cb6e4743$var$I.useId(), o = $2a051a86cb6e4743$var$I.useId(), [a, l] = $2a051a86cb6e4743$var$I.useState(!0), [u, c] = $2a051a86cb6e4743$var$I.useState(), d = $2a051a86cb6e4743$var$K((h)=>h.facetTags), f = $2a051a86cb6e4743$var$K((h)=>h.facetedSearchResults), m = $2a051a86cb6e4743$var$K((h)=>h.addFacetTag), v = $2a051a86cb6e4743$var$K((h)=>h.removeFacetTag), y = i1.map((h)=>h.id);
    $2a051a86cb6e4743$var$I.useEffect(()=>{
        const h = $2a051a86cb6e4743$var$Ao(f, e);
        h && c(h);
    }, [
        f
    ]);
    const k = ()=>{
        l(!a);
    }, p = (h)=>{
        h.currentTarget.checked ? m(h.currentTarget.value) : v(h.currentTarget.value);
    };
    return i1 && i1.length > 0 && u != null && u.tags && u.tags.length > 0 ? $2a051a86cb6e4743$var$S.jsxs("fieldset", {
        id: s,
        className: "cmp-facet-group",
        children: [
            $2a051a86cb6e4743$var$S.jsx("legend", {
                className: "cmp-facet-group__header",
                children: $2a051a86cb6e4743$var$S.jsxs("button", {
                    type: "button",
                    className: "cmp-facet-group__header-button",
                    onClick: k,
                    "aria-controls": o,
                    "aria-expanded": a,
                    children: [
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-title",
                            children: t
                        }),
                        $2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-facet-group__header-icon"
                        })
                    ]
                })
            }),
            $2a051a86cb6e4743$var$S.jsxs("div", {
                id: o,
                className: `cmp-facet-group__content ${a ? "cmp-facet-group__content--expanded" : ""} cmp-form-options cmp-form-options--checkbox`,
                "aria-hidden": !a,
                children: [
                    i1 && i1.length > 0 && $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$S.Fragment, {
                        children: $2a051a86cb6e4743$var$S.jsx("div", {
                            className: "cmp-facets-tag-search-promoted-items",
                            children: i1.map((h, g)=>{
                                const E = u == null ? void 0 : u.tags.find((R)=>R.id === h.id), P = E || h, N = !E, b = !N && d.includes(P.id);
                                return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Ni, {
                                    checked: b,
                                    tag: P,
                                    onChange: p,
                                    disabled: N
                                }, `${P.id}--${g}`);
                            })
                        })
                    }),
                    $2a051a86cb6e4743$var$S.jsxs("fieldset", {
                        className: "cmp-facet-group__fieldset",
                        children: [
                            $2a051a86cb6e4743$var$S.jsx("legend", {
                                children: n
                            }),
                            (u == null ? void 0 : u.tags) && u.tags.length > 0 && $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$nh, {
                                id: e,
                                placeholder: r,
                                exludeTags: y
                            }),
                            (u == null ? void 0 : u.tags) && u.tags.length > 0 && u.tags.map((h, g)=>{
                                const E = d.includes(h.id);
                                return !y.includes(h.id) && E ? $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Ni, {
                                    checked: E,
                                    tag: h,
                                    onChange: p
                                }, `${h.id}--${g}`) : null;
                            })
                        ]
                    })
                ]
            })
        ]
    }) : $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$rh, {
        id: e,
        label: t,
        placeholder: r
    });
};
var $2a051a86cb6e4743$var$li = ((e)=>(e.DATE = "date", e.TAG_LIST = "tag_list", e.TAG_SEARCH = "tag_search", e.TAG_SEARCH_WITH_PROMOTED_ITEMS = "tag_search_with_promoted_items", e))($2a051a86cb6e4743$var$li || {});
const $2a051a86cb6e4743$var$ih = ()=>{
    const e = $2a051a86cb6e4743$var$Fo();
    return $2a051a86cb6e4743$var$S.jsx("div", {
        className: "cmp-facet-rail__content",
        children: e.facetGroups && Object.entries(e.facetGroups).map(([t, n])=>{
            switch(n.type){
                case $2a051a86cb6e4743$var$li.DATE:
                    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$kv, {
                        label: n.label
                    }, t);
                case $2a051a86cb6e4743$var$li.TAG_LIST:
                    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Pv, {
                        id: n.id,
                        label: n.label
                    }, t);
                case $2a051a86cb6e4743$var$li.TAG_SEARCH:
                    const r = n;
                    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$rh, {
                        id: n.id,
                        label: r.label,
                        placeholder: r.placeholder
                    }, t);
                case $2a051a86cb6e4743$var$li.TAG_SEARCH_WITH_PROMOTED_ITEMS:
                    const i1 = n;
                    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$_v, {
                        id: n.id,
                        label: i1.label,
                        subtitle: i1.subtitle,
                        placeholder: i1.placeholder,
                        promotedItems: i1.promotedItems
                    }, t);
                default:
                    return null;
            }
        })
    });
}, $2a051a86cb6e4743$var$sh = ()=>{
    const [e, t] = $2a051a86cb6e4743$var$I.useState(!1), n = $2a051a86cb6e4743$var$K((l)=>l.resetFilters), r = $2a051a86cb6e4743$var$K((l)=>l.facetTags), i1 = $2a051a86cb6e4743$var$K((l)=>l.minPublicationYear), s = $2a051a86cb6e4743$var$K((l)=>l.maxPublicationYear), { t: o } = $2a051a86cb6e4743$var$Nt(), a = ()=>n();
    return $2a051a86cb6e4743$var$I.useEffect(()=>{
        r && r.length > 0 || i1 && s ? t(!0) : t(!1);
    }, [
        r,
        i1,
        s
    ]), $2a051a86cb6e4743$var$S.jsxs("div", {
        className: "cmp-facet-rail__header",
        children: [
            $2a051a86cb6e4743$var$S.jsx("h2", {
                className: "cmp-facet-rail__header-title",
                children: o("search-app-facet-rail-filters")
            }),
            $2a051a86cb6e4743$var$S.jsx("div", {
                className: `cmp-facet-rail__header-button button button--secondary${e ? "" : " cmp-facet-rail__header-button--hidden"}`,
                children: $2a051a86cb6e4743$var$S.jsx("button", {
                    className: "cmp-button",
                    type: "button",
                    onClick: a,
                    children: $2a051a86cb6e4743$var$S.jsx("span", {
                        className: "cmp-button__text",
                        children: o("search-app-facet-rail-reset")
                    })
                })
            })
        ]
    });
}, $2a051a86cb6e4743$var$bv = ()=>{
    const e = $2a051a86cb6e4743$var$Fo(), { t: t } = $2a051a86cb6e4743$var$Nt();
    return $2a051a86cb6e4743$var$S.jsx("div", {
        className: "cmp-facet-rail__footer",
        children: $2a051a86cb6e4743$var$S.jsx("div", {
            className: "cmp-facet-rail__footer-button button button--primary",
            children: $2a051a86cb6e4743$var$S.jsx("button", {
                className: "cmp-button",
                type: "button",
                onClick: e.toggleMobileDialogVisibility,
                children: $2a051a86cb6e4743$var$S.jsx("span", {
                    className: "cmp-button__text",
                    children: t("search-app-facet-rail-show-results")
                })
            })
        })
    });
}, $2a051a86cb6e4743$var$Ov = ()=>{
    const e = $2a051a86cb6e4743$var$Fo(), t = $2a051a86cb6e4743$var$I.useRef(), n = window.matchMedia("(min-width: 992px)");
    return $2a051a86cb6e4743$var$I.useEffect(()=>{
        const r = ()=>{
            n.matches && e.mobileModalIsActive && e.toggleMobileDialogVisibility();
        };
        return n.addEventListener("change", r), ()=>{
            n.removeEventListener("change", r);
        };
    }, [
        n
    ]), $2a051a86cb6e4743$var$I.useEffect(()=>{
        var r, i1;
        e.mobileModalIsActive ? (document.body.classList.add("js-mobile-facet-rail-is-open"), document.documentElement.style.overflowY = "hidden", document.documentElement.style.paddingInlineEnd = "var(--scrollbar-width)", document.documentElement.style.position = "fixed", (r = t.current) == null || r.showModal()) : ((i1 = t.current) == null || i1.close(), document.documentElement.style.overflowY = "", document.documentElement.style.paddingInlineEnd = "", document.documentElement.style.position = "", document.body.classList.remove("js-mobile-facet-rail-is-open"));
    }, [
        e.mobileModalIsActive
    ]), $2a051a86cb6e4743$var$S.jsx("dialog", {
        className: "cmp-facet-rail-mobile-dialog",
        ref: t,
        onCancel: e.toggleMobileDialogVisibility,
        children: $2a051a86cb6e4743$var$S.jsxs("div", {
            className: "cmp-facet-rail-mobile-dialog__wrapper",
            children: [
                $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$sh, {}),
                $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$ih, {}),
                $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$bv, {})
            ]
        })
    });
}, $2a051a86cb6e4743$var$Nv = ()=>{
    const e = $2a051a86cb6e4743$var$Fo(), { t: t } = $2a051a86cb6e4743$var$Nt();
    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$S.Fragment, {
        children: $2a051a86cb6e4743$var$S.jsxs("div", {
            className: "cmp-facet-rail",
            children: [
                $2a051a86cb6e4743$var$S.jsxs("div", {
                    className: "cmp-facet-rail__toggle-mobile",
                    children: [
                        $2a051a86cb6e4743$var$S.jsxs("div", {
                            className: "cmp-facet-rail__toggle-mobile--header",
                            children: [
                                $2a051a86cb6e4743$var$S.jsx("h2", {
                                    className: "cmp-facet-rail__toggle-mobile--header-title",
                                    children: t("search-app-facet-rail-filters")
                                }),
                                $2a051a86cb6e4743$var$S.jsx("button", {
                                    className: "cmp-facet-rail__toggle-mobile--header-button",
                                    type: "button",
                                    onClick: e.toggleMobileDialogVisibility,
                                    children: $2a051a86cb6e4743$var$S.jsx("span", {
                                        children: t("search-app-facet-rail-filters")
                                    })
                                })
                            ]
                        }),
                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Ov, {})
                    ]
                }),
                $2a051a86cb6e4743$var$S.jsxs("div", {
                    className: "cmp-facet-rail__desktop",
                    children: [
                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$sh, {}),
                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$ih, {})
                    ]
                })
            ]
        })
    });
}, $2a051a86cb6e4743$var$Tv = ()=>{
    const e = new $2a051a86cb6e4743$var$jo;
    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Io, {
        client: e,
        children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Vy, {
            children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Nv, {})
        })
    });
}, $2a051a86cb6e4743$var$Rt = {
    globalSearch: !1,
    searchApiUrl: window.aemOecdSearchAppConfiguration.searchApiUrl,
    siteName: window.aemOecdSearchAppConfiguration.siteName,
    interfaceLanguage: $2a051a86cb6e4743$var$le.resolvedLanguage || window.localStorage.i18nextLng || "en",
    pageSize: window.aemOecdSearchAppConfiguration.pageSize,
    initialFacetTags: window.aemOecdSearchAppConfiguration.initialFacetTags || [],
    templateConfigs: window.aemOecdSearchAppConfiguration.templateConfigs || [],
    googleTagManagerEnabled: window.aemOecdSearchAppConfiguration.googleTagManagerEnabled || !1,
    parentPathBreadcrumbItems: window.aemOecdSearchAppConfiguration.parentPathBreadcrumbItems || []
}, $2a051a86cb6e4743$var$oh = $2a051a86cb6e4743$var$I.createContext($2a051a86cb6e4743$var$Rt), $2a051a86cb6e4743$var$tu = ({ globalSearch: e, children: t })=>$2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$oh.Provider, {
        value: {
            globalSearch: e,
            searchApiUrl: $2a051a86cb6e4743$var$Rt.searchApiUrl,
            siteName: $2a051a86cb6e4743$var$Rt.siteName,
            interfaceLanguage: $2a051a86cb6e4743$var$Rt.interfaceLanguage,
            pageSize: $2a051a86cb6e4743$var$Rt.pageSize,
            initialFacetTags: $2a051a86cb6e4743$var$Rt.initialFacetTags,
            templateConfigs: $2a051a86cb6e4743$var$Rt.templateConfigs,
            googleTagManagerEnabled: $2a051a86cb6e4743$var$Rt.googleTagManagerEnabled,
            parentPathBreadcrumbItems: $2a051a86cb6e4743$var$Rt.parentPathBreadcrumbItems
        },
        children: t
    }), $2a051a86cb6e4743$var$os = ()=>{
    const e = $2a051a86cb6e4743$var$I.useContext($2a051a86cb6e4743$var$oh);
    if (!e) throw new Error("useSearchAppContext must be used within a SearchAppContextProvider");
    return e;
}, $2a051a86cb6e4743$var$ah = ()=>{
    var u;
    const e = $2a051a86cb6e4743$var$os();
    if (!e.googleTagManagerEnabled) return null;
    const t = "search", n = ((u = $2a051a86cb6e4743$var$K((c)=>c.searchTerm)) == null ? void 0 : u.length) > 0, r = $2a051a86cb6e4743$var$K((c)=>c.searchTerm), i1 = $2a051a86cb6e4743$var$K((c)=>c.facetTags), s = $2a051a86cb6e4743$var$K((c)=>c.minPublicationYear), o = $2a051a86cb6e4743$var$K((c)=>c.maxPublicationYear), a = $2a051a86cb6e4743$var$K((c)=>c.order), l = $2a051a86cb6e4743$var$K((c)=>c.page);
    return window.dataLayer = window.dataLayer || [], $2a051a86cb6e4743$var$I.useEffect(()=>{
        n && window.dataLayer.push({
            event: t,
            search_type: e.globalSearch ? "global_search_page" : "faceted_search_page",
            ...r && {
                search_term: r
            },
            ...i1 && i1.length > 0 && {
                search_facets: i1.join(";")
            },
            ...e.initialFacetTags.length > 0 && {
                search_hidden_facets: e.initialFacetTags.join(";")
            },
            ...s && {
                search_min_publication_year: s
            },
            ...o && {
                search_max_publication_year: o
            },
            search_order: a,
            search_page_number: l
        });
    }, [
        n,
        r,
        i1,
        s,
        o,
        a,
        l
    ]), $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$S.Fragment, {});
}, $2a051a86cb6e4743$var$lh = ()=>{
    var s, o;
    const e = $2a051a86cb6e4743$var$os(), t = $2a051a86cb6e4743$var$K((a)=>a.path), n = $2a051a86cb6e4743$var$K((a)=>a.resetPath), { t: r } = $2a051a86cb6e4743$var$Nt(), i1 = ()=>{
        n();
    };
    return (s = e.parentPathBreadcrumbItems) != null && s.length && t ? $2a051a86cb6e4743$var$S.jsx("div", {
        className: "cmp-search-results__path-filter",
        children: $2a051a86cb6e4743$var$S.jsxs("div", {
            className: "cmp-search-results__path-indicator",
            children: [
                $2a051a86cb6e4743$var$S.jsx("span", {
                    className: "cmp-search-results__path-indicator__path-prefix",
                    children: r("search-app-path-filter-in")
                }),
                $2a051a86cb6e4743$var$S.jsx("span", {
                    className: "cmp-search-results__path-indicator__path",
                    id: "path-segment-path",
                    children: ((o = e.parentPathBreadcrumbItems) == null ? void 0 : o.length) && e.parentPathBreadcrumbItems.map((a, l)=>$2a051a86cb6e4743$var$S.jsx("span", {
                            className: "cmp-search-results__path-indicator__path-part",
                            children: a
                        }, l))
                }),
                $2a051a86cb6e4743$var$S.jsx("button", {
                    className: "cmp-search-results__path-indicator__action",
                    id: "path-segment-btn",
                    onClick: i1,
                    "aria-labelledby": "path-segment-btn",
                    "aria-describedby": "path-segment-path",
                    children: $2a051a86cb6e4743$var$S.jsx("span", {
                        className: "cmp-search-results__path-indicator__action-label",
                        children: r("search-app-remove-path-filter")
                    })
                })
            ]
        })
    }) : null;
}, $2a051a86cb6e4743$var$uh = ()=>{
    const e = $2a051a86cb6e4743$var$K((r)=>r.facetedSearchResults), t = e == null ? void 0 : e.total, { t: n } = $2a051a86cb6e4743$var$Nt();
    return t ? t > 0 ? $2a051a86cb6e4743$var$S.jsx("span", {
        className: "cmp-search-results__result-count",
        children: n("search-app-results-count", {
            count: t
        })
    }) : $2a051a86cb6e4743$var$S.jsx("div", {
        className: "cmp-search-results__result-count",
        children: n("search-app-results-no-results")
    }) : null;
}, $2a051a86cb6e4743$var$Lv = ({ message: e })=>$2a051a86cb6e4743$var$S.jsx("p", {
        className: "cmp-search-results__loading",
        children: $2a051a86cb6e4743$var$S.jsx("span", {
            className: "cmp-search-results__loading-text",
            children: e
        })
    });
var $2a051a86cb6e4743$var$nu = ((e)=>(e.CARD = "card", e.DATA_CARD = "data-card", e))($2a051a86cb6e4743$var$nu || {});
class $2a051a86cb6e4743$var$Ms {
    static formatDate(t, n, r) {
        const i1 = new Intl.DateTimeFormat(n, r).formatToParts(t).reduce((s, o)=>(s[o.type] = o.value, s), {});
        return `${i1.day} ${i1.month} ${i1.year}`;
    }
    static format(t, n) {
        const r = {
            day: "numeric",
            month: "long",
            year: "numeric",
            timeZone: this.DEFAULT_TIMEZONE
        };
        return this.formatDate(t, n, r);
    }
    static formatShortMonth(t, n) {
        const r = {
            day: "numeric",
            month: "short",
            year: "numeric",
            timeZone: this.DEFAULT_TIMEZONE
        };
        return this.formatDate(t, n, r);
    }
    static formatRange(t, n, r) {
        const i1 = new Date(t), s = new Date(n);
        return i1.getFullYear() === s.getFullYear() ? i1.getMonth() === s.getMonth() ? i1.getDate() === s.getDate() ? this.format(t, r) : `${i1.getDate()}-${s.getDate()} ${this.getMonthFormatted(t, r)} ${i1.getFullYear()}` : `${i1.getDate()} ${this.getMonthFormatted(t, r)} - ${s.getDate()} ${this.getMonthFormatted(n, r)} ${s.getFullYear()}` : `${this.formatShortMonth(t, r)} - ${this.formatShortMonth(n, r)}`;
    }
    static getMonthFormatted(t, n) {
        return new Intl.DateTimeFormat(n, {
            month: "long",
            timeZone: this.DEFAULT_TIMEZONE
        }).format(t);
    }
}
$2a051a86cb6e4743$var$bn($2a051a86cb6e4743$var$Ms, "DEFAULT_TIMEZONE", "CET");
const $2a051a86cb6e4743$var$ru = (e)=>e.url && e.url.length > 0 && e.isExternal ? new URL(e.url).hostname.replace("www.", "") : null, $2a051a86cb6e4743$var$ch = (e)=>e.startDateTime && e.startDateTime.length > 0 ? e.endDateTime && e.endDateTime.length > 0 ? $2a051a86cb6e4743$var$Ms.formatRange(Date.parse(e.startDateTime), Date.parse(e.endDateTime), $2a051a86cb6e4743$var$le.resolvedLanguage ? $2a051a86cb6e4743$var$le.resolvedLanguage : "en") : $2a051a86cb6e4743$var$Ms.format(Date.parse(e.startDateTime), $2a051a86cb6e4743$var$le.resolvedLanguage ? $2a051a86cb6e4743$var$le.resolvedLanguage : "en") : e.publicationDateTime && e.publicationDateTime.length > 0 ? $2a051a86cb6e4743$var$Ms.format(Date.parse(e.publicationDateTime), $2a051a86cb6e4743$var$le.resolvedLanguage ? $2a051a86cb6e4743$var$le.resolvedLanguage : "en") : "", $2a051a86cb6e4743$var$Mo = (e)=>$2a051a86cb6e4743$var$os().templateConfigs.find((n)=>n.templatePath === e.template || null), $2a051a86cb6e4743$var$Rv = (e)=>{
    if (e.template && e.template.length > 0) {
        const t = $2a051a86cb6e4743$var$Mo(e);
        return t == null ? void 0 : t.defaultListRendition;
    }
    return $2a051a86cb6e4743$var$nu.CARD;
}, $2a051a86cb6e4743$var$jv = (e, t)=>{
    if (e === t) return !0;
    const n = e.endsWith(":") || e.endsWith("/") ? e : `${e}/`;
    return t.startsWith(n);
}, $2a051a86cb6e4743$var$Iv = (e, t)=>e ? e.visibleTagsAllowChildTags ? e.visibleTags.some((n)=>t.length > 0 && $2a051a86cb6e4743$var$jv(n, t)) : e.visibleTags.some((n)=>n === t) : !0, $2a051a86cb6e4743$var$iu = (e, t)=>e.tags && e.tags.length > 0 ? t ? e.tags.filter((n)=>$2a051a86cb6e4743$var$Iv(t, n.id)).map((n)=>n.title) : e.tags.map((n)=>n.title) : [], $2a051a86cb6e4743$var$fh = (e)=>{
    if (!e || e.length === 0) return "";
    const t = e.split("/");
    return t[t.length - 1];
}, $2a051a86cb6e4743$var$Fv = ({ searchResult: e })=>{
    const t = $2a051a86cb6e4743$var$ru(e), n = $2a051a86cb6e4743$var$ch(e), r = $2a051a86cb6e4743$var$Mo(e), i1 = $2a051a86cb6e4743$var$iu(e, r);
    return $2a051a86cb6e4743$var$S.jsxs("article", {
        className: `card ${$2a051a86cb6e4743$var$fh(e.template)}${e.colorScheme ? ` card--${e.colorScheme}-theme` : ""}${e.isExternal ? " card--is-external" : ""}`,
        children: [
            e.featuredImageUrl && $2a051a86cb6e4743$var$S.jsx("div", {
                className: "card__image",
                children: $2a051a86cb6e4743$var$S.jsx("div", {
                    className: "cmp-image",
                    children: $2a051a86cb6e4743$var$S.jsx("img", {
                        loading: "lazy",
                        className: "cmp-image__image",
                        src: e.featuredImageUrl,
                        alt: ""
                    })
                })
            }),
            $2a051a86cb6e4743$var$S.jsxs("div", {
                className: "card__content",
                children: [
                    i1 && i1.length > 0 && $2a051a86cb6e4743$var$S.jsx("div", {
                        className: "card__tags",
                        children: i1.map((s, o)=>$2a051a86cb6e4743$var$S.jsx("div", {
                                className: "tag tag--small",
                                children: s
                            }, o))
                    }),
                    $2a051a86cb6e4743$var$S.jsx("div", {
                        className: "card__title",
                        children: e.highlightTitle && e.highlightTitle.length > 0 ? $2a051a86cb6e4743$var$S.jsx("a", {
                            href: e.url || "",
                            className: "card__title-link",
                            dangerouslySetInnerHTML: {
                                __html: e.highlightTitle
                            }
                        }) : $2a051a86cb6e4743$var$S.jsx("a", {
                            href: e.url || "",
                            className: "card__title-link",
                            children: e.title || ""
                        })
                    })
                ]
            }),
            $2a051a86cb6e4743$var$S.jsxs("div", {
                className: "card__metadata",
                children: [
                    t && $2a051a86cb6e4743$var$S.jsx("div", {
                        className: "data-card__external-label",
                        children: t
                    }),
                    $2a051a86cb6e4743$var$S.jsx("div", {
                        className: "card__date",
                        children: n
                    })
                ]
            })
        ]
    });
}, $2a051a86cb6e4743$var$Dv = ({ searchResult: e })=>{
    const t = $2a051a86cb6e4743$var$ru(e), n = $2a051a86cb6e4743$var$Mo(e), r = $2a051a86cb6e4743$var$iu(e, n);
    return $2a051a86cb6e4743$var$S.jsxs("article", {
        className: `data-card ${$2a051a86cb6e4743$var$fh(e.template)}${e.isExternal ? " data-card--is-external" : ""}`,
        children: [
            $2a051a86cb6e4743$var$S.jsxs("div", {
                className: "data-card__content",
                children: [
                    r && r.length > 0 && $2a051a86cb6e4743$var$S.jsx("div", {
                        className: "data-card__tags",
                        children: r.map((i1, s)=>$2a051a86cb6e4743$var$S.jsx("div", {
                                className: "tag tag--small",
                                children: i1
                            }, s))
                    }),
                    e.title && $2a051a86cb6e4743$var$S.jsx("div", {
                        className: "data-card__title",
                        children: $2a051a86cb6e4743$var$S.jsx("a", {
                            href: e.url || "",
                            className: "data-card__title-link",
                            children: e.title
                        })
                    }),
                    e.description && $2a051a86cb6e4743$var$S.jsx("div", {
                        className: "data-card__description",
                        dangerouslySetInnerHTML: {
                            __html: e.description
                        }
                    })
                ]
            }),
            $2a051a86cb6e4743$var$S.jsx("div", {
                className: "data-card__metadata",
                children: t && $2a051a86cb6e4743$var$S.jsx("div", {
                    className: "data-card__external-label",
                    children: t
                })
            })
        ]
    });
}, $2a051a86cb6e4743$var$Av = ({ searchResult: e })=>$2a051a86cb6e4743$var$Rv(e) === $2a051a86cb6e4743$var$nu.DATA_CARD ? $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Dv, {
        searchResult: e
    }) : $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Fv, {
        searchResult: e
    }), $2a051a86cb6e4743$var$Mv = ({ searchResult: e })=>{
    const t = $2a051a86cb6e4743$var$ch(e), n = $2a051a86cb6e4743$var$ru(e), r = $2a051a86cb6e4743$var$Mo(e), i1 = $2a051a86cb6e4743$var$iu(e, r);
    return $2a051a86cb6e4743$var$S.jsxs("article", {
        className: `search-result-list-item${e.isExternal ? " search-result-list-item--is-external" : ""}`,
        children: [
            e.title && $2a051a86cb6e4743$var$S.jsx("div", {
                className: "search-result-list-item__title",
                children: e.isExternal ? $2a051a86cb6e4743$var$S.jsx("a", {
                    href: e.url || "",
                    target: "_blank",
                    rel: "noreferrer",
                    children: e.title
                }) : $2a051a86cb6e4743$var$S.jsx("a", {
                    href: e.url || "",
                    children: e.title
                })
            }),
            $2a051a86cb6e4743$var$S.jsxs("div", {
                className: "search-result-list-item__meta",
                children: [
                    i1.map((s, o)=>$2a051a86cb6e4743$var$S.jsx("span", {
                            className: "search-result-list-item__tag",
                            children: s
                        }, o)),
                    n && $2a051a86cb6e4743$var$S.jsx("span", {
                        className: "search-result-list-item__external-source",
                        children: n
                    }),
                    t && $2a051a86cb6e4743$var$S.jsx("span", {
                        className: "search-result-list-item__date",
                        children: t
                    })
                ]
            }),
            e.snippet && $2a051a86cb6e4743$var$S.jsx("p", {
                className: "search-result-list-item__snippet",
                dangerouslySetInnerHTML: {
                    __html: e.snippet
                }
            })
        ]
    });
};
var $2a051a86cb6e4743$var$dh = {
    exports: {}
};
(function(e, t) {
    (function(n, r) {
        e.exports = r($2a051a86cb6e4743$var$I);
    })($2a051a86cb6e4743$var$mr, (n)=>(()=>{
            var r = {
                703: (a, l, u)=>{
                    var c = u(414);
                    function d() {}
                    function f() {}
                    f.resetWarningCache = d, a.exports = function() {
                        function m(k, p, h, g, E, P) {
                            if (P !== c) {
                                var N = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                                throw N.name = "Invariant Violation", N;
                            }
                        }
                        function v() {
                            return m;
                        }
                        m.isRequired = m;
                        var y = {
                            array: m,
                            bigint: m,
                            bool: m,
                            func: m,
                            number: m,
                            object: m,
                            string: m,
                            symbol: m,
                            any: m,
                            arrayOf: v,
                            element: m,
                            elementType: m,
                            instanceOf: v,
                            node: m,
                            objectOf: v,
                            oneOf: v,
                            oneOfType: v,
                            shape: v,
                            exact: v,
                            checkPropTypes: f,
                            resetWarningCache: d
                        };
                        return y.PropTypes = y, y;
                    };
                },
                697: (a, l, u)=>{
                    a.exports = u(703)();
                },
                414: (a)=>{
                    a.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                },
                98: (a)=>{
                    a.exports = n;
                }
            }, i1 = {};
            function s(a) {
                var l = i1[a];
                if (l !== void 0) return l.exports;
                var u = i1[a] = {
                    exports: {}
                };
                return r[a](u, u.exports, s), u.exports;
            }
            s.n = (a)=>{
                var l = a && a.__esModule ? ()=>a.default : ()=>a;
                return s.d(l, {
                    a: l
                }), l;
            }, s.d = (a, l)=>{
                for(var u in l)s.o(l, u) && !s.o(a, u) && Object.defineProperty(a, u, {
                    enumerable: !0,
                    get: l[u]
                });
            }, s.o = (a, l)=>Object.prototype.hasOwnProperty.call(a, l), s.r = (a)=>{
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(a, "__esModule", {
                    value: !0
                });
            };
            var o = {};
            return (()=>{
                s.r(o), s.d(o, {
                    default: ()=>M
                });
                var a = s(98), l = s.n(a), u = s(697), c = s.n(u);
                function d() {
                    return d = Object.assign ? Object.assign.bind() : function(L) {
                        for(var F = 1; F < arguments.length; F++){
                            var W = arguments[F];
                            for(var x in W)Object.prototype.hasOwnProperty.call(W, x) && (L[x] = W[x]);
                        }
                        return L;
                    }, d.apply(this, arguments);
                }
                var f = function(L) {
                    var F = L.pageClassName, W = L.pageLinkClassName, x = L.page, T = L.selected, Q = L.activeClassName, O = L.activeLinkClassName, _ = L.getEventListener, C = L.pageSelectedHandler, z = L.href, A = L.extraAriaContext, B = L.pageLabelBuilder, q = L.rel, ie = L.ariaLabel || "Page " + x + (A ? " " + A : ""), oe = null;
                    return T && (oe = "page", ie = L.ariaLabel || "Page " + x + " is your current page", F = F !== void 0 ? F + " " + Q : Q, W !== void 0 ? O !== void 0 && (W = W + " " + O) : W = O), l().createElement("li", {
                        className: F
                    }, l().createElement("a", d({
                        rel: q,
                        role: z ? void 0 : "button",
                        className: W,
                        href: z,
                        tabIndex: T ? "-1" : "0",
                        "aria-label": ie,
                        "aria-current": oe,
                        onKeyPress: C
                    }, _(C)), B(x)));
                };
                f.propTypes = {
                    pageSelectedHandler: c().func.isRequired,
                    selected: c().bool.isRequired,
                    pageClassName: c().string,
                    pageLinkClassName: c().string,
                    activeClassName: c().string,
                    activeLinkClassName: c().string,
                    extraAriaContext: c().string,
                    href: c().string,
                    ariaLabel: c().string,
                    page: c().number.isRequired,
                    getEventListener: c().func.isRequired,
                    pageLabelBuilder: c().func.isRequired,
                    rel: c().string
                };
                const m = f;
                function v() {
                    return v = Object.assign ? Object.assign.bind() : function(L) {
                        for(var F = 1; F < arguments.length; F++){
                            var W = arguments[F];
                            for(var x in W)Object.prototype.hasOwnProperty.call(W, x) && (L[x] = W[x]);
                        }
                        return L;
                    }, v.apply(this, arguments);
                }
                var y = function(L) {
                    var F = L.breakLabel, W = L.breakAriaLabel, x = L.breakClassName, T = L.breakLinkClassName, Q = L.breakHandler, O = L.getEventListener, _ = x || "break";
                    return l().createElement("li", {
                        className: _
                    }, l().createElement("a", v({
                        className: T,
                        role: "button",
                        tabIndex: "0",
                        "aria-label": W,
                        onKeyPress: Q
                    }, O(Q)), F));
                };
                y.propTypes = {
                    breakLabel: c().oneOfType([
                        c().string,
                        c().node
                    ]),
                    breakAriaLabel: c().string,
                    breakClassName: c().string,
                    breakLinkClassName: c().string,
                    breakHandler: c().func.isRequired,
                    getEventListener: c().func.isRequired
                };
                const k = y;
                function p(L) {
                    var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                    return L ?? F;
                }
                function h(L) {
                    return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(F) {
                        return typeof F;
                    } : function(F) {
                        return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
                    }, h(L);
                }
                function g() {
                    return g = Object.assign ? Object.assign.bind() : function(L) {
                        for(var F = 1; F < arguments.length; F++){
                            var W = arguments[F];
                            for(var x in W)Object.prototype.hasOwnProperty.call(W, x) && (L[x] = W[x]);
                        }
                        return L;
                    }, g.apply(this, arguments);
                }
                function E(L, F) {
                    for(var W = 0; W < F.length; W++){
                        var x = F[W];
                        x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(L, x.key, x);
                    }
                }
                function P(L, F) {
                    return P = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(W, x) {
                        return W.__proto__ = x, W;
                    }, P(L, F);
                }
                function N(L, F) {
                    if (F && (h(F) === "object" || typeof F == "function")) return F;
                    if (F !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return b(L);
                }
                function b(L) {
                    if (L === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return L;
                }
                function R(L) {
                    return R = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(F) {
                        return F.__proto__ || Object.getPrototypeOf(F);
                    }, R(L);
                }
                function D(L, F, W) {
                    return F in L ? Object.defineProperty(L, F, {
                        value: W,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : L[F] = W, L;
                }
                var H = function(L) {
                    (function(_, C) {
                        if (typeof C != "function" && C !== null) throw new TypeError("Super expression must either be null or a function");
                        _.prototype = Object.create(C && C.prototype, {
                            constructor: {
                                value: _,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(_, "prototype", {
                            writable: !1
                        }), C && P(_, C);
                    })(O, L);
                    var F, W, x, T, Q = (x = O, T = function() {
                        if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
                        if (typeof Proxy == "function") return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch  {
                            return !1;
                        }
                    }(), function() {
                        var _, C = R(x);
                        if (T) {
                            var z = R(this).constructor;
                            _ = Reflect.construct(C, arguments, z);
                        } else _ = C.apply(this, arguments);
                        return N(this, _);
                    });
                    function O(_) {
                        var C, z;
                        return function(A, B) {
                            if (!(A instanceof B)) throw new TypeError("Cannot call a class as a function");
                        }(this, O), D(b(C = Q.call(this, _)), "handlePreviousPage", function(A) {
                            var B = C.state.selected;
                            C.handleClick(A, null, B > 0 ? B - 1 : void 0, {
                                isPrevious: !0
                            });
                        }), D(b(C), "handleNextPage", function(A) {
                            var B = C.state.selected, q = C.props.pageCount;
                            C.handleClick(A, null, B < q - 1 ? B + 1 : void 0, {
                                isNext: !0
                            });
                        }), D(b(C), "handlePageSelected", function(A, B) {
                            if (C.state.selected === A) return C.callActiveCallback(A), void C.handleClick(B, null, void 0, {
                                isActive: !0
                            });
                            C.handleClick(B, null, A);
                        }), D(b(C), "handlePageChange", function(A) {
                            C.state.selected !== A && (C.setState({
                                selected: A
                            }), C.callCallback(A));
                        }), D(b(C), "getEventListener", function(A) {
                            return D({}, C.props.eventListener, A);
                        }), D(b(C), "handleClick", function(A, B, q) {
                            var ie = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, oe = ie.isPrevious, Te = oe !== void 0 && oe, er = ie.isNext, qr = er !== void 0 && er, _n = ie.isBreak, Ge = _n !== void 0 && _n, Vt = ie.isActive, Qt = Vt !== void 0 && Vt;
                            A.preventDefault ? A.preventDefault() : A.returnValue = !1;
                            var Kt = C.state.selected, he = C.props.onClick, Xe = q;
                            if (he) {
                                var He = he({
                                    index: B,
                                    selected: Kt,
                                    nextSelectedPage: q,
                                    event: A,
                                    isPrevious: Te,
                                    isNext: qr,
                                    isBreak: Ge,
                                    isActive: Qt
                                });
                                if (He === !1) return;
                                Number.isInteger(He) && (Xe = He);
                            }
                            Xe !== void 0 && C.handlePageChange(Xe);
                        }), D(b(C), "handleBreakClick", function(A, B) {
                            var q = C.state.selected;
                            C.handleClick(B, A, q < A ? C.getForwardJump() : C.getBackwardJump(), {
                                isBreak: !0
                            });
                        }), D(b(C), "callCallback", function(A) {
                            C.props.onPageChange !== void 0 && typeof C.props.onPageChange == "function" && C.props.onPageChange({
                                selected: A
                            });
                        }), D(b(C), "callActiveCallback", function(A) {
                            C.props.onPageActive !== void 0 && typeof C.props.onPageActive == "function" && C.props.onPageActive({
                                selected: A
                            });
                        }), D(b(C), "getElementPageRel", function(A) {
                            var B = C.state.selected, q = C.props, ie = q.nextPageRel, oe = q.prevPageRel, Te = q.selectedPageRel;
                            return B - 1 === A ? oe : B === A ? Te : B + 1 === A ? ie : void 0;
                        }), D(b(C), "pagination", function() {
                            var A = [], B = C.props, q = B.pageRangeDisplayed, ie = B.pageCount, oe = B.marginPagesDisplayed, Te = B.breakLabel, er = B.breakClassName, qr = B.breakLinkClassName, _n = B.breakAriaLabels, Ge = C.state.selected;
                            if (ie <= q) for(var Vt = 0; Vt < ie; Vt++)A.push(C.getPageElement(Vt));
                            else {
                                var Qt = q / 2, Kt = q - Qt;
                                Ge > ie - q / 2 ? Qt = q - (Kt = ie - Ge) : Ge < q / 2 && (Kt = q - (Qt = Ge));
                                var he, Xe, He = function(Wt) {
                                    return C.getPageElement(Wt);
                                }, me = [];
                                for(he = 0; he < ie; he++){
                                    var ds = he + 1;
                                    if (ds <= oe) me.push({
                                        type: "page",
                                        index: he,
                                        display: He(he)
                                    });
                                    else if (ds > ie - oe) me.push({
                                        type: "page",
                                        index: he,
                                        display: He(he)
                                    });
                                    else if (he >= Ge - Qt && he <= Ge + (Ge === 0 && q > 1 ? Kt - 1 : Kt)) me.push({
                                        type: "page",
                                        index: he,
                                        display: He(he)
                                    });
                                    else if (Te && me.length > 0 && me[me.length - 1].display !== Xe && (q > 0 || oe > 0)) {
                                        var ea = he < Ge ? _n.backward : _n.forward;
                                        Xe = l().createElement(k, {
                                            key: he,
                                            breakAriaLabel: ea,
                                            breakLabel: Te,
                                            breakClassName: er,
                                            breakLinkClassName: qr,
                                            breakHandler: C.handleBreakClick.bind(null, he),
                                            getEventListener: C.getEventListener
                                        }), me.push({
                                            type: "break",
                                            index: he,
                                            display: Xe
                                        });
                                    }
                                }
                                me.forEach(function(Wt, Yt) {
                                    var hs = Wt;
                                    Wt.type === "break" && me[Yt - 1] && me[Yt - 1].type === "page" && me[Yt + 1] && me[Yt + 1].type === "page" && me[Yt + 1].index - me[Yt - 1].index <= 2 && (hs = {
                                        type: "page",
                                        index: Wt.index,
                                        display: He(Wt.index)
                                    }), A.push(hs.display);
                                });
                            }
                            return A;
                        }), _.initialPage !== void 0 && _.forcePage !== void 0 && console.warn("(react-paginate): Both initialPage (".concat(_.initialPage, ") and forcePage (").concat(_.forcePage, ") props are provided, which is discouraged.") + ` Use exclusively forcePage prop for a controlled component.
See https://reactjs.org/docs/forms.html#controlled-components`), z = _.initialPage ? _.initialPage : _.forcePage ? _.forcePage : 0, C.state = {
                            selected: z
                        }, C;
                    }
                    return F = O, W = [
                        {
                            key: "componentDidMount",
                            value: function() {
                                var _ = this.props, C = _.initialPage, z = _.disableInitialCallback, A = _.extraAriaContext, B = _.pageCount, q = _.forcePage;
                                C === void 0 || z || this.callCallback(C), A && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(B) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(B, "). Did you forget a Math.ceil()?")), C !== void 0 && C > B - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(C, " > ").concat(B - 1, ").")), q !== void 0 && q > B - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(q, " > ").concat(B - 1, ")."));
                            }
                        },
                        {
                            key: "componentDidUpdate",
                            value: function(_) {
                                this.props.forcePage !== void 0 && this.props.forcePage !== _.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                                    selected: this.props.forcePage
                                })), Number.isInteger(_.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
                            }
                        },
                        {
                            key: "getForwardJump",
                            value: function() {
                                var _ = this.state.selected, C = this.props, z = C.pageCount, A = _ + C.pageRangeDisplayed;
                                return A >= z ? z - 1 : A;
                            }
                        },
                        {
                            key: "getBackwardJump",
                            value: function() {
                                var _ = this.state.selected - this.props.pageRangeDisplayed;
                                return _ < 0 ? 0 : _;
                            }
                        },
                        {
                            key: "getElementHref",
                            value: function(_) {
                                var C = this.props, z = C.hrefBuilder, A = C.pageCount, B = C.hrefAllControls;
                                if (z) return B || _ >= 0 && _ < A ? z(_ + 1, A, this.state.selected) : void 0;
                            }
                        },
                        {
                            key: "ariaLabelBuilder",
                            value: function(_) {
                                var C = _ === this.state.selected;
                                if (this.props.ariaLabelBuilder && _ >= 0 && _ < this.props.pageCount) {
                                    var z = this.props.ariaLabelBuilder(_ + 1, C);
                                    return this.props.extraAriaContext && !C && (z = z + " " + this.props.extraAriaContext), z;
                                }
                            }
                        },
                        {
                            key: "getPageElement",
                            value: function(_) {
                                var C = this.state.selected, z = this.props, A = z.pageClassName, B = z.pageLinkClassName, q = z.activeClassName, ie = z.activeLinkClassName, oe = z.extraAriaContext, Te = z.pageLabelBuilder;
                                return l().createElement(m, {
                                    key: _,
                                    pageSelectedHandler: this.handlePageSelected.bind(null, _),
                                    selected: C === _,
                                    rel: this.getElementPageRel(_),
                                    pageClassName: A,
                                    pageLinkClassName: B,
                                    activeClassName: q,
                                    activeLinkClassName: ie,
                                    extraAriaContext: oe,
                                    href: this.getElementHref(_),
                                    ariaLabel: this.ariaLabelBuilder(_),
                                    page: _ + 1,
                                    pageLabelBuilder: Te,
                                    getEventListener: this.getEventListener
                                });
                            }
                        },
                        {
                            key: "render",
                            value: function() {
                                var _ = this.props.renderOnZeroPageCount;
                                if (this.props.pageCount === 0 && _ !== void 0) return _ && _(this.props);
                                var C = this.props, z = C.disabledClassName, A = C.disabledLinkClassName, B = C.pageCount, q = C.className, ie = C.containerClassName, oe = C.previousLabel, Te = C.previousClassName, er = C.previousLinkClassName, qr = C.previousAriaLabel, _n = C.prevRel, Ge = C.nextLabel, Vt = C.nextClassName, Qt = C.nextLinkClassName, Kt = C.nextAriaLabel, he = C.nextRel, Xe = this.state.selected, He = Xe === 0, me = Xe === B - 1, ds = "".concat(p(Te)).concat(He ? " ".concat(p(z)) : ""), ea = "".concat(p(Vt)).concat(me ? " ".concat(p(z)) : ""), Wt = "".concat(p(er)).concat(He ? " ".concat(p(A)) : ""), Yt = "".concat(p(Qt)).concat(me ? " ".concat(p(A)) : ""), hs = He ? "true" : "false", yg = me ? "true" : "false";
                                return l().createElement("ul", {
                                    className: q || ie,
                                    role: "navigation",
                                    "aria-label": "Pagination"
                                }, l().createElement("li", {
                                    className: ds
                                }, l().createElement("a", g({
                                    className: Wt,
                                    href: this.getElementHref(Xe - 1),
                                    tabIndex: He ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handlePreviousPage,
                                    "aria-disabled": hs,
                                    "aria-label": qr,
                                    rel: _n
                                }, this.getEventListener(this.handlePreviousPage)), oe)), this.pagination(), l().createElement("li", {
                                    className: ea
                                }, l().createElement("a", g({
                                    className: Yt,
                                    href: this.getElementHref(Xe + 1),
                                    tabIndex: me ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handleNextPage,
                                    "aria-disabled": yg,
                                    "aria-label": Kt,
                                    rel: he
                                }, this.getEventListener(this.handleNextPage)), Ge)));
                            }
                        }
                    ], E(F.prototype, W), Object.defineProperty(F, "prototype", {
                        writable: !1
                    }), O;
                }(a.Component);
                D(H, "propTypes", {
                    pageCount: c().number.isRequired,
                    pageRangeDisplayed: c().number,
                    marginPagesDisplayed: c().number,
                    previousLabel: c().node,
                    previousAriaLabel: c().string,
                    prevPageRel: c().string,
                    prevRel: c().string,
                    nextLabel: c().node,
                    nextAriaLabel: c().string,
                    nextPageRel: c().string,
                    nextRel: c().string,
                    breakLabel: c().oneOfType([
                        c().string,
                        c().node
                    ]),
                    breakAriaLabels: c().shape({
                        forward: c().string,
                        backward: c().string
                    }),
                    hrefBuilder: c().func,
                    hrefAllControls: c().bool,
                    onPageChange: c().func,
                    onPageActive: c().func,
                    onClick: c().func,
                    initialPage: c().number,
                    forcePage: c().number,
                    disableInitialCallback: c().bool,
                    containerClassName: c().string,
                    className: c().string,
                    pageClassName: c().string,
                    pageLinkClassName: c().string,
                    pageLabelBuilder: c().func,
                    activeClassName: c().string,
                    activeLinkClassName: c().string,
                    previousClassName: c().string,
                    nextClassName: c().string,
                    previousLinkClassName: c().string,
                    nextLinkClassName: c().string,
                    disabledClassName: c().string,
                    disabledLinkClassName: c().string,
                    breakClassName: c().string,
                    breakLinkClassName: c().string,
                    extraAriaContext: c().string,
                    ariaLabelBuilder: c().func,
                    eventListener: c().string,
                    renderOnZeroPageCount: c().func,
                    selectedPageRel: c().string
                }), D(H, "defaultProps", {
                    pageRangeDisplayed: 2,
                    marginPagesDisplayed: 3,
                    activeClassName: "selected",
                    previousLabel: "Previous",
                    previousClassName: "previous",
                    previousAriaLabel: "Previous page",
                    prevPageRel: "prev",
                    prevRel: "prev",
                    nextLabel: "Next",
                    nextClassName: "next",
                    nextAriaLabel: "Next page",
                    nextPageRel: "next",
                    nextRel: "next",
                    breakLabel: "...",
                    breakAriaLabels: {
                        forward: "Jump forward",
                        backward: "Jump backward"
                    },
                    disabledClassName: "disabled",
                    disableInitialCallback: !1,
                    pageLabelBuilder: function(L) {
                        return L;
                    },
                    eventListener: "onClick",
                    renderOnZeroPageCount: void 0,
                    selectedPageRel: "canonical",
                    hrefAllControls: !1
                });
                const M = H;
            })(), o;
        })());
})($2a051a86cb6e4743$var$dh);
var $2a051a86cb6e4743$var$Uv = $2a051a86cb6e4743$var$dh.exports;
const $2a051a86cb6e4743$var$$v = $2a051a86cb6e4743$var$Oo($2a051a86cb6e4743$var$Uv), $2a051a86cb6e4743$var$zv = ({ totalResults: e, triggerFocusUpdateOnRefresh: t })=>{
    const n = $2a051a86cb6e4743$var$os(), r = $2a051a86cb6e4743$var$K((a)=>a.page), i1 = $2a051a86cb6e4743$var$K((a)=>a.setPage), s = (a)=>{
        const l = new URLSearchParams(window.location.search), { searchTerm: u, facetTags: c } = $2a051a86cb6e4743$var$K.getState();
        return !u && (!c || c.length === 0) ? (l.set("page", (a - 1).toString()), `${window.location.pathname}?${l.toString()}`) : null;
    }, o = (a)=>{
        i1(a.selected), t && t();
    };
    return e > 0 && e > n.pageSize ? $2a051a86cb6e4743$var$S.jsx("div", {
        className: "cmp-pagination",
        children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$$v, {
            breakLabel: "...",
            nextLabel: "",
            previousLabel: "",
            containerClassName: "cmp-pagination__list",
            pageClassName: "cmp-pagination__link",
            breakClassName: "cmp-pagination__break",
            previousClassName: "cmp-pagination__previous",
            nextClassName: "cmp-pagination__next",
            initialPage: r,
            pageCount: Math.ceil(e / n.pageSize),
            onPageChange: o,
            renderOnZeroPageCount: null,
            marginPagesDisplayed: 2,
            disableInitialCallback: !0,
            hrefBuilder: s
        })
    }) : null;
}, $2a051a86cb6e4743$var$Bv = 500, $2a051a86cb6e4743$var$Hv = 9e5, $2a051a86cb6e4743$var$Vv = 6e5, $2a051a86cb6e4743$var$su = (e = !0)=>{
    const t = $2a051a86cb6e4743$var$os(), n = $2a051a86cb6e4743$var$K((d)=>d.order), r = $2a051a86cb6e4743$var$K((d)=>d.page), i1 = $2a051a86cb6e4743$var$K((d)=>d.path), s = $2a051a86cb6e4743$var$K((d)=>d.searchTerm), o = $2a051a86cb6e4743$var$K((d)=>d.facetTags), a = $2a051a86cb6e4743$var$K((d)=>d.minPublicationYear), l = $2a051a86cb6e4743$var$K((d)=>d.maxPublicationYear), u = new URL(t.searchApiUrl), c = $2a051a86cb6e4743$var$Xd({
        siteName: t.siteName,
        searchTerm: s,
        interfaceLanguage: t.interfaceLanguage,
        orderBy: n,
        page: r,
        path: i1,
        ...t.pageSize && {
            pageSize: t.pageSize.toString()
        },
        ...t.initialFacetTags.length > 0 && {
            hiddenFacets: t.initialFacetTags
        },
        ...o.length > 0 && {
            facets: o
        },
        ...a && {
            minPublicationYear: a
        },
        ...l && {
            maxPublicationYear: l
        }
    }, $2a051a86cb6e4743$var$Bv);
    return Object.entries(c).forEach(([d, f])=>{
        Array.isArray(f) ? f.forEach((m)=>{
            u.searchParams.append(d, m);
        }) : f && u.searchParams.append(d, f);
    }), $2a051a86cb6e4743$var$Hy({
        queryKey: [
            "facetedSearchResults",
            c
        ],
        queryFn: async ()=>fetch(u.href).then((d)=>d.json()).then((d)=>d).catch((d)=>window.console.error(d)),
        gcTime: $2a051a86cb6e4743$var$Hv,
        staleTime: $2a051a86cb6e4743$var$Vv,
        refetchOnWindowFocus: !1,
        refetchOnReconnect: !1,
        enabled: e
    });
}, $2a051a86cb6e4743$var$hh = ({ displayType: e })=>{
    var l, u;
    e || (e = $2a051a86cb6e4743$var$K((c)=>c.displayType));
    const t = $2a051a86cb6e4743$var$I.useRef(null), n = $2a051a86cb6e4743$var$K((c)=>c.facetedSearchResults), r = $2a051a86cb6e4743$var$K((c)=>c.setFacetedSearchResults), { data: i1, isLoading: s } = $2a051a86cb6e4743$var$su(), { t: o } = $2a051a86cb6e4743$var$Nt(), a = ()=>{
        t.current && (t.current.setAttribute("tabindex", "-1"), t.current.focus());
    };
    return $2a051a86cb6e4743$var$I.useEffect(()=>{
        r(i1);
    }, [
        i1,
        r
    ]), $2a051a86cb6e4743$var$S.jsxs("div", {
        className: "cmp-search-results__body",
        "aria-live": "polite",
        "aria-busy": s,
        children: [
            $2a051a86cb6e4743$var$S.jsx("span", {
                ref: t
            }),
            s && $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Lv, {
                message: o("search-app-results-loading")
            }),
            ((l = n == null ? void 0 : n.results) == null ? void 0 : l.length) > 0 && $2a051a86cb6e4743$var$S.jsxs($2a051a86cb6e4743$var$S.Fragment, {
                children: [
                    $2a051a86cb6e4743$var$S.jsx("ul", {
                        className: `cmp-list${e === $2a051a86cb6e4743$var$_t.GRID ? " cmp-list--grid-layout cmp-list--card-rendition" : ""}`,
                        children: n.results.map((c, d)=>$2a051a86cb6e4743$var$S.jsxs("li", {
                                className: "cmp-list__item",
                                children: [
                                    e === $2a051a86cb6e4743$var$_t.GRID && $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Av, {
                                        searchResult: c
                                    }),
                                    e === $2a051a86cb6e4743$var$_t.LIST && $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Mv, {
                                        searchResult: c
                                    })
                                ]
                            }, d))
                    }),
                    (i1 == null ? void 0 : i1.total) > 0 && $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$zv, {
                        totalResults: i1.total,
                        triggerFocusUpdateOnRefresh: a
                    })
                ]
            }),
            ((u = n == null ? void 0 : n.results) == null ? void 0 : u.length) === 0 && $2a051a86cb6e4743$var$S.jsx("span", {
                children: o("search-app-results-no-results")
            })
        ]
    });
}, $2a051a86cb6e4743$var$ph = ()=>{
    const e = $2a051a86cb6e4743$var$K((o)=>o.order), t = $2a051a86cb6e4743$var$K((o)=>o.setOrder), { t: n } = $2a051a86cb6e4743$var$Nt(), r = (o)=>{
        const a = o.currentTarget.value;
        t(a);
    }, { isLoading: i1, refetch: s } = $2a051a86cb6e4743$var$su(!1);
    return $2a051a86cb6e4743$var$I.useEffect(()=>{
        s();
    }, [
        e
    ]), $2a051a86cb6e4743$var$S.jsxs("div", {
        className: "cmp-search-results__sort-control",
        children: [
            $2a051a86cb6e4743$var$S.jsx("label", {
                className: "cmp-search-results__sort-control-label",
                htmlFor: "search-order-toggle",
                children: n("search-app-toggle-order-label")
            }),
            $2a051a86cb6e4743$var$S.jsx("select", {
                className: "cmp-search-results__sort-control-select",
                id: "search-order-toggle",
                onChange: r,
                value: e,
                disabled: i1,
                children: Object.entries($2a051a86cb6e4743$var$eu).map(([o, a])=>$2a051a86cb6e4743$var$S.jsx("option", {
                        value: a,
                        children: n(`search-app-toggle-order-option_${o.toLowerCase()}`)
                    }, o))
            })
        ]
    });
}, $2a051a86cb6e4743$var$Qv = ()=>{
    const e = $2a051a86cb6e4743$var$K((s)=>s.displayType), t = $2a051a86cb6e4743$var$K((s)=>s.setDisplayType), { t: n } = $2a051a86cb6e4743$var$Nt(), r = ()=>{
        t($2a051a86cb6e4743$var$_t.LIST);
    }, i1 = ()=>{
        t($2a051a86cb6e4743$var$_t.GRID);
    };
    return $2a051a86cb6e4743$var$S.jsxs("ul", {
        className: "cmp-search-results__view-modes",
        children: [
            $2a051a86cb6e4743$var$S.jsx("li", {
                className: "cmp-search-results__view-mode cmp-search-results__view-mode--list button button--secondary",
                children: $2a051a86cb6e4743$var$S.jsx("button", {
                    className: "cmp-button",
                    type: "button",
                    "aria-pressed": e === $2a051a86cb6e4743$var$_t.LIST ? "true" : "false",
                    onClick: r,
                    children: $2a051a86cb6e4743$var$S.jsx("span", {
                        className: "cmp-button__text",
                        children: n("search-app-display-type-list")
                    })
                })
            }),
            $2a051a86cb6e4743$var$S.jsx("li", {
                className: "cmp-search-results__view-mode cmp-search-results__view-mode--grid button button--secondary",
                children: $2a051a86cb6e4743$var$S.jsx("button", {
                    className: "cmp-button",
                    type: "button",
                    "aria-pressed": e === $2a051a86cb6e4743$var$_t.GRID ? "true" : "false",
                    onClick: i1,
                    children: $2a051a86cb6e4743$var$S.jsx("span", {
                        className: "cmp-button__text",
                        children: n("search-app-display-type-grid")
                    })
                })
            })
        ]
    });
}, $2a051a86cb6e4743$var$Kv = ()=>{
    const e = new $2a051a86cb6e4743$var$jo;
    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Io, {
        client: e,
        children: $2a051a86cb6e4743$var$S.jsxs($2a051a86cb6e4743$var$tu, {
            globalSearch: !1,
            children: [
                $2a051a86cb6e4743$var$S.jsxs("div", {
                    className: "cmp-search-results__wrapper",
                    children: [
                        $2a051a86cb6e4743$var$S.jsxs("div", {
                            className: "cmp-search-results__header",
                            children: [
                                $2a051a86cb6e4743$var$S.jsxs("h2", {
                                    className: "cmp-search-results__header-result",
                                    children: [
                                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$uh, {}),
                                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$lh, {})
                                    ]
                                }),
                                $2a051a86cb6e4743$var$S.jsxs("div", {
                                    className: "cmp-search-results__header-actions",
                                    children: [
                                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$ph, {}),
                                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Qv, {})
                                    ]
                                })
                            ]
                        }),
                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$hh, {})
                    ]
                }),
                $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$ah, {})
            ]
        })
    });
}, $2a051a86cb6e4743$var$Wv = ()=>{
    const e = new $2a051a86cb6e4743$var$jo;
    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Io, {
        client: e,
        children: $2a051a86cb6e4743$var$S.jsxs($2a051a86cb6e4743$var$tu, {
            globalSearch: !0,
            children: [
                $2a051a86cb6e4743$var$S.jsxs("div", {
                    className: "cmp-search-results__wrapper",
                    children: [
                        $2a051a86cb6e4743$var$S.jsxs("div", {
                            className: "cmp-search-results__header",
                            children: [
                                $2a051a86cb6e4743$var$S.jsxs("h2", {
                                    className: "cmp-search-results__header-result",
                                    children: [
                                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$uh, {}),
                                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$lh, {})
                                    ]
                                }),
                                $2a051a86cb6e4743$var$S.jsx("div", {
                                    className: "cmp-search-results__header-actions",
                                    children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$ph, {})
                                })
                            ]
                        }),
                        $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$hh, {
                            displayType: $2a051a86cb6e4743$var$_t.LIST
                        })
                    ]
                }),
                $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$ah, {})
            ]
        })
    });
};
var $2a051a86cb6e4743$var$ad, $2a051a86cb6e4743$var$ld, $2a051a86cb6e4743$var$ud;
const $2a051a86cb6e4743$var$Us = {
    placeholder: (($2a051a86cb6e4743$var$ad = document.getElementById("oecd-searchbox")) == null ? void 0 : $2a051a86cb6e4743$var$ad.getAttribute("data-placeholder")) || "",
    ariaLabel: (($2a051a86cb6e4743$var$ld = document.getElementById("oecd-searchbox")) == null ? void 0 : $2a051a86cb6e4743$var$ld.getAttribute("data-aria-label")) || "",
    buttonText: (($2a051a86cb6e4743$var$ud = document.getElementById("oecd-searchbox")) == null ? void 0 : $2a051a86cb6e4743$var$ud.getAttribute("data-button-text")) || ""
}, $2a051a86cb6e4743$var$gh = $2a051a86cb6e4743$var$I.createContext($2a051a86cb6e4743$var$Us), $2a051a86cb6e4743$var$Yv = ({ children: e })=>$2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$gh.Provider, {
        value: {
            placeholder: $2a051a86cb6e4743$var$Us.placeholder,
            ariaLabel: $2a051a86cb6e4743$var$Us.ariaLabel,
            buttonText: $2a051a86cb6e4743$var$Us.buttonText
        },
        children: e
    }), $2a051a86cb6e4743$var$qv = ()=>{
    const e = $2a051a86cb6e4743$var$I.useContext($2a051a86cb6e4743$var$gh);
    if (!e) throw new Error("useSearchBoxAppContext must be used within a SearchBoxAppContextProvider");
    return e;
}, $2a051a86cb6e4743$var$$c = "recentSearchQueries", $2a051a86cb6e4743$var$Gv = 4, $2a051a86cb6e4743$var$Xv = (e)=>{
    const t = e.trim().toLowerCase();
    if (!t.length) return;
    const n = JSON.parse(localStorage.getItem($2a051a86cb6e4743$var$$c)) || [], r = n.indexOf(t);
    r !== -1 && n.splice(r, 1), n.unshift(t);
    const i1 = n.slice(0, $2a051a86cb6e4743$var$Gv);
    localStorage.setItem($2a051a86cb6e4743$var$$c, JSON.stringify(i1));
}, $2a051a86cb6e4743$var$Jv = (e)=>{
    const t = new CustomEvent("searchBoxValueUpdate", {
        detail: {
            searchTerm: e
        }
    });
    document.dispatchEvent(t);
}, $2a051a86cb6e4743$var$Zv = ()=>{
    const e = $2a051a86cb6e4743$var$I.useRef(), t = $2a051a86cb6e4743$var$qv(), n = $2a051a86cb6e4743$var$K((f)=>f.searchTerm), r = $2a051a86cb6e4743$var$K((f)=>f.setSearchTerm), i1 = $2a051a86cb6e4743$var$K((f)=>f.resetFilters), { refetch: s } = $2a051a86cb6e4743$var$su(!1), [o, a] = $2a051a86cb6e4743$var$I.useState(n), l = $2a051a86cb6e4743$var$I.useRef(n), u = (f)=>{
        a(f.currentTarget.value);
    }, c = (f)=>{
        f.preventDefault(), r(o);
    }, d = (f)=>{
        var m;
        f.preventDefault(), r((m = f.currentTarget) == null ? void 0 : m.value);
    };
    return $2a051a86cb6e4743$var$I.useEffect(()=>(e.current.addEventListener("search", d), ()=>{
            e.current.removeEventListener("search", d);
        }), []), $2a051a86cb6e4743$var$I.useEffect(()=>{
        $2a051a86cb6e4743$var$Jv(n), l.current !== n && (l.current = n, $2a051a86cb6e4743$var$Xv(n), i1(), s());
    }, [
        n
    ]), $2a051a86cb6e4743$var$S.jsxs("form", {
        className: "cmp-searchbox",
        onSubmit: c,
        children: [
            $2a051a86cb6e4743$var$S.jsx("input", {
                className: "cmp-searchbox__input",
                type: "search",
                ref: e,
                placeholder: t.placeholder,
                defaultValue: n,
                "aria-label": t.ariaLabel,
                onChange: u
            }),
            $2a051a86cb6e4743$var$S.jsx("button", {
                className: "cmp-searchbox__button",
                type: "submit",
                children: $2a051a86cb6e4743$var$S.jsx("span", {
                    className: "cmp-searchbox__button-txt",
                    children: t.buttonText
                })
            })
        ]
    });
}, $2a051a86cb6e4743$var$e0 = ()=>{
    const e = new $2a051a86cb6e4743$var$jo;
    return $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Io, {
        client: e,
        children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$tu, {
            globalSearch: !1,
            children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Yv, {
                children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Zv, {})
            })
        })
    });
};
var $2a051a86cb6e4743$var$mh = {
    exports: {}
}, $2a051a86cb6e4743$var$Ye = {}, $2a051a86cb6e4743$var$yh = {
    exports: {}
}, $2a051a86cb6e4743$var$vh = {}; /**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
(function(e) {
    function t(O, _) {
        var C = O.length;
        O.push(_);
        e: for(; 0 < C;){
            var z = C - 1 >>> 1, A = O[z];
            if (0 < i1(A, _)) O[z] = _, O[C] = A, C = z;
            else break e;
        }
    }
    function n(O) {
        return O.length === 0 ? null : O[0];
    }
    function r(O) {
        if (O.length === 0) return null;
        var _ = O[0], C = O.pop();
        if (C !== _) {
            O[0] = C;
            e: for(var z = 0, A = O.length, B = A >>> 1; z < B;){
                var q = 2 * (z + 1) - 1, ie = O[q], oe = q + 1, Te = O[oe];
                if (0 > i1(ie, C)) oe < A && 0 > i1(Te, ie) ? (O[z] = Te, O[oe] = C, z = oe) : (O[z] = ie, O[q] = C, z = q);
                else if (oe < A && 0 > i1(Te, C)) O[z] = Te, O[oe] = C, z = oe;
                else break e;
            }
        }
        return _;
    }
    function i1(O, _) {
        var C = O.sortIndex - _.sortIndex;
        return C !== 0 ? C : O.id - _.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
        var s = performance;
        e.unstable_now = function() {
            return s.now();
        };
    } else {
        var o = Date, a = o.now();
        e.unstable_now = function() {
            return o.now() - a;
        };
    }
    var l = [], u = [], c = 1, d = null, f = 3, m = !1, v = !1, y = !1, k = typeof setTimeout == "function" ? setTimeout : null, p = typeof clearTimeout == "function" ? clearTimeout : null, h = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function g(O) {
        for(var _ = n(u); _ !== null;){
            if (_.callback === null) r(u);
            else if (_.startTime <= O) r(u), _.sortIndex = _.expirationTime, t(l, _);
            else break;
            _ = n(u);
        }
    }
    function E(O) {
        if (y = !1, g(O), !v) {
            if (n(l) !== null) v = !0, T(P);
            else {
                var _ = n(u);
                _ !== null && Q(E, _.startTime - O);
            }
        }
    }
    function P(O, _) {
        v = !1, y && (y = !1, p(R), R = -1), m = !0;
        var C = f;
        try {
            for(g(_), d = n(l); d !== null && (!(d.expirationTime > _) || O && !M());){
                var z = d.callback;
                if (typeof z == "function") {
                    d.callback = null, f = d.priorityLevel;
                    var A = z(d.expirationTime <= _);
                    _ = e.unstable_now(), typeof A == "function" ? d.callback = A : d === n(l) && r(l), g(_);
                } else r(l);
                d = n(l);
            }
            if (d !== null) var B = !0;
            else {
                var q = n(u);
                q !== null && Q(E, q.startTime - _), B = !1;
            }
            return B;
        } finally{
            d = null, f = C, m = !1;
        }
    }
    var N = !1, b = null, R = -1, D = 5, H = -1;
    function M() {
        return !(e.unstable_now() - H < D);
    }
    function L() {
        if (b !== null) {
            var O = e.unstable_now();
            H = O;
            var _ = !0;
            try {
                _ = b(!0, O);
            } finally{
                _ ? F() : (N = !1, b = null);
            }
        } else N = !1;
    }
    var F;
    if (typeof h == "function") F = function() {
        h(L);
    };
    else if (typeof MessageChannel < "u") {
        var W = new MessageChannel, x = W.port2;
        W.port1.onmessage = L, F = function() {
            x.postMessage(null);
        };
    } else F = function() {
        k(L, 0);
    };
    function T(O) {
        b = O, N || (N = !0, F());
    }
    function Q(O, _) {
        R = k(function() {
            O(e.unstable_now());
        }, _);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(O) {
        O.callback = null;
    }, e.unstable_continueExecution = function() {
        v || m || (v = !0, T(P));
    }, e.unstable_forceFrameRate = function(O) {
        0 > O || 125 < O ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < O ? Math.floor(1e3 / O) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
        return f;
    }, e.unstable_getFirstCallbackNode = function() {
        return n(l);
    }, e.unstable_next = function(O) {
        switch(f){
            case 1:
            case 2:
            case 3:
                var _ = 3;
                break;
            default:
                _ = f;
        }
        var C = f;
        f = _;
        try {
            return O();
        } finally{
            f = C;
        }
    }, e.unstable_pauseExecution = function() {}, e.unstable_requestPaint = function() {}, e.unstable_runWithPriority = function(O, _) {
        switch(O){
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            default:
                O = 3;
        }
        var C = f;
        f = O;
        try {
            return _();
        } finally{
            f = C;
        }
    }, e.unstable_scheduleCallback = function(O, _, C) {
        var z = e.unstable_now();
        switch(typeof C == "object" && C !== null ? (C = C.delay, C = typeof C == "number" && 0 < C ? z + C : z) : C = z, O){
            case 1:
                var A = -1;
                break;
            case 2:
                A = 250;
                break;
            case 5:
                A = 1073741823;
                break;
            case 4:
                A = 1e4;
                break;
            default:
                A = 5e3;
        }
        return A = C + A, O = {
            id: c++,
            callback: _,
            priorityLevel: O,
            startTime: C,
            expirationTime: A,
            sortIndex: -1
        }, C > z ? (O.sortIndex = C, t(u, O), n(l) === null && O === n(u) && (y ? (p(R), R = -1) : y = !0, Q(E, C - z))) : (O.sortIndex = A, t(l, O), v || m || (v = !0, T(P))), O;
    }, e.unstable_shouldYield = M, e.unstable_wrapCallback = function(O) {
        var _ = f;
        return function() {
            var C = f;
            f = _;
            try {
                return O.apply(this, arguments);
            } finally{
                f = C;
            }
        };
    };
})($2a051a86cb6e4743$var$vh);
$2a051a86cb6e4743$var$yh.exports = $2a051a86cb6e4743$var$vh;
var $2a051a86cb6e4743$var$t0 = $2a051a86cb6e4743$var$yh.exports; /**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2a051a86cb6e4743$var$n0 = $2a051a86cb6e4743$var$I, $2a051a86cb6e4743$var$We = $2a051a86cb6e4743$var$t0;
function $2a051a86cb6e4743$var$j(e) {
    for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2a051a86cb6e4743$var$Sh = new Set, $2a051a86cb6e4743$var$Ti = {};
function $2a051a86cb6e4743$var$Jn(e, t) {
    $2a051a86cb6e4743$var$Ur(e, t), $2a051a86cb6e4743$var$Ur(e + "Capture", t);
}
function $2a051a86cb6e4743$var$Ur(e, t) {
    for($2a051a86cb6e4743$var$Ti[e] = t, e = 0; e < t.length; e++)$2a051a86cb6e4743$var$Sh.add(t[e]);
}
var $2a051a86cb6e4743$var$Ut = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), $2a051a86cb6e4743$var$el = Object.prototype.hasOwnProperty, $2a051a86cb6e4743$var$r0 = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2a051a86cb6e4743$var$zc = {}, $2a051a86cb6e4743$var$Bc = {};
function $2a051a86cb6e4743$var$i0(e) {
    return $2a051a86cb6e4743$var$el.call($2a051a86cb6e4743$var$Bc, e) ? !0 : $2a051a86cb6e4743$var$el.call($2a051a86cb6e4743$var$zc, e) ? !1 : $2a051a86cb6e4743$var$r0.test(e) ? $2a051a86cb6e4743$var$Bc[e] = !0 : ($2a051a86cb6e4743$var$zc[e] = !0, !1);
}
function $2a051a86cb6e4743$var$s0(e, t, n, r) {
    if (n !== null && n.type === 0) return !1;
    switch(typeof t){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
        default:
            return !1;
    }
}
function $2a051a86cb6e4743$var$o0(e, t, n, r) {
    if (t === null || typeof t > "u" || $2a051a86cb6e4743$var$s0(e, t, n, r)) return !0;
    if (r) return !1;
    if (n !== null) switch(n.type){
        case 3:
            return !t;
        case 4:
            return t === !1;
        case 5:
            return isNaN(t);
        case 6:
            return isNaN(t) || 1 > t;
    }
    return !1;
}
function $2a051a86cb6e4743$var$De(e, t, n, r, i1, s, o) {
    this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = i1, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = s, this.removeEmptyString = o;
}
var $2a051a86cb6e4743$var$ke = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 0, !1, e, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(e) {
    var t = e[0];
    $2a051a86cb6e4743$var$ke[t] = new $2a051a86cb6e4743$var$De(t, 1, !1, e[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 3, !0, e, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 4, !1, e, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 6, !1, e, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var $2a051a86cb6e4743$var$ou = /[\-:]([a-z])/g;
function $2a051a86cb6e4743$var$au(e) {
    return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
    var t = e.replace($2a051a86cb6e4743$var$ou, $2a051a86cb6e4743$var$au);
    $2a051a86cb6e4743$var$ke[t] = new $2a051a86cb6e4743$var$De(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
    var t = e.replace($2a051a86cb6e4743$var$ou, $2a051a86cb6e4743$var$au);
    $2a051a86cb6e4743$var$ke[t] = new $2a051a86cb6e4743$var$De(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(e) {
    var t = e.replace($2a051a86cb6e4743$var$ou, $2a051a86cb6e4743$var$au);
    $2a051a86cb6e4743$var$ke[t] = new $2a051a86cb6e4743$var$De(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
$2a051a86cb6e4743$var$ke.xlinkHref = new $2a051a86cb6e4743$var$De("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(e) {
    $2a051a86cb6e4743$var$ke[e] = new $2a051a86cb6e4743$var$De(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function $2a051a86cb6e4743$var$lu(e, t, n, r) {
    var i1 = $2a051a86cb6e4743$var$ke.hasOwnProperty(t) ? $2a051a86cb6e4743$var$ke[t] : null;
    (i1 !== null ? i1.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && ($2a051a86cb6e4743$var$o0(t, n, i1, r) && (n = null), r || i1 === null ? $2a051a86cb6e4743$var$i0(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : i1.mustUseProperty ? e[i1.propertyName] = n === null ? i1.type === 3 ? !1 : "" : n : (t = i1.attributeName, r = i1.attributeNamespace, n === null ? e.removeAttribute(t) : (i1 = i1.type, n = i1 === 3 || i1 === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var $2a051a86cb6e4743$var$Ht = $2a051a86cb6e4743$var$n0.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $2a051a86cb6e4743$var$Ss = Symbol.for("react.element"), $2a051a86cb6e4743$var$ir = Symbol.for("react.portal"), $2a051a86cb6e4743$var$sr = Symbol.for("react.fragment"), $2a051a86cb6e4743$var$uu = Symbol.for("react.strict_mode"), $2a051a86cb6e4743$var$tl = Symbol.for("react.profiler"), $2a051a86cb6e4743$var$wh = Symbol.for("react.provider"), $2a051a86cb6e4743$var$xh = Symbol.for("react.context"), $2a051a86cb6e4743$var$cu = Symbol.for("react.forward_ref"), $2a051a86cb6e4743$var$nl = Symbol.for("react.suspense"), $2a051a86cb6e4743$var$rl = Symbol.for("react.suspense_list"), $2a051a86cb6e4743$var$fu = Symbol.for("react.memo"), $2a051a86cb6e4743$var$Xt = Symbol.for("react.lazy"), $2a051a86cb6e4743$var$Ch = Symbol.for("react.offscreen"), $2a051a86cb6e4743$var$Hc = Symbol.iterator;
function $2a051a86cb6e4743$var$Zr(e) {
    return e === null || typeof e != "object" ? null : (e = $2a051a86cb6e4743$var$Hc && e[$2a051a86cb6e4743$var$Hc] || e["@@iterator"], typeof e == "function" ? e : null);
}
var $2a051a86cb6e4743$var$ce = Object.assign, $2a051a86cb6e4743$var$ua;
function $2a051a86cb6e4743$var$ui(e) {
    if ($2a051a86cb6e4743$var$ua === void 0) try {
        throw Error();
    } catch (n) {
        var t = n.stack.trim().match(/\n( *(at )?)/);
        $2a051a86cb6e4743$var$ua = t && t[1] || "";
    }
    return `
` + $2a051a86cb6e4743$var$ua + e;
}
var $2a051a86cb6e4743$var$ca = !1;
function $2a051a86cb6e4743$var$fa(e, t) {
    if (!e || $2a051a86cb6e4743$var$ca) return "";
    $2a051a86cb6e4743$var$ca = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (t) {
            if (t = function() {
                throw Error();
            }, Object.defineProperty(t.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), typeof Reflect == "object" && Reflect.construct) {
                try {
                    Reflect.construct(t, []);
                } catch (u) {
                    var r = u;
                }
                Reflect.construct(e, [], t);
            } else {
                try {
                    t.call();
                } catch (u) {
                    r = u;
                }
                e.call(t.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (u) {
                r = u;
            }
            e();
        }
    } catch (u) {
        if (u && r && typeof u.stack == "string") {
            for(var i1 = u.stack.split(`
`), s = r.stack.split(`
`), o = i1.length - 1, a = s.length - 1; 1 <= o && 0 <= a && i1[o] !== s[a];)a--;
            for(; 1 <= o && 0 <= a; o--, a--)if (i1[o] !== s[a]) {
                if (o !== 1 || a !== 1) do if (o--, a--, 0 > a || i1[o] !== s[a]) {
                    var l = `
` + i1[o].replace(" at new ", " at ");
                    return e.displayName && l.includes("<anonymous>") && (l = l.replace("<anonymous>", e.displayName)), l;
                }
                while (1 <= o && 0 <= a);
                break;
            }
        }
    } finally{
        $2a051a86cb6e4743$var$ca = !1, Error.prepareStackTrace = n;
    }
    return (e = e ? e.displayName || e.name : "") ? $2a051a86cb6e4743$var$ui(e) : "";
}
function $2a051a86cb6e4743$var$a0(e) {
    switch(e.tag){
        case 5:
            return $2a051a86cb6e4743$var$ui(e.type);
        case 16:
            return $2a051a86cb6e4743$var$ui("Lazy");
        case 13:
            return $2a051a86cb6e4743$var$ui("Suspense");
        case 19:
            return $2a051a86cb6e4743$var$ui("SuspenseList");
        case 0:
        case 2:
        case 15:
            return e = $2a051a86cb6e4743$var$fa(e.type, !1), e;
        case 11:
            return e = $2a051a86cb6e4743$var$fa(e.type.render, !1), e;
        case 1:
            return e = $2a051a86cb6e4743$var$fa(e.type, !0), e;
        default:
            return "";
    }
}
function $2a051a86cb6e4743$var$il(e) {
    if (e == null) return null;
    if (typeof e == "function") return e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch(e){
        case $2a051a86cb6e4743$var$sr:
            return "Fragment";
        case $2a051a86cb6e4743$var$ir:
            return "Portal";
        case $2a051a86cb6e4743$var$tl:
            return "Profiler";
        case $2a051a86cb6e4743$var$uu:
            return "StrictMode";
        case $2a051a86cb6e4743$var$nl:
            return "Suspense";
        case $2a051a86cb6e4743$var$rl:
            return "SuspenseList";
    }
    if (typeof e == "object") switch(e.$$typeof){
        case $2a051a86cb6e4743$var$xh:
            return (e.displayName || "Context") + ".Consumer";
        case $2a051a86cb6e4743$var$wh:
            return (e._context.displayName || "Context") + ".Provider";
        case $2a051a86cb6e4743$var$cu:
            var t = e.render;
            return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case $2a051a86cb6e4743$var$fu:
            return t = e.displayName || null, t !== null ? t : $2a051a86cb6e4743$var$il(e.type) || "Memo";
        case $2a051a86cb6e4743$var$Xt:
            t = e._payload, e = e._init;
            try {
                return $2a051a86cb6e4743$var$il(e(t));
            } catch  {}
    }
    return null;
}
function $2a051a86cb6e4743$var$l0(e) {
    var t = e.type;
    switch(e.tag){
        case 24:
            return "Cache";
        case 9:
            return (t.displayName || "Context") + ".Consumer";
        case 10:
            return (t._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return t;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $2a051a86cb6e4743$var$il(t);
        case 8:
            return t === $2a051a86cb6e4743$var$uu ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if (typeof t == "function") return t.displayName || t.name || null;
            if (typeof t == "string") return t;
    }
    return null;
}
function $2a051a86cb6e4743$var$xn(e) {
    switch(typeof e){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return e;
        case "object":
            return e;
        default:
            return "";
    }
}
function $2a051a86cb6e4743$var$Eh(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function $2a051a86cb6e4743$var$u0(e) {
    var t = $2a051a86cb6e4743$var$Eh(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
    if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
        var i1 = n.get, s = n.set;
        return Object.defineProperty(e, t, {
            configurable: !0,
            get: function() {
                return i1.call(this);
            },
            set: function(o) {
                r = "" + o, s.call(this, o);
            }
        }), Object.defineProperty(e, t, {
            enumerable: n.enumerable
        }), {
            getValue: function() {
                return r;
            },
            setValue: function(o) {
                r = "" + o;
            },
            stopTracking: function() {
                e._valueTracker = null, delete e[t];
            }
        };
    }
}
function $2a051a86cb6e4743$var$ws(e) {
    e._valueTracker || (e._valueTracker = $2a051a86cb6e4743$var$u0(e));
}
function $2a051a86cb6e4743$var$kh(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var n = t.getValue(), r = "";
    return e && (r = $2a051a86cb6e4743$var$Eh(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function $2a051a86cb6e4743$var$no(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
        return e.activeElement || e.body;
    } catch  {
        return e.body;
    }
}
function $2a051a86cb6e4743$var$sl(e, t) {
    var n = t.checked;
    return $2a051a86cb6e4743$var$ce({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: n ?? e._wrapperState.initialChecked
    });
}
function $2a051a86cb6e4743$var$Vc(e, t) {
    var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
    n = $2a051a86cb6e4743$var$xn(t.value != null ? t.value : n), e._wrapperState = {
        initialChecked: r,
        initialValue: n,
        controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null
    };
}
function $2a051a86cb6e4743$var$Ph(e, t) {
    t = t.checked, t != null && $2a051a86cb6e4743$var$lu(e, "checked", t, !1);
}
function $2a051a86cb6e4743$var$ol(e, t) {
    $2a051a86cb6e4743$var$Ph(e, t);
    var n = $2a051a86cb6e4743$var$xn(t.value), r = t.type;
    if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
    else if (r === "submit" || r === "reset") {
        e.removeAttribute("value");
        return;
    }
    t.hasOwnProperty("value") ? $2a051a86cb6e4743$var$al(e, t.type, n) : t.hasOwnProperty("defaultValue") && $2a051a86cb6e4743$var$al(e, t.type, $2a051a86cb6e4743$var$xn(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function $2a051a86cb6e4743$var$Qc(e, t, n) {
    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var r = t.type;
        if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
        t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
    }
    n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function $2a051a86cb6e4743$var$al(e, t, n) {
    (t !== "number" || $2a051a86cb6e4743$var$no(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var $2a051a86cb6e4743$var$ci = Array.isArray;
function $2a051a86cb6e4743$var$vr(e, t, n, r) {
    if (e = e.options, t) {
        t = {};
        for(var i1 = 0; i1 < n.length; i1++)t["$" + n[i1]] = !0;
        for(n = 0; n < e.length; n++)i1 = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i1 && (e[n].selected = i1), i1 && r && (e[n].defaultSelected = !0);
    } else {
        for(n = "" + $2a051a86cb6e4743$var$xn(n), t = null, i1 = 0; i1 < e.length; i1++){
            if (e[i1].value === n) {
                e[i1].selected = !0, r && (e[i1].defaultSelected = !0);
                return;
            }
            t !== null || e[i1].disabled || (t = e[i1]);
        }
        t !== null && (t.selected = !0);
    }
}
function $2a051a86cb6e4743$var$ll(e, t) {
    if (t.dangerouslySetInnerHTML != null) throw Error($2a051a86cb6e4743$var$j(91));
    return $2a051a86cb6e4743$var$ce({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: "" + e._wrapperState.initialValue
    });
}
function $2a051a86cb6e4743$var$Kc(e, t) {
    var n = t.value;
    if (n == null) {
        if (n = t.children, t = t.defaultValue, n != null) {
            if (t != null) throw Error($2a051a86cb6e4743$var$j(92));
            if ($2a051a86cb6e4743$var$ci(n)) {
                if (1 < n.length) throw Error($2a051a86cb6e4743$var$j(93));
                n = n[0];
            }
            t = n;
        }
        t == null && (t = ""), n = t;
    }
    e._wrapperState = {
        initialValue: $2a051a86cb6e4743$var$xn(n)
    };
}
function $2a051a86cb6e4743$var$_h(e, t) {
    var n = $2a051a86cb6e4743$var$xn(t.value), r = $2a051a86cb6e4743$var$xn(t.defaultValue);
    n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function $2a051a86cb6e4743$var$Wc(e) {
    var t = e.textContent;
    t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function $2a051a86cb6e4743$var$bh(e) {
    switch(e){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $2a051a86cb6e4743$var$ul(e, t) {
    return e == null || e === "http://www.w3.org/1999/xhtml" ? $2a051a86cb6e4743$var$bh(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var $2a051a86cb6e4743$var$xs, $2a051a86cb6e4743$var$Oh = function(e) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, i1) {
        MSApp.execUnsafeLocalFunction(function() {
            return e(t, n, r, i1);
        });
    } : e;
}(function(e, t) {
    if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
    else {
        for($2a051a86cb6e4743$var$xs = $2a051a86cb6e4743$var$xs || document.createElement("div"), $2a051a86cb6e4743$var$xs.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = $2a051a86cb6e4743$var$xs.firstChild; e.firstChild;)e.removeChild(e.firstChild);
        for(; t.firstChild;)e.appendChild(t.firstChild);
    }
});
function $2a051a86cb6e4743$var$Li(e, t) {
    if (t) {
        var n = e.firstChild;
        if (n && n === e.lastChild && n.nodeType === 3) {
            n.nodeValue = t;
            return;
        }
    }
    e.textContent = t;
}
var $2a051a86cb6e4743$var$pi = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2a051a86cb6e4743$var$c0 = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2a051a86cb6e4743$var$pi).forEach(function(e) {
    $2a051a86cb6e4743$var$c0.forEach(function(t) {
        t = t + e.charAt(0).toUpperCase() + e.substring(1), $2a051a86cb6e4743$var$pi[t] = $2a051a86cb6e4743$var$pi[e];
    });
});
function $2a051a86cb6e4743$var$Nh(e, t, n) {
    return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || $2a051a86cb6e4743$var$pi.hasOwnProperty(e) && $2a051a86cb6e4743$var$pi[e] ? ("" + t).trim() : t + "px";
}
function $2a051a86cb6e4743$var$Th(e, t) {
    e = e.style;
    for(var n in t)if (t.hasOwnProperty(n)) {
        var r = n.indexOf("--") === 0, i1 = $2a051a86cb6e4743$var$Nh(n, t[n], r);
        n === "float" && (n = "cssFloat"), r ? e.setProperty(n, i1) : e[n] = i1;
    }
}
var $2a051a86cb6e4743$var$f0 = $2a051a86cb6e4743$var$ce({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $2a051a86cb6e4743$var$cl(e, t) {
    if (t) {
        if ($2a051a86cb6e4743$var$f0[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error($2a051a86cb6e4743$var$j(137, e));
        if (t.dangerouslySetInnerHTML != null) {
            if (t.children != null) throw Error($2a051a86cb6e4743$var$j(60));
            if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error($2a051a86cb6e4743$var$j(61));
        }
        if (t.style != null && typeof t.style != "object") throw Error($2a051a86cb6e4743$var$j(62));
    }
}
function $2a051a86cb6e4743$var$fl(e, t) {
    if (e.indexOf("-") === -1) return typeof t.is == "string";
    switch(e){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2a051a86cb6e4743$var$dl = null;
function $2a051a86cb6e4743$var$du(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var $2a051a86cb6e4743$var$hl = null, $2a051a86cb6e4743$var$Sr = null, $2a051a86cb6e4743$var$wr = null;
function $2a051a86cb6e4743$var$Yc(e) {
    if (e = $2a051a86cb6e4743$var$us(e)) {
        if (typeof $2a051a86cb6e4743$var$hl != "function") throw Error($2a051a86cb6e4743$var$j(280));
        var t = e.stateNode;
        t && (t = $2a051a86cb6e4743$var$Ho(t), $2a051a86cb6e4743$var$hl(e.stateNode, e.type, t));
    }
}
function $2a051a86cb6e4743$var$Lh(e) {
    $2a051a86cb6e4743$var$Sr ? $2a051a86cb6e4743$var$wr ? $2a051a86cb6e4743$var$wr.push(e) : $2a051a86cb6e4743$var$wr = [
        e
    ] : $2a051a86cb6e4743$var$Sr = e;
}
function $2a051a86cb6e4743$var$Rh() {
    if ($2a051a86cb6e4743$var$Sr) {
        var e = $2a051a86cb6e4743$var$Sr, t = $2a051a86cb6e4743$var$wr;
        if ($2a051a86cb6e4743$var$wr = $2a051a86cb6e4743$var$Sr = null, $2a051a86cb6e4743$var$Yc(e), t) for(e = 0; e < t.length; e++)$2a051a86cb6e4743$var$Yc(t[e]);
    }
}
function $2a051a86cb6e4743$var$jh(e, t) {
    return e(t);
}
function $2a051a86cb6e4743$var$Ih() {}
var $2a051a86cb6e4743$var$da = !1;
function $2a051a86cb6e4743$var$Fh(e, t, n) {
    if ($2a051a86cb6e4743$var$da) return e(t, n);
    $2a051a86cb6e4743$var$da = !0;
    try {
        return $2a051a86cb6e4743$var$jh(e, t, n);
    } finally{
        $2a051a86cb6e4743$var$da = !1, ($2a051a86cb6e4743$var$Sr !== null || $2a051a86cb6e4743$var$wr !== null) && ($2a051a86cb6e4743$var$Ih(), $2a051a86cb6e4743$var$Rh());
    }
}
function $2a051a86cb6e4743$var$Ri(e, t) {
    var n = e.stateNode;
    if (n === null) return null;
    var r = $2a051a86cb6e4743$var$Ho(n);
    if (r === null) return null;
    n = r[t];
    e: switch(t){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
            break e;
        default:
            e = !1;
    }
    if (e) return null;
    if (n && typeof n != "function") throw Error($2a051a86cb6e4743$var$j(231, t, typeof n));
    return n;
}
var $2a051a86cb6e4743$var$pl = !1;
if ($2a051a86cb6e4743$var$Ut) try {
    var $2a051a86cb6e4743$var$ei = {};
    Object.defineProperty($2a051a86cb6e4743$var$ei, "passive", {
        get: function() {
            $2a051a86cb6e4743$var$pl = !0;
        }
    }), window.addEventListener("test", $2a051a86cb6e4743$var$ei, $2a051a86cb6e4743$var$ei), window.removeEventListener("test", $2a051a86cb6e4743$var$ei, $2a051a86cb6e4743$var$ei);
} catch  {
    $2a051a86cb6e4743$var$pl = !1;
}
function $2a051a86cb6e4743$var$d0(e, t, n, r, i1, s, o, a, l) {
    var u = Array.prototype.slice.call(arguments, 3);
    try {
        t.apply(n, u);
    } catch (c) {
        this.onError(c);
    }
}
var $2a051a86cb6e4743$var$gi = !1, $2a051a86cb6e4743$var$ro = null, $2a051a86cb6e4743$var$io = !1, $2a051a86cb6e4743$var$gl = null, $2a051a86cb6e4743$var$h0 = {
    onError: function(e) {
        $2a051a86cb6e4743$var$gi = !0, $2a051a86cb6e4743$var$ro = e;
    }
};
function $2a051a86cb6e4743$var$p0(e, t, n, r, i1, s, o, a, l) {
    $2a051a86cb6e4743$var$gi = !1, $2a051a86cb6e4743$var$ro = null, $2a051a86cb6e4743$var$d0.apply($2a051a86cb6e4743$var$h0, arguments);
}
function $2a051a86cb6e4743$var$g0(e, t, n, r, i1, s, o, a, l) {
    if ($2a051a86cb6e4743$var$p0.apply(this, arguments), $2a051a86cb6e4743$var$gi) {
        if ($2a051a86cb6e4743$var$gi) {
            var u = $2a051a86cb6e4743$var$ro;
            $2a051a86cb6e4743$var$gi = !1, $2a051a86cb6e4743$var$ro = null;
        } else throw Error($2a051a86cb6e4743$var$j(198));
        $2a051a86cb6e4743$var$io || ($2a051a86cb6e4743$var$io = !0, $2a051a86cb6e4743$var$gl = u);
    }
}
function $2a051a86cb6e4743$var$Zn(e) {
    var t = e, n = e;
    if (e.alternate) for(; t.return;)t = t.return;
    else {
        e = t;
        do t = e, t.flags & 4098 && (n = t.return), e = t.return;
        while (e);
    }
    return t.tag === 3 ? n : null;
}
function $2a051a86cb6e4743$var$Dh(e) {
    if (e.tag === 13) {
        var t = e.memoizedState;
        if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
}
function $2a051a86cb6e4743$var$qc(e) {
    if ($2a051a86cb6e4743$var$Zn(e) !== e) throw Error($2a051a86cb6e4743$var$j(188));
}
function $2a051a86cb6e4743$var$m0(e) {
    var t = e.alternate;
    if (!t) {
        if (t = $2a051a86cb6e4743$var$Zn(e), t === null) throw Error($2a051a86cb6e4743$var$j(188));
        return t !== e ? null : e;
    }
    for(var n = e, r = t;;){
        var i1 = n.return;
        if (i1 === null) break;
        var s = i1.alternate;
        if (s === null) {
            if (r = i1.return, r !== null) {
                n = r;
                continue;
            }
            break;
        }
        if (i1.child === s.child) {
            for(s = i1.child; s;){
                if (s === n) return $2a051a86cb6e4743$var$qc(i1), e;
                if (s === r) return $2a051a86cb6e4743$var$qc(i1), t;
                s = s.sibling;
            }
            throw Error($2a051a86cb6e4743$var$j(188));
        }
        if (n.return !== r.return) n = i1, r = s;
        else {
            for(var o = !1, a = i1.child; a;){
                if (a === n) {
                    o = !0, n = i1, r = s;
                    break;
                }
                if (a === r) {
                    o = !0, r = i1, n = s;
                    break;
                }
                a = a.sibling;
            }
            if (!o) {
                for(a = s.child; a;){
                    if (a === n) {
                        o = !0, n = s, r = i1;
                        break;
                    }
                    if (a === r) {
                        o = !0, r = s, n = i1;
                        break;
                    }
                    a = a.sibling;
                }
                if (!o) throw Error($2a051a86cb6e4743$var$j(189));
            }
        }
        if (n.alternate !== r) throw Error($2a051a86cb6e4743$var$j(190));
    }
    if (n.tag !== 3) throw Error($2a051a86cb6e4743$var$j(188));
    return n.stateNode.current === n ? e : t;
}
function $2a051a86cb6e4743$var$Ah(e) {
    return e = $2a051a86cb6e4743$var$m0(e), e !== null ? $2a051a86cb6e4743$var$Mh(e) : null;
}
function $2a051a86cb6e4743$var$Mh(e) {
    if (e.tag === 5 || e.tag === 6) return e;
    for(e = e.child; e !== null;){
        var t = $2a051a86cb6e4743$var$Mh(e);
        if (t !== null) return t;
        e = e.sibling;
    }
    return null;
}
var $2a051a86cb6e4743$var$Uh = $2a051a86cb6e4743$var$We.unstable_scheduleCallback, $2a051a86cb6e4743$var$Gc = $2a051a86cb6e4743$var$We.unstable_cancelCallback, $2a051a86cb6e4743$var$y0 = $2a051a86cb6e4743$var$We.unstable_shouldYield, $2a051a86cb6e4743$var$v0 = $2a051a86cb6e4743$var$We.unstable_requestPaint, $2a051a86cb6e4743$var$pe = $2a051a86cb6e4743$var$We.unstable_now, $2a051a86cb6e4743$var$S0 = $2a051a86cb6e4743$var$We.unstable_getCurrentPriorityLevel, $2a051a86cb6e4743$var$hu = $2a051a86cb6e4743$var$We.unstable_ImmediatePriority, $2a051a86cb6e4743$var$$h = $2a051a86cb6e4743$var$We.unstable_UserBlockingPriority, $2a051a86cb6e4743$var$so = $2a051a86cb6e4743$var$We.unstable_NormalPriority, $2a051a86cb6e4743$var$w0 = $2a051a86cb6e4743$var$We.unstable_LowPriority, $2a051a86cb6e4743$var$zh = $2a051a86cb6e4743$var$We.unstable_IdlePriority, $2a051a86cb6e4743$var$Uo = null, $2a051a86cb6e4743$var$bt = null;
function $2a051a86cb6e4743$var$x0(e) {
    if ($2a051a86cb6e4743$var$bt && typeof $2a051a86cb6e4743$var$bt.onCommitFiberRoot == "function") try {
        $2a051a86cb6e4743$var$bt.onCommitFiberRoot($2a051a86cb6e4743$var$Uo, e, void 0, (e.current.flags & 128) === 128);
    } catch  {}
}
var $2a051a86cb6e4743$var$pt = Math.clz32 ? Math.clz32 : $2a051a86cb6e4743$var$k0, $2a051a86cb6e4743$var$C0 = Math.log, $2a051a86cb6e4743$var$E0 = Math.LN2;
function $2a051a86cb6e4743$var$k0(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - ($2a051a86cb6e4743$var$C0(e) / $2a051a86cb6e4743$var$E0 | 0) | 0;
}
var $2a051a86cb6e4743$var$Cs = 64, $2a051a86cb6e4743$var$Es = 4194304;
function $2a051a86cb6e4743$var$fi(e) {
    switch(e & -e){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return e & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return e & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return e;
    }
}
function $2a051a86cb6e4743$var$oo(e, t) {
    var n = e.pendingLanes;
    if (n === 0) return 0;
    var r = 0, i1 = e.suspendedLanes, s = e.pingedLanes, o = n & 268435455;
    if (o !== 0) {
        var a = o & ~i1;
        a !== 0 ? r = $2a051a86cb6e4743$var$fi(a) : (s &= o, s !== 0 && (r = $2a051a86cb6e4743$var$fi(s)));
    } else o = n & ~i1, o !== 0 ? r = $2a051a86cb6e4743$var$fi(o) : s !== 0 && (r = $2a051a86cb6e4743$var$fi(s));
    if (r === 0) return 0;
    if (t !== 0 && t !== r && !(t & i1) && (i1 = r & -r, s = t & -t, i1 >= s || i1 === 16 && (s & 4194240) !== 0)) return t;
    if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for(e = e.entanglements, t &= r; 0 < t;)n = 31 - $2a051a86cb6e4743$var$pt(t), i1 = 1 << n, r |= e[n], t &= ~i1;
    return r;
}
function $2a051a86cb6e4743$var$P0(e, t) {
    switch(e){
        case 1:
        case 2:
        case 4:
            return t + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return t + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2a051a86cb6e4743$var$_0(e, t) {
    for(var n = e.suspendedLanes, r = e.pingedLanes, i1 = e.expirationTimes, s = e.pendingLanes; 0 < s;){
        var o = 31 - $2a051a86cb6e4743$var$pt(s), a = 1 << o, l = i1[o];
        l === -1 ? (!(a & n) || a & r) && (i1[o] = $2a051a86cb6e4743$var$P0(a, t)) : l <= t && (e.expiredLanes |= a), s &= ~a;
    }
}
function $2a051a86cb6e4743$var$ml(e) {
    return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function $2a051a86cb6e4743$var$Bh() {
    var e = $2a051a86cb6e4743$var$Cs;
    return $2a051a86cb6e4743$var$Cs <<= 1, !($2a051a86cb6e4743$var$Cs & 4194240) && ($2a051a86cb6e4743$var$Cs = 64), e;
}
function $2a051a86cb6e4743$var$ha(e) {
    for(var t = [], n = 0; 31 > n; n++)t.push(e);
    return t;
}
function $2a051a86cb6e4743$var$as(e, t, n) {
    e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - $2a051a86cb6e4743$var$pt(t), e[t] = n;
}
function $2a051a86cb6e4743$var$b0(e, t) {
    var n = e.pendingLanes & ~t;
    e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
    var r = e.eventTimes;
    for(e = e.expirationTimes; 0 < n;){
        var i1 = 31 - $2a051a86cb6e4743$var$pt(n), s = 1 << i1;
        t[i1] = 0, r[i1] = -1, e[i1] = -1, n &= ~s;
    }
}
function $2a051a86cb6e4743$var$pu(e, t) {
    var n = e.entangledLanes |= t;
    for(e = e.entanglements; n;){
        var r = 31 - $2a051a86cb6e4743$var$pt(n), i1 = 1 << r;
        i1 & t | e[r] & t && (e[r] |= t), n &= ~i1;
    }
}
var $2a051a86cb6e4743$var$ee = 0;
function $2a051a86cb6e4743$var$Hh(e) {
    return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var $2a051a86cb6e4743$var$Vh, $2a051a86cb6e4743$var$gu, $2a051a86cb6e4743$var$Qh, $2a051a86cb6e4743$var$Kh, $2a051a86cb6e4743$var$Wh, $2a051a86cb6e4743$var$yl = !1, $2a051a86cb6e4743$var$ks = [], $2a051a86cb6e4743$var$dn = null, $2a051a86cb6e4743$var$hn = null, $2a051a86cb6e4743$var$pn = null, $2a051a86cb6e4743$var$ji = new Map, $2a051a86cb6e4743$var$Ii = new Map, $2a051a86cb6e4743$var$en = [], $2a051a86cb6e4743$var$O0 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $2a051a86cb6e4743$var$Xc(e, t) {
    switch(e){
        case "focusin":
        case "focusout":
            $2a051a86cb6e4743$var$dn = null;
            break;
        case "dragenter":
        case "dragleave":
            $2a051a86cb6e4743$var$hn = null;
            break;
        case "mouseover":
        case "mouseout":
            $2a051a86cb6e4743$var$pn = null;
            break;
        case "pointerover":
        case "pointerout":
            $2a051a86cb6e4743$var$ji.delete(t.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2a051a86cb6e4743$var$Ii.delete(t.pointerId);
    }
}
function $2a051a86cb6e4743$var$ti(e, t, n, r, i1, s) {
    return e === null || e.nativeEvent !== s ? (e = {
        blockedOn: t,
        domEventName: n,
        eventSystemFlags: r,
        nativeEvent: s,
        targetContainers: [
            i1
        ]
    }, t !== null && (t = $2a051a86cb6e4743$var$us(t), t !== null && $2a051a86cb6e4743$var$gu(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i1 !== null && t.indexOf(i1) === -1 && t.push(i1), e);
}
function $2a051a86cb6e4743$var$N0(e, t, n, r, i1) {
    switch(t){
        case "focusin":
            return $2a051a86cb6e4743$var$dn = $2a051a86cb6e4743$var$ti($2a051a86cb6e4743$var$dn, e, t, n, r, i1), !0;
        case "dragenter":
            return $2a051a86cb6e4743$var$hn = $2a051a86cb6e4743$var$ti($2a051a86cb6e4743$var$hn, e, t, n, r, i1), !0;
        case "mouseover":
            return $2a051a86cb6e4743$var$pn = $2a051a86cb6e4743$var$ti($2a051a86cb6e4743$var$pn, e, t, n, r, i1), !0;
        case "pointerover":
            var s = i1.pointerId;
            return $2a051a86cb6e4743$var$ji.set(s, $2a051a86cb6e4743$var$ti($2a051a86cb6e4743$var$ji.get(s) || null, e, t, n, r, i1)), !0;
        case "gotpointercapture":
            return s = i1.pointerId, $2a051a86cb6e4743$var$Ii.set(s, $2a051a86cb6e4743$var$ti($2a051a86cb6e4743$var$Ii.get(s) || null, e, t, n, r, i1)), !0;
    }
    return !1;
}
function $2a051a86cb6e4743$var$Yh(e) {
    var t = $2a051a86cb6e4743$var$Tn(e.target);
    if (t !== null) {
        var n = $2a051a86cb6e4743$var$Zn(t);
        if (n !== null) {
            if (t = n.tag, t === 13) {
                if (t = $2a051a86cb6e4743$var$Dh(n), t !== null) {
                    e.blockedOn = t, $2a051a86cb6e4743$var$Wh(e.priority, function() {
                        $2a051a86cb6e4743$var$Qh(n);
                    });
                    return;
                }
            } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
                e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
                return;
            }
        }
    }
    e.blockedOn = null;
}
function $2a051a86cb6e4743$var$$s(e) {
    if (e.blockedOn !== null) return !1;
    for(var t = e.targetContainers; 0 < t.length;){
        var n = $2a051a86cb6e4743$var$vl(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
        if (n === null) {
            n = e.nativeEvent;
            var r = new n.constructor(n.type, n);
            $2a051a86cb6e4743$var$dl = r, n.target.dispatchEvent(r), $2a051a86cb6e4743$var$dl = null;
        } else return t = $2a051a86cb6e4743$var$us(n), t !== null && $2a051a86cb6e4743$var$gu(t), e.blockedOn = n, !1;
        t.shift();
    }
    return !0;
}
function $2a051a86cb6e4743$var$Jc(e, t, n) {
    $2a051a86cb6e4743$var$$s(e) && n.delete(t);
}
function $2a051a86cb6e4743$var$T0() {
    $2a051a86cb6e4743$var$yl = !1, $2a051a86cb6e4743$var$dn !== null && $2a051a86cb6e4743$var$$s($2a051a86cb6e4743$var$dn) && ($2a051a86cb6e4743$var$dn = null), $2a051a86cb6e4743$var$hn !== null && $2a051a86cb6e4743$var$$s($2a051a86cb6e4743$var$hn) && ($2a051a86cb6e4743$var$hn = null), $2a051a86cb6e4743$var$pn !== null && $2a051a86cb6e4743$var$$s($2a051a86cb6e4743$var$pn) && ($2a051a86cb6e4743$var$pn = null), $2a051a86cb6e4743$var$ji.forEach($2a051a86cb6e4743$var$Jc), $2a051a86cb6e4743$var$Ii.forEach($2a051a86cb6e4743$var$Jc);
}
function $2a051a86cb6e4743$var$ni(e, t) {
    e.blockedOn === t && (e.blockedOn = null, $2a051a86cb6e4743$var$yl || ($2a051a86cb6e4743$var$yl = !0, $2a051a86cb6e4743$var$We.unstable_scheduleCallback($2a051a86cb6e4743$var$We.unstable_NormalPriority, $2a051a86cb6e4743$var$T0)));
}
function $2a051a86cb6e4743$var$Fi(e) {
    function t(i1) {
        return $2a051a86cb6e4743$var$ni(i1, e);
    }
    if (0 < $2a051a86cb6e4743$var$ks.length) {
        $2a051a86cb6e4743$var$ni($2a051a86cb6e4743$var$ks[0], e);
        for(var n = 1; n < $2a051a86cb6e4743$var$ks.length; n++){
            var r = $2a051a86cb6e4743$var$ks[n];
            r.blockedOn === e && (r.blockedOn = null);
        }
    }
    for($2a051a86cb6e4743$var$dn !== null && $2a051a86cb6e4743$var$ni($2a051a86cb6e4743$var$dn, e), $2a051a86cb6e4743$var$hn !== null && $2a051a86cb6e4743$var$ni($2a051a86cb6e4743$var$hn, e), $2a051a86cb6e4743$var$pn !== null && $2a051a86cb6e4743$var$ni($2a051a86cb6e4743$var$pn, e), $2a051a86cb6e4743$var$ji.forEach(t), $2a051a86cb6e4743$var$Ii.forEach(t), n = 0; n < $2a051a86cb6e4743$var$en.length; n++)r = $2a051a86cb6e4743$var$en[n], r.blockedOn === e && (r.blockedOn = null);
    for(; 0 < $2a051a86cb6e4743$var$en.length && (n = $2a051a86cb6e4743$var$en[0], n.blockedOn === null);)$2a051a86cb6e4743$var$Yh(n), n.blockedOn === null && $2a051a86cb6e4743$var$en.shift();
}
var $2a051a86cb6e4743$var$xr = $2a051a86cb6e4743$var$Ht.ReactCurrentBatchConfig, $2a051a86cb6e4743$var$ao = !0;
function $2a051a86cb6e4743$var$L0(e, t, n, r) {
    var i1 = $2a051a86cb6e4743$var$ee, s = $2a051a86cb6e4743$var$xr.transition;
    $2a051a86cb6e4743$var$xr.transition = null;
    try {
        $2a051a86cb6e4743$var$ee = 1, $2a051a86cb6e4743$var$mu(e, t, n, r);
    } finally{
        $2a051a86cb6e4743$var$ee = i1, $2a051a86cb6e4743$var$xr.transition = s;
    }
}
function $2a051a86cb6e4743$var$R0(e, t, n, r) {
    var i1 = $2a051a86cb6e4743$var$ee, s = $2a051a86cb6e4743$var$xr.transition;
    $2a051a86cb6e4743$var$xr.transition = null;
    try {
        $2a051a86cb6e4743$var$ee = 4, $2a051a86cb6e4743$var$mu(e, t, n, r);
    } finally{
        $2a051a86cb6e4743$var$ee = i1, $2a051a86cb6e4743$var$xr.transition = s;
    }
}
function $2a051a86cb6e4743$var$mu(e, t, n, r) {
    if ($2a051a86cb6e4743$var$ao) {
        var i1 = $2a051a86cb6e4743$var$vl(e, t, n, r);
        if (i1 === null) $2a051a86cb6e4743$var$Ea(e, t, r, $2a051a86cb6e4743$var$lo, n), $2a051a86cb6e4743$var$Xc(e, r);
        else if ($2a051a86cb6e4743$var$N0(i1, e, t, n, r)) r.stopPropagation();
        else if ($2a051a86cb6e4743$var$Xc(e, r), t & 4 && -1 < $2a051a86cb6e4743$var$O0.indexOf(e)) {
            for(; i1 !== null;){
                var s = $2a051a86cb6e4743$var$us(i1);
                if (s !== null && $2a051a86cb6e4743$var$Vh(s), s = $2a051a86cb6e4743$var$vl(e, t, n, r), s === null && $2a051a86cb6e4743$var$Ea(e, t, r, $2a051a86cb6e4743$var$lo, n), s === i1) break;
                i1 = s;
            }
            i1 !== null && r.stopPropagation();
        } else $2a051a86cb6e4743$var$Ea(e, t, r, null, n);
    }
}
var $2a051a86cb6e4743$var$lo = null;
function $2a051a86cb6e4743$var$vl(e, t, n, r) {
    if ($2a051a86cb6e4743$var$lo = null, e = $2a051a86cb6e4743$var$du(r), e = $2a051a86cb6e4743$var$Tn(e), e !== null) {
        if (t = $2a051a86cb6e4743$var$Zn(e), t === null) e = null;
        else if (n = t.tag, n === 13) {
            if (e = $2a051a86cb6e4743$var$Dh(t), e !== null) return e;
            e = null;
        } else if (n === 3) {
            if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
            e = null;
        } else t !== e && (e = null);
    }
    return $2a051a86cb6e4743$var$lo = e, null;
}
function $2a051a86cb6e4743$var$qh(e) {
    switch(e){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($2a051a86cb6e4743$var$S0()){
                case $2a051a86cb6e4743$var$hu:
                    return 1;
                case $2a051a86cb6e4743$var$$h:
                    return 4;
                case $2a051a86cb6e4743$var$so:
                case $2a051a86cb6e4743$var$w0:
                    return 16;
                case $2a051a86cb6e4743$var$zh:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $2a051a86cb6e4743$var$cn = null, $2a051a86cb6e4743$var$yu = null, $2a051a86cb6e4743$var$zs = null;
function $2a051a86cb6e4743$var$Gh() {
    if ($2a051a86cb6e4743$var$zs) return $2a051a86cb6e4743$var$zs;
    var e, t = $2a051a86cb6e4743$var$yu, n = t.length, r, i1 = "value" in $2a051a86cb6e4743$var$cn ? $2a051a86cb6e4743$var$cn.value : $2a051a86cb6e4743$var$cn.textContent, s = i1.length;
    for(e = 0; e < n && t[e] === i1[e]; e++);
    var o = n - e;
    for(r = 1; r <= o && t[n - r] === i1[s - r]; r++);
    return $2a051a86cb6e4743$var$zs = i1.slice(e, 1 < r ? 1 - r : void 0);
}
function $2a051a86cb6e4743$var$Bs(e) {
    var t = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function $2a051a86cb6e4743$var$Ps() {
    return !0;
}
function $2a051a86cb6e4743$var$Zc() {
    return !1;
}
function $2a051a86cb6e4743$var$qe(e) {
    function t(n, r, i1, s, o) {
        this._reactName = n, this._targetInst = i1, this.type = r, this.nativeEvent = s, this.target = o, this.currentTarget = null;
        for(var a in e)e.hasOwnProperty(a) && (n = e[a], this[a] = n ? n(s) : s[a]);
        return this.isDefaultPrevented = (s.defaultPrevented != null ? s.defaultPrevented : s.returnValue === !1) ? $2a051a86cb6e4743$var$Ps : $2a051a86cb6e4743$var$Zc, this.isPropagationStopped = $2a051a86cb6e4743$var$Zc, this;
    }
    return $2a051a86cb6e4743$var$ce(t.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var n = this.nativeEvent;
            n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = $2a051a86cb6e4743$var$Ps);
        },
        stopPropagation: function() {
            var n = this.nativeEvent;
            n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = $2a051a86cb6e4743$var$Ps);
        },
        persist: function() {},
        isPersistent: $2a051a86cb6e4743$var$Ps
    }), t;
}
var $2a051a86cb6e4743$var$Wr = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(e) {
        return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2a051a86cb6e4743$var$vu = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$Wr), $2a051a86cb6e4743$var$ls = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$Wr, {
    view: 0,
    detail: 0
}), $2a051a86cb6e4743$var$j0 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$ls), $2a051a86cb6e4743$var$pa, $2a051a86cb6e4743$var$ga, $2a051a86cb6e4743$var$ri, $2a051a86cb6e4743$var$$o = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$ls, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2a051a86cb6e4743$var$Su,
    button: 0,
    buttons: 0,
    relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function(e) {
        return "movementX" in e ? e.movementX : (e !== $2a051a86cb6e4743$var$ri && ($2a051a86cb6e4743$var$ri && e.type === "mousemove" ? ($2a051a86cb6e4743$var$pa = e.screenX - $2a051a86cb6e4743$var$ri.screenX, $2a051a86cb6e4743$var$ga = e.screenY - $2a051a86cb6e4743$var$ri.screenY) : $2a051a86cb6e4743$var$ga = $2a051a86cb6e4743$var$pa = 0, $2a051a86cb6e4743$var$ri = e), $2a051a86cb6e4743$var$pa);
    },
    movementY: function(e) {
        return "movementY" in e ? e.movementY : $2a051a86cb6e4743$var$ga;
    }
}), $2a051a86cb6e4743$var$ef = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$$o), $2a051a86cb6e4743$var$I0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$$o, {
    dataTransfer: 0
}), $2a051a86cb6e4743$var$F0 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$I0), $2a051a86cb6e4743$var$D0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$ls, {
    relatedTarget: 0
}), $2a051a86cb6e4743$var$ma = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$D0), $2a051a86cb6e4743$var$A0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$Wr, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2a051a86cb6e4743$var$M0 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$A0), $2a051a86cb6e4743$var$U0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$Wr, {
    clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
}), $2a051a86cb6e4743$var$$0 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$U0), $2a051a86cb6e4743$var$z0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$Wr, {
    data: 0
}), $2a051a86cb6e4743$var$tf = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$z0), $2a051a86cb6e4743$var$B0 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2a051a86cb6e4743$var$H0 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2a051a86cb6e4743$var$V0 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2a051a86cb6e4743$var$Q0(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = $2a051a86cb6e4743$var$V0[e]) ? !!t[e] : !1;
}
function $2a051a86cb6e4743$var$Su() {
    return $2a051a86cb6e4743$var$Q0;
}
var $2a051a86cb6e4743$var$K0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$ls, {
    key: function(e) {
        if (e.key) {
            var t = $2a051a86cb6e4743$var$B0[e.key] || e.key;
            if (t !== "Unidentified") return t;
        }
        return e.type === "keypress" ? (e = $2a051a86cb6e4743$var$Bs(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? $2a051a86cb6e4743$var$H0[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2a051a86cb6e4743$var$Su,
    charCode: function(e) {
        return e.type === "keypress" ? $2a051a86cb6e4743$var$Bs(e) : 0;
    },
    keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function(e) {
        return e.type === "keypress" ? $2a051a86cb6e4743$var$Bs(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
}), $2a051a86cb6e4743$var$W0 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$K0), $2a051a86cb6e4743$var$Y0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$$o, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2a051a86cb6e4743$var$nf = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$Y0), $2a051a86cb6e4743$var$q0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$ls, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2a051a86cb6e4743$var$Su
}), $2a051a86cb6e4743$var$G0 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$q0), $2a051a86cb6e4743$var$X0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$Wr, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2a051a86cb6e4743$var$J0 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$X0), $2a051a86cb6e4743$var$Z0 = $2a051a86cb6e4743$var$ce({}, $2a051a86cb6e4743$var$$o, {
    deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2a051a86cb6e4743$var$e1 = $2a051a86cb6e4743$var$qe($2a051a86cb6e4743$var$Z0), $2a051a86cb6e4743$var$t1 = [
    9,
    13,
    27,
    32
], $2a051a86cb6e4743$var$wu = $2a051a86cb6e4743$var$Ut && "CompositionEvent" in window, $2a051a86cb6e4743$var$mi = null;
$2a051a86cb6e4743$var$Ut && "documentMode" in document && ($2a051a86cb6e4743$var$mi = document.documentMode);
var $2a051a86cb6e4743$var$n1 = $2a051a86cb6e4743$var$Ut && "TextEvent" in window && !$2a051a86cb6e4743$var$mi, $2a051a86cb6e4743$var$Xh = $2a051a86cb6e4743$var$Ut && (!$2a051a86cb6e4743$var$wu || $2a051a86cb6e4743$var$mi && 8 < $2a051a86cb6e4743$var$mi && 11 >= $2a051a86cb6e4743$var$mi), $2a051a86cb6e4743$var$rf = String.fromCharCode(32), $2a051a86cb6e4743$var$sf = !1;
function $2a051a86cb6e4743$var$Jh(e, t) {
    switch(e){
        case "keyup":
            return $2a051a86cb6e4743$var$t1.indexOf(t.keyCode) !== -1;
        case "keydown":
            return t.keyCode !== 229;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2a051a86cb6e4743$var$Zh(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var $2a051a86cb6e4743$var$or = !1;
function $2a051a86cb6e4743$var$r1(e, t) {
    switch(e){
        case "compositionend":
            return $2a051a86cb6e4743$var$Zh(t);
        case "keypress":
            return t.which !== 32 ? null : ($2a051a86cb6e4743$var$sf = !0, $2a051a86cb6e4743$var$rf);
        case "textInput":
            return e = t.data, e === $2a051a86cb6e4743$var$rf && $2a051a86cb6e4743$var$sf ? null : e;
        default:
            return null;
    }
}
function $2a051a86cb6e4743$var$i1(e, t) {
    if ($2a051a86cb6e4743$var$or) return e === "compositionend" || !$2a051a86cb6e4743$var$wu && $2a051a86cb6e4743$var$Jh(e, t) ? (e = $2a051a86cb6e4743$var$Gh(), $2a051a86cb6e4743$var$zs = $2a051a86cb6e4743$var$yu = $2a051a86cb6e4743$var$cn = null, $2a051a86cb6e4743$var$or = !1, e) : null;
    switch(e){
        case "paste":
            return null;
        case "keypress":
            if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                if (t.char && 1 < t.char.length) return t.char;
                if (t.which) return String.fromCharCode(t.which);
            }
            return null;
        case "compositionend":
            return $2a051a86cb6e4743$var$Xh && t.locale !== "ko" ? null : t.data;
        default:
            return null;
    }
}
var $2a051a86cb6e4743$var$s1 = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2a051a86cb6e4743$var$of(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!$2a051a86cb6e4743$var$s1[e.type] : t === "textarea";
}
function $2a051a86cb6e4743$var$ep(e, t, n, r) {
    $2a051a86cb6e4743$var$Lh(r), t = $2a051a86cb6e4743$var$uo(t, "onChange"), 0 < t.length && (n = new $2a051a86cb6e4743$var$vu("onChange", "change", null, n, r), e.push({
        event: n,
        listeners: t
    }));
}
var $2a051a86cb6e4743$var$yi = null, $2a051a86cb6e4743$var$Di = null;
function $2a051a86cb6e4743$var$o1(e) {
    $2a051a86cb6e4743$var$fp(e, 0);
}
function $2a051a86cb6e4743$var$zo(e) {
    var t = $2a051a86cb6e4743$var$ur(e);
    if ($2a051a86cb6e4743$var$kh(t)) return e;
}
function $2a051a86cb6e4743$var$a1(e, t) {
    if (e === "change") return t;
}
var $2a051a86cb6e4743$var$tp = !1;
if ($2a051a86cb6e4743$var$Ut) {
    var $2a051a86cb6e4743$var$ya;
    if ($2a051a86cb6e4743$var$Ut) {
        var $2a051a86cb6e4743$var$va = "oninput" in document;
        if (!$2a051a86cb6e4743$var$va) {
            var $2a051a86cb6e4743$var$af = document.createElement("div");
            $2a051a86cb6e4743$var$af.setAttribute("oninput", "return;"), $2a051a86cb6e4743$var$va = typeof $2a051a86cb6e4743$var$af.oninput == "function";
        }
        $2a051a86cb6e4743$var$ya = $2a051a86cb6e4743$var$va;
    } else $2a051a86cb6e4743$var$ya = !1;
    $2a051a86cb6e4743$var$tp = $2a051a86cb6e4743$var$ya && (!document.documentMode || 9 < document.documentMode);
}
function $2a051a86cb6e4743$var$lf() {
    $2a051a86cb6e4743$var$yi && ($2a051a86cb6e4743$var$yi.detachEvent("onpropertychange", $2a051a86cb6e4743$var$np), $2a051a86cb6e4743$var$Di = $2a051a86cb6e4743$var$yi = null);
}
function $2a051a86cb6e4743$var$np(e) {
    if (e.propertyName === "value" && $2a051a86cb6e4743$var$zo($2a051a86cb6e4743$var$Di)) {
        var t = [];
        $2a051a86cb6e4743$var$ep(t, $2a051a86cb6e4743$var$Di, e, $2a051a86cb6e4743$var$du(e)), $2a051a86cb6e4743$var$Fh($2a051a86cb6e4743$var$o1, t);
    }
}
function $2a051a86cb6e4743$var$l1(e, t, n) {
    e === "focusin" ? ($2a051a86cb6e4743$var$lf(), $2a051a86cb6e4743$var$yi = t, $2a051a86cb6e4743$var$Di = n, $2a051a86cb6e4743$var$yi.attachEvent("onpropertychange", $2a051a86cb6e4743$var$np)) : e === "focusout" && $2a051a86cb6e4743$var$lf();
}
function $2a051a86cb6e4743$var$u1(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown") return $2a051a86cb6e4743$var$zo($2a051a86cb6e4743$var$Di);
}
function $2a051a86cb6e4743$var$c1(e, t) {
    if (e === "click") return $2a051a86cb6e4743$var$zo(t);
}
function $2a051a86cb6e4743$var$f1(e, t) {
    if (e === "input" || e === "change") return $2a051a86cb6e4743$var$zo(t);
}
function $2a051a86cb6e4743$var$d1(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var $2a051a86cb6e4743$var$mt = typeof Object.is == "function" ? Object.is : $2a051a86cb6e4743$var$d1;
function $2a051a86cb6e4743$var$Ai(e, t) {
    if ($2a051a86cb6e4743$var$mt(e, t)) return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
    var n = Object.keys(e), r = Object.keys(t);
    if (n.length !== r.length) return !1;
    for(r = 0; r < n.length; r++){
        var i1 = n[r];
        if (!$2a051a86cb6e4743$var$el.call(t, i1) || !$2a051a86cb6e4743$var$mt(e[i1], t[i1])) return !1;
    }
    return !0;
}
function $2a051a86cb6e4743$var$uf(e) {
    for(; e && e.firstChild;)e = e.firstChild;
    return e;
}
function $2a051a86cb6e4743$var$cf(e, t) {
    var n = $2a051a86cb6e4743$var$uf(e);
    e = 0;
    for(var r; n;){
        if (n.nodeType === 3) {
            if (r = e + n.textContent.length, e <= t && r >= t) return {
                node: n,
                offset: t - e
            };
            e = r;
        }
        e: {
            for(; n;){
                if (n.nextSibling) {
                    n = n.nextSibling;
                    break e;
                }
                n = n.parentNode;
            }
            n = void 0;
        }
        n = $2a051a86cb6e4743$var$uf(n);
    }
}
function $2a051a86cb6e4743$var$rp(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? $2a051a86cb6e4743$var$rp(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function $2a051a86cb6e4743$var$ip() {
    for(var e = window, t = $2a051a86cb6e4743$var$no(); t instanceof e.HTMLIFrameElement;){
        try {
            var n = typeof t.contentWindow.location.href == "string";
        } catch  {
            n = !1;
        }
        if (n) e = t.contentWindow;
        else break;
        t = $2a051a86cb6e4743$var$no(e.document);
    }
    return t;
}
function $2a051a86cb6e4743$var$xu(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function $2a051a86cb6e4743$var$h1(e) {
    var t = $2a051a86cb6e4743$var$ip(), n = e.focusedElem, r = e.selectionRange;
    if (t !== n && n && n.ownerDocument && $2a051a86cb6e4743$var$rp(n.ownerDocument.documentElement, n)) {
        if (r !== null && $2a051a86cb6e4743$var$xu(n)) {
            if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
            else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
                e = e.getSelection();
                var i1 = n.textContent.length, s = Math.min(r.start, i1);
                r = r.end === void 0 ? s : Math.min(r.end, i1), !e.extend && s > r && (i1 = r, r = s, s = i1), i1 = $2a051a86cb6e4743$var$cf(n, s);
                var o = $2a051a86cb6e4743$var$cf(n, r);
                i1 && o && (e.rangeCount !== 1 || e.anchorNode !== i1.node || e.anchorOffset !== i1.offset || e.focusNode !== o.node || e.focusOffset !== o.offset) && (t = t.createRange(), t.setStart(i1.node, i1.offset), e.removeAllRanges(), s > r ? (e.addRange(t), e.extend(o.node, o.offset)) : (t.setEnd(o.node, o.offset), e.addRange(t)));
            }
        }
        for(t = [], e = n; e = e.parentNode;)e.nodeType === 1 && t.push({
            element: e,
            left: e.scrollLeft,
            top: e.scrollTop
        });
        for(typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++)e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
    }
}
var $2a051a86cb6e4743$var$p1 = $2a051a86cb6e4743$var$Ut && "documentMode" in document && 11 >= document.documentMode, $2a051a86cb6e4743$var$ar = null, $2a051a86cb6e4743$var$Sl = null, $2a051a86cb6e4743$var$vi = null, $2a051a86cb6e4743$var$wl = !1;
function $2a051a86cb6e4743$var$ff(e, t, n) {
    var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    $2a051a86cb6e4743$var$wl || $2a051a86cb6e4743$var$ar == null || $2a051a86cb6e4743$var$ar !== $2a051a86cb6e4743$var$no(r) || (r = $2a051a86cb6e4743$var$ar, "selectionStart" in r && $2a051a86cb6e4743$var$xu(r) ? r = {
        start: r.selectionStart,
        end: r.selectionEnd
    } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
        anchorNode: r.anchorNode,
        anchorOffset: r.anchorOffset,
        focusNode: r.focusNode,
        focusOffset: r.focusOffset
    }), $2a051a86cb6e4743$var$vi && $2a051a86cb6e4743$var$Ai($2a051a86cb6e4743$var$vi, r) || ($2a051a86cb6e4743$var$vi = r, r = $2a051a86cb6e4743$var$uo($2a051a86cb6e4743$var$Sl, "onSelect"), 0 < r.length && (t = new $2a051a86cb6e4743$var$vu("onSelect", "select", null, t, n), e.push({
        event: t,
        listeners: r
    }), t.target = $2a051a86cb6e4743$var$ar)));
}
function $2a051a86cb6e4743$var$_s(e, t) {
    var n = {};
    return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var $2a051a86cb6e4743$var$lr = {
    animationend: $2a051a86cb6e4743$var$_s("Animation", "AnimationEnd"),
    animationiteration: $2a051a86cb6e4743$var$_s("Animation", "AnimationIteration"),
    animationstart: $2a051a86cb6e4743$var$_s("Animation", "AnimationStart"),
    transitionend: $2a051a86cb6e4743$var$_s("Transition", "TransitionEnd")
}, $2a051a86cb6e4743$var$Sa = {}, $2a051a86cb6e4743$var$sp = {};
$2a051a86cb6e4743$var$Ut && ($2a051a86cb6e4743$var$sp = document.createElement("div").style, "AnimationEvent" in window || (delete $2a051a86cb6e4743$var$lr.animationend.animation, delete $2a051a86cb6e4743$var$lr.animationiteration.animation, delete $2a051a86cb6e4743$var$lr.animationstart.animation), "TransitionEvent" in window || delete $2a051a86cb6e4743$var$lr.transitionend.transition);
function $2a051a86cb6e4743$var$Bo(e) {
    if ($2a051a86cb6e4743$var$Sa[e]) return $2a051a86cb6e4743$var$Sa[e];
    if (!$2a051a86cb6e4743$var$lr[e]) return e;
    var t = $2a051a86cb6e4743$var$lr[e], n;
    for(n in t)if (t.hasOwnProperty(n) && n in $2a051a86cb6e4743$var$sp) return $2a051a86cb6e4743$var$Sa[e] = t[n];
    return e;
}
var $2a051a86cb6e4743$var$op = $2a051a86cb6e4743$var$Bo("animationend"), $2a051a86cb6e4743$var$ap = $2a051a86cb6e4743$var$Bo("animationiteration"), $2a051a86cb6e4743$var$lp = $2a051a86cb6e4743$var$Bo("animationstart"), $2a051a86cb6e4743$var$up = $2a051a86cb6e4743$var$Bo("transitionend"), $2a051a86cb6e4743$var$cp = new Map, $2a051a86cb6e4743$var$df = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $2a051a86cb6e4743$var$En(e, t) {
    $2a051a86cb6e4743$var$cp.set(e, t), $2a051a86cb6e4743$var$Jn(t, [
        e
    ]);
}
for(var $2a051a86cb6e4743$var$wa = 0; $2a051a86cb6e4743$var$wa < $2a051a86cb6e4743$var$df.length; $2a051a86cb6e4743$var$wa++){
    var $2a051a86cb6e4743$var$xa = $2a051a86cb6e4743$var$df[$2a051a86cb6e4743$var$wa], $2a051a86cb6e4743$var$g1 = $2a051a86cb6e4743$var$xa.toLowerCase(), $2a051a86cb6e4743$var$m1 = $2a051a86cb6e4743$var$xa[0].toUpperCase() + $2a051a86cb6e4743$var$xa.slice(1);
    $2a051a86cb6e4743$var$En($2a051a86cb6e4743$var$g1, "on" + $2a051a86cb6e4743$var$m1);
}
$2a051a86cb6e4743$var$En($2a051a86cb6e4743$var$op, "onAnimationEnd");
$2a051a86cb6e4743$var$En($2a051a86cb6e4743$var$ap, "onAnimationIteration");
$2a051a86cb6e4743$var$En($2a051a86cb6e4743$var$lp, "onAnimationStart");
$2a051a86cb6e4743$var$En("dblclick", "onDoubleClick");
$2a051a86cb6e4743$var$En("focusin", "onFocus");
$2a051a86cb6e4743$var$En("focusout", "onBlur");
$2a051a86cb6e4743$var$En($2a051a86cb6e4743$var$up, "onTransitionEnd");
$2a051a86cb6e4743$var$Ur("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2a051a86cb6e4743$var$Ur("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2a051a86cb6e4743$var$Ur("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2a051a86cb6e4743$var$Ur("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2a051a86cb6e4743$var$Jn("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2a051a86cb6e4743$var$Jn("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2a051a86cb6e4743$var$Jn("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2a051a86cb6e4743$var$Jn("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2a051a86cb6e4743$var$Jn("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2a051a86cb6e4743$var$Jn("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2a051a86cb6e4743$var$di = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2a051a86cb6e4743$var$y1 = new Set("cancel close invalid load scroll toggle".split(" ").concat($2a051a86cb6e4743$var$di));
function $2a051a86cb6e4743$var$hf(e, t, n) {
    var r = e.type || "unknown-event";
    e.currentTarget = n, $2a051a86cb6e4743$var$g0(r, t, void 0, e), e.currentTarget = null;
}
function $2a051a86cb6e4743$var$fp(e, t) {
    t = (t & 4) !== 0;
    for(var n = 0; n < e.length; n++){
        var r = e[n], i1 = r.event;
        r = r.listeners;
        e: {
            var s = void 0;
            if (t) for(var o = r.length - 1; 0 <= o; o--){
                var a = r[o], l = a.instance, u = a.currentTarget;
                if (a = a.listener, l !== s && i1.isPropagationStopped()) break e;
                $2a051a86cb6e4743$var$hf(i1, a, u), s = l;
            }
            else for(o = 0; o < r.length; o++){
                if (a = r[o], l = a.instance, u = a.currentTarget, a = a.listener, l !== s && i1.isPropagationStopped()) break e;
                $2a051a86cb6e4743$var$hf(i1, a, u), s = l;
            }
        }
    }
    if ($2a051a86cb6e4743$var$io) throw e = $2a051a86cb6e4743$var$gl, $2a051a86cb6e4743$var$io = !1, $2a051a86cb6e4743$var$gl = null, e;
}
function $2a051a86cb6e4743$var$ne(e, t) {
    var n = t[$2a051a86cb6e4743$var$Pl];
    n === void 0 && (n = t[$2a051a86cb6e4743$var$Pl] = new Set);
    var r = e + "__bubble";
    n.has(r) || ($2a051a86cb6e4743$var$dp(t, e, 2, !1), n.add(r));
}
function $2a051a86cb6e4743$var$Ca(e, t, n) {
    var r = 0;
    t && (r |= 4), $2a051a86cb6e4743$var$dp(n, e, r, t);
}
var $2a051a86cb6e4743$var$bs = "_reactListening" + Math.random().toString(36).slice(2);
function $2a051a86cb6e4743$var$Mi(e) {
    if (!e[$2a051a86cb6e4743$var$bs]) {
        e[$2a051a86cb6e4743$var$bs] = !0, $2a051a86cb6e4743$var$Sh.forEach(function(n) {
            n !== "selectionchange" && ($2a051a86cb6e4743$var$y1.has(n) || $2a051a86cb6e4743$var$Ca(n, !1, e), $2a051a86cb6e4743$var$Ca(n, !0, e));
        });
        var t = e.nodeType === 9 ? e : e.ownerDocument;
        t === null || t[$2a051a86cb6e4743$var$bs] || (t[$2a051a86cb6e4743$var$bs] = !0, $2a051a86cb6e4743$var$Ca("selectionchange", !1, t));
    }
}
function $2a051a86cb6e4743$var$dp(e, t, n, r) {
    switch($2a051a86cb6e4743$var$qh(t)){
        case 1:
            var i1 = $2a051a86cb6e4743$var$L0;
            break;
        case 4:
            i1 = $2a051a86cb6e4743$var$R0;
            break;
        default:
            i1 = $2a051a86cb6e4743$var$mu;
    }
    n = i1.bind(null, t, n, e), i1 = void 0, !$2a051a86cb6e4743$var$pl || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i1 = !0), r ? i1 !== void 0 ? e.addEventListener(t, n, {
        capture: !0,
        passive: i1
    }) : e.addEventListener(t, n, !0) : i1 !== void 0 ? e.addEventListener(t, n, {
        passive: i1
    }) : e.addEventListener(t, n, !1);
}
function $2a051a86cb6e4743$var$Ea(e, t, n, r, i2) {
    var s = r;
    if (!(t & 1) && !(t & 2) && r !== null) e: for(;;){
        if (r === null) return;
        var o = r.tag;
        if (o === 3 || o === 4) {
            var a = r.stateNode.containerInfo;
            if (a === i2 || a.nodeType === 8 && a.parentNode === i2) break;
            if (o === 4) for(o = r.return; o !== null;){
                var l = o.tag;
                if ((l === 3 || l === 4) && (l = o.stateNode.containerInfo, l === i2 || l.nodeType === 8 && l.parentNode === i2)) return;
                o = o.return;
            }
            for(; a !== null;){
                if (o = $2a051a86cb6e4743$var$Tn(a), o === null) return;
                if (l = o.tag, l === 5 || l === 6) {
                    r = s = o;
                    continue e;
                }
                a = a.parentNode;
            }
        }
        r = r.return;
    }
    $2a051a86cb6e4743$var$Fh(function() {
        var u = s, c = $2a051a86cb6e4743$var$du(n), d = [];
        e: {
            var f = $2a051a86cb6e4743$var$cp.get(e);
            if (f !== void 0) {
                var m = $2a051a86cb6e4743$var$vu, v = e;
                switch(e){
                    case "keypress":
                        if ($2a051a86cb6e4743$var$Bs(n) === 0) break e;
                    case "keydown":
                    case "keyup":
                        m = $2a051a86cb6e4743$var$W0;
                        break;
                    case "focusin":
                        v = "focus", m = $2a051a86cb6e4743$var$ma;
                        break;
                    case "focusout":
                        v = "blur", m = $2a051a86cb6e4743$var$ma;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        m = $2a051a86cb6e4743$var$ma;
                        break;
                    case "click":
                        if (n.button === 2) break e;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        m = $2a051a86cb6e4743$var$ef;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        m = $2a051a86cb6e4743$var$F0;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        m = $2a051a86cb6e4743$var$G0;
                        break;
                    case $2a051a86cb6e4743$var$op:
                    case $2a051a86cb6e4743$var$ap:
                    case $2a051a86cb6e4743$var$lp:
                        m = $2a051a86cb6e4743$var$M0;
                        break;
                    case $2a051a86cb6e4743$var$up:
                        m = $2a051a86cb6e4743$var$J0;
                        break;
                    case "scroll":
                        m = $2a051a86cb6e4743$var$j0;
                        break;
                    case "wheel":
                        m = $2a051a86cb6e4743$var$e1;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        m = $2a051a86cb6e4743$var$$0;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        m = $2a051a86cb6e4743$var$nf;
                }
                var y = (t & 4) !== 0, k = !y && e === "scroll", p = y ? f !== null ? f + "Capture" : null : f;
                y = [];
                for(var h = u, g; h !== null;){
                    g = h;
                    var E = g.stateNode;
                    if (g.tag === 5 && E !== null && (g = E, p !== null && (E = $2a051a86cb6e4743$var$Ri(h, p), E != null && y.push($2a051a86cb6e4743$var$Ui(h, E, g)))), k) break;
                    h = h.return;
                }
                0 < y.length && (f = new m(f, v, null, n, c), d.push({
                    event: f,
                    listeners: y
                }));
            }
        }
        if (!(t & 7)) {
            e: {
                if (f = e === "mouseover" || e === "pointerover", m = e === "mouseout" || e === "pointerout", f && n !== $2a051a86cb6e4743$var$dl && (v = n.relatedTarget || n.fromElement) && ($2a051a86cb6e4743$var$Tn(v) || v[$2a051a86cb6e4743$var$$t])) break e;
                if ((m || f) && (f = c.window === c ? c : (f = c.ownerDocument) ? f.defaultView || f.parentWindow : window, m ? (v = n.relatedTarget || n.toElement, m = u, v = v ? $2a051a86cb6e4743$var$Tn(v) : null, v !== null && (k = $2a051a86cb6e4743$var$Zn(v), v !== k || v.tag !== 5 && v.tag !== 6) && (v = null)) : (m = null, v = u), m !== v)) {
                    if (y = $2a051a86cb6e4743$var$ef, E = "onMouseLeave", p = "onMouseEnter", h = "mouse", (e === "pointerout" || e === "pointerover") && (y = $2a051a86cb6e4743$var$nf, E = "onPointerLeave", p = "onPointerEnter", h = "pointer"), k = m == null ? f : $2a051a86cb6e4743$var$ur(m), g = v == null ? f : $2a051a86cb6e4743$var$ur(v), f = new y(E, h + "leave", m, n, c), f.target = k, f.relatedTarget = g, E = null, $2a051a86cb6e4743$var$Tn(c) === u && (y = new y(p, h + "enter", v, n, c), y.target = g, y.relatedTarget = k, E = y), k = E, m && v) t: {
                        for(y = m, p = v, h = 0, g = y; g; g = $2a051a86cb6e4743$var$rr(g))h++;
                        for(g = 0, E = p; E; E = $2a051a86cb6e4743$var$rr(E))g++;
                        for(; 0 < h - g;)y = $2a051a86cb6e4743$var$rr(y), h--;
                        for(; 0 < g - h;)p = $2a051a86cb6e4743$var$rr(p), g--;
                        for(; h--;){
                            if (y === p || p !== null && y === p.alternate) break t;
                            y = $2a051a86cb6e4743$var$rr(y), p = $2a051a86cb6e4743$var$rr(p);
                        }
                        y = null;
                    }
                    else y = null;
                    m !== null && $2a051a86cb6e4743$var$pf(d, f, m, y, !1), v !== null && k !== null && $2a051a86cb6e4743$var$pf(d, k, v, y, !0);
                }
            }
            e: {
                if (f = u ? $2a051a86cb6e4743$var$ur(u) : window, m = f.nodeName && f.nodeName.toLowerCase(), m === "select" || m === "input" && f.type === "file") var P = $2a051a86cb6e4743$var$a1;
                else if ($2a051a86cb6e4743$var$of(f)) {
                    if ($2a051a86cb6e4743$var$tp) P = $2a051a86cb6e4743$var$f1;
                    else {
                        P = $2a051a86cb6e4743$var$u1;
                        var N = $2a051a86cb6e4743$var$l1;
                    }
                } else (m = f.nodeName) && m.toLowerCase() === "input" && (f.type === "checkbox" || f.type === "radio") && (P = $2a051a86cb6e4743$var$c1);
                if (P && (P = P(e, u))) {
                    $2a051a86cb6e4743$var$ep(d, P, n, c);
                    break e;
                }
                N && N(e, f, u), e === "focusout" && (N = f._wrapperState) && N.controlled && f.type === "number" && $2a051a86cb6e4743$var$al(f, "number", f.value);
            }
            switch(N = u ? $2a051a86cb6e4743$var$ur(u) : window, e){
                case "focusin":
                    ($2a051a86cb6e4743$var$of(N) || N.contentEditable === "true") && ($2a051a86cb6e4743$var$ar = N, $2a051a86cb6e4743$var$Sl = u, $2a051a86cb6e4743$var$vi = null);
                    break;
                case "focusout":
                    $2a051a86cb6e4743$var$vi = $2a051a86cb6e4743$var$Sl = $2a051a86cb6e4743$var$ar = null;
                    break;
                case "mousedown":
                    $2a051a86cb6e4743$var$wl = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2a051a86cb6e4743$var$wl = !1, $2a051a86cb6e4743$var$ff(d, n, c);
                    break;
                case "selectionchange":
                    if ($2a051a86cb6e4743$var$p1) break;
                case "keydown":
                case "keyup":
                    $2a051a86cb6e4743$var$ff(d, n, c);
            }
            var b;
            if ($2a051a86cb6e4743$var$wu) e: {
                switch(e){
                    case "compositionstart":
                        var R = "onCompositionStart";
                        break e;
                    case "compositionend":
                        R = "onCompositionEnd";
                        break e;
                    case "compositionupdate":
                        R = "onCompositionUpdate";
                        break e;
                }
                R = void 0;
            }
            else $2a051a86cb6e4743$var$or ? $2a051a86cb6e4743$var$Jh(e, n) && (R = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (R = "onCompositionStart");
            R && ($2a051a86cb6e4743$var$Xh && n.locale !== "ko" && ($2a051a86cb6e4743$var$or || R !== "onCompositionStart" ? R === "onCompositionEnd" && $2a051a86cb6e4743$var$or && (b = $2a051a86cb6e4743$var$Gh()) : ($2a051a86cb6e4743$var$cn = c, $2a051a86cb6e4743$var$yu = "value" in $2a051a86cb6e4743$var$cn ? $2a051a86cb6e4743$var$cn.value : $2a051a86cb6e4743$var$cn.textContent, $2a051a86cb6e4743$var$or = !0)), N = $2a051a86cb6e4743$var$uo(u, R), 0 < N.length && (R = new $2a051a86cb6e4743$var$tf(R, e, null, n, c), d.push({
                event: R,
                listeners: N
            }), b ? R.data = b : (b = $2a051a86cb6e4743$var$Zh(n), b !== null && (R.data = b)))), (b = $2a051a86cb6e4743$var$n1 ? $2a051a86cb6e4743$var$r1(e, n) : $2a051a86cb6e4743$var$i1(e, n)) && (u = $2a051a86cb6e4743$var$uo(u, "onBeforeInput"), 0 < u.length && (c = new $2a051a86cb6e4743$var$tf("onBeforeInput", "beforeinput", null, n, c), d.push({
                event: c,
                listeners: u
            }), c.data = b));
        }
        $2a051a86cb6e4743$var$fp(d, t);
    });
}
function $2a051a86cb6e4743$var$Ui(e, t, n) {
    return {
        instance: e,
        listener: t,
        currentTarget: n
    };
}
function $2a051a86cb6e4743$var$uo(e, t) {
    for(var n = t + "Capture", r = []; e !== null;){
        var i1 = e, s = i1.stateNode;
        i1.tag === 5 && s !== null && (i1 = s, s = $2a051a86cb6e4743$var$Ri(e, n), s != null && r.unshift($2a051a86cb6e4743$var$Ui(e, s, i1)), s = $2a051a86cb6e4743$var$Ri(e, t), s != null && r.push($2a051a86cb6e4743$var$Ui(e, s, i1))), e = e.return;
    }
    return r;
}
function $2a051a86cb6e4743$var$rr(e) {
    if (e === null) return null;
    do e = e.return;
    while (e && e.tag !== 5);
    return e || null;
}
function $2a051a86cb6e4743$var$pf(e, t, n, r, i1) {
    for(var s = t._reactName, o = []; n !== null && n !== r;){
        var a = n, l = a.alternate, u = a.stateNode;
        if (l !== null && l === r) break;
        a.tag === 5 && u !== null && (a = u, i1 ? (l = $2a051a86cb6e4743$var$Ri(n, s), l != null && o.unshift($2a051a86cb6e4743$var$Ui(n, l, a))) : i1 || (l = $2a051a86cb6e4743$var$Ri(n, s), l != null && o.push($2a051a86cb6e4743$var$Ui(n, l, a)))), n = n.return;
    }
    o.length !== 0 && e.push({
        event: t,
        listeners: o
    });
}
var $2a051a86cb6e4743$var$v1 = /\r\n?/g, $2a051a86cb6e4743$var$S1 = /\u0000|\uFFFD/g;
function $2a051a86cb6e4743$var$gf(e) {
    return (typeof e == "string" ? e : "" + e).replace($2a051a86cb6e4743$var$v1, `
`).replace($2a051a86cb6e4743$var$S1, "");
}
function $2a051a86cb6e4743$var$Os(e, t, n) {
    if (t = $2a051a86cb6e4743$var$gf(t), $2a051a86cb6e4743$var$gf(e) !== t && n) throw Error($2a051a86cb6e4743$var$j(425));
}
function $2a051a86cb6e4743$var$co() {}
var $2a051a86cb6e4743$var$xl = null, $2a051a86cb6e4743$var$Cl = null;
function $2a051a86cb6e4743$var$El(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var $2a051a86cb6e4743$var$kl = typeof setTimeout == "function" ? setTimeout : void 0, $2a051a86cb6e4743$var$w1 = typeof clearTimeout == "function" ? clearTimeout : void 0, $2a051a86cb6e4743$var$mf = typeof Promise == "function" ? Promise : void 0, $2a051a86cb6e4743$var$x1 = typeof queueMicrotask == "function" ? queueMicrotask : typeof $2a051a86cb6e4743$var$mf < "u" ? function(e) {
    return $2a051a86cb6e4743$var$mf.resolve(null).then(e).catch($2a051a86cb6e4743$var$C1);
} : $2a051a86cb6e4743$var$kl;
function $2a051a86cb6e4743$var$C1(e) {
    setTimeout(function() {
        throw e;
    });
}
function $2a051a86cb6e4743$var$ka(e, t) {
    var n = t, r = 0;
    do {
        var i1 = n.nextSibling;
        if (e.removeChild(n), i1 && i1.nodeType === 8) {
            if (n = i1.data, n === "/$") {
                if (r === 0) {
                    e.removeChild(i1), $2a051a86cb6e4743$var$Fi(t);
                    return;
                }
                r--;
            } else n !== "$" && n !== "$?" && n !== "$!" || r++;
        }
        n = i1;
    }while (n);
    $2a051a86cb6e4743$var$Fi(t);
}
function $2a051a86cb6e4743$var$gn(e) {
    for(; e != null; e = e.nextSibling){
        var t = e.nodeType;
        if (t === 1 || t === 3) break;
        if (t === 8) {
            if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
            if (t === "/$") return null;
        }
    }
    return e;
}
function $2a051a86cb6e4743$var$yf(e) {
    e = e.previousSibling;
    for(var t = 0; e;){
        if (e.nodeType === 8) {
            var n = e.data;
            if (n === "$" || n === "$!" || n === "$?") {
                if (t === 0) return e;
                t--;
            } else n === "/$" && t++;
        }
        e = e.previousSibling;
    }
    return null;
}
var $2a051a86cb6e4743$var$Yr = Math.random().toString(36).slice(2), $2a051a86cb6e4743$var$kt = "__reactFiber$" + $2a051a86cb6e4743$var$Yr, $2a051a86cb6e4743$var$$i = "__reactProps$" + $2a051a86cb6e4743$var$Yr, $2a051a86cb6e4743$var$$t = "__reactContainer$" + $2a051a86cb6e4743$var$Yr, $2a051a86cb6e4743$var$Pl = "__reactEvents$" + $2a051a86cb6e4743$var$Yr, $2a051a86cb6e4743$var$E1 = "__reactListeners$" + $2a051a86cb6e4743$var$Yr, $2a051a86cb6e4743$var$k1 = "__reactHandles$" + $2a051a86cb6e4743$var$Yr;
function $2a051a86cb6e4743$var$Tn(e) {
    var t = e[$2a051a86cb6e4743$var$kt];
    if (t) return t;
    for(var n = e.parentNode; n;){
        if (t = n[$2a051a86cb6e4743$var$$t] || n[$2a051a86cb6e4743$var$kt]) {
            if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for(e = $2a051a86cb6e4743$var$yf(e); e !== null;){
                if (n = e[$2a051a86cb6e4743$var$kt]) return n;
                e = $2a051a86cb6e4743$var$yf(e);
            }
            return t;
        }
        e = n, n = e.parentNode;
    }
    return null;
}
function $2a051a86cb6e4743$var$us(e) {
    return e = e[$2a051a86cb6e4743$var$kt] || e[$2a051a86cb6e4743$var$$t], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function $2a051a86cb6e4743$var$ur(e) {
    if (e.tag === 5 || e.tag === 6) return e.stateNode;
    throw Error($2a051a86cb6e4743$var$j(33));
}
function $2a051a86cb6e4743$var$Ho(e) {
    return e[$2a051a86cb6e4743$var$$i] || null;
}
var $2a051a86cb6e4743$var$_l = [], $2a051a86cb6e4743$var$cr = -1;
function $2a051a86cb6e4743$var$kn(e) {
    return {
        current: e
    };
}
function $2a051a86cb6e4743$var$re(e) {
    0 > $2a051a86cb6e4743$var$cr || (e.current = $2a051a86cb6e4743$var$_l[$2a051a86cb6e4743$var$cr], $2a051a86cb6e4743$var$_l[$2a051a86cb6e4743$var$cr] = null, $2a051a86cb6e4743$var$cr--);
}
function $2a051a86cb6e4743$var$te(e, t) {
    $2a051a86cb6e4743$var$cr++, $2a051a86cb6e4743$var$_l[$2a051a86cb6e4743$var$cr] = e.current, e.current = t;
}
var $2a051a86cb6e4743$var$Cn = {}, $2a051a86cb6e4743$var$Ne = $2a051a86cb6e4743$var$kn($2a051a86cb6e4743$var$Cn), $2a051a86cb6e4743$var$$e = $2a051a86cb6e4743$var$kn(!1), $2a051a86cb6e4743$var$Wn = $2a051a86cb6e4743$var$Cn;
function $2a051a86cb6e4743$var$$r(e, t) {
    var n = e.type.contextTypes;
    if (!n) return $2a051a86cb6e4743$var$Cn;
    var r = e.stateNode;
    if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
    var i1 = {}, s;
    for(s in n)i1[s] = t[s];
    return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i1), i1;
}
function $2a051a86cb6e4743$var$ze(e) {
    return e = e.childContextTypes, e != null;
}
function $2a051a86cb6e4743$var$fo() {
    $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$$e), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ne);
}
function $2a051a86cb6e4743$var$vf(e, t, n) {
    if ($2a051a86cb6e4743$var$Ne.current !== $2a051a86cb6e4743$var$Cn) throw Error($2a051a86cb6e4743$var$j(168));
    $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$Ne, t), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$$e, n);
}
function $2a051a86cb6e4743$var$hp(e, t, n) {
    var r = e.stateNode;
    if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
    r = r.getChildContext();
    for(var i1 in r)if (!(i1 in t)) throw Error($2a051a86cb6e4743$var$j(108, $2a051a86cb6e4743$var$l0(e) || "Unknown", i1));
    return $2a051a86cb6e4743$var$ce({}, n, r);
}
function $2a051a86cb6e4743$var$ho(e) {
    return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || $2a051a86cb6e4743$var$Cn, $2a051a86cb6e4743$var$Wn = $2a051a86cb6e4743$var$Ne.current, $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$Ne, e), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$$e, $2a051a86cb6e4743$var$$e.current), !0;
}
function $2a051a86cb6e4743$var$Sf(e, t, n) {
    var r = e.stateNode;
    if (!r) throw Error($2a051a86cb6e4743$var$j(169));
    n ? (e = $2a051a86cb6e4743$var$hp(e, t, $2a051a86cb6e4743$var$Wn), r.__reactInternalMemoizedMergedChildContext = e, $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$$e), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ne), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$Ne, e)) : $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$$e), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$$e, n);
}
var $2a051a86cb6e4743$var$It = null, $2a051a86cb6e4743$var$Vo = !1, $2a051a86cb6e4743$var$Pa = !1;
function $2a051a86cb6e4743$var$pp(e) {
    $2a051a86cb6e4743$var$It === null ? $2a051a86cb6e4743$var$It = [
        e
    ] : $2a051a86cb6e4743$var$It.push(e);
}
function $2a051a86cb6e4743$var$P1(e) {
    $2a051a86cb6e4743$var$Vo = !0, $2a051a86cb6e4743$var$pp(e);
}
function $2a051a86cb6e4743$var$Pn() {
    if (!$2a051a86cb6e4743$var$Pa && $2a051a86cb6e4743$var$It !== null) {
        $2a051a86cb6e4743$var$Pa = !0;
        var e = 0, t = $2a051a86cb6e4743$var$ee;
        try {
            var n = $2a051a86cb6e4743$var$It;
            for($2a051a86cb6e4743$var$ee = 1; e < n.length; e++){
                var r = n[e];
                do r = r(!0);
                while (r !== null);
            }
            $2a051a86cb6e4743$var$It = null, $2a051a86cb6e4743$var$Vo = !1;
        } catch (i1) {
            throw $2a051a86cb6e4743$var$It !== null && ($2a051a86cb6e4743$var$It = $2a051a86cb6e4743$var$It.slice(e + 1)), $2a051a86cb6e4743$var$Uh($2a051a86cb6e4743$var$hu, $2a051a86cb6e4743$var$Pn), i1;
        } finally{
            $2a051a86cb6e4743$var$ee = t, $2a051a86cb6e4743$var$Pa = !1;
        }
    }
    return null;
}
var $2a051a86cb6e4743$var$fr = [], $2a051a86cb6e4743$var$dr = 0, $2a051a86cb6e4743$var$po = null, $2a051a86cb6e4743$var$go = 0, $2a051a86cb6e4743$var$et = [], $2a051a86cb6e4743$var$tt = 0, $2a051a86cb6e4743$var$Yn = null, $2a051a86cb6e4743$var$Dt = 1, $2a051a86cb6e4743$var$At = "";
function $2a051a86cb6e4743$var$On(e, t) {
    $2a051a86cb6e4743$var$fr[$2a051a86cb6e4743$var$dr++] = $2a051a86cb6e4743$var$go, $2a051a86cb6e4743$var$fr[$2a051a86cb6e4743$var$dr++] = $2a051a86cb6e4743$var$po, $2a051a86cb6e4743$var$po = e, $2a051a86cb6e4743$var$go = t;
}
function $2a051a86cb6e4743$var$gp(e, t, n) {
    $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt++] = $2a051a86cb6e4743$var$Dt, $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt++] = $2a051a86cb6e4743$var$At, $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt++] = $2a051a86cb6e4743$var$Yn, $2a051a86cb6e4743$var$Yn = e;
    var r = $2a051a86cb6e4743$var$Dt;
    e = $2a051a86cb6e4743$var$At;
    var i1 = 32 - $2a051a86cb6e4743$var$pt(r) - 1;
    r &= ~(1 << i1), n += 1;
    var s = 32 - $2a051a86cb6e4743$var$pt(t) + i1;
    if (30 < s) {
        var o = i1 - i1 % 5;
        s = (r & (1 << o) - 1).toString(32), r >>= o, i1 -= o, $2a051a86cb6e4743$var$Dt = 1 << 32 - $2a051a86cb6e4743$var$pt(t) + i1 | n << i1 | r, $2a051a86cb6e4743$var$At = s + e;
    } else $2a051a86cb6e4743$var$Dt = 1 << s | n << i1 | r, $2a051a86cb6e4743$var$At = e;
}
function $2a051a86cb6e4743$var$Cu(e) {
    e.return !== null && ($2a051a86cb6e4743$var$On(e, 1), $2a051a86cb6e4743$var$gp(e, 1, 0));
}
function $2a051a86cb6e4743$var$Eu(e) {
    for(; e === $2a051a86cb6e4743$var$po;)$2a051a86cb6e4743$var$po = $2a051a86cb6e4743$var$fr[--$2a051a86cb6e4743$var$dr], $2a051a86cb6e4743$var$fr[$2a051a86cb6e4743$var$dr] = null, $2a051a86cb6e4743$var$go = $2a051a86cb6e4743$var$fr[--$2a051a86cb6e4743$var$dr], $2a051a86cb6e4743$var$fr[$2a051a86cb6e4743$var$dr] = null;
    for(; e === $2a051a86cb6e4743$var$Yn;)$2a051a86cb6e4743$var$Yn = $2a051a86cb6e4743$var$et[--$2a051a86cb6e4743$var$tt], $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt] = null, $2a051a86cb6e4743$var$At = $2a051a86cb6e4743$var$et[--$2a051a86cb6e4743$var$tt], $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt] = null, $2a051a86cb6e4743$var$Dt = $2a051a86cb6e4743$var$et[--$2a051a86cb6e4743$var$tt], $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt] = null;
}
var $2a051a86cb6e4743$var$Ke = null, $2a051a86cb6e4743$var$Qe = null, $2a051a86cb6e4743$var$se = !1, $2a051a86cb6e4743$var$ht = null;
function $2a051a86cb6e4743$var$mp(e, t) {
    var n = $2a051a86cb6e4743$var$nt(5, null, null, 0);
    n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [
        n
    ], e.flags |= 16) : t.push(n);
}
function $2a051a86cb6e4743$var$wf(e, t) {
    switch(e.tag){
        case 5:
            var n = e.type;
            return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, $2a051a86cb6e4743$var$Ke = e, $2a051a86cb6e4743$var$Qe = $2a051a86cb6e4743$var$gn(t.firstChild), !0) : !1;
        case 6:
            return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, $2a051a86cb6e4743$var$Ke = e, $2a051a86cb6e4743$var$Qe = null, !0) : !1;
        case 13:
            return t = t.nodeType !== 8 ? null : t, t !== null ? (n = $2a051a86cb6e4743$var$Yn !== null ? {
                id: $2a051a86cb6e4743$var$Dt,
                overflow: $2a051a86cb6e4743$var$At
            } : null, e.memoizedState = {
                dehydrated: t,
                treeContext: n,
                retryLane: 1073741824
            }, n = $2a051a86cb6e4743$var$nt(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, $2a051a86cb6e4743$var$Ke = e, $2a051a86cb6e4743$var$Qe = null, !0) : !1;
        default:
            return !1;
    }
}
function $2a051a86cb6e4743$var$bl(e) {
    return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function $2a051a86cb6e4743$var$Ol(e) {
    if ($2a051a86cb6e4743$var$se) {
        var t = $2a051a86cb6e4743$var$Qe;
        if (t) {
            var n = t;
            if (!$2a051a86cb6e4743$var$wf(e, t)) {
                if ($2a051a86cb6e4743$var$bl(e)) throw Error($2a051a86cb6e4743$var$j(418));
                t = $2a051a86cb6e4743$var$gn(n.nextSibling);
                var r = $2a051a86cb6e4743$var$Ke;
                t && $2a051a86cb6e4743$var$wf(e, t) ? $2a051a86cb6e4743$var$mp(r, n) : (e.flags = e.flags & -4097 | 2, $2a051a86cb6e4743$var$se = !1, $2a051a86cb6e4743$var$Ke = e);
            }
        } else {
            if ($2a051a86cb6e4743$var$bl(e)) throw Error($2a051a86cb6e4743$var$j(418));
            e.flags = e.flags & -4097 | 2, $2a051a86cb6e4743$var$se = !1, $2a051a86cb6e4743$var$Ke = e;
        }
    }
}
function $2a051a86cb6e4743$var$xf(e) {
    for(e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13;)e = e.return;
    $2a051a86cb6e4743$var$Ke = e;
}
function $2a051a86cb6e4743$var$Ns(e) {
    if (e !== $2a051a86cb6e4743$var$Ke) return !1;
    if (!$2a051a86cb6e4743$var$se) return $2a051a86cb6e4743$var$xf(e), $2a051a86cb6e4743$var$se = !0, !1;
    var t;
    if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !$2a051a86cb6e4743$var$El(e.type, e.memoizedProps)), t && (t = $2a051a86cb6e4743$var$Qe)) {
        if ($2a051a86cb6e4743$var$bl(e)) throw $2a051a86cb6e4743$var$yp(), Error($2a051a86cb6e4743$var$j(418));
        for(; t;)$2a051a86cb6e4743$var$mp(e, t), t = $2a051a86cb6e4743$var$gn(t.nextSibling);
    }
    if ($2a051a86cb6e4743$var$xf(e), e.tag === 13) {
        if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error($2a051a86cb6e4743$var$j(317));
        e: {
            for(e = e.nextSibling, t = 0; e;){
                if (e.nodeType === 8) {
                    var n = e.data;
                    if (n === "/$") {
                        if (t === 0) {
                            $2a051a86cb6e4743$var$Qe = $2a051a86cb6e4743$var$gn(e.nextSibling);
                            break e;
                        }
                        t--;
                    } else n !== "$" && n !== "$!" && n !== "$?" || t++;
                }
                e = e.nextSibling;
            }
            $2a051a86cb6e4743$var$Qe = null;
        }
    } else $2a051a86cb6e4743$var$Qe = $2a051a86cb6e4743$var$Ke ? $2a051a86cb6e4743$var$gn(e.stateNode.nextSibling) : null;
    return !0;
}
function $2a051a86cb6e4743$var$yp() {
    for(var e = $2a051a86cb6e4743$var$Qe; e;)e = $2a051a86cb6e4743$var$gn(e.nextSibling);
}
function $2a051a86cb6e4743$var$zr() {
    $2a051a86cb6e4743$var$Qe = $2a051a86cb6e4743$var$Ke = null, $2a051a86cb6e4743$var$se = !1;
}
function $2a051a86cb6e4743$var$ku(e) {
    $2a051a86cb6e4743$var$ht === null ? $2a051a86cb6e4743$var$ht = [
        e
    ] : $2a051a86cb6e4743$var$ht.push(e);
}
var $2a051a86cb6e4743$var$_1 = $2a051a86cb6e4743$var$Ht.ReactCurrentBatchConfig;
function $2a051a86cb6e4743$var$ii(e, t, n) {
    if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
        if (n._owner) {
            if (n = n._owner, n) {
                if (n.tag !== 1) throw Error($2a051a86cb6e4743$var$j(309));
                var r = n.stateNode;
            }
            if (!r) throw Error($2a051a86cb6e4743$var$j(147, e));
            var i1 = r, s = "" + e;
            return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === s ? t.ref : (t = function(o) {
                var a = i1.refs;
                o === null ? delete a[s] : a[s] = o;
            }, t._stringRef = s, t);
        }
        if (typeof e != "string") throw Error($2a051a86cb6e4743$var$j(284));
        if (!n._owner) throw Error($2a051a86cb6e4743$var$j(290, e));
    }
    return e;
}
function $2a051a86cb6e4743$var$Ts(e, t) {
    throw e = Object.prototype.toString.call(t), Error($2a051a86cb6e4743$var$j(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function $2a051a86cb6e4743$var$Cf(e) {
    var t = e._init;
    return t(e._payload);
}
function $2a051a86cb6e4743$var$vp(e) {
    function t(p, h) {
        if (e) {
            var g = p.deletions;
            g === null ? (p.deletions = [
                h
            ], p.flags |= 16) : g.push(h);
        }
    }
    function n(p, h) {
        if (!e) return null;
        for(; h !== null;)t(p, h), h = h.sibling;
        return null;
    }
    function r(p, h) {
        for(p = new Map; h !== null;)h.key !== null ? p.set(h.key, h) : p.set(h.index, h), h = h.sibling;
        return p;
    }
    function i1(p, h) {
        return p = $2a051a86cb6e4743$var$Sn(p, h), p.index = 0, p.sibling = null, p;
    }
    function s(p, h, g) {
        return p.index = g, e ? (g = p.alternate, g !== null ? (g = g.index, g < h ? (p.flags |= 2, h) : g) : (p.flags |= 2, h)) : (p.flags |= 1048576, h);
    }
    function o(p) {
        return e && p.alternate === null && (p.flags |= 2), p;
    }
    function a(p, h, g, E) {
        return h === null || h.tag !== 6 ? (h = $2a051a86cb6e4743$var$Ra(g, p.mode, E), h.return = p, h) : (h = i1(h, g), h.return = p, h);
    }
    function l(p, h, g, E) {
        var P = g.type;
        return P === $2a051a86cb6e4743$var$sr ? c(p, h, g.props.children, E, g.key) : h !== null && (h.elementType === P || typeof P == "object" && P !== null && P.$$typeof === $2a051a86cb6e4743$var$Xt && $2a051a86cb6e4743$var$Cf(P) === h.type) ? (E = i1(h, g.props), E.ref = $2a051a86cb6e4743$var$ii(p, h, g), E.return = p, E) : (E = $2a051a86cb6e4743$var$qs(g.type, g.key, g.props, null, p.mode, E), E.ref = $2a051a86cb6e4743$var$ii(p, h, g), E.return = p, E);
    }
    function u(p, h, g, E) {
        return h === null || h.tag !== 4 || h.stateNode.containerInfo !== g.containerInfo || h.stateNode.implementation !== g.implementation ? (h = $2a051a86cb6e4743$var$ja(g, p.mode, E), h.return = p, h) : (h = i1(h, g.children || []), h.return = p, h);
    }
    function c(p, h, g, E, P) {
        return h === null || h.tag !== 7 ? (h = $2a051a86cb6e4743$var$Vn(g, p.mode, E, P), h.return = p, h) : (h = i1(h, g), h.return = p, h);
    }
    function d(p, h, g) {
        if (typeof h == "string" && h !== "" || typeof h == "number") return h = $2a051a86cb6e4743$var$Ra("" + h, p.mode, g), h.return = p, h;
        if (typeof h == "object" && h !== null) {
            switch(h.$$typeof){
                case $2a051a86cb6e4743$var$Ss:
                    return g = $2a051a86cb6e4743$var$qs(h.type, h.key, h.props, null, p.mode, g), g.ref = $2a051a86cb6e4743$var$ii(p, null, h), g.return = p, g;
                case $2a051a86cb6e4743$var$ir:
                    return h = $2a051a86cb6e4743$var$ja(h, p.mode, g), h.return = p, h;
                case $2a051a86cb6e4743$var$Xt:
                    var E = h._init;
                    return d(p, E(h._payload), g);
            }
            if ($2a051a86cb6e4743$var$ci(h) || $2a051a86cb6e4743$var$Zr(h)) return h = $2a051a86cb6e4743$var$Vn(h, p.mode, g, null), h.return = p, h;
            $2a051a86cb6e4743$var$Ts(p, h);
        }
        return null;
    }
    function f(p, h, g, E) {
        var P = h !== null ? h.key : null;
        if (typeof g == "string" && g !== "" || typeof g == "number") return P !== null ? null : a(p, h, "" + g, E);
        if (typeof g == "object" && g !== null) {
            switch(g.$$typeof){
                case $2a051a86cb6e4743$var$Ss:
                    return g.key === P ? l(p, h, g, E) : null;
                case $2a051a86cb6e4743$var$ir:
                    return g.key === P ? u(p, h, g, E) : null;
                case $2a051a86cb6e4743$var$Xt:
                    return P = g._init, f(p, h, P(g._payload), E);
            }
            if ($2a051a86cb6e4743$var$ci(g) || $2a051a86cb6e4743$var$Zr(g)) return P !== null ? null : c(p, h, g, E, null);
            $2a051a86cb6e4743$var$Ts(p, g);
        }
        return null;
    }
    function m(p, h, g, E, P) {
        if (typeof E == "string" && E !== "" || typeof E == "number") return p = p.get(g) || null, a(h, p, "" + E, P);
        if (typeof E == "object" && E !== null) {
            switch(E.$$typeof){
                case $2a051a86cb6e4743$var$Ss:
                    return p = p.get(E.key === null ? g : E.key) || null, l(h, p, E, P);
                case $2a051a86cb6e4743$var$ir:
                    return p = p.get(E.key === null ? g : E.key) || null, u(h, p, E, P);
                case $2a051a86cb6e4743$var$Xt:
                    var N = E._init;
                    return m(p, h, g, N(E._payload), P);
            }
            if ($2a051a86cb6e4743$var$ci(E) || $2a051a86cb6e4743$var$Zr(E)) return p = p.get(g) || null, c(h, p, E, P, null);
            $2a051a86cb6e4743$var$Ts(h, E);
        }
        return null;
    }
    function v(p, h, g, E) {
        for(var P = null, N = null, b = h, R = h = 0, D = null; b !== null && R < g.length; R++){
            b.index > R ? (D = b, b = null) : D = b.sibling;
            var H = f(p, b, g[R], E);
            if (H === null) {
                b === null && (b = D);
                break;
            }
            e && b && H.alternate === null && t(p, b), h = s(H, h, R), N === null ? P = H : N.sibling = H, N = H, b = D;
        }
        if (R === g.length) return n(p, b), $2a051a86cb6e4743$var$se && $2a051a86cb6e4743$var$On(p, R), P;
        if (b === null) {
            for(; R < g.length; R++)b = d(p, g[R], E), b !== null && (h = s(b, h, R), N === null ? P = b : N.sibling = b, N = b);
            return $2a051a86cb6e4743$var$se && $2a051a86cb6e4743$var$On(p, R), P;
        }
        for(b = r(p, b); R < g.length; R++)D = m(b, p, R, g[R], E), D !== null && (e && D.alternate !== null && b.delete(D.key === null ? R : D.key), h = s(D, h, R), N === null ? P = D : N.sibling = D, N = D);
        return e && b.forEach(function(M) {
            return t(p, M);
        }), $2a051a86cb6e4743$var$se && $2a051a86cb6e4743$var$On(p, R), P;
    }
    function y(p, h, g, E) {
        var P = $2a051a86cb6e4743$var$Zr(g);
        if (typeof P != "function") throw Error($2a051a86cb6e4743$var$j(150));
        if (g = P.call(g), g == null) throw Error($2a051a86cb6e4743$var$j(151));
        for(var N = P = null, b = h, R = h = 0, D = null, H = g.next(); b !== null && !H.done; R++, H = g.next()){
            b.index > R ? (D = b, b = null) : D = b.sibling;
            var M = f(p, b, H.value, E);
            if (M === null) {
                b === null && (b = D);
                break;
            }
            e && b && M.alternate === null && t(p, b), h = s(M, h, R), N === null ? P = M : N.sibling = M, N = M, b = D;
        }
        if (H.done) return n(p, b), $2a051a86cb6e4743$var$se && $2a051a86cb6e4743$var$On(p, R), P;
        if (b === null) {
            for(; !H.done; R++, H = g.next())H = d(p, H.value, E), H !== null && (h = s(H, h, R), N === null ? P = H : N.sibling = H, N = H);
            return $2a051a86cb6e4743$var$se && $2a051a86cb6e4743$var$On(p, R), P;
        }
        for(b = r(p, b); !H.done; R++, H = g.next())H = m(b, p, R, H.value, E), H !== null && (e && H.alternate !== null && b.delete(H.key === null ? R : H.key), h = s(H, h, R), N === null ? P = H : N.sibling = H, N = H);
        return e && b.forEach(function(L) {
            return t(p, L);
        }), $2a051a86cb6e4743$var$se && $2a051a86cb6e4743$var$On(p, R), P;
    }
    function k(p, h, g, E) {
        if (typeof g == "object" && g !== null && g.type === $2a051a86cb6e4743$var$sr && g.key === null && (g = g.props.children), typeof g == "object" && g !== null) {
            switch(g.$$typeof){
                case $2a051a86cb6e4743$var$Ss:
                    e: {
                        for(var P = g.key, N = h; N !== null;){
                            if (N.key === P) {
                                if (P = g.type, P === $2a051a86cb6e4743$var$sr) {
                                    if (N.tag === 7) {
                                        n(p, N.sibling), h = i1(N, g.props.children), h.return = p, p = h;
                                        break e;
                                    }
                                } else if (N.elementType === P || typeof P == "object" && P !== null && P.$$typeof === $2a051a86cb6e4743$var$Xt && $2a051a86cb6e4743$var$Cf(P) === N.type) {
                                    n(p, N.sibling), h = i1(N, g.props), h.ref = $2a051a86cb6e4743$var$ii(p, N, g), h.return = p, p = h;
                                    break e;
                                }
                                n(p, N);
                                break;
                            } else t(p, N);
                            N = N.sibling;
                        }
                        g.type === $2a051a86cb6e4743$var$sr ? (h = $2a051a86cb6e4743$var$Vn(g.props.children, p.mode, E, g.key), h.return = p, p = h) : (E = $2a051a86cb6e4743$var$qs(g.type, g.key, g.props, null, p.mode, E), E.ref = $2a051a86cb6e4743$var$ii(p, h, g), E.return = p, p = E);
                    }
                    return o(p);
                case $2a051a86cb6e4743$var$ir:
                    e: {
                        for(N = g.key; h !== null;){
                            if (h.key === N) {
                                if (h.tag === 4 && h.stateNode.containerInfo === g.containerInfo && h.stateNode.implementation === g.implementation) {
                                    n(p, h.sibling), h = i1(h, g.children || []), h.return = p, p = h;
                                    break e;
                                } else {
                                    n(p, h);
                                    break;
                                }
                            } else t(p, h);
                            h = h.sibling;
                        }
                        h = $2a051a86cb6e4743$var$ja(g, p.mode, E), h.return = p, p = h;
                    }
                    return o(p);
                case $2a051a86cb6e4743$var$Xt:
                    return N = g._init, k(p, h, N(g._payload), E);
            }
            if ($2a051a86cb6e4743$var$ci(g)) return v(p, h, g, E);
            if ($2a051a86cb6e4743$var$Zr(g)) return y(p, h, g, E);
            $2a051a86cb6e4743$var$Ts(p, g);
        }
        return typeof g == "string" && g !== "" || typeof g == "number" ? (g = "" + g, h !== null && h.tag === 6 ? (n(p, h.sibling), h = i1(h, g), h.return = p, p = h) : (n(p, h), h = $2a051a86cb6e4743$var$Ra(g, p.mode, E), h.return = p, p = h), o(p)) : n(p, h);
    }
    return k;
}
var $2a051a86cb6e4743$var$Br = $2a051a86cb6e4743$var$vp(!0), $2a051a86cb6e4743$var$Sp = $2a051a86cb6e4743$var$vp(!1), $2a051a86cb6e4743$var$mo = $2a051a86cb6e4743$var$kn(null), $2a051a86cb6e4743$var$yo = null, $2a051a86cb6e4743$var$hr = null, $2a051a86cb6e4743$var$Pu = null;
function $2a051a86cb6e4743$var$_u() {
    $2a051a86cb6e4743$var$Pu = $2a051a86cb6e4743$var$hr = $2a051a86cb6e4743$var$yo = null;
}
function $2a051a86cb6e4743$var$bu(e) {
    var t = $2a051a86cb6e4743$var$mo.current;
    $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$mo), e._currentValue = t;
}
function $2a051a86cb6e4743$var$Nl(e, t, n) {
    for(; e !== null;){
        var r = e.alternate;
        if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
        e = e.return;
    }
}
function $2a051a86cb6e4743$var$Cr(e, t) {
    $2a051a86cb6e4743$var$yo = e, $2a051a86cb6e4743$var$Pu = $2a051a86cb6e4743$var$hr = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && ($2a051a86cb6e4743$var$Ue = !0), e.firstContext = null);
}
function $2a051a86cb6e4743$var$it(e) {
    var t = e._currentValue;
    if ($2a051a86cb6e4743$var$Pu !== e) {
        if (e = {
            context: e,
            memoizedValue: t,
            next: null
        }, $2a051a86cb6e4743$var$hr === null) {
            if ($2a051a86cb6e4743$var$yo === null) throw Error($2a051a86cb6e4743$var$j(308));
            $2a051a86cb6e4743$var$hr = e, $2a051a86cb6e4743$var$yo.dependencies = {
                lanes: 0,
                firstContext: e
            };
        } else $2a051a86cb6e4743$var$hr = $2a051a86cb6e4743$var$hr.next = e;
    }
    return t;
}
var $2a051a86cb6e4743$var$Ln = null;
function $2a051a86cb6e4743$var$Ou(e) {
    $2a051a86cb6e4743$var$Ln === null ? $2a051a86cb6e4743$var$Ln = [
        e
    ] : $2a051a86cb6e4743$var$Ln.push(e);
}
function $2a051a86cb6e4743$var$wp(e, t, n, r) {
    var i1 = t.interleaved;
    return i1 === null ? (n.next = n, $2a051a86cb6e4743$var$Ou(t)) : (n.next = i1.next, i1.next = n), t.interleaved = n, $2a051a86cb6e4743$var$zt(e, r);
}
function $2a051a86cb6e4743$var$zt(e, t) {
    e.lanes |= t;
    var n = e.alternate;
    for(n !== null && (n.lanes |= t), n = e, e = e.return; e !== null;)e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
    return n.tag === 3 ? n.stateNode : null;
}
var $2a051a86cb6e4743$var$Jt = !1;
function $2a051a86cb6e4743$var$Nu(e) {
    e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $2a051a86cb6e4743$var$xp(e, t) {
    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        effects: e.effects
    });
}
function $2a051a86cb6e4743$var$Mt(e, t) {
    return {
        eventTime: e,
        lane: t,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2a051a86cb6e4743$var$mn(e, t, n) {
    var r = e.updateQueue;
    if (r === null) return null;
    if (r = r.shared, $2a051a86cb6e4743$var$Z & 2) {
        var i1 = r.pending;
        return i1 === null ? t.next = t : (t.next = i1.next, i1.next = t), r.pending = t, $2a051a86cb6e4743$var$zt(e, n);
    }
    return i1 = r.interleaved, i1 === null ? (t.next = t, $2a051a86cb6e4743$var$Ou(r)) : (t.next = i1.next, i1.next = t), r.interleaved = t, $2a051a86cb6e4743$var$zt(e, n);
}
function $2a051a86cb6e4743$var$Hs(e, t, n) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
        var r = t.lanes;
        r &= e.pendingLanes, n |= r, t.lanes = n, $2a051a86cb6e4743$var$pu(e, n);
    }
}
function $2a051a86cb6e4743$var$Ef(e, t) {
    var n = e.updateQueue, r = e.alternate;
    if (r !== null && (r = r.updateQueue, n === r)) {
        var i1 = null, s = null;
        if (n = n.firstBaseUpdate, n !== null) {
            do {
                var o = {
                    eventTime: n.eventTime,
                    lane: n.lane,
                    tag: n.tag,
                    payload: n.payload,
                    callback: n.callback,
                    next: null
                };
                s === null ? i1 = s = o : s = s.next = o, n = n.next;
            }while (n !== null);
            s === null ? i1 = s = t : s = s.next = t;
        } else i1 = s = t;
        n = {
            baseState: r.baseState,
            firstBaseUpdate: i1,
            lastBaseUpdate: s,
            shared: r.shared,
            effects: r.effects
        }, e.updateQueue = n;
        return;
    }
    e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function $2a051a86cb6e4743$var$vo(e, t, n, r) {
    var i1 = e.updateQueue;
    $2a051a86cb6e4743$var$Jt = !1;
    var s = i1.firstBaseUpdate, o = i1.lastBaseUpdate, a = i1.shared.pending;
    if (a !== null) {
        i1.shared.pending = null;
        var l = a, u = l.next;
        l.next = null, o === null ? s = u : o.next = u, o = l;
        var c = e.alternate;
        c !== null && (c = c.updateQueue, a = c.lastBaseUpdate, a !== o && (a === null ? c.firstBaseUpdate = u : a.next = u, c.lastBaseUpdate = l));
    }
    if (s !== null) {
        var d = i1.baseState;
        o = 0, c = u = l = null, a = s;
        do {
            var f = a.lane, m = a.eventTime;
            if ((r & f) === f) {
                c !== null && (c = c.next = {
                    eventTime: m,
                    lane: 0,
                    tag: a.tag,
                    payload: a.payload,
                    callback: a.callback,
                    next: null
                });
                e: {
                    var v = e, y = a;
                    switch(f = t, m = n, y.tag){
                        case 1:
                            if (v = y.payload, typeof v == "function") {
                                d = v.call(m, d, f);
                                break e;
                            }
                            d = v;
                            break e;
                        case 3:
                            v.flags = v.flags & -65537 | 128;
                        case 0:
                            if (v = y.payload, f = typeof v == "function" ? v.call(m, d, f) : v, f == null) break e;
                            d = $2a051a86cb6e4743$var$ce({}, d, f);
                            break e;
                        case 2:
                            $2a051a86cb6e4743$var$Jt = !0;
                    }
                }
                a.callback !== null && a.lane !== 0 && (e.flags |= 64, f = i1.effects, f === null ? i1.effects = [
                    a
                ] : f.push(a));
            } else m = {
                eventTime: m,
                lane: f,
                tag: a.tag,
                payload: a.payload,
                callback: a.callback,
                next: null
            }, c === null ? (u = c = m, l = d) : c = c.next = m, o |= f;
            if (a = a.next, a === null) {
                if (a = i1.shared.pending, a === null) break;
                f = a, a = f.next, f.next = null, i1.lastBaseUpdate = f, i1.shared.pending = null;
            }
        }while (1);
        if (c === null && (l = d), i1.baseState = l, i1.firstBaseUpdate = u, i1.lastBaseUpdate = c, t = i1.shared.interleaved, t !== null) {
            i1 = t;
            do o |= i1.lane, i1 = i1.next;
            while (i1 !== t);
        } else s === null && (i1.shared.lanes = 0);
        $2a051a86cb6e4743$var$Gn |= o, e.lanes = o, e.memoizedState = d;
    }
}
function $2a051a86cb6e4743$var$kf(e, t, n) {
    if (e = t.effects, t.effects = null, e !== null) for(t = 0; t < e.length; t++){
        var r = e[t], i1 = r.callback;
        if (i1 !== null) {
            if (r.callback = null, r = n, typeof i1 != "function") throw Error($2a051a86cb6e4743$var$j(191, i1));
            i1.call(r);
        }
    }
}
var $2a051a86cb6e4743$var$cs = {}, $2a051a86cb6e4743$var$Ot = $2a051a86cb6e4743$var$kn($2a051a86cb6e4743$var$cs), $2a051a86cb6e4743$var$zi = $2a051a86cb6e4743$var$kn($2a051a86cb6e4743$var$cs), $2a051a86cb6e4743$var$Bi = $2a051a86cb6e4743$var$kn($2a051a86cb6e4743$var$cs);
function $2a051a86cb6e4743$var$Rn(e) {
    if (e === $2a051a86cb6e4743$var$cs) throw Error($2a051a86cb6e4743$var$j(174));
    return e;
}
function $2a051a86cb6e4743$var$Tu(e, t) {
    switch($2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$Bi, t), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$zi, e), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$Ot, $2a051a86cb6e4743$var$cs), e = t.nodeType, e){
        case 9:
        case 11:
            t = (t = t.documentElement) ? t.namespaceURI : $2a051a86cb6e4743$var$ul(null, "");
            break;
        default:
            e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = $2a051a86cb6e4743$var$ul(t, e);
    }
    $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ot), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$Ot, t);
}
function $2a051a86cb6e4743$var$Hr() {
    $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ot), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$zi), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Bi);
}
function $2a051a86cb6e4743$var$Cp(e) {
    $2a051a86cb6e4743$var$Rn($2a051a86cb6e4743$var$Bi.current);
    var t = $2a051a86cb6e4743$var$Rn($2a051a86cb6e4743$var$Ot.current), n = $2a051a86cb6e4743$var$ul(t, e.type);
    t !== n && ($2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$zi, e), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$Ot, n));
}
function $2a051a86cb6e4743$var$Lu(e) {
    $2a051a86cb6e4743$var$zi.current === e && ($2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ot), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$zi));
}
var $2a051a86cb6e4743$var$ae = $2a051a86cb6e4743$var$kn(0);
function $2a051a86cb6e4743$var$So(e) {
    for(var t = e; t !== null;){
        if (t.tag === 13) {
            var n = t.memoizedState;
            if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
        } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
            if (t.flags & 128) return t;
        } else if (t.child !== null) {
            t.child.return = t, t = t.child;
            continue;
        }
        if (t === e) break;
        for(; t.sibling === null;){
            if (t.return === null || t.return === e) return null;
            t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
    }
    return null;
}
var $2a051a86cb6e4743$var$_a = [];
function $2a051a86cb6e4743$var$Ru() {
    for(var e = 0; e < $2a051a86cb6e4743$var$_a.length; e++)$2a051a86cb6e4743$var$_a[e]._workInProgressVersionPrimary = null;
    $2a051a86cb6e4743$var$_a.length = 0;
}
var $2a051a86cb6e4743$var$Vs = $2a051a86cb6e4743$var$Ht.ReactCurrentDispatcher, $2a051a86cb6e4743$var$ba = $2a051a86cb6e4743$var$Ht.ReactCurrentBatchConfig, $2a051a86cb6e4743$var$qn = 0, $2a051a86cb6e4743$var$ue = null, $2a051a86cb6e4743$var$ye = null, $2a051a86cb6e4743$var$Se = null, $2a051a86cb6e4743$var$wo = !1, $2a051a86cb6e4743$var$Si = !1, $2a051a86cb6e4743$var$Hi = 0, $2a051a86cb6e4743$var$b1 = 0;
function $2a051a86cb6e4743$var$Pe() {
    throw Error($2a051a86cb6e4743$var$j(321));
}
function $2a051a86cb6e4743$var$ju(e, t) {
    if (t === null) return !1;
    for(var n = 0; n < t.length && n < e.length; n++)if (!$2a051a86cb6e4743$var$mt(e[n], t[n])) return !1;
    return !0;
}
function $2a051a86cb6e4743$var$Iu(e, t, n, r, i1, s) {
    if ($2a051a86cb6e4743$var$qn = s, $2a051a86cb6e4743$var$ue = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, $2a051a86cb6e4743$var$Vs.current = e === null || e.memoizedState === null ? $2a051a86cb6e4743$var$L1 : $2a051a86cb6e4743$var$R1, e = n(r, i1), $2a051a86cb6e4743$var$Si) {
        s = 0;
        do {
            if ($2a051a86cb6e4743$var$Si = !1, $2a051a86cb6e4743$var$Hi = 0, 25 <= s) throw Error($2a051a86cb6e4743$var$j(301));
            s += 1, $2a051a86cb6e4743$var$Se = $2a051a86cb6e4743$var$ye = null, t.updateQueue = null, $2a051a86cb6e4743$var$Vs.current = $2a051a86cb6e4743$var$j1, e = n(r, i1);
        }while ($2a051a86cb6e4743$var$Si);
    }
    if ($2a051a86cb6e4743$var$Vs.current = $2a051a86cb6e4743$var$xo, t = $2a051a86cb6e4743$var$ye !== null && $2a051a86cb6e4743$var$ye.next !== null, $2a051a86cb6e4743$var$qn = 0, $2a051a86cb6e4743$var$Se = $2a051a86cb6e4743$var$ye = $2a051a86cb6e4743$var$ue = null, $2a051a86cb6e4743$var$wo = !1, t) throw Error($2a051a86cb6e4743$var$j(300));
    return e;
}
function $2a051a86cb6e4743$var$Fu() {
    var e = $2a051a86cb6e4743$var$Hi !== 0;
    return $2a051a86cb6e4743$var$Hi = 0, e;
}
function $2a051a86cb6e4743$var$vt() {
    var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    return $2a051a86cb6e4743$var$Se === null ? $2a051a86cb6e4743$var$ue.memoizedState = $2a051a86cb6e4743$var$Se = e : $2a051a86cb6e4743$var$Se = $2a051a86cb6e4743$var$Se.next = e, $2a051a86cb6e4743$var$Se;
}
function $2a051a86cb6e4743$var$st() {
    if ($2a051a86cb6e4743$var$ye === null) {
        var e = $2a051a86cb6e4743$var$ue.alternate;
        e = e !== null ? e.memoizedState : null;
    } else e = $2a051a86cb6e4743$var$ye.next;
    var t = $2a051a86cb6e4743$var$Se === null ? $2a051a86cb6e4743$var$ue.memoizedState : $2a051a86cb6e4743$var$Se.next;
    if (t !== null) $2a051a86cb6e4743$var$Se = t, $2a051a86cb6e4743$var$ye = e;
    else {
        if (e === null) throw Error($2a051a86cb6e4743$var$j(310));
        $2a051a86cb6e4743$var$ye = e, e = {
            memoizedState: $2a051a86cb6e4743$var$ye.memoizedState,
            baseState: $2a051a86cb6e4743$var$ye.baseState,
            baseQueue: $2a051a86cb6e4743$var$ye.baseQueue,
            queue: $2a051a86cb6e4743$var$ye.queue,
            next: null
        }, $2a051a86cb6e4743$var$Se === null ? $2a051a86cb6e4743$var$ue.memoizedState = $2a051a86cb6e4743$var$Se = e : $2a051a86cb6e4743$var$Se = $2a051a86cb6e4743$var$Se.next = e;
    }
    return $2a051a86cb6e4743$var$Se;
}
function $2a051a86cb6e4743$var$Vi(e, t) {
    return typeof t == "function" ? t(e) : t;
}
function $2a051a86cb6e4743$var$Oa(e) {
    var t = $2a051a86cb6e4743$var$st(), n = t.queue;
    if (n === null) throw Error($2a051a86cb6e4743$var$j(311));
    n.lastRenderedReducer = e;
    var r = $2a051a86cb6e4743$var$ye, i1 = r.baseQueue, s = n.pending;
    if (s !== null) {
        if (i1 !== null) {
            var o = i1.next;
            i1.next = s.next, s.next = o;
        }
        r.baseQueue = i1 = s, n.pending = null;
    }
    if (i1 !== null) {
        s = i1.next, r = r.baseState;
        var a = o = null, l = null, u = s;
        do {
            var c = u.lane;
            if (($2a051a86cb6e4743$var$qn & c) === c) l !== null && (l = l.next = {
                lane: 0,
                action: u.action,
                hasEagerState: u.hasEagerState,
                eagerState: u.eagerState,
                next: null
            }), r = u.hasEagerState ? u.eagerState : e(r, u.action);
            else {
                var d = {
                    lane: c,
                    action: u.action,
                    hasEagerState: u.hasEagerState,
                    eagerState: u.eagerState,
                    next: null
                };
                l === null ? (a = l = d, o = r) : l = l.next = d, $2a051a86cb6e4743$var$ue.lanes |= c, $2a051a86cb6e4743$var$Gn |= c;
            }
            u = u.next;
        }while (u !== null && u !== s);
        l === null ? o = r : l.next = a, $2a051a86cb6e4743$var$mt(r, t.memoizedState) || ($2a051a86cb6e4743$var$Ue = !0), t.memoizedState = r, t.baseState = o, t.baseQueue = l, n.lastRenderedState = r;
    }
    if (e = n.interleaved, e !== null) {
        i1 = e;
        do s = i1.lane, $2a051a86cb6e4743$var$ue.lanes |= s, $2a051a86cb6e4743$var$Gn |= s, i1 = i1.next;
        while (i1 !== e);
    } else i1 === null && (n.lanes = 0);
    return [
        t.memoizedState,
        n.dispatch
    ];
}
function $2a051a86cb6e4743$var$Na(e) {
    var t = $2a051a86cb6e4743$var$st(), n = t.queue;
    if (n === null) throw Error($2a051a86cb6e4743$var$j(311));
    n.lastRenderedReducer = e;
    var r = n.dispatch, i1 = n.pending, s = t.memoizedState;
    if (i1 !== null) {
        n.pending = null;
        var o = i1 = i1.next;
        do s = e(s, o.action), o = o.next;
        while (o !== i1);
        $2a051a86cb6e4743$var$mt(s, t.memoizedState) || ($2a051a86cb6e4743$var$Ue = !0), t.memoizedState = s, t.baseQueue === null && (t.baseState = s), n.lastRenderedState = s;
    }
    return [
        s,
        r
    ];
}
function $2a051a86cb6e4743$var$Ep() {}
function $2a051a86cb6e4743$var$kp(e, t) {
    var n = $2a051a86cb6e4743$var$ue, r = $2a051a86cb6e4743$var$st(), i1 = t(), s = !$2a051a86cb6e4743$var$mt(r.memoizedState, i1);
    if (s && (r.memoizedState = i1, $2a051a86cb6e4743$var$Ue = !0), r = r.queue, $2a051a86cb6e4743$var$Du($2a051a86cb6e4743$var$bp.bind(null, n, r, e), [
        e
    ]), r.getSnapshot !== t || s || $2a051a86cb6e4743$var$Se !== null && $2a051a86cb6e4743$var$Se.memoizedState.tag & 1) {
        if (n.flags |= 2048, $2a051a86cb6e4743$var$Qi(9, $2a051a86cb6e4743$var$_p.bind(null, n, r, i1, t), void 0, null), $2a051a86cb6e4743$var$we === null) throw Error($2a051a86cb6e4743$var$j(349));
        $2a051a86cb6e4743$var$qn & 30 || $2a051a86cb6e4743$var$Pp(n, t, i1);
    }
    return i1;
}
function $2a051a86cb6e4743$var$Pp(e, t, n) {
    e.flags |= 16384, e = {
        getSnapshot: t,
        value: n
    }, t = $2a051a86cb6e4743$var$ue.updateQueue, t === null ? (t = {
        lastEffect: null,
        stores: null
    }, $2a051a86cb6e4743$var$ue.updateQueue = t, t.stores = [
        e
    ]) : (n = t.stores, n === null ? t.stores = [
        e
    ] : n.push(e));
}
function $2a051a86cb6e4743$var$_p(e, t, n, r) {
    t.value = n, t.getSnapshot = r, $2a051a86cb6e4743$var$Op(t) && $2a051a86cb6e4743$var$Np(e);
}
function $2a051a86cb6e4743$var$bp(e, t, n) {
    return n(function() {
        $2a051a86cb6e4743$var$Op(t) && $2a051a86cb6e4743$var$Np(e);
    });
}
function $2a051a86cb6e4743$var$Op(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
        var n = t();
        return !$2a051a86cb6e4743$var$mt(e, n);
    } catch  {
        return !0;
    }
}
function $2a051a86cb6e4743$var$Np(e) {
    var t = $2a051a86cb6e4743$var$zt(e, 1);
    t !== null && $2a051a86cb6e4743$var$gt(t, e, 1, -1);
}
function $2a051a86cb6e4743$var$Pf(e) {
    var t = $2a051a86cb6e4743$var$vt();
    return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2a051a86cb6e4743$var$Vi,
        lastRenderedState: e
    }, t.queue = e, e = e.dispatch = $2a051a86cb6e4743$var$T1.bind(null, $2a051a86cb6e4743$var$ue, e), [
        t.memoizedState,
        e
    ];
}
function $2a051a86cb6e4743$var$Qi(e, t, n, r) {
    return e = {
        tag: e,
        create: t,
        destroy: n,
        deps: r,
        next: null
    }, t = $2a051a86cb6e4743$var$ue.updateQueue, t === null ? (t = {
        lastEffect: null,
        stores: null
    }, $2a051a86cb6e4743$var$ue.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function $2a051a86cb6e4743$var$Tp() {
    return $2a051a86cb6e4743$var$st().memoizedState;
}
function $2a051a86cb6e4743$var$Qs(e, t, n, r) {
    var i1 = $2a051a86cb6e4743$var$vt();
    $2a051a86cb6e4743$var$ue.flags |= e, i1.memoizedState = $2a051a86cb6e4743$var$Qi(1 | t, n, void 0, r === void 0 ? null : r);
}
function $2a051a86cb6e4743$var$Qo(e, t, n, r) {
    var i1 = $2a051a86cb6e4743$var$st();
    r = r === void 0 ? null : r;
    var s = void 0;
    if ($2a051a86cb6e4743$var$ye !== null) {
        var o = $2a051a86cb6e4743$var$ye.memoizedState;
        if (s = o.destroy, r !== null && $2a051a86cb6e4743$var$ju(r, o.deps)) {
            i1.memoizedState = $2a051a86cb6e4743$var$Qi(t, n, s, r);
            return;
        }
    }
    $2a051a86cb6e4743$var$ue.flags |= e, i1.memoizedState = $2a051a86cb6e4743$var$Qi(1 | t, n, s, r);
}
function $2a051a86cb6e4743$var$_f(e, t) {
    return $2a051a86cb6e4743$var$Qs(8390656, 8, e, t);
}
function $2a051a86cb6e4743$var$Du(e, t) {
    return $2a051a86cb6e4743$var$Qo(2048, 8, e, t);
}
function $2a051a86cb6e4743$var$Lp(e, t) {
    return $2a051a86cb6e4743$var$Qo(4, 2, e, t);
}
function $2a051a86cb6e4743$var$Rp(e, t) {
    return $2a051a86cb6e4743$var$Qo(4, 4, e, t);
}
function $2a051a86cb6e4743$var$jp(e, t) {
    if (typeof t == "function") return e = e(), t(e), function() {
        t(null);
    };
    if (t != null) return e = e(), t.current = e, function() {
        t.current = null;
    };
}
function $2a051a86cb6e4743$var$Ip(e, t, n) {
    return n = n != null ? n.concat([
        e
    ]) : null, $2a051a86cb6e4743$var$Qo(4, 4, $2a051a86cb6e4743$var$jp.bind(null, t, e), n);
}
function $2a051a86cb6e4743$var$Au() {}
function $2a051a86cb6e4743$var$Fp(e, t) {
    var n = $2a051a86cb6e4743$var$st();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    return r !== null && t !== null && $2a051a86cb6e4743$var$ju(t, r[1]) ? r[0] : (n.memoizedState = [
        e,
        t
    ], e);
}
function $2a051a86cb6e4743$var$Dp(e, t) {
    var n = $2a051a86cb6e4743$var$st();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    return r !== null && t !== null && $2a051a86cb6e4743$var$ju(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [
        e,
        t
    ], e);
}
function $2a051a86cb6e4743$var$Ap(e, t, n) {
    return $2a051a86cb6e4743$var$qn & 21 ? ($2a051a86cb6e4743$var$mt(n, t) || (n = $2a051a86cb6e4743$var$Bh(), $2a051a86cb6e4743$var$ue.lanes |= n, $2a051a86cb6e4743$var$Gn |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, $2a051a86cb6e4743$var$Ue = !0), e.memoizedState = n);
}
function $2a051a86cb6e4743$var$O1(e, t) {
    var n = $2a051a86cb6e4743$var$ee;
    $2a051a86cb6e4743$var$ee = n !== 0 && 4 > n ? n : 4, e(!0);
    var r = $2a051a86cb6e4743$var$ba.transition;
    $2a051a86cb6e4743$var$ba.transition = {};
    try {
        e(!1), t();
    } finally{
        $2a051a86cb6e4743$var$ee = n, $2a051a86cb6e4743$var$ba.transition = r;
    }
}
function $2a051a86cb6e4743$var$Mp() {
    return $2a051a86cb6e4743$var$st().memoizedState;
}
function $2a051a86cb6e4743$var$N1(e, t, n) {
    var r = $2a051a86cb6e4743$var$vn(e);
    if (n = {
        lane: r,
        action: n,
        hasEagerState: !1,
        eagerState: null,
        next: null
    }, $2a051a86cb6e4743$var$Up(e)) $2a051a86cb6e4743$var$$p(t, n);
    else if (n = $2a051a86cb6e4743$var$wp(e, t, n, r), n !== null) {
        var i1 = $2a051a86cb6e4743$var$Ie();
        $2a051a86cb6e4743$var$gt(n, e, r, i1), $2a051a86cb6e4743$var$zp(n, t, r);
    }
}
function $2a051a86cb6e4743$var$T1(e, t, n) {
    var r = $2a051a86cb6e4743$var$vn(e), i1 = {
        lane: r,
        action: n,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2a051a86cb6e4743$var$Up(e)) $2a051a86cb6e4743$var$$p(t, i1);
    else {
        var s = e.alternate;
        if (e.lanes === 0 && (s === null || s.lanes === 0) && (s = t.lastRenderedReducer, s !== null)) try {
            var o = t.lastRenderedState, a = s(o, n);
            if (i1.hasEagerState = !0, i1.eagerState = a, $2a051a86cb6e4743$var$mt(a, o)) {
                var l = t.interleaved;
                l === null ? (i1.next = i1, $2a051a86cb6e4743$var$Ou(t)) : (i1.next = l.next, l.next = i1), t.interleaved = i1;
                return;
            }
        } catch  {} finally{}
        n = $2a051a86cb6e4743$var$wp(e, t, i1, r), n !== null && (i1 = $2a051a86cb6e4743$var$Ie(), $2a051a86cb6e4743$var$gt(n, e, r, i1), $2a051a86cb6e4743$var$zp(n, t, r));
    }
}
function $2a051a86cb6e4743$var$Up(e) {
    var t = e.alternate;
    return e === $2a051a86cb6e4743$var$ue || t !== null && t === $2a051a86cb6e4743$var$ue;
}
function $2a051a86cb6e4743$var$$p(e, t) {
    $2a051a86cb6e4743$var$Si = $2a051a86cb6e4743$var$wo = !0;
    var n = e.pending;
    n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function $2a051a86cb6e4743$var$zp(e, t, n) {
    if (n & 4194240) {
        var r = t.lanes;
        r &= e.pendingLanes, n |= r, t.lanes = n, $2a051a86cb6e4743$var$pu(e, n);
    }
}
var $2a051a86cb6e4743$var$xo = {
    readContext: $2a051a86cb6e4743$var$it,
    useCallback: $2a051a86cb6e4743$var$Pe,
    useContext: $2a051a86cb6e4743$var$Pe,
    useEffect: $2a051a86cb6e4743$var$Pe,
    useImperativeHandle: $2a051a86cb6e4743$var$Pe,
    useInsertionEffect: $2a051a86cb6e4743$var$Pe,
    useLayoutEffect: $2a051a86cb6e4743$var$Pe,
    useMemo: $2a051a86cb6e4743$var$Pe,
    useReducer: $2a051a86cb6e4743$var$Pe,
    useRef: $2a051a86cb6e4743$var$Pe,
    useState: $2a051a86cb6e4743$var$Pe,
    useDebugValue: $2a051a86cb6e4743$var$Pe,
    useDeferredValue: $2a051a86cb6e4743$var$Pe,
    useTransition: $2a051a86cb6e4743$var$Pe,
    useMutableSource: $2a051a86cb6e4743$var$Pe,
    useSyncExternalStore: $2a051a86cb6e4743$var$Pe,
    useId: $2a051a86cb6e4743$var$Pe,
    unstable_isNewReconciler: !1
}, $2a051a86cb6e4743$var$L1 = {
    readContext: $2a051a86cb6e4743$var$it,
    useCallback: function(e, t) {
        return $2a051a86cb6e4743$var$vt().memoizedState = [
            e,
            t === void 0 ? null : t
        ], e;
    },
    useContext: $2a051a86cb6e4743$var$it,
    useEffect: $2a051a86cb6e4743$var$_f,
    useImperativeHandle: function(e, t, n) {
        return n = n != null ? n.concat([
            e
        ]) : null, $2a051a86cb6e4743$var$Qs(4194308, 4, $2a051a86cb6e4743$var$jp.bind(null, t, e), n);
    },
    useLayoutEffect: function(e, t) {
        return $2a051a86cb6e4743$var$Qs(4194308, 4, e, t);
    },
    useInsertionEffect: function(e, t) {
        return $2a051a86cb6e4743$var$Qs(4, 2, e, t);
    },
    useMemo: function(e, t) {
        var n = $2a051a86cb6e4743$var$vt();
        return t = t === void 0 ? null : t, e = e(), n.memoizedState = [
            e,
            t
        ], e;
    },
    useReducer: function(e, t, n) {
        var r = $2a051a86cb6e4743$var$vt();
        return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: e,
            lastRenderedState: t
        }, r.queue = e, e = e.dispatch = $2a051a86cb6e4743$var$N1.bind(null, $2a051a86cb6e4743$var$ue, e), [
            r.memoizedState,
            e
        ];
    },
    useRef: function(e) {
        var t = $2a051a86cb6e4743$var$vt();
        return e = {
            current: e
        }, t.memoizedState = e;
    },
    useState: $2a051a86cb6e4743$var$Pf,
    useDebugValue: $2a051a86cb6e4743$var$Au,
    useDeferredValue: function(e) {
        return $2a051a86cb6e4743$var$vt().memoizedState = e;
    },
    useTransition: function() {
        var e = $2a051a86cb6e4743$var$Pf(!1), t = e[0];
        return e = $2a051a86cb6e4743$var$O1.bind(null, e[1]), $2a051a86cb6e4743$var$vt().memoizedState = e, [
            t,
            e
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(e, t, n) {
        var r = $2a051a86cb6e4743$var$ue, i1 = $2a051a86cb6e4743$var$vt();
        if ($2a051a86cb6e4743$var$se) {
            if (n === void 0) throw Error($2a051a86cb6e4743$var$j(407));
            n = n();
        } else {
            if (n = t(), $2a051a86cb6e4743$var$we === null) throw Error($2a051a86cb6e4743$var$j(349));
            $2a051a86cb6e4743$var$qn & 30 || $2a051a86cb6e4743$var$Pp(r, t, n);
        }
        i1.memoizedState = n;
        var s = {
            value: n,
            getSnapshot: t
        };
        return i1.queue = s, $2a051a86cb6e4743$var$_f($2a051a86cb6e4743$var$bp.bind(null, r, s, e), [
            e
        ]), r.flags |= 2048, $2a051a86cb6e4743$var$Qi(9, $2a051a86cb6e4743$var$_p.bind(null, r, s, n, t), void 0, null), n;
    },
    useId: function() {
        var e = $2a051a86cb6e4743$var$vt(), t = $2a051a86cb6e4743$var$we.identifierPrefix;
        if ($2a051a86cb6e4743$var$se) {
            var n = $2a051a86cb6e4743$var$At, r = $2a051a86cb6e4743$var$Dt;
            n = (r & ~(1 << 32 - $2a051a86cb6e4743$var$pt(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = $2a051a86cb6e4743$var$Hi++, 0 < n && (t += "H" + n.toString(32)), t += ":";
        } else n = $2a051a86cb6e4743$var$b1++, t = ":" + t + "r" + n.toString(32) + ":";
        return e.memoizedState = t;
    },
    unstable_isNewReconciler: !1
}, $2a051a86cb6e4743$var$R1 = {
    readContext: $2a051a86cb6e4743$var$it,
    useCallback: $2a051a86cb6e4743$var$Fp,
    useContext: $2a051a86cb6e4743$var$it,
    useEffect: $2a051a86cb6e4743$var$Du,
    useImperativeHandle: $2a051a86cb6e4743$var$Ip,
    useInsertionEffect: $2a051a86cb6e4743$var$Lp,
    useLayoutEffect: $2a051a86cb6e4743$var$Rp,
    useMemo: $2a051a86cb6e4743$var$Dp,
    useReducer: $2a051a86cb6e4743$var$Oa,
    useRef: $2a051a86cb6e4743$var$Tp,
    useState: function() {
        return $2a051a86cb6e4743$var$Oa($2a051a86cb6e4743$var$Vi);
    },
    useDebugValue: $2a051a86cb6e4743$var$Au,
    useDeferredValue: function(e) {
        var t = $2a051a86cb6e4743$var$st();
        return $2a051a86cb6e4743$var$Ap(t, $2a051a86cb6e4743$var$ye.memoizedState, e);
    },
    useTransition: function() {
        var e = $2a051a86cb6e4743$var$Oa($2a051a86cb6e4743$var$Vi)[0], t = $2a051a86cb6e4743$var$st().memoizedState;
        return [
            e,
            t
        ];
    },
    useMutableSource: $2a051a86cb6e4743$var$Ep,
    useSyncExternalStore: $2a051a86cb6e4743$var$kp,
    useId: $2a051a86cb6e4743$var$Mp,
    unstable_isNewReconciler: !1
}, $2a051a86cb6e4743$var$j1 = {
    readContext: $2a051a86cb6e4743$var$it,
    useCallback: $2a051a86cb6e4743$var$Fp,
    useContext: $2a051a86cb6e4743$var$it,
    useEffect: $2a051a86cb6e4743$var$Du,
    useImperativeHandle: $2a051a86cb6e4743$var$Ip,
    useInsertionEffect: $2a051a86cb6e4743$var$Lp,
    useLayoutEffect: $2a051a86cb6e4743$var$Rp,
    useMemo: $2a051a86cb6e4743$var$Dp,
    useReducer: $2a051a86cb6e4743$var$Na,
    useRef: $2a051a86cb6e4743$var$Tp,
    useState: function() {
        return $2a051a86cb6e4743$var$Na($2a051a86cb6e4743$var$Vi);
    },
    useDebugValue: $2a051a86cb6e4743$var$Au,
    useDeferredValue: function(e) {
        var t = $2a051a86cb6e4743$var$st();
        return $2a051a86cb6e4743$var$ye === null ? t.memoizedState = e : $2a051a86cb6e4743$var$Ap(t, $2a051a86cb6e4743$var$ye.memoizedState, e);
    },
    useTransition: function() {
        var e = $2a051a86cb6e4743$var$Na($2a051a86cb6e4743$var$Vi)[0], t = $2a051a86cb6e4743$var$st().memoizedState;
        return [
            e,
            t
        ];
    },
    useMutableSource: $2a051a86cb6e4743$var$Ep,
    useSyncExternalStore: $2a051a86cb6e4743$var$kp,
    useId: $2a051a86cb6e4743$var$Mp,
    unstable_isNewReconciler: !1
};
function $2a051a86cb6e4743$var$lt(e, t) {
    if (e && e.defaultProps) {
        t = $2a051a86cb6e4743$var$ce({}, t), e = e.defaultProps;
        for(var n in e)t[n] === void 0 && (t[n] = e[n]);
        return t;
    }
    return t;
}
function $2a051a86cb6e4743$var$Tl(e, t, n, r) {
    t = e.memoizedState, n = n(r, t), n = n == null ? t : $2a051a86cb6e4743$var$ce({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var $2a051a86cb6e4743$var$Ko = {
    isMounted: function(e) {
        return (e = e._reactInternals) ? $2a051a86cb6e4743$var$Zn(e) === e : !1;
    },
    enqueueSetState: function(e, t, n) {
        e = e._reactInternals;
        var r = $2a051a86cb6e4743$var$Ie(), i1 = $2a051a86cb6e4743$var$vn(e), s = $2a051a86cb6e4743$var$Mt(r, i1);
        s.payload = t, n != null && (s.callback = n), t = $2a051a86cb6e4743$var$mn(e, s, i1), t !== null && ($2a051a86cb6e4743$var$gt(t, e, i1, r), $2a051a86cb6e4743$var$Hs(t, e, i1));
    },
    enqueueReplaceState: function(e, t, n) {
        e = e._reactInternals;
        var r = $2a051a86cb6e4743$var$Ie(), i1 = $2a051a86cb6e4743$var$vn(e), s = $2a051a86cb6e4743$var$Mt(r, i1);
        s.tag = 1, s.payload = t, n != null && (s.callback = n), t = $2a051a86cb6e4743$var$mn(e, s, i1), t !== null && ($2a051a86cb6e4743$var$gt(t, e, i1, r), $2a051a86cb6e4743$var$Hs(t, e, i1));
    },
    enqueueForceUpdate: function(e, t) {
        e = e._reactInternals;
        var n = $2a051a86cb6e4743$var$Ie(), r = $2a051a86cb6e4743$var$vn(e), i1 = $2a051a86cb6e4743$var$Mt(n, r);
        i1.tag = 2, t != null && (i1.callback = t), t = $2a051a86cb6e4743$var$mn(e, i1, r), t !== null && ($2a051a86cb6e4743$var$gt(t, e, r, n), $2a051a86cb6e4743$var$Hs(t, e, r));
    }
};
function $2a051a86cb6e4743$var$bf(e, t, n, r, i1, s, o) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, s, o) : t.prototype && t.prototype.isPureReactComponent ? !$2a051a86cb6e4743$var$Ai(n, r) || !$2a051a86cb6e4743$var$Ai(i1, s) : !0;
}
function $2a051a86cb6e4743$var$Bp(e, t, n) {
    var r = !1, i1 = $2a051a86cb6e4743$var$Cn, s = t.contextType;
    return typeof s == "object" && s !== null ? s = $2a051a86cb6e4743$var$it(s) : (i1 = $2a051a86cb6e4743$var$ze(t) ? $2a051a86cb6e4743$var$Wn : $2a051a86cb6e4743$var$Ne.current, r = t.contextTypes, s = (r = r != null) ? $2a051a86cb6e4743$var$$r(e, i1) : $2a051a86cb6e4743$var$Cn), t = new t(n, s), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = $2a051a86cb6e4743$var$Ko, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = i1, e.__reactInternalMemoizedMaskedChildContext = s), t;
}
function $2a051a86cb6e4743$var$Of(e, t, n, r) {
    e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && $2a051a86cb6e4743$var$Ko.enqueueReplaceState(t, t.state, null);
}
function $2a051a86cb6e4743$var$Ll(e, t, n, r) {
    var i1 = e.stateNode;
    i1.props = n, i1.state = e.memoizedState, i1.refs = {}, $2a051a86cb6e4743$var$Nu(e);
    var s = t.contextType;
    typeof s == "object" && s !== null ? i1.context = $2a051a86cb6e4743$var$it(s) : (s = $2a051a86cb6e4743$var$ze(t) ? $2a051a86cb6e4743$var$Wn : $2a051a86cb6e4743$var$Ne.current, i1.context = $2a051a86cb6e4743$var$$r(e, s)), i1.state = e.memoizedState, s = t.getDerivedStateFromProps, typeof s == "function" && ($2a051a86cb6e4743$var$Tl(e, t, s, n), i1.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof i1.getSnapshotBeforeUpdate == "function" || typeof i1.UNSAFE_componentWillMount != "function" && typeof i1.componentWillMount != "function" || (t = i1.state, typeof i1.componentWillMount == "function" && i1.componentWillMount(), typeof i1.UNSAFE_componentWillMount == "function" && i1.UNSAFE_componentWillMount(), t !== i1.state && $2a051a86cb6e4743$var$Ko.enqueueReplaceState(i1, i1.state, null), $2a051a86cb6e4743$var$vo(e, n, i1, r), i1.state = e.memoizedState), typeof i1.componentDidMount == "function" && (e.flags |= 4194308);
}
function $2a051a86cb6e4743$var$Vr(e, t) {
    try {
        var n = "", r = t;
        do n += $2a051a86cb6e4743$var$a0(r), r = r.return;
        while (r);
        var i1 = n;
    } catch (s) {
        i1 = `
Error generating stack: ` + s.message + `
` + s.stack;
    }
    return {
        value: e,
        source: t,
        stack: i1,
        digest: null
    };
}
function $2a051a86cb6e4743$var$Ta(e, t, n) {
    return {
        value: e,
        source: null,
        stack: n ?? null,
        digest: t ?? null
    };
}
function $2a051a86cb6e4743$var$Rl(e, t) {
    try {
        console.error(t.value);
    } catch (n) {
        setTimeout(function() {
            throw n;
        });
    }
}
var $2a051a86cb6e4743$var$I1 = typeof WeakMap == "function" ? WeakMap : Map;
function $2a051a86cb6e4743$var$Hp(e, t, n) {
    n = $2a051a86cb6e4743$var$Mt(-1, n), n.tag = 3, n.payload = {
        element: null
    };
    var r = t.value;
    return n.callback = function() {
        $2a051a86cb6e4743$var$Eo || ($2a051a86cb6e4743$var$Eo = !0, $2a051a86cb6e4743$var$Bl = r), $2a051a86cb6e4743$var$Rl(e, t);
    }, n;
}
function $2a051a86cb6e4743$var$Vp(e, t, n) {
    n = $2a051a86cb6e4743$var$Mt(-1, n), n.tag = 3;
    var r = e.type.getDerivedStateFromError;
    if (typeof r == "function") {
        var i1 = t.value;
        n.payload = function() {
            return r(i1);
        }, n.callback = function() {
            $2a051a86cb6e4743$var$Rl(e, t);
        };
    }
    var s = e.stateNode;
    return s !== null && typeof s.componentDidCatch == "function" && (n.callback = function() {
        $2a051a86cb6e4743$var$Rl(e, t), typeof r != "function" && ($2a051a86cb6e4743$var$yn === null ? $2a051a86cb6e4743$var$yn = new Set([
            this
        ]) : $2a051a86cb6e4743$var$yn.add(this));
        var o = t.stack;
        this.componentDidCatch(t.value, {
            componentStack: o !== null ? o : ""
        });
    }), n;
}
function $2a051a86cb6e4743$var$Nf(e, t, n) {
    var r = e.pingCache;
    if (r === null) {
        r = e.pingCache = new $2a051a86cb6e4743$var$I1;
        var i1 = new Set;
        r.set(t, i1);
    } else i1 = r.get(t), i1 === void 0 && (i1 = new Set, r.set(t, i1));
    i1.has(n) || (i1.add(n), e = $2a051a86cb6e4743$var$Y1.bind(null, e, t, n), t.then(e, e));
}
function $2a051a86cb6e4743$var$Tf(e) {
    do {
        var t;
        if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
        e = e.return;
    }while (e !== null);
    return null;
}
function $2a051a86cb6e4743$var$Lf(e, t, n, r, i1) {
    return e.mode & 1 ? (e.flags |= 65536, e.lanes = i1, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = $2a051a86cb6e4743$var$Mt(-1, 1), t.tag = 2, $2a051a86cb6e4743$var$mn(n, t, 1))), n.lanes |= 1), e);
}
var $2a051a86cb6e4743$var$F1 = $2a051a86cb6e4743$var$Ht.ReactCurrentOwner, $2a051a86cb6e4743$var$Ue = !1;
function $2a051a86cb6e4743$var$je(e, t, n, r) {
    t.child = e === null ? $2a051a86cb6e4743$var$Sp(t, null, n, r) : $2a051a86cb6e4743$var$Br(t, e.child, n, r);
}
function $2a051a86cb6e4743$var$Rf(e, t, n, r, i1) {
    n = n.render;
    var s = t.ref;
    return $2a051a86cb6e4743$var$Cr(t, i1), r = $2a051a86cb6e4743$var$Iu(e, t, n, r, s, i1), n = $2a051a86cb6e4743$var$Fu(), e !== null && !$2a051a86cb6e4743$var$Ue ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i1, $2a051a86cb6e4743$var$Bt(e, t, i1)) : ($2a051a86cb6e4743$var$se && n && $2a051a86cb6e4743$var$Cu(t), t.flags |= 1, $2a051a86cb6e4743$var$je(e, t, r, i1), t.child);
}
function $2a051a86cb6e4743$var$jf(e, t, n, r, i1) {
    if (e === null) {
        var s = n.type;
        return typeof s == "function" && !$2a051a86cb6e4743$var$Qu(s) && s.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = s, $2a051a86cb6e4743$var$Qp(e, t, s, r, i1)) : (e = $2a051a86cb6e4743$var$qs(n.type, null, r, t, t.mode, i1), e.ref = t.ref, e.return = t, t.child = e);
    }
    if (s = e.child, !(e.lanes & i1)) {
        var o = s.memoizedProps;
        if (n = n.compare, n = n !== null ? n : $2a051a86cb6e4743$var$Ai, n(o, r) && e.ref === t.ref) return $2a051a86cb6e4743$var$Bt(e, t, i1);
    }
    return t.flags |= 1, e = $2a051a86cb6e4743$var$Sn(s, r), e.ref = t.ref, e.return = t, t.child = e;
}
function $2a051a86cb6e4743$var$Qp(e, t, n, r, i1) {
    if (e !== null) {
        var s = e.memoizedProps;
        if ($2a051a86cb6e4743$var$Ai(s, r) && e.ref === t.ref) {
            if ($2a051a86cb6e4743$var$Ue = !1, t.pendingProps = r = s, (e.lanes & i1) !== 0) e.flags & 131072 && ($2a051a86cb6e4743$var$Ue = !0);
            else return t.lanes = e.lanes, $2a051a86cb6e4743$var$Bt(e, t, i1);
        }
    }
    return $2a051a86cb6e4743$var$jl(e, t, n, r, i1);
}
function $2a051a86cb6e4743$var$Kp(e, t, n) {
    var r = t.pendingProps, i1 = r.children, s = e !== null ? e.memoizedState : null;
    if (r.mode === "hidden") {
        if (!(t.mode & 1)) t.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$gr, $2a051a86cb6e4743$var$Ve), $2a051a86cb6e4743$var$Ve |= n;
        else {
            if (!(n & 1073741824)) return e = s !== null ? s.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
                baseLanes: e,
                cachePool: null,
                transitions: null
            }, t.updateQueue = null, $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$gr, $2a051a86cb6e4743$var$Ve), $2a051a86cb6e4743$var$Ve |= e, null;
            t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            }, r = s !== null ? s.baseLanes : n, $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$gr, $2a051a86cb6e4743$var$Ve), $2a051a86cb6e4743$var$Ve |= r;
        }
    } else s !== null ? (r = s.baseLanes | n, t.memoizedState = null) : r = n, $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$gr, $2a051a86cb6e4743$var$Ve), $2a051a86cb6e4743$var$Ve |= r;
    return $2a051a86cb6e4743$var$je(e, t, i1, n), t.child;
}
function $2a051a86cb6e4743$var$Wp(e, t) {
    var n = t.ref;
    (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function $2a051a86cb6e4743$var$jl(e, t, n, r, i1) {
    var s = $2a051a86cb6e4743$var$ze(n) ? $2a051a86cb6e4743$var$Wn : $2a051a86cb6e4743$var$Ne.current;
    return s = $2a051a86cb6e4743$var$$r(t, s), $2a051a86cb6e4743$var$Cr(t, i1), n = $2a051a86cb6e4743$var$Iu(e, t, n, r, s, i1), r = $2a051a86cb6e4743$var$Fu(), e !== null && !$2a051a86cb6e4743$var$Ue ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i1, $2a051a86cb6e4743$var$Bt(e, t, i1)) : ($2a051a86cb6e4743$var$se && r && $2a051a86cb6e4743$var$Cu(t), t.flags |= 1, $2a051a86cb6e4743$var$je(e, t, n, i1), t.child);
}
function $2a051a86cb6e4743$var$If(e, t, n, r, i1) {
    if ($2a051a86cb6e4743$var$ze(n)) {
        var s = !0;
        $2a051a86cb6e4743$var$ho(t);
    } else s = !1;
    if ($2a051a86cb6e4743$var$Cr(t, i1), t.stateNode === null) $2a051a86cb6e4743$var$Ks(e, t), $2a051a86cb6e4743$var$Bp(t, n, r), $2a051a86cb6e4743$var$Ll(t, n, r, i1), r = !0;
    else if (e === null) {
        var o = t.stateNode, a = t.memoizedProps;
        o.props = a;
        var l = o.context, u = n.contextType;
        typeof u == "object" && u !== null ? u = $2a051a86cb6e4743$var$it(u) : (u = $2a051a86cb6e4743$var$ze(n) ? $2a051a86cb6e4743$var$Wn : $2a051a86cb6e4743$var$Ne.current, u = $2a051a86cb6e4743$var$$r(t, u));
        var c = n.getDerivedStateFromProps, d = typeof c == "function" || typeof o.getSnapshotBeforeUpdate == "function";
        d || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (a !== r || l !== u) && $2a051a86cb6e4743$var$Of(t, o, r, u), $2a051a86cb6e4743$var$Jt = !1;
        var f = t.memoizedState;
        o.state = f, $2a051a86cb6e4743$var$vo(t, r, o, i1), l = t.memoizedState, a !== r || f !== l || $2a051a86cb6e4743$var$$e.current || $2a051a86cb6e4743$var$Jt ? (typeof c == "function" && ($2a051a86cb6e4743$var$Tl(t, n, c, r), l = t.memoizedState), (a = $2a051a86cb6e4743$var$Jt || $2a051a86cb6e4743$var$bf(t, n, a, r, f, l, u)) ? (d || typeof o.UNSAFE_componentWillMount != "function" && typeof o.componentWillMount != "function" || (typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount()), typeof o.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), o.props = r, o.state = l, o.context = u, r = a) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
    } else {
        o = t.stateNode, $2a051a86cb6e4743$var$xp(e, t), a = t.memoizedProps, u = t.type === t.elementType ? a : $2a051a86cb6e4743$var$lt(t.type, a), o.props = u, d = t.pendingProps, f = o.context, l = n.contextType, typeof l == "object" && l !== null ? l = $2a051a86cb6e4743$var$it(l) : (l = $2a051a86cb6e4743$var$ze(n) ? $2a051a86cb6e4743$var$Wn : $2a051a86cb6e4743$var$Ne.current, l = $2a051a86cb6e4743$var$$r(t, l));
        var m = n.getDerivedStateFromProps;
        (c = typeof m == "function" || typeof o.getSnapshotBeforeUpdate == "function") || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (a !== d || f !== l) && $2a051a86cb6e4743$var$Of(t, o, r, l), $2a051a86cb6e4743$var$Jt = !1, f = t.memoizedState, o.state = f, $2a051a86cb6e4743$var$vo(t, r, o, i1);
        var v = t.memoizedState;
        a !== d || f !== v || $2a051a86cb6e4743$var$$e.current || $2a051a86cb6e4743$var$Jt ? (typeof m == "function" && ($2a051a86cb6e4743$var$Tl(t, n, m, r), v = t.memoizedState), (u = $2a051a86cb6e4743$var$Jt || $2a051a86cb6e4743$var$bf(t, n, u, r, f, v, l) || !1) ? (c || typeof o.UNSAFE_componentWillUpdate != "function" && typeof o.componentWillUpdate != "function" || (typeof o.componentWillUpdate == "function" && o.componentWillUpdate(r, v, l), typeof o.UNSAFE_componentWillUpdate == "function" && o.UNSAFE_componentWillUpdate(r, v, l)), typeof o.componentDidUpdate == "function" && (t.flags |= 4), typeof o.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof o.componentDidUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = v), o.props = r, o.state = v, o.context = l, r = u) : (typeof o.componentDidUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || a === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
    }
    return $2a051a86cb6e4743$var$Il(e, t, n, r, s, i1);
}
function $2a051a86cb6e4743$var$Il(e, t, n, r, i1, s) {
    $2a051a86cb6e4743$var$Wp(e, t);
    var o = (t.flags & 128) !== 0;
    if (!r && !o) return i1 && $2a051a86cb6e4743$var$Sf(t, n, !1), $2a051a86cb6e4743$var$Bt(e, t, s);
    r = t.stateNode, $2a051a86cb6e4743$var$F1.current = t;
    var a = o && typeof n.getDerivedStateFromError != "function" ? null : r.render();
    return t.flags |= 1, e !== null && o ? (t.child = $2a051a86cb6e4743$var$Br(t, e.child, null, s), t.child = $2a051a86cb6e4743$var$Br(t, null, a, s)) : $2a051a86cb6e4743$var$je(e, t, a, s), t.memoizedState = r.state, i1 && $2a051a86cb6e4743$var$Sf(t, n, !0), t.child;
}
function $2a051a86cb6e4743$var$Yp(e) {
    var t = e.stateNode;
    t.pendingContext ? $2a051a86cb6e4743$var$vf(e, t.pendingContext, t.pendingContext !== t.context) : t.context && $2a051a86cb6e4743$var$vf(e, t.context, !1), $2a051a86cb6e4743$var$Tu(e, t.containerInfo);
}
function $2a051a86cb6e4743$var$Ff(e, t, n, r, i1) {
    return $2a051a86cb6e4743$var$zr(), $2a051a86cb6e4743$var$ku(i1), t.flags |= 256, $2a051a86cb6e4743$var$je(e, t, n, r), t.child;
}
var $2a051a86cb6e4743$var$Fl = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $2a051a86cb6e4743$var$Dl(e) {
    return {
        baseLanes: e,
        cachePool: null,
        transitions: null
    };
}
function $2a051a86cb6e4743$var$qp(e, t, n) {
    var r = t.pendingProps, i1 = $2a051a86cb6e4743$var$ae.current, s = !1, o = (t.flags & 128) !== 0, a;
    if ((a = o) || (a = e !== null && e.memoizedState === null ? !1 : (i1 & 2) !== 0), a ? (s = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (i1 |= 1), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, i1 & 1), e === null) return $2a051a86cb6e4743$var$Ol(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (o = r.children, e = r.fallback, s ? (r = t.mode, s = t.child, o = {
        mode: "hidden",
        children: o
    }, !(r & 1) && s !== null ? (s.childLanes = 0, s.pendingProps = o) : s = $2a051a86cb6e4743$var$qo(o, r, 0, null), e = $2a051a86cb6e4743$var$Vn(e, r, n, null), s.return = t, e.return = t, s.sibling = e, t.child = s, t.child.memoizedState = $2a051a86cb6e4743$var$Dl(n), t.memoizedState = $2a051a86cb6e4743$var$Fl, e) : $2a051a86cb6e4743$var$Mu(t, o));
    if (i1 = e.memoizedState, i1 !== null && (a = i1.dehydrated, a !== null)) return $2a051a86cb6e4743$var$D1(e, t, o, r, a, i1, n);
    if (s) {
        s = r.fallback, o = t.mode, i1 = e.child, a = i1.sibling;
        var l = {
            mode: "hidden",
            children: r.children
        };
        return !(o & 1) && t.child !== i1 ? (r = t.child, r.childLanes = 0, r.pendingProps = l, t.deletions = null) : (r = $2a051a86cb6e4743$var$Sn(i1, l), r.subtreeFlags = i1.subtreeFlags & 14680064), a !== null ? s = $2a051a86cb6e4743$var$Sn(a, s) : (s = $2a051a86cb6e4743$var$Vn(s, o, n, null), s.flags |= 2), s.return = t, r.return = t, r.sibling = s, t.child = r, r = s, s = t.child, o = e.child.memoizedState, o = o === null ? $2a051a86cb6e4743$var$Dl(n) : {
            baseLanes: o.baseLanes | n,
            cachePool: null,
            transitions: o.transitions
        }, s.memoizedState = o, s.childLanes = e.childLanes & ~n, t.memoizedState = $2a051a86cb6e4743$var$Fl, r;
    }
    return s = e.child, e = s.sibling, r = $2a051a86cb6e4743$var$Sn(s, {
        mode: "visible",
        children: r.children
    }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [
        e
    ], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function $2a051a86cb6e4743$var$Mu(e, t) {
    return t = $2a051a86cb6e4743$var$qo({
        mode: "visible",
        children: t
    }, e.mode, 0, null), t.return = e, e.child = t;
}
function $2a051a86cb6e4743$var$Ls(e, t, n, r) {
    return r !== null && $2a051a86cb6e4743$var$ku(r), $2a051a86cb6e4743$var$Br(t, e.child, null, n), e = $2a051a86cb6e4743$var$Mu(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function $2a051a86cb6e4743$var$D1(e, t, n, r, i1, s, o) {
    if (n) return t.flags & 256 ? (t.flags &= -257, r = $2a051a86cb6e4743$var$Ta(Error($2a051a86cb6e4743$var$j(422))), $2a051a86cb6e4743$var$Ls(e, t, o, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (s = r.fallback, i1 = t.mode, r = $2a051a86cb6e4743$var$qo({
        mode: "visible",
        children: r.children
    }, i1, 0, null), s = $2a051a86cb6e4743$var$Vn(s, i1, o, null), s.flags |= 2, r.return = t, s.return = t, r.sibling = s, t.child = r, t.mode & 1 && $2a051a86cb6e4743$var$Br(t, e.child, null, o), t.child.memoizedState = $2a051a86cb6e4743$var$Dl(o), t.memoizedState = $2a051a86cb6e4743$var$Fl, s);
    if (!(t.mode & 1)) return $2a051a86cb6e4743$var$Ls(e, t, o, null);
    if (i1.data === "$!") {
        if (r = i1.nextSibling && i1.nextSibling.dataset, r) var a = r.dgst;
        return r = a, s = Error($2a051a86cb6e4743$var$j(419)), r = $2a051a86cb6e4743$var$Ta(s, r, void 0), $2a051a86cb6e4743$var$Ls(e, t, o, r);
    }
    if (a = (o & e.childLanes) !== 0, $2a051a86cb6e4743$var$Ue || a) {
        if (r = $2a051a86cb6e4743$var$we, r !== null) {
            switch(o & -o){
                case 4:
                    i1 = 2;
                    break;
                case 16:
                    i1 = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    i1 = 32;
                    break;
                case 536870912:
                    i1 = 268435456;
                    break;
                default:
                    i1 = 0;
            }
            i1 = i1 & (r.suspendedLanes | o) ? 0 : i1, i1 !== 0 && i1 !== s.retryLane && (s.retryLane = i1, $2a051a86cb6e4743$var$zt(e, i1), $2a051a86cb6e4743$var$gt(r, e, i1, -1));
        }
        return $2a051a86cb6e4743$var$Vu(), r = $2a051a86cb6e4743$var$Ta(Error($2a051a86cb6e4743$var$j(421))), $2a051a86cb6e4743$var$Ls(e, t, o, r);
    }
    return i1.data === "$?" ? (t.flags |= 128, t.child = e.child, t = $2a051a86cb6e4743$var$q1.bind(null, e), i1._reactRetry = t, null) : (e = s.treeContext, $2a051a86cb6e4743$var$Qe = $2a051a86cb6e4743$var$gn(i1.nextSibling), $2a051a86cb6e4743$var$Ke = t, $2a051a86cb6e4743$var$se = !0, $2a051a86cb6e4743$var$ht = null, e !== null && ($2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt++] = $2a051a86cb6e4743$var$Dt, $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt++] = $2a051a86cb6e4743$var$At, $2a051a86cb6e4743$var$et[$2a051a86cb6e4743$var$tt++] = $2a051a86cb6e4743$var$Yn, $2a051a86cb6e4743$var$Dt = e.id, $2a051a86cb6e4743$var$At = e.overflow, $2a051a86cb6e4743$var$Yn = t), t = $2a051a86cb6e4743$var$Mu(t, r.children), t.flags |= 4096, t);
}
function $2a051a86cb6e4743$var$Df(e, t, n) {
    e.lanes |= t;
    var r = e.alternate;
    r !== null && (r.lanes |= t), $2a051a86cb6e4743$var$Nl(e.return, t, n);
}
function $2a051a86cb6e4743$var$La(e, t, n, r, i1) {
    var s = e.memoizedState;
    s === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: r,
        tail: n,
        tailMode: i1
    } : (s.isBackwards = t, s.rendering = null, s.renderingStartTime = 0, s.last = r, s.tail = n, s.tailMode = i1);
}
function $2a051a86cb6e4743$var$Gp(e, t, n) {
    var r = t.pendingProps, i1 = r.revealOrder, s = r.tail;
    if ($2a051a86cb6e4743$var$je(e, t, r.children, n), r = $2a051a86cb6e4743$var$ae.current, r & 2) r = r & 1 | 2, t.flags |= 128;
    else {
        if (e !== null && e.flags & 128) e: for(e = t.child; e !== null;){
            if (e.tag === 13) e.memoizedState !== null && $2a051a86cb6e4743$var$Df(e, n, t);
            else if (e.tag === 19) $2a051a86cb6e4743$var$Df(e, n, t);
            else if (e.child !== null) {
                e.child.return = e, e = e.child;
                continue;
            }
            if (e === t) break e;
            for(; e.sibling === null;){
                if (e.return === null || e.return === t) break e;
                e = e.return;
            }
            e.sibling.return = e.return, e = e.sibling;
        }
        r &= 1;
    }
    if ($2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, r), !(t.mode & 1)) t.memoizedState = null;
    else switch(i1){
        case "forwards":
            for(n = t.child, i1 = null; n !== null;)e = n.alternate, e !== null && $2a051a86cb6e4743$var$So(e) === null && (i1 = n), n = n.sibling;
            n = i1, n === null ? (i1 = t.child, t.child = null) : (i1 = n.sibling, n.sibling = null), $2a051a86cb6e4743$var$La(t, !1, i1, n, s);
            break;
        case "backwards":
            for(n = null, i1 = t.child, t.child = null; i1 !== null;){
                if (e = i1.alternate, e !== null && $2a051a86cb6e4743$var$So(e) === null) {
                    t.child = i1;
                    break;
                }
                e = i1.sibling, i1.sibling = n, n = i1, i1 = e;
            }
            $2a051a86cb6e4743$var$La(t, !0, n, null, s);
            break;
        case "together":
            $2a051a86cb6e4743$var$La(t, !1, null, null, void 0);
            break;
        default:
            t.memoizedState = null;
    }
    return t.child;
}
function $2a051a86cb6e4743$var$Ks(e, t) {
    !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function $2a051a86cb6e4743$var$Bt(e, t, n) {
    if (e !== null && (t.dependencies = e.dependencies), $2a051a86cb6e4743$var$Gn |= t.lanes, !(n & t.childLanes)) return null;
    if (e !== null && t.child !== e.child) throw Error($2a051a86cb6e4743$var$j(153));
    if (t.child !== null) {
        for(e = t.child, n = $2a051a86cb6e4743$var$Sn(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;)e = e.sibling, n = n.sibling = $2a051a86cb6e4743$var$Sn(e, e.pendingProps), n.return = t;
        n.sibling = null;
    }
    return t.child;
}
function $2a051a86cb6e4743$var$A1(e, t, n) {
    switch(t.tag){
        case 3:
            $2a051a86cb6e4743$var$Yp(t), $2a051a86cb6e4743$var$zr();
            break;
        case 5:
            $2a051a86cb6e4743$var$Cp(t);
            break;
        case 1:
            $2a051a86cb6e4743$var$ze(t.type) && $2a051a86cb6e4743$var$ho(t);
            break;
        case 4:
            $2a051a86cb6e4743$var$Tu(t, t.stateNode.containerInfo);
            break;
        case 10:
            var r = t.type._context, i1 = t.memoizedProps.value;
            $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$mo, r._currentValue), r._currentValue = i1;
            break;
        case 13:
            if (r = t.memoizedState, r !== null) return r.dehydrated !== null ? ($2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, $2a051a86cb6e4743$var$ae.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? $2a051a86cb6e4743$var$qp(e, t, n) : ($2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, $2a051a86cb6e4743$var$ae.current & 1), e = $2a051a86cb6e4743$var$Bt(e, t, n), e !== null ? e.sibling : null);
            $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, $2a051a86cb6e4743$var$ae.current & 1);
            break;
        case 19:
            if (r = (n & t.childLanes) !== 0, e.flags & 128) {
                if (r) return $2a051a86cb6e4743$var$Gp(e, t, n);
                t.flags |= 128;
            }
            if (i1 = t.memoizedState, i1 !== null && (i1.rendering = null, i1.tail = null, i1.lastEffect = null), $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, $2a051a86cb6e4743$var$ae.current), r) break;
            return null;
        case 22:
        case 23:
            return t.lanes = 0, $2a051a86cb6e4743$var$Kp(e, t, n);
    }
    return $2a051a86cb6e4743$var$Bt(e, t, n);
}
var $2a051a86cb6e4743$var$Xp, $2a051a86cb6e4743$var$Al, $2a051a86cb6e4743$var$Jp, $2a051a86cb6e4743$var$Zp;
$2a051a86cb6e4743$var$Xp = function(e, t) {
    for(var n = t.child; n !== null;){
        if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
        else if (n.tag !== 4 && n.child !== null) {
            n.child.return = n, n = n.child;
            continue;
        }
        if (n === t) break;
        for(; n.sibling === null;){
            if (n.return === null || n.return === t) return;
            n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
    }
};
$2a051a86cb6e4743$var$Al = function() {};
$2a051a86cb6e4743$var$Jp = function(e, t, n, r) {
    var i1 = e.memoizedProps;
    if (i1 !== r) {
        e = t.stateNode, $2a051a86cb6e4743$var$Rn($2a051a86cb6e4743$var$Ot.current);
        var s = null;
        switch(n){
            case "input":
                i1 = $2a051a86cb6e4743$var$sl(e, i1), r = $2a051a86cb6e4743$var$sl(e, r), s = [];
                break;
            case "select":
                i1 = $2a051a86cb6e4743$var$ce({}, i1, {
                    value: void 0
                }), r = $2a051a86cb6e4743$var$ce({}, r, {
                    value: void 0
                }), s = [];
                break;
            case "textarea":
                i1 = $2a051a86cb6e4743$var$ll(e, i1), r = $2a051a86cb6e4743$var$ll(e, r), s = [];
                break;
            default:
                typeof i1.onClick != "function" && typeof r.onClick == "function" && (e.onclick = $2a051a86cb6e4743$var$co);
        }
        $2a051a86cb6e4743$var$cl(n, r);
        var o;
        n = null;
        for(u in i1)if (!r.hasOwnProperty(u) && i1.hasOwnProperty(u) && i1[u] != null) {
            if (u === "style") {
                var a = i1[u];
                for(o in a)a.hasOwnProperty(o) && (n || (n = {}), n[o] = "");
            } else u !== "dangerouslySetInnerHTML" && u !== "children" && u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && u !== "autoFocus" && ($2a051a86cb6e4743$var$Ti.hasOwnProperty(u) ? s || (s = []) : (s = s || []).push(u, null));
        }
        for(u in r){
            var l = r[u];
            if (a = i1 != null ? i1[u] : void 0, r.hasOwnProperty(u) && l !== a && (l != null || a != null)) {
                if (u === "style") {
                    if (a) {
                        for(o in a)!a.hasOwnProperty(o) || l && l.hasOwnProperty(o) || (n || (n = {}), n[o] = "");
                        for(o in l)l.hasOwnProperty(o) && a[o] !== l[o] && (n || (n = {}), n[o] = l[o]);
                    } else n || (s || (s = []), s.push(u, n)), n = l;
                } else u === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, a = a ? a.__html : void 0, l != null && a !== l && (s = s || []).push(u, l)) : u === "children" ? typeof l != "string" && typeof l != "number" || (s = s || []).push(u, "" + l) : u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && ($2a051a86cb6e4743$var$Ti.hasOwnProperty(u) ? (l != null && u === "onScroll" && $2a051a86cb6e4743$var$ne("scroll", e), s || a === l || (s = [])) : (s = s || []).push(u, l));
            }
        }
        n && (s = s || []).push("style", n);
        var u = s;
        (t.updateQueue = u) && (t.flags |= 4);
    }
};
$2a051a86cb6e4743$var$Zp = function(e, t, n, r) {
    n !== r && (t.flags |= 4);
};
function $2a051a86cb6e4743$var$si(e, t) {
    if (!$2a051a86cb6e4743$var$se) switch(e.tailMode){
        case "hidden":
            t = e.tail;
            for(var n = null; t !== null;)t.alternate !== null && (n = t), t = t.sibling;
            n === null ? e.tail = null : n.sibling = null;
            break;
        case "collapsed":
            n = e.tail;
            for(var r = null; n !== null;)n.alternate !== null && (r = n), n = n.sibling;
            r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
    }
}
function $2a051a86cb6e4743$var$_e(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
    if (t) for(var i1 = e.child; i1 !== null;)n |= i1.lanes | i1.childLanes, r |= i1.subtreeFlags & 14680064, r |= i1.flags & 14680064, i1.return = e, i1 = i1.sibling;
    else for(i1 = e.child; i1 !== null;)n |= i1.lanes | i1.childLanes, r |= i1.subtreeFlags, r |= i1.flags, i1.return = e, i1 = i1.sibling;
    return e.subtreeFlags |= r, e.childLanes = n, t;
}
function $2a051a86cb6e4743$var$M1(e, t, n) {
    var r = t.pendingProps;
    switch($2a051a86cb6e4743$var$Eu(t), t.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2a051a86cb6e4743$var$_e(t), null;
        case 1:
            return $2a051a86cb6e4743$var$ze(t.type) && $2a051a86cb6e4743$var$fo(), $2a051a86cb6e4743$var$_e(t), null;
        case 3:
            return r = t.stateNode, $2a051a86cb6e4743$var$Hr(), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$$e), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ne), $2a051a86cb6e4743$var$Ru(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && ($2a051a86cb6e4743$var$Ns(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, $2a051a86cb6e4743$var$ht !== null && ($2a051a86cb6e4743$var$Ql($2a051a86cb6e4743$var$ht), $2a051a86cb6e4743$var$ht = null))), $2a051a86cb6e4743$var$Al(e, t), $2a051a86cb6e4743$var$_e(t), null;
        case 5:
            $2a051a86cb6e4743$var$Lu(t);
            var i1 = $2a051a86cb6e4743$var$Rn($2a051a86cb6e4743$var$Bi.current);
            if (n = t.type, e !== null && t.stateNode != null) $2a051a86cb6e4743$var$Jp(e, t, n, r, i1), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
            else {
                if (!r) {
                    if (t.stateNode === null) throw Error($2a051a86cb6e4743$var$j(166));
                    return $2a051a86cb6e4743$var$_e(t), null;
                }
                if (e = $2a051a86cb6e4743$var$Rn($2a051a86cb6e4743$var$Ot.current), $2a051a86cb6e4743$var$Ns(t)) {
                    r = t.stateNode, n = t.type;
                    var s = t.memoizedProps;
                    switch(r[$2a051a86cb6e4743$var$kt] = t, r[$2a051a86cb6e4743$var$$i] = s, e = (t.mode & 1) !== 0, n){
                        case "dialog":
                            $2a051a86cb6e4743$var$ne("cancel", r), $2a051a86cb6e4743$var$ne("close", r);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $2a051a86cb6e4743$var$ne("load", r);
                            break;
                        case "video":
                        case "audio":
                            for(i1 = 0; i1 < $2a051a86cb6e4743$var$di.length; i1++)$2a051a86cb6e4743$var$ne($2a051a86cb6e4743$var$di[i1], r);
                            break;
                        case "source":
                            $2a051a86cb6e4743$var$ne("error", r);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $2a051a86cb6e4743$var$ne("error", r), $2a051a86cb6e4743$var$ne("load", r);
                            break;
                        case "details":
                            $2a051a86cb6e4743$var$ne("toggle", r);
                            break;
                        case "input":
                            $2a051a86cb6e4743$var$Vc(r, s), $2a051a86cb6e4743$var$ne("invalid", r);
                            break;
                        case "select":
                            r._wrapperState = {
                                wasMultiple: !!s.multiple
                            }, $2a051a86cb6e4743$var$ne("invalid", r);
                            break;
                        case "textarea":
                            $2a051a86cb6e4743$var$Kc(r, s), $2a051a86cb6e4743$var$ne("invalid", r);
                    }
                    $2a051a86cb6e4743$var$cl(n, s), i1 = null;
                    for(var o in s)if (s.hasOwnProperty(o)) {
                        var a = s[o];
                        o === "children" ? typeof a == "string" ? r.textContent !== a && (s.suppressHydrationWarning !== !0 && $2a051a86cb6e4743$var$Os(r.textContent, a, e), i1 = [
                            "children",
                            a
                        ]) : typeof a == "number" && r.textContent !== "" + a && (s.suppressHydrationWarning !== !0 && $2a051a86cb6e4743$var$Os(r.textContent, a, e), i1 = [
                            "children",
                            "" + a
                        ]) : $2a051a86cb6e4743$var$Ti.hasOwnProperty(o) && a != null && o === "onScroll" && $2a051a86cb6e4743$var$ne("scroll", r);
                    }
                    switch(n){
                        case "input":
                            $2a051a86cb6e4743$var$ws(r), $2a051a86cb6e4743$var$Qc(r, s, !0);
                            break;
                        case "textarea":
                            $2a051a86cb6e4743$var$ws(r), $2a051a86cb6e4743$var$Wc(r);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            typeof s.onClick == "function" && (r.onclick = $2a051a86cb6e4743$var$co);
                    }
                    r = i1, t.updateQueue = r, r !== null && (t.flags |= 4);
                } else {
                    o = i1.nodeType === 9 ? i1 : i1.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = $2a051a86cb6e4743$var$bh(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = o.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = o.createElement(n, {
                        is: r.is
                    }) : (e = o.createElement(n), n === "select" && (o = e, r.multiple ? o.multiple = !0 : r.size && (o.size = r.size))) : e = o.createElementNS(e, n), e[$2a051a86cb6e4743$var$kt] = t, e[$2a051a86cb6e4743$var$$i] = r, $2a051a86cb6e4743$var$Xp(e, t, !1, !1), t.stateNode = e;
                    e: {
                        switch(o = $2a051a86cb6e4743$var$fl(n, r), n){
                            case "dialog":
                                $2a051a86cb6e4743$var$ne("cancel", e), $2a051a86cb6e4743$var$ne("close", e), i1 = r;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $2a051a86cb6e4743$var$ne("load", e), i1 = r;
                                break;
                            case "video":
                            case "audio":
                                for(i1 = 0; i1 < $2a051a86cb6e4743$var$di.length; i1++)$2a051a86cb6e4743$var$ne($2a051a86cb6e4743$var$di[i1], e);
                                i1 = r;
                                break;
                            case "source":
                                $2a051a86cb6e4743$var$ne("error", e), i1 = r;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $2a051a86cb6e4743$var$ne("error", e), $2a051a86cb6e4743$var$ne("load", e), i1 = r;
                                break;
                            case "details":
                                $2a051a86cb6e4743$var$ne("toggle", e), i1 = r;
                                break;
                            case "input":
                                $2a051a86cb6e4743$var$Vc(e, r), i1 = $2a051a86cb6e4743$var$sl(e, r), $2a051a86cb6e4743$var$ne("invalid", e);
                                break;
                            case "option":
                                i1 = r;
                                break;
                            case "select":
                                e._wrapperState = {
                                    wasMultiple: !!r.multiple
                                }, i1 = $2a051a86cb6e4743$var$ce({}, r, {
                                    value: void 0
                                }), $2a051a86cb6e4743$var$ne("invalid", e);
                                break;
                            case "textarea":
                                $2a051a86cb6e4743$var$Kc(e, r), i1 = $2a051a86cb6e4743$var$ll(e, r), $2a051a86cb6e4743$var$ne("invalid", e);
                                break;
                            default:
                                i1 = r;
                        }
                        $2a051a86cb6e4743$var$cl(n, i1), a = i1;
                        for(s in a)if (a.hasOwnProperty(s)) {
                            var l = a[s];
                            s === "style" ? $2a051a86cb6e4743$var$Th(e, l) : s === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, l != null && $2a051a86cb6e4743$var$Oh(e, l)) : s === "children" ? typeof l == "string" ? (n !== "textarea" || l !== "") && $2a051a86cb6e4743$var$Li(e, l) : typeof l == "number" && $2a051a86cb6e4743$var$Li(e, "" + l) : s !== "suppressContentEditableWarning" && s !== "suppressHydrationWarning" && s !== "autoFocus" && ($2a051a86cb6e4743$var$Ti.hasOwnProperty(s) ? l != null && s === "onScroll" && $2a051a86cb6e4743$var$ne("scroll", e) : l != null && $2a051a86cb6e4743$var$lu(e, s, l, o));
                        }
                        switch(n){
                            case "input":
                                $2a051a86cb6e4743$var$ws(e), $2a051a86cb6e4743$var$Qc(e, r, !1);
                                break;
                            case "textarea":
                                $2a051a86cb6e4743$var$ws(e), $2a051a86cb6e4743$var$Wc(e);
                                break;
                            case "option":
                                r.value != null && e.setAttribute("value", "" + $2a051a86cb6e4743$var$xn(r.value));
                                break;
                            case "select":
                                e.multiple = !!r.multiple, s = r.value, s != null ? $2a051a86cb6e4743$var$vr(e, !!r.multiple, s, !1) : r.defaultValue != null && $2a051a86cb6e4743$var$vr(e, !!r.multiple, r.defaultValue, !0);
                                break;
                            default:
                                typeof i1.onClick == "function" && (e.onclick = $2a051a86cb6e4743$var$co);
                        }
                        switch(n){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                r = !!r.autoFocus;
                                break e;
                            case "img":
                                r = !0;
                                break e;
                            default:
                                r = !1;
                        }
                    }
                    r && (t.flags |= 4);
                }
                t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
            }
            return $2a051a86cb6e4743$var$_e(t), null;
        case 6:
            if (e && t.stateNode != null) $2a051a86cb6e4743$var$Zp(e, t, e.memoizedProps, r);
            else {
                if (typeof r != "string" && t.stateNode === null) throw Error($2a051a86cb6e4743$var$j(166));
                if (n = $2a051a86cb6e4743$var$Rn($2a051a86cb6e4743$var$Bi.current), $2a051a86cb6e4743$var$Rn($2a051a86cb6e4743$var$Ot.current), $2a051a86cb6e4743$var$Ns(t)) {
                    if (r = t.stateNode, n = t.memoizedProps, r[$2a051a86cb6e4743$var$kt] = t, (s = r.nodeValue !== n) && (e = $2a051a86cb6e4743$var$Ke, e !== null)) switch(e.tag){
                        case 3:
                            $2a051a86cb6e4743$var$Os(r.nodeValue, n, (e.mode & 1) !== 0);
                            break;
                        case 5:
                            e.memoizedProps.suppressHydrationWarning !== !0 && $2a051a86cb6e4743$var$Os(r.nodeValue, n, (e.mode & 1) !== 0);
                    }
                    s && (t.flags |= 4);
                } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[$2a051a86cb6e4743$var$kt] = t, t.stateNode = r;
            }
            return $2a051a86cb6e4743$var$_e(t), null;
        case 13:
            if ($2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$ae), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
                if ($2a051a86cb6e4743$var$se && $2a051a86cb6e4743$var$Qe !== null && t.mode & 1 && !(t.flags & 128)) $2a051a86cb6e4743$var$yp(), $2a051a86cb6e4743$var$zr(), t.flags |= 98560, s = !1;
                else if (s = $2a051a86cb6e4743$var$Ns(t), r !== null && r.dehydrated !== null) {
                    if (e === null) {
                        if (!s) throw Error($2a051a86cb6e4743$var$j(318));
                        if (s = t.memoizedState, s = s !== null ? s.dehydrated : null, !s) throw Error($2a051a86cb6e4743$var$j(317));
                        s[$2a051a86cb6e4743$var$kt] = t;
                    } else $2a051a86cb6e4743$var$zr(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
                    $2a051a86cb6e4743$var$_e(t), s = !1;
                } else $2a051a86cb6e4743$var$ht !== null && ($2a051a86cb6e4743$var$Ql($2a051a86cb6e4743$var$ht), $2a051a86cb6e4743$var$ht = null), s = !0;
                if (!s) return t.flags & 65536 ? t : null;
            }
            return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || $2a051a86cb6e4743$var$ae.current & 1 ? $2a051a86cb6e4743$var$ve === 0 && ($2a051a86cb6e4743$var$ve = 3) : $2a051a86cb6e4743$var$Vu())), t.updateQueue !== null && (t.flags |= 4), $2a051a86cb6e4743$var$_e(t), null);
        case 4:
            return $2a051a86cb6e4743$var$Hr(), $2a051a86cb6e4743$var$Al(e, t), e === null && $2a051a86cb6e4743$var$Mi(t.stateNode.containerInfo), $2a051a86cb6e4743$var$_e(t), null;
        case 10:
            return $2a051a86cb6e4743$var$bu(t.type._context), $2a051a86cb6e4743$var$_e(t), null;
        case 17:
            return $2a051a86cb6e4743$var$ze(t.type) && $2a051a86cb6e4743$var$fo(), $2a051a86cb6e4743$var$_e(t), null;
        case 19:
            if ($2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$ae), s = t.memoizedState, s === null) return $2a051a86cb6e4743$var$_e(t), null;
            if (r = (t.flags & 128) !== 0, o = s.rendering, o === null) {
                if (r) $2a051a86cb6e4743$var$si(s, !1);
                else {
                    if ($2a051a86cb6e4743$var$ve !== 0 || e !== null && e.flags & 128) for(e = t.child; e !== null;){
                        if (o = $2a051a86cb6e4743$var$So(e), o !== null) {
                            for(t.flags |= 128, $2a051a86cb6e4743$var$si(s, !1), r = o.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null;)s = n, e = r, s.flags &= 14680066, o = s.alternate, o === null ? (s.childLanes = 0, s.lanes = e, s.child = null, s.subtreeFlags = 0, s.memoizedProps = null, s.memoizedState = null, s.updateQueue = null, s.dependencies = null, s.stateNode = null) : (s.childLanes = o.childLanes, s.lanes = o.lanes, s.child = o.child, s.subtreeFlags = 0, s.deletions = null, s.memoizedProps = o.memoizedProps, s.memoizedState = o.memoizedState, s.updateQueue = o.updateQueue, s.type = o.type, e = o.dependencies, s.dependencies = e === null ? null : {
                                lanes: e.lanes,
                                firstContext: e.firstContext
                            }), n = n.sibling;
                            return $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, $2a051a86cb6e4743$var$ae.current & 1 | 2), t.child;
                        }
                        e = e.sibling;
                    }
                    s.tail !== null && $2a051a86cb6e4743$var$pe() > $2a051a86cb6e4743$var$Qr && (t.flags |= 128, r = !0, $2a051a86cb6e4743$var$si(s, !1), t.lanes = 4194304);
                }
            } else {
                if (!r) {
                    if (e = $2a051a86cb6e4743$var$So(o), e !== null) {
                        if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), $2a051a86cb6e4743$var$si(s, !0), s.tail === null && s.tailMode === "hidden" && !o.alternate && !$2a051a86cb6e4743$var$se) return $2a051a86cb6e4743$var$_e(t), null;
                    } else 2 * $2a051a86cb6e4743$var$pe() - s.renderingStartTime > $2a051a86cb6e4743$var$Qr && n !== 1073741824 && (t.flags |= 128, r = !0, $2a051a86cb6e4743$var$si(s, !1), t.lanes = 4194304);
                }
                s.isBackwards ? (o.sibling = t.child, t.child = o) : (n = s.last, n !== null ? n.sibling = o : t.child = o, s.last = o);
            }
            return s.tail !== null ? (t = s.tail, s.rendering = t, s.tail = t.sibling, s.renderingStartTime = $2a051a86cb6e4743$var$pe(), t.sibling = null, n = $2a051a86cb6e4743$var$ae.current, $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$ae, r ? n & 1 | 2 : n & 1), t) : ($2a051a86cb6e4743$var$_e(t), null);
        case 22:
        case 23:
            return $2a051a86cb6e4743$var$Hu(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? $2a051a86cb6e4743$var$Ve & 1073741824 && ($2a051a86cb6e4743$var$_e(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : $2a051a86cb6e4743$var$_e(t), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($2a051a86cb6e4743$var$j(156, t.tag));
}
function $2a051a86cb6e4743$var$U1(e, t) {
    switch($2a051a86cb6e4743$var$Eu(t), t.tag){
        case 1:
            return $2a051a86cb6e4743$var$ze(t.type) && $2a051a86cb6e4743$var$fo(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
        case 3:
            return $2a051a86cb6e4743$var$Hr(), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$$e), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ne), $2a051a86cb6e4743$var$Ru(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
        case 5:
            return $2a051a86cb6e4743$var$Lu(t), null;
        case 13:
            if ($2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$ae), e = t.memoizedState, e !== null && e.dehydrated !== null) {
                if (t.alternate === null) throw Error($2a051a86cb6e4743$var$j(340));
                $2a051a86cb6e4743$var$zr();
            }
            return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
        case 19:
            return $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$ae), null;
        case 4:
            return $2a051a86cb6e4743$var$Hr(), null;
        case 10:
            return $2a051a86cb6e4743$var$bu(t.type._context), null;
        case 22:
        case 23:
            return $2a051a86cb6e4743$var$Hu(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $2a051a86cb6e4743$var$Rs = !1, $2a051a86cb6e4743$var$Oe = !1, $2a051a86cb6e4743$var$$1 = typeof WeakSet == "function" ? WeakSet : Set, $2a051a86cb6e4743$var$$ = null;
function $2a051a86cb6e4743$var$pr(e, t) {
    var n = e.ref;
    if (n !== null) {
        if (typeof n == "function") try {
            n(null);
        } catch (r) {
            $2a051a86cb6e4743$var$de(e, t, r);
        }
        else n.current = null;
    }
}
function $2a051a86cb6e4743$var$Ml(e, t, n) {
    try {
        n();
    } catch (r) {
        $2a051a86cb6e4743$var$de(e, t, r);
    }
}
var $2a051a86cb6e4743$var$Af = !1;
function $2a051a86cb6e4743$var$z1(e, t) {
    if ($2a051a86cb6e4743$var$xl = $2a051a86cb6e4743$var$ao, e = $2a051a86cb6e4743$var$ip(), $2a051a86cb6e4743$var$xu(e)) {
        if ("selectionStart" in e) var n = {
            start: e.selectionStart,
            end: e.selectionEnd
        };
        else e: {
            n = (n = e.ownerDocument) && n.defaultView || window;
            var r = n.getSelection && n.getSelection();
            if (r && r.rangeCount !== 0) {
                n = r.anchorNode;
                var i1 = r.anchorOffset, s = r.focusNode;
                r = r.focusOffset;
                try {
                    n.nodeType, s.nodeType;
                } catch  {
                    n = null;
                    break e;
                }
                var o = 0, a = -1, l = -1, u = 0, c = 0, d = e, f = null;
                t: for(;;){
                    for(var m; d !== n || i1 !== 0 && d.nodeType !== 3 || (a = o + i1), d !== s || r !== 0 && d.nodeType !== 3 || (l = o + r), d.nodeType === 3 && (o += d.nodeValue.length), (m = d.firstChild) !== null;)f = d, d = m;
                    for(;;){
                        if (d === e) break t;
                        if (f === n && ++u === i1 && (a = o), f === s && ++c === r && (l = o), (m = d.nextSibling) !== null) break;
                        d = f, f = d.parentNode;
                    }
                    d = m;
                }
                n = a === -1 || l === -1 ? null : {
                    start: a,
                    end: l
                };
            } else n = null;
        }
        n = n || {
            start: 0,
            end: 0
        };
    } else n = null;
    for($2a051a86cb6e4743$var$Cl = {
        focusedElem: e,
        selectionRange: n
    }, $2a051a86cb6e4743$var$ao = !1, $2a051a86cb6e4743$var$$ = t; $2a051a86cb6e4743$var$$ !== null;)if (t = $2a051a86cb6e4743$var$$, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, $2a051a86cb6e4743$var$$ = e;
    else for(; $2a051a86cb6e4743$var$$ !== null;){
        t = $2a051a86cb6e4743$var$$;
        try {
            var v = t.alternate;
            if (t.flags & 1024) switch(t.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (v !== null) {
                        var y = v.memoizedProps, k = v.memoizedState, p = t.stateNode, h = p.getSnapshotBeforeUpdate(t.elementType === t.type ? y : $2a051a86cb6e4743$var$lt(t.type, y), k);
                        p.__reactInternalSnapshotBeforeUpdate = h;
                    }
                    break;
                case 3:
                    var g = t.stateNode.containerInfo;
                    g.nodeType === 1 ? g.textContent = "" : g.nodeType === 9 && g.documentElement && g.removeChild(g.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($2a051a86cb6e4743$var$j(163));
            }
        } catch (E) {
            $2a051a86cb6e4743$var$de(t, t.return, E);
        }
        if (e = t.sibling, e !== null) {
            e.return = t.return, $2a051a86cb6e4743$var$$ = e;
            break;
        }
        $2a051a86cb6e4743$var$$ = t.return;
    }
    return v = $2a051a86cb6e4743$var$Af, $2a051a86cb6e4743$var$Af = !1, v;
}
function $2a051a86cb6e4743$var$wi(e, t, n) {
    var r = t.updateQueue;
    if (r = r !== null ? r.lastEffect : null, r !== null) {
        var i1 = r = r.next;
        do {
            if ((i1.tag & e) === e) {
                var s = i1.destroy;
                i1.destroy = void 0, s !== void 0 && $2a051a86cb6e4743$var$Ml(t, n, s);
            }
            i1 = i1.next;
        }while (i1 !== r);
    }
}
function $2a051a86cb6e4743$var$Wo(e, t) {
    if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
        var n = t = t.next;
        do {
            if ((n.tag & e) === e) {
                var r = n.create;
                n.destroy = r();
            }
            n = n.next;
        }while (n !== t);
    }
}
function $2a051a86cb6e4743$var$Ul(e) {
    var t = e.ref;
    if (t !== null) {
        var n = e.stateNode;
        switch(e.tag){
            case 5:
                e = n;
                break;
            default:
                e = n;
        }
        typeof t == "function" ? t(e) : t.current = e;
    }
}
function $2a051a86cb6e4743$var$eg(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, $2a051a86cb6e4743$var$eg(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[$2a051a86cb6e4743$var$kt], delete t[$2a051a86cb6e4743$var$$i], delete t[$2a051a86cb6e4743$var$Pl], delete t[$2a051a86cb6e4743$var$E1], delete t[$2a051a86cb6e4743$var$k1])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function $2a051a86cb6e4743$var$tg(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function $2a051a86cb6e4743$var$Mf(e) {
    e: for(;;){
        for(; e.sibling === null;){
            if (e.return === null || $2a051a86cb6e4743$var$tg(e.return)) return null;
            e = e.return;
        }
        for(e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;){
            if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
            e.child.return = e, e = e.child;
        }
        if (!(e.flags & 2)) return e.stateNode;
    }
}
function $2a051a86cb6e4743$var$$l(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = $2a051a86cb6e4743$var$co));
    else if (r !== 4 && (e = e.child, e !== null)) for($2a051a86cb6e4743$var$$l(e, t, n), e = e.sibling; e !== null;)$2a051a86cb6e4743$var$$l(e, t, n), e = e.sibling;
}
function $2a051a86cb6e4743$var$zl(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
    else if (r !== 4 && (e = e.child, e !== null)) for($2a051a86cb6e4743$var$zl(e, t, n), e = e.sibling; e !== null;)$2a051a86cb6e4743$var$zl(e, t, n), e = e.sibling;
}
var $2a051a86cb6e4743$var$xe = null, $2a051a86cb6e4743$var$ft = !1;
function $2a051a86cb6e4743$var$qt(e, t, n) {
    for(n = n.child; n !== null;)$2a051a86cb6e4743$var$ng(e, t, n), n = n.sibling;
}
function $2a051a86cb6e4743$var$ng(e, t, n) {
    if ($2a051a86cb6e4743$var$bt && typeof $2a051a86cb6e4743$var$bt.onCommitFiberUnmount == "function") try {
        $2a051a86cb6e4743$var$bt.onCommitFiberUnmount($2a051a86cb6e4743$var$Uo, n);
    } catch  {}
    switch(n.tag){
        case 5:
            $2a051a86cb6e4743$var$Oe || $2a051a86cb6e4743$var$pr(n, t);
        case 6:
            var r = $2a051a86cb6e4743$var$xe, i1 = $2a051a86cb6e4743$var$ft;
            $2a051a86cb6e4743$var$xe = null, $2a051a86cb6e4743$var$qt(e, t, n), $2a051a86cb6e4743$var$xe = r, $2a051a86cb6e4743$var$ft = i1, $2a051a86cb6e4743$var$xe !== null && ($2a051a86cb6e4743$var$ft ? (e = $2a051a86cb6e4743$var$xe, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : $2a051a86cb6e4743$var$xe.removeChild(n.stateNode));
            break;
        case 18:
            $2a051a86cb6e4743$var$xe !== null && ($2a051a86cb6e4743$var$ft ? (e = $2a051a86cb6e4743$var$xe, n = n.stateNode, e.nodeType === 8 ? $2a051a86cb6e4743$var$ka(e.parentNode, n) : e.nodeType === 1 && $2a051a86cb6e4743$var$ka(e, n), $2a051a86cb6e4743$var$Fi(e)) : $2a051a86cb6e4743$var$ka($2a051a86cb6e4743$var$xe, n.stateNode));
            break;
        case 4:
            r = $2a051a86cb6e4743$var$xe, i1 = $2a051a86cb6e4743$var$ft, $2a051a86cb6e4743$var$xe = n.stateNode.containerInfo, $2a051a86cb6e4743$var$ft = !0, $2a051a86cb6e4743$var$qt(e, t, n), $2a051a86cb6e4743$var$xe = r, $2a051a86cb6e4743$var$ft = i1;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$2a051a86cb6e4743$var$Oe && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
                i1 = r = r.next;
                do {
                    var s = i1, o = s.destroy;
                    s = s.tag, o !== void 0 && (s & 2 || s & 4) && $2a051a86cb6e4743$var$Ml(n, t, o), i1 = i1.next;
                }while (i1 !== r);
            }
            $2a051a86cb6e4743$var$qt(e, t, n);
            break;
        case 1:
            if (!$2a051a86cb6e4743$var$Oe && ($2a051a86cb6e4743$var$pr(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
                r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
            } catch (a) {
                $2a051a86cb6e4743$var$de(n, t, a);
            }
            $2a051a86cb6e4743$var$qt(e, t, n);
            break;
        case 21:
            $2a051a86cb6e4743$var$qt(e, t, n);
            break;
        case 22:
            n.mode & 1 ? ($2a051a86cb6e4743$var$Oe = (r = $2a051a86cb6e4743$var$Oe) || n.memoizedState !== null, $2a051a86cb6e4743$var$qt(e, t, n), $2a051a86cb6e4743$var$Oe = r) : $2a051a86cb6e4743$var$qt(e, t, n);
            break;
        default:
            $2a051a86cb6e4743$var$qt(e, t, n);
    }
}
function $2a051a86cb6e4743$var$Uf(e) {
    var t = e.updateQueue;
    if (t !== null) {
        e.updateQueue = null;
        var n = e.stateNode;
        n === null && (n = e.stateNode = new $2a051a86cb6e4743$var$$1), t.forEach(function(r) {
            var i1 = $2a051a86cb6e4743$var$G1.bind(null, e, r);
            n.has(r) || (n.add(r), r.then(i1, i1));
        });
    }
}
function $2a051a86cb6e4743$var$at(e, t) {
    var n = t.deletions;
    if (n !== null) for(var r = 0; r < n.length; r++){
        var i1 = n[r];
        try {
            var s = e, o = t, a = o;
            e: for(; a !== null;){
                switch(a.tag){
                    case 5:
                        $2a051a86cb6e4743$var$xe = a.stateNode, $2a051a86cb6e4743$var$ft = !1;
                        break e;
                    case 3:
                        $2a051a86cb6e4743$var$xe = a.stateNode.containerInfo, $2a051a86cb6e4743$var$ft = !0;
                        break e;
                    case 4:
                        $2a051a86cb6e4743$var$xe = a.stateNode.containerInfo, $2a051a86cb6e4743$var$ft = !0;
                        break e;
                }
                a = a.return;
            }
            if ($2a051a86cb6e4743$var$xe === null) throw Error($2a051a86cb6e4743$var$j(160));
            $2a051a86cb6e4743$var$ng(s, o, i1), $2a051a86cb6e4743$var$xe = null, $2a051a86cb6e4743$var$ft = !1;
            var l = i1.alternate;
            l !== null && (l.return = null), i1.return = null;
        } catch (u) {
            $2a051a86cb6e4743$var$de(i1, t, u);
        }
    }
    if (t.subtreeFlags & 12854) for(t = t.child; t !== null;)$2a051a86cb6e4743$var$rg(t, e), t = t.sibling;
}
function $2a051a86cb6e4743$var$rg(e, t) {
    var n = e.alternate, r = e.flags;
    switch(e.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if ($2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), r & 4) {
                try {
                    $2a051a86cb6e4743$var$wi(3, e, e.return), $2a051a86cb6e4743$var$Wo(3, e);
                } catch (y) {
                    $2a051a86cb6e4743$var$de(e, e.return, y);
                }
                try {
                    $2a051a86cb6e4743$var$wi(5, e, e.return);
                } catch (y) {
                    $2a051a86cb6e4743$var$de(e, e.return, y);
                }
            }
            break;
        case 1:
            $2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), r & 512 && n !== null && $2a051a86cb6e4743$var$pr(n, n.return);
            break;
        case 5:
            if ($2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), r & 512 && n !== null && $2a051a86cb6e4743$var$pr(n, n.return), e.flags & 32) {
                var i1 = e.stateNode;
                try {
                    $2a051a86cb6e4743$var$Li(i1, "");
                } catch (y) {
                    $2a051a86cb6e4743$var$de(e, e.return, y);
                }
            }
            if (r & 4 && (i1 = e.stateNode, i1 != null)) {
                var s = e.memoizedProps, o = n !== null ? n.memoizedProps : s, a = e.type, l = e.updateQueue;
                if (e.updateQueue = null, l !== null) try {
                    a === "input" && s.type === "radio" && s.name != null && $2a051a86cb6e4743$var$Ph(i1, s), $2a051a86cb6e4743$var$fl(a, o);
                    var u = $2a051a86cb6e4743$var$fl(a, s);
                    for(o = 0; o < l.length; o += 2){
                        var c = l[o], d = l[o + 1];
                        c === "style" ? $2a051a86cb6e4743$var$Th(i1, d) : c === "dangerouslySetInnerHTML" ? $2a051a86cb6e4743$var$Oh(i1, d) : c === "children" ? $2a051a86cb6e4743$var$Li(i1, d) : $2a051a86cb6e4743$var$lu(i1, c, d, u);
                    }
                    switch(a){
                        case "input":
                            $2a051a86cb6e4743$var$ol(i1, s);
                            break;
                        case "textarea":
                            $2a051a86cb6e4743$var$_h(i1, s);
                            break;
                        case "select":
                            var f = i1._wrapperState.wasMultiple;
                            i1._wrapperState.wasMultiple = !!s.multiple;
                            var m = s.value;
                            m != null ? $2a051a86cb6e4743$var$vr(i1, !!s.multiple, m, !1) : f !== !!s.multiple && (s.defaultValue != null ? $2a051a86cb6e4743$var$vr(i1, !!s.multiple, s.defaultValue, !0) : $2a051a86cb6e4743$var$vr(i1, !!s.multiple, s.multiple ? [] : "", !1));
                    }
                    i1[$2a051a86cb6e4743$var$$i] = s;
                } catch (y) {
                    $2a051a86cb6e4743$var$de(e, e.return, y);
                }
            }
            break;
        case 6:
            if ($2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), r & 4) {
                if (e.stateNode === null) throw Error($2a051a86cb6e4743$var$j(162));
                i1 = e.stateNode, s = e.memoizedProps;
                try {
                    i1.nodeValue = s;
                } catch (y) {
                    $2a051a86cb6e4743$var$de(e, e.return, y);
                }
            }
            break;
        case 3:
            if ($2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
                $2a051a86cb6e4743$var$Fi(t.containerInfo);
            } catch (y) {
                $2a051a86cb6e4743$var$de(e, e.return, y);
            }
            break;
        case 4:
            $2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e);
            break;
        case 13:
            $2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), i1 = e.child, i1.flags & 8192 && (s = i1.memoizedState !== null, i1.stateNode.isHidden = s, !s || i1.alternate !== null && i1.alternate.memoizedState !== null || ($2a051a86cb6e4743$var$zu = $2a051a86cb6e4743$var$pe())), r & 4 && $2a051a86cb6e4743$var$Uf(e);
            break;
        case 22:
            if (c = n !== null && n.memoizedState !== null, e.mode & 1 ? ($2a051a86cb6e4743$var$Oe = (u = $2a051a86cb6e4743$var$Oe) || c, $2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$Oe = u) : $2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), r & 8192) {
                if (u = e.memoizedState !== null, (e.stateNode.isHidden = u) && !c && e.mode & 1) for($2a051a86cb6e4743$var$$ = e, c = e.child; c !== null;){
                    for(d = $2a051a86cb6e4743$var$$ = c; $2a051a86cb6e4743$var$$ !== null;){
                        switch(f = $2a051a86cb6e4743$var$$, m = f.child, f.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $2a051a86cb6e4743$var$wi(4, f, f.return);
                                break;
                            case 1:
                                $2a051a86cb6e4743$var$pr(f, f.return);
                                var v = f.stateNode;
                                if (typeof v.componentWillUnmount == "function") {
                                    r = f, n = f.return;
                                    try {
                                        t = r, v.props = t.memoizedProps, v.state = t.memoizedState, v.componentWillUnmount();
                                    } catch (y) {
                                        $2a051a86cb6e4743$var$de(r, n, y);
                                    }
                                }
                                break;
                            case 5:
                                $2a051a86cb6e4743$var$pr(f, f.return);
                                break;
                            case 22:
                                if (f.memoizedState !== null) {
                                    $2a051a86cb6e4743$var$zf(d);
                                    continue;
                                }
                        }
                        m !== null ? (m.return = f, $2a051a86cb6e4743$var$$ = m) : $2a051a86cb6e4743$var$zf(d);
                    }
                    c = c.sibling;
                }
                e: for(c = null, d = e;;){
                    if (d.tag === 5) {
                        if (c === null) {
                            c = d;
                            try {
                                i1 = d.stateNode, u ? (s = i1.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none") : (a = d.stateNode, l = d.memoizedProps.style, o = l != null && l.hasOwnProperty("display") ? l.display : null, a.style.display = $2a051a86cb6e4743$var$Nh("display", o));
                            } catch (y) {
                                $2a051a86cb6e4743$var$de(e, e.return, y);
                            }
                        }
                    } else if (d.tag === 6) {
                        if (c === null) try {
                            d.stateNode.nodeValue = u ? "" : d.memoizedProps;
                        } catch (y) {
                            $2a051a86cb6e4743$var$de(e, e.return, y);
                        }
                    } else if ((d.tag !== 22 && d.tag !== 23 || d.memoizedState === null || d === e) && d.child !== null) {
                        d.child.return = d, d = d.child;
                        continue;
                    }
                    if (d === e) break e;
                    for(; d.sibling === null;){
                        if (d.return === null || d.return === e) break e;
                        c === d && (c = null), d = d.return;
                    }
                    c === d && (c = null), d.sibling.return = d.return, d = d.sibling;
                }
            }
            break;
        case 19:
            $2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e), r & 4 && $2a051a86cb6e4743$var$Uf(e);
            break;
        case 21:
            break;
        default:
            $2a051a86cb6e4743$var$at(t, e), $2a051a86cb6e4743$var$yt(e);
    }
}
function $2a051a86cb6e4743$var$yt(e) {
    var t = e.flags;
    if (t & 2) {
        try {
            e: {
                for(var n = e.return; n !== null;){
                    if ($2a051a86cb6e4743$var$tg(n)) {
                        var r = n;
                        break e;
                    }
                    n = n.return;
                }
                throw Error($2a051a86cb6e4743$var$j(160));
            }
            switch(r.tag){
                case 5:
                    var i1 = r.stateNode;
                    r.flags & 32 && ($2a051a86cb6e4743$var$Li(i1, ""), r.flags &= -33);
                    var s = $2a051a86cb6e4743$var$Mf(e);
                    $2a051a86cb6e4743$var$zl(e, s, i1);
                    break;
                case 3:
                case 4:
                    var o = r.stateNode.containerInfo, a = $2a051a86cb6e4743$var$Mf(e);
                    $2a051a86cb6e4743$var$$l(e, a, o);
                    break;
                default:
                    throw Error($2a051a86cb6e4743$var$j(161));
            }
        } catch (l) {
            $2a051a86cb6e4743$var$de(e, e.return, l);
        }
        e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
}
function $2a051a86cb6e4743$var$B1(e, t, n) {
    $2a051a86cb6e4743$var$$ = e, $2a051a86cb6e4743$var$ig(e);
}
function $2a051a86cb6e4743$var$ig(e, t, n) {
    for(var r = (e.mode & 1) !== 0; $2a051a86cb6e4743$var$$ !== null;){
        var i1 = $2a051a86cb6e4743$var$$, s = i1.child;
        if (i1.tag === 22 && r) {
            var o = i1.memoizedState !== null || $2a051a86cb6e4743$var$Rs;
            if (!o) {
                var a = i1.alternate, l = a !== null && a.memoizedState !== null || $2a051a86cb6e4743$var$Oe;
                a = $2a051a86cb6e4743$var$Rs;
                var u = $2a051a86cb6e4743$var$Oe;
                if ($2a051a86cb6e4743$var$Rs = o, ($2a051a86cb6e4743$var$Oe = l) && !u) for($2a051a86cb6e4743$var$$ = i1; $2a051a86cb6e4743$var$$ !== null;)o = $2a051a86cb6e4743$var$$, l = o.child, o.tag === 22 && o.memoizedState !== null ? $2a051a86cb6e4743$var$Bf(i1) : l !== null ? (l.return = o, $2a051a86cb6e4743$var$$ = l) : $2a051a86cb6e4743$var$Bf(i1);
                for(; s !== null;)$2a051a86cb6e4743$var$$ = s, $2a051a86cb6e4743$var$ig(s), s = s.sibling;
                $2a051a86cb6e4743$var$$ = i1, $2a051a86cb6e4743$var$Rs = a, $2a051a86cb6e4743$var$Oe = u;
            }
            $2a051a86cb6e4743$var$$f(e);
        } else i1.subtreeFlags & 8772 && s !== null ? (s.return = i1, $2a051a86cb6e4743$var$$ = s) : $2a051a86cb6e4743$var$$f(e);
    }
}
function $2a051a86cb6e4743$var$$f(e) {
    for(; $2a051a86cb6e4743$var$$ !== null;){
        var t = $2a051a86cb6e4743$var$$;
        if (t.flags & 8772) {
            var n = t.alternate;
            try {
                if (t.flags & 8772) switch(t.tag){
                    case 0:
                    case 11:
                    case 15:
                        $2a051a86cb6e4743$var$Oe || $2a051a86cb6e4743$var$Wo(5, t);
                        break;
                    case 1:
                        var r = t.stateNode;
                        if (t.flags & 4 && !$2a051a86cb6e4743$var$Oe) {
                            if (n === null) r.componentDidMount();
                            else {
                                var i1 = t.elementType === t.type ? n.memoizedProps : $2a051a86cb6e4743$var$lt(t.type, n.memoizedProps);
                                r.componentDidUpdate(i1, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var s = t.updateQueue;
                        s !== null && $2a051a86cb6e4743$var$kf(t, s, r);
                        break;
                    case 3:
                        var o = t.updateQueue;
                        if (o !== null) {
                            if (n = null, t.child !== null) switch(t.child.tag){
                                case 5:
                                    n = t.child.stateNode;
                                    break;
                                case 1:
                                    n = t.child.stateNode;
                            }
                            $2a051a86cb6e4743$var$kf(t, o, n);
                        }
                        break;
                    case 5:
                        var a = t.stateNode;
                        if (n === null && t.flags & 4) {
                            n = a;
                            var l = t.memoizedProps;
                            switch(t.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    l.autoFocus && n.focus();
                                    break;
                                case "img":
                                    l.src && (n.src = l.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (t.memoizedState === null) {
                            var u = t.alternate;
                            if (u !== null) {
                                var c = u.memoizedState;
                                if (c !== null) {
                                    var d = c.dehydrated;
                                    d !== null && $2a051a86cb6e4743$var$Fi(d);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($2a051a86cb6e4743$var$j(163));
                }
                $2a051a86cb6e4743$var$Oe || t.flags & 512 && $2a051a86cb6e4743$var$Ul(t);
            } catch (f) {
                $2a051a86cb6e4743$var$de(t, t.return, f);
            }
        }
        if (t === e) {
            $2a051a86cb6e4743$var$$ = null;
            break;
        }
        if (n = t.sibling, n !== null) {
            n.return = t.return, $2a051a86cb6e4743$var$$ = n;
            break;
        }
        $2a051a86cb6e4743$var$$ = t.return;
    }
}
function $2a051a86cb6e4743$var$zf(e) {
    for(; $2a051a86cb6e4743$var$$ !== null;){
        var t = $2a051a86cb6e4743$var$$;
        if (t === e) {
            $2a051a86cb6e4743$var$$ = null;
            break;
        }
        var n = t.sibling;
        if (n !== null) {
            n.return = t.return, $2a051a86cb6e4743$var$$ = n;
            break;
        }
        $2a051a86cb6e4743$var$$ = t.return;
    }
}
function $2a051a86cb6e4743$var$Bf(e) {
    for(; $2a051a86cb6e4743$var$$ !== null;){
        var t = $2a051a86cb6e4743$var$$;
        try {
            switch(t.tag){
                case 0:
                case 11:
                case 15:
                    var n = t.return;
                    try {
                        $2a051a86cb6e4743$var$Wo(4, t);
                    } catch (l) {
                        $2a051a86cb6e4743$var$de(t, n, l);
                    }
                    break;
                case 1:
                    var r = t.stateNode;
                    if (typeof r.componentDidMount == "function") {
                        var i1 = t.return;
                        try {
                            r.componentDidMount();
                        } catch (l) {
                            $2a051a86cb6e4743$var$de(t, i1, l);
                        }
                    }
                    var s = t.return;
                    try {
                        $2a051a86cb6e4743$var$Ul(t);
                    } catch (l) {
                        $2a051a86cb6e4743$var$de(t, s, l);
                    }
                    break;
                case 5:
                    var o = t.return;
                    try {
                        $2a051a86cb6e4743$var$Ul(t);
                    } catch (l) {
                        $2a051a86cb6e4743$var$de(t, o, l);
                    }
            }
        } catch (l) {
            $2a051a86cb6e4743$var$de(t, t.return, l);
        }
        if (t === e) {
            $2a051a86cb6e4743$var$$ = null;
            break;
        }
        var a = t.sibling;
        if (a !== null) {
            a.return = t.return, $2a051a86cb6e4743$var$$ = a;
            break;
        }
        $2a051a86cb6e4743$var$$ = t.return;
    }
}
var $2a051a86cb6e4743$var$H1 = Math.ceil, $2a051a86cb6e4743$var$Co = $2a051a86cb6e4743$var$Ht.ReactCurrentDispatcher, $2a051a86cb6e4743$var$Uu = $2a051a86cb6e4743$var$Ht.ReactCurrentOwner, $2a051a86cb6e4743$var$rt = $2a051a86cb6e4743$var$Ht.ReactCurrentBatchConfig, $2a051a86cb6e4743$var$Z = 0, $2a051a86cb6e4743$var$we = null, $2a051a86cb6e4743$var$ge = null, $2a051a86cb6e4743$var$Ee = 0, $2a051a86cb6e4743$var$Ve = 0, $2a051a86cb6e4743$var$gr = $2a051a86cb6e4743$var$kn(0), $2a051a86cb6e4743$var$ve = 0, $2a051a86cb6e4743$var$Ki = null, $2a051a86cb6e4743$var$Gn = 0, $2a051a86cb6e4743$var$Yo = 0, $2a051a86cb6e4743$var$$u = 0, $2a051a86cb6e4743$var$xi = null, $2a051a86cb6e4743$var$Me = null, $2a051a86cb6e4743$var$zu = 0, $2a051a86cb6e4743$var$Qr = 1 / 0, $2a051a86cb6e4743$var$jt = null, $2a051a86cb6e4743$var$Eo = !1, $2a051a86cb6e4743$var$Bl = null, $2a051a86cb6e4743$var$yn = null, $2a051a86cb6e4743$var$js = !1, $2a051a86cb6e4743$var$fn = null, $2a051a86cb6e4743$var$ko = 0, $2a051a86cb6e4743$var$Ci = 0, $2a051a86cb6e4743$var$Hl = null, $2a051a86cb6e4743$var$Ws = -1, $2a051a86cb6e4743$var$Ys = 0;
function $2a051a86cb6e4743$var$Ie() {
    return $2a051a86cb6e4743$var$Z & 6 ? $2a051a86cb6e4743$var$pe() : $2a051a86cb6e4743$var$Ws !== -1 ? $2a051a86cb6e4743$var$Ws : $2a051a86cb6e4743$var$Ws = $2a051a86cb6e4743$var$pe();
}
function $2a051a86cb6e4743$var$vn(e) {
    return e.mode & 1 ? $2a051a86cb6e4743$var$Z & 2 && $2a051a86cb6e4743$var$Ee !== 0 ? $2a051a86cb6e4743$var$Ee & -$2a051a86cb6e4743$var$Ee : $2a051a86cb6e4743$var$_1.transition !== null ? ($2a051a86cb6e4743$var$Ys === 0 && ($2a051a86cb6e4743$var$Ys = $2a051a86cb6e4743$var$Bh()), $2a051a86cb6e4743$var$Ys) : (e = $2a051a86cb6e4743$var$ee, e !== 0 || (e = window.event, e = e === void 0 ? 16 : $2a051a86cb6e4743$var$qh(e.type)), e) : 1;
}
function $2a051a86cb6e4743$var$gt(e, t, n, r) {
    if (50 < $2a051a86cb6e4743$var$Ci) throw $2a051a86cb6e4743$var$Ci = 0, $2a051a86cb6e4743$var$Hl = null, Error($2a051a86cb6e4743$var$j(185));
    $2a051a86cb6e4743$var$as(e, n, r), (!($2a051a86cb6e4743$var$Z & 2) || e !== $2a051a86cb6e4743$var$we) && (e === $2a051a86cb6e4743$var$we && (!($2a051a86cb6e4743$var$Z & 2) && ($2a051a86cb6e4743$var$Yo |= n), $2a051a86cb6e4743$var$ve === 4 && $2a051a86cb6e4743$var$tn(e, $2a051a86cb6e4743$var$Ee)), $2a051a86cb6e4743$var$Be(e, r), n === 1 && $2a051a86cb6e4743$var$Z === 0 && !(t.mode & 1) && ($2a051a86cb6e4743$var$Qr = $2a051a86cb6e4743$var$pe() + 500, $2a051a86cb6e4743$var$Vo && $2a051a86cb6e4743$var$Pn()));
}
function $2a051a86cb6e4743$var$Be(e, t) {
    var n = e.callbackNode;
    $2a051a86cb6e4743$var$_0(e, t);
    var r = $2a051a86cb6e4743$var$oo(e, e === $2a051a86cb6e4743$var$we ? $2a051a86cb6e4743$var$Ee : 0);
    if (r === 0) n !== null && $2a051a86cb6e4743$var$Gc(n), e.callbackNode = null, e.callbackPriority = 0;
    else if (t = r & -r, e.callbackPriority !== t) {
        if (n != null && $2a051a86cb6e4743$var$Gc(n), t === 1) e.tag === 0 ? $2a051a86cb6e4743$var$P1($2a051a86cb6e4743$var$Hf.bind(null, e)) : $2a051a86cb6e4743$var$pp($2a051a86cb6e4743$var$Hf.bind(null, e)), $2a051a86cb6e4743$var$x1(function() {
            !($2a051a86cb6e4743$var$Z & 6) && $2a051a86cb6e4743$var$Pn();
        }), n = null;
        else {
            switch($2a051a86cb6e4743$var$Hh(r)){
                case 1:
                    n = $2a051a86cb6e4743$var$hu;
                    break;
                case 4:
                    n = $2a051a86cb6e4743$var$$h;
                    break;
                case 16:
                    n = $2a051a86cb6e4743$var$so;
                    break;
                case 536870912:
                    n = $2a051a86cb6e4743$var$zh;
                    break;
                default:
                    n = $2a051a86cb6e4743$var$so;
            }
            n = $2a051a86cb6e4743$var$dg(n, $2a051a86cb6e4743$var$sg.bind(null, e));
        }
        e.callbackPriority = t, e.callbackNode = n;
    }
}
function $2a051a86cb6e4743$var$sg(e, t) {
    if ($2a051a86cb6e4743$var$Ws = -1, $2a051a86cb6e4743$var$Ys = 0, $2a051a86cb6e4743$var$Z & 6) throw Error($2a051a86cb6e4743$var$j(327));
    var n = e.callbackNode;
    if ($2a051a86cb6e4743$var$Er() && e.callbackNode !== n) return null;
    var r = $2a051a86cb6e4743$var$oo(e, e === $2a051a86cb6e4743$var$we ? $2a051a86cb6e4743$var$Ee : 0);
    if (r === 0) return null;
    if (r & 30 || r & e.expiredLanes || t) t = $2a051a86cb6e4743$var$Po(e, r);
    else {
        t = r;
        var i1 = $2a051a86cb6e4743$var$Z;
        $2a051a86cb6e4743$var$Z |= 2;
        var s = $2a051a86cb6e4743$var$ag();
        ($2a051a86cb6e4743$var$we !== e || $2a051a86cb6e4743$var$Ee !== t) && ($2a051a86cb6e4743$var$jt = null, $2a051a86cb6e4743$var$Qr = $2a051a86cb6e4743$var$pe() + 500, $2a051a86cb6e4743$var$Hn(e, t));
        for(;;)try {
            $2a051a86cb6e4743$var$K1();
            break;
        } catch (a) {
            $2a051a86cb6e4743$var$og(e, a);
        }
        $2a051a86cb6e4743$var$_u(), $2a051a86cb6e4743$var$Co.current = s, $2a051a86cb6e4743$var$Z = i1, $2a051a86cb6e4743$var$ge !== null ? t = 0 : ($2a051a86cb6e4743$var$we = null, $2a051a86cb6e4743$var$Ee = 0, t = $2a051a86cb6e4743$var$ve);
    }
    if (t !== 0) {
        if (t === 2 && (i1 = $2a051a86cb6e4743$var$ml(e), i1 !== 0 && (r = i1, t = $2a051a86cb6e4743$var$Vl(e, i1))), t === 1) throw n = $2a051a86cb6e4743$var$Ki, $2a051a86cb6e4743$var$Hn(e, 0), $2a051a86cb6e4743$var$tn(e, r), $2a051a86cb6e4743$var$Be(e, $2a051a86cb6e4743$var$pe()), n;
        if (t === 6) $2a051a86cb6e4743$var$tn(e, r);
        else {
            if (i1 = e.current.alternate, !(r & 30) && !$2a051a86cb6e4743$var$V1(i1) && (t = $2a051a86cb6e4743$var$Po(e, r), t === 2 && (s = $2a051a86cb6e4743$var$ml(e), s !== 0 && (r = s, t = $2a051a86cb6e4743$var$Vl(e, s))), t === 1)) throw n = $2a051a86cb6e4743$var$Ki, $2a051a86cb6e4743$var$Hn(e, 0), $2a051a86cb6e4743$var$tn(e, r), $2a051a86cb6e4743$var$Be(e, $2a051a86cb6e4743$var$pe()), n;
            switch(e.finishedWork = i1, e.finishedLanes = r, t){
                case 0:
                case 1:
                    throw Error($2a051a86cb6e4743$var$j(345));
                case 2:
                    $2a051a86cb6e4743$var$Nn(e, $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$jt);
                    break;
                case 3:
                    if ($2a051a86cb6e4743$var$tn(e, r), (r & 130023424) === r && (t = $2a051a86cb6e4743$var$zu + 500 - $2a051a86cb6e4743$var$pe(), 10 < t)) {
                        if ($2a051a86cb6e4743$var$oo(e, 0) !== 0) break;
                        if (i1 = e.suspendedLanes, (i1 & r) !== r) {
                            $2a051a86cb6e4743$var$Ie(), e.pingedLanes |= e.suspendedLanes & i1;
                            break;
                        }
                        e.timeoutHandle = $2a051a86cb6e4743$var$kl($2a051a86cb6e4743$var$Nn.bind(null, e, $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$jt), t);
                        break;
                    }
                    $2a051a86cb6e4743$var$Nn(e, $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$jt);
                    break;
                case 4:
                    if ($2a051a86cb6e4743$var$tn(e, r), (r & 4194240) === r) break;
                    for(t = e.eventTimes, i1 = -1; 0 < r;){
                        var o = 31 - $2a051a86cb6e4743$var$pt(r);
                        s = 1 << o, o = t[o], o > i1 && (i1 = o), r &= ~s;
                    }
                    if (r = i1, r = $2a051a86cb6e4743$var$pe() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * $2a051a86cb6e4743$var$H1(r / 1960)) - r, 10 < r) {
                        e.timeoutHandle = $2a051a86cb6e4743$var$kl($2a051a86cb6e4743$var$Nn.bind(null, e, $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$jt), r);
                        break;
                    }
                    $2a051a86cb6e4743$var$Nn(e, $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$jt);
                    break;
                case 5:
                    $2a051a86cb6e4743$var$Nn(e, $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$jt);
                    break;
                default:
                    throw Error($2a051a86cb6e4743$var$j(329));
            }
        }
    }
    return $2a051a86cb6e4743$var$Be(e, $2a051a86cb6e4743$var$pe()), e.callbackNode === n ? $2a051a86cb6e4743$var$sg.bind(null, e) : null;
}
function $2a051a86cb6e4743$var$Vl(e, t) {
    var n = $2a051a86cb6e4743$var$xi;
    return e.current.memoizedState.isDehydrated && ($2a051a86cb6e4743$var$Hn(e, t).flags |= 256), e = $2a051a86cb6e4743$var$Po(e, t), e !== 2 && (t = $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$Me = n, t !== null && $2a051a86cb6e4743$var$Ql(t)), e;
}
function $2a051a86cb6e4743$var$Ql(e) {
    $2a051a86cb6e4743$var$Me === null ? $2a051a86cb6e4743$var$Me = e : $2a051a86cb6e4743$var$Me.push.apply($2a051a86cb6e4743$var$Me, e);
}
function $2a051a86cb6e4743$var$V1(e) {
    for(var t = e;;){
        if (t.flags & 16384) {
            var n = t.updateQueue;
            if (n !== null && (n = n.stores, n !== null)) for(var r = 0; r < n.length; r++){
                var i1 = n[r], s = i1.getSnapshot;
                i1 = i1.value;
                try {
                    if (!$2a051a86cb6e4743$var$mt(s(), i1)) return !1;
                } catch  {
                    return !1;
                }
            }
        }
        if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
        else {
            if (t === e) break;
            for(; t.sibling === null;){
                if (t.return === null || t.return === e) return !0;
                t = t.return;
            }
            t.sibling.return = t.return, t = t.sibling;
        }
    }
    return !0;
}
function $2a051a86cb6e4743$var$tn(e, t) {
    for(t &= ~$2a051a86cb6e4743$var$$u, t &= ~$2a051a86cb6e4743$var$Yo, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t;){
        var n = 31 - $2a051a86cb6e4743$var$pt(t), r = 1 << n;
        e[n] = -1, t &= ~r;
    }
}
function $2a051a86cb6e4743$var$Hf(e) {
    if ($2a051a86cb6e4743$var$Z & 6) throw Error($2a051a86cb6e4743$var$j(327));
    $2a051a86cb6e4743$var$Er();
    var t = $2a051a86cb6e4743$var$oo(e, 0);
    if (!(t & 1)) return $2a051a86cb6e4743$var$Be(e, $2a051a86cb6e4743$var$pe()), null;
    var n = $2a051a86cb6e4743$var$Po(e, t);
    if (e.tag !== 0 && n === 2) {
        var r = $2a051a86cb6e4743$var$ml(e);
        r !== 0 && (t = r, n = $2a051a86cb6e4743$var$Vl(e, r));
    }
    if (n === 1) throw n = $2a051a86cb6e4743$var$Ki, $2a051a86cb6e4743$var$Hn(e, 0), $2a051a86cb6e4743$var$tn(e, t), $2a051a86cb6e4743$var$Be(e, $2a051a86cb6e4743$var$pe()), n;
    if (n === 6) throw Error($2a051a86cb6e4743$var$j(345));
    return e.finishedWork = e.current.alternate, e.finishedLanes = t, $2a051a86cb6e4743$var$Nn(e, $2a051a86cb6e4743$var$Me, $2a051a86cb6e4743$var$jt), $2a051a86cb6e4743$var$Be(e, $2a051a86cb6e4743$var$pe()), null;
}
function $2a051a86cb6e4743$var$Bu(e, t) {
    var n = $2a051a86cb6e4743$var$Z;
    $2a051a86cb6e4743$var$Z |= 1;
    try {
        return e(t);
    } finally{
        $2a051a86cb6e4743$var$Z = n, $2a051a86cb6e4743$var$Z === 0 && ($2a051a86cb6e4743$var$Qr = $2a051a86cb6e4743$var$pe() + 500, $2a051a86cb6e4743$var$Vo && $2a051a86cb6e4743$var$Pn());
    }
}
function $2a051a86cb6e4743$var$Xn(e) {
    $2a051a86cb6e4743$var$fn !== null && $2a051a86cb6e4743$var$fn.tag === 0 && !($2a051a86cb6e4743$var$Z & 6) && $2a051a86cb6e4743$var$Er();
    var t = $2a051a86cb6e4743$var$Z;
    $2a051a86cb6e4743$var$Z |= 1;
    var n = $2a051a86cb6e4743$var$rt.transition, r = $2a051a86cb6e4743$var$ee;
    try {
        if ($2a051a86cb6e4743$var$rt.transition = null, $2a051a86cb6e4743$var$ee = 1, e) return e();
    } finally{
        $2a051a86cb6e4743$var$ee = r, $2a051a86cb6e4743$var$rt.transition = n, $2a051a86cb6e4743$var$Z = t, !($2a051a86cb6e4743$var$Z & 6) && $2a051a86cb6e4743$var$Pn();
    }
}
function $2a051a86cb6e4743$var$Hu() {
    $2a051a86cb6e4743$var$Ve = $2a051a86cb6e4743$var$gr.current, $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$gr);
}
function $2a051a86cb6e4743$var$Hn(e, t) {
    e.finishedWork = null, e.finishedLanes = 0;
    var n = e.timeoutHandle;
    if (n !== -1 && (e.timeoutHandle = -1, $2a051a86cb6e4743$var$w1(n)), $2a051a86cb6e4743$var$ge !== null) for(n = $2a051a86cb6e4743$var$ge.return; n !== null;){
        var r = n;
        switch($2a051a86cb6e4743$var$Eu(r), r.tag){
            case 1:
                r = r.type.childContextTypes, r != null && $2a051a86cb6e4743$var$fo();
                break;
            case 3:
                $2a051a86cb6e4743$var$Hr(), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$$e), $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$Ne), $2a051a86cb6e4743$var$Ru();
                break;
            case 5:
                $2a051a86cb6e4743$var$Lu(r);
                break;
            case 4:
                $2a051a86cb6e4743$var$Hr();
                break;
            case 13:
                $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$ae);
                break;
            case 19:
                $2a051a86cb6e4743$var$re($2a051a86cb6e4743$var$ae);
                break;
            case 10:
                $2a051a86cb6e4743$var$bu(r.type._context);
                break;
            case 22:
            case 23:
                $2a051a86cb6e4743$var$Hu();
        }
        n = n.return;
    }
    if ($2a051a86cb6e4743$var$we = e, $2a051a86cb6e4743$var$ge = e = $2a051a86cb6e4743$var$Sn(e.current, null), $2a051a86cb6e4743$var$Ee = $2a051a86cb6e4743$var$Ve = t, $2a051a86cb6e4743$var$ve = 0, $2a051a86cb6e4743$var$Ki = null, $2a051a86cb6e4743$var$$u = $2a051a86cb6e4743$var$Yo = $2a051a86cb6e4743$var$Gn = 0, $2a051a86cb6e4743$var$Me = $2a051a86cb6e4743$var$xi = null, $2a051a86cb6e4743$var$Ln !== null) {
        for(t = 0; t < $2a051a86cb6e4743$var$Ln.length; t++)if (n = $2a051a86cb6e4743$var$Ln[t], r = n.interleaved, r !== null) {
            n.interleaved = null;
            var i1 = r.next, s = n.pending;
            if (s !== null) {
                var o = s.next;
                s.next = i1, r.next = o;
            }
            n.pending = r;
        }
        $2a051a86cb6e4743$var$Ln = null;
    }
    return e;
}
function $2a051a86cb6e4743$var$og(e, t) {
    do {
        var n = $2a051a86cb6e4743$var$ge;
        try {
            if ($2a051a86cb6e4743$var$_u(), $2a051a86cb6e4743$var$Vs.current = $2a051a86cb6e4743$var$xo, $2a051a86cb6e4743$var$wo) {
                for(var r = $2a051a86cb6e4743$var$ue.memoizedState; r !== null;){
                    var i1 = r.queue;
                    i1 !== null && (i1.pending = null), r = r.next;
                }
                $2a051a86cb6e4743$var$wo = !1;
            }
            if ($2a051a86cb6e4743$var$qn = 0, $2a051a86cb6e4743$var$Se = $2a051a86cb6e4743$var$ye = $2a051a86cb6e4743$var$ue = null, $2a051a86cb6e4743$var$Si = !1, $2a051a86cb6e4743$var$Hi = 0, $2a051a86cb6e4743$var$Uu.current = null, n === null || n.return === null) {
                $2a051a86cb6e4743$var$ve = 1, $2a051a86cb6e4743$var$Ki = t, $2a051a86cb6e4743$var$ge = null;
                break;
            }
            e: {
                var s = e, o = n.return, a = n, l = t;
                if (t = $2a051a86cb6e4743$var$Ee, a.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
                    var u = l, c = a, d = c.tag;
                    if (!(c.mode & 1) && (d === 0 || d === 11 || d === 15)) {
                        var f = c.alternate;
                        f ? (c.updateQueue = f.updateQueue, c.memoizedState = f.memoizedState, c.lanes = f.lanes) : (c.updateQueue = null, c.memoizedState = null);
                    }
                    var m = $2a051a86cb6e4743$var$Tf(o);
                    if (m !== null) {
                        m.flags &= -257, $2a051a86cb6e4743$var$Lf(m, o, a, s, t), m.mode & 1 && $2a051a86cb6e4743$var$Nf(s, u, t), t = m, l = u;
                        var v = t.updateQueue;
                        if (v === null) {
                            var y = new Set;
                            y.add(l), t.updateQueue = y;
                        } else v.add(l);
                        break e;
                    } else {
                        if (!(t & 1)) {
                            $2a051a86cb6e4743$var$Nf(s, u, t), $2a051a86cb6e4743$var$Vu();
                            break e;
                        }
                        l = Error($2a051a86cb6e4743$var$j(426));
                    }
                } else if ($2a051a86cb6e4743$var$se && a.mode & 1) {
                    var k = $2a051a86cb6e4743$var$Tf(o);
                    if (k !== null) {
                        !(k.flags & 65536) && (k.flags |= 256), $2a051a86cb6e4743$var$Lf(k, o, a, s, t), $2a051a86cb6e4743$var$ku($2a051a86cb6e4743$var$Vr(l, a));
                        break e;
                    }
                }
                s = l = $2a051a86cb6e4743$var$Vr(l, a), $2a051a86cb6e4743$var$ve !== 4 && ($2a051a86cb6e4743$var$ve = 2), $2a051a86cb6e4743$var$xi === null ? $2a051a86cb6e4743$var$xi = [
                    s
                ] : $2a051a86cb6e4743$var$xi.push(s), s = o;
                do {
                    switch(s.tag){
                        case 3:
                            s.flags |= 65536, t &= -t, s.lanes |= t;
                            var p = $2a051a86cb6e4743$var$Hp(s, l, t);
                            $2a051a86cb6e4743$var$Ef(s, p);
                            break e;
                        case 1:
                            a = l;
                            var h = s.type, g = s.stateNode;
                            if (!(s.flags & 128) && (typeof h.getDerivedStateFromError == "function" || g !== null && typeof g.componentDidCatch == "function" && ($2a051a86cb6e4743$var$yn === null || !$2a051a86cb6e4743$var$yn.has(g)))) {
                                s.flags |= 65536, t &= -t, s.lanes |= t;
                                var E = $2a051a86cb6e4743$var$Vp(s, a, t);
                                $2a051a86cb6e4743$var$Ef(s, E);
                                break e;
                            }
                    }
                    s = s.return;
                }while (s !== null);
            }
            $2a051a86cb6e4743$var$ug(n);
        } catch (P) {
            t = P, $2a051a86cb6e4743$var$ge === n && n !== null && ($2a051a86cb6e4743$var$ge = n = n.return);
            continue;
        }
        break;
    }while (1);
}
function $2a051a86cb6e4743$var$ag() {
    var e = $2a051a86cb6e4743$var$Co.current;
    return $2a051a86cb6e4743$var$Co.current = $2a051a86cb6e4743$var$xo, e === null ? $2a051a86cb6e4743$var$xo : e;
}
function $2a051a86cb6e4743$var$Vu() {
    ($2a051a86cb6e4743$var$ve === 0 || $2a051a86cb6e4743$var$ve === 3 || $2a051a86cb6e4743$var$ve === 2) && ($2a051a86cb6e4743$var$ve = 4), $2a051a86cb6e4743$var$we === null || !($2a051a86cb6e4743$var$Gn & 268435455) && !($2a051a86cb6e4743$var$Yo & 268435455) || $2a051a86cb6e4743$var$tn($2a051a86cb6e4743$var$we, $2a051a86cb6e4743$var$Ee);
}
function $2a051a86cb6e4743$var$Po(e, t) {
    var n = $2a051a86cb6e4743$var$Z;
    $2a051a86cb6e4743$var$Z |= 2;
    var r = $2a051a86cb6e4743$var$ag();
    ($2a051a86cb6e4743$var$we !== e || $2a051a86cb6e4743$var$Ee !== t) && ($2a051a86cb6e4743$var$jt = null, $2a051a86cb6e4743$var$Hn(e, t));
    for(;;)try {
        $2a051a86cb6e4743$var$Q1();
        break;
    } catch (i1) {
        $2a051a86cb6e4743$var$og(e, i1);
    }
    if ($2a051a86cb6e4743$var$_u(), $2a051a86cb6e4743$var$Z = n, $2a051a86cb6e4743$var$Co.current = r, $2a051a86cb6e4743$var$ge !== null) throw Error($2a051a86cb6e4743$var$j(261));
    return $2a051a86cb6e4743$var$we = null, $2a051a86cb6e4743$var$Ee = 0, $2a051a86cb6e4743$var$ve;
}
function $2a051a86cb6e4743$var$Q1() {
    for(; $2a051a86cb6e4743$var$ge !== null;)$2a051a86cb6e4743$var$lg($2a051a86cb6e4743$var$ge);
}
function $2a051a86cb6e4743$var$K1() {
    for(; $2a051a86cb6e4743$var$ge !== null && !$2a051a86cb6e4743$var$y0();)$2a051a86cb6e4743$var$lg($2a051a86cb6e4743$var$ge);
}
function $2a051a86cb6e4743$var$lg(e) {
    var t = $2a051a86cb6e4743$var$fg(e.alternate, e, $2a051a86cb6e4743$var$Ve);
    e.memoizedProps = e.pendingProps, t === null ? $2a051a86cb6e4743$var$ug(e) : $2a051a86cb6e4743$var$ge = t, $2a051a86cb6e4743$var$Uu.current = null;
}
function $2a051a86cb6e4743$var$ug(e) {
    var t = e;
    do {
        var n = t.alternate;
        if (e = t.return, t.flags & 32768) {
            if (n = $2a051a86cb6e4743$var$U1(n, t), n !== null) {
                n.flags &= 32767, $2a051a86cb6e4743$var$ge = n;
                return;
            }
            if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
            else {
                $2a051a86cb6e4743$var$ve = 6, $2a051a86cb6e4743$var$ge = null;
                return;
            }
        } else if (n = $2a051a86cb6e4743$var$M1(n, t, $2a051a86cb6e4743$var$Ve), n !== null) {
            $2a051a86cb6e4743$var$ge = n;
            return;
        }
        if (t = t.sibling, t !== null) {
            $2a051a86cb6e4743$var$ge = t;
            return;
        }
        $2a051a86cb6e4743$var$ge = t = e;
    }while (t !== null);
    $2a051a86cb6e4743$var$ve === 0 && ($2a051a86cb6e4743$var$ve = 5);
}
function $2a051a86cb6e4743$var$Nn(e, t, n) {
    var r = $2a051a86cb6e4743$var$ee, i1 = $2a051a86cb6e4743$var$rt.transition;
    try {
        $2a051a86cb6e4743$var$rt.transition = null, $2a051a86cb6e4743$var$ee = 1, $2a051a86cb6e4743$var$W1(e, t, n, r);
    } finally{
        $2a051a86cb6e4743$var$rt.transition = i1, $2a051a86cb6e4743$var$ee = r;
    }
    return null;
}
function $2a051a86cb6e4743$var$W1(e, t, n, r) {
    do $2a051a86cb6e4743$var$Er();
    while ($2a051a86cb6e4743$var$fn !== null);
    if ($2a051a86cb6e4743$var$Z & 6) throw Error($2a051a86cb6e4743$var$j(327));
    n = e.finishedWork;
    var i1 = e.finishedLanes;
    if (n === null) return null;
    if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error($2a051a86cb6e4743$var$j(177));
    e.callbackNode = null, e.callbackPriority = 0;
    var s = n.lanes | n.childLanes;
    if ($2a051a86cb6e4743$var$b0(e, s), e === $2a051a86cb6e4743$var$we && ($2a051a86cb6e4743$var$ge = $2a051a86cb6e4743$var$we = null, $2a051a86cb6e4743$var$Ee = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || $2a051a86cb6e4743$var$js || ($2a051a86cb6e4743$var$js = !0, $2a051a86cb6e4743$var$dg($2a051a86cb6e4743$var$so, function() {
        return $2a051a86cb6e4743$var$Er(), null;
    })), s = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || s) {
        s = $2a051a86cb6e4743$var$rt.transition, $2a051a86cb6e4743$var$rt.transition = null;
        var o = $2a051a86cb6e4743$var$ee;
        $2a051a86cb6e4743$var$ee = 1;
        var a = $2a051a86cb6e4743$var$Z;
        $2a051a86cb6e4743$var$Z |= 4, $2a051a86cb6e4743$var$Uu.current = null, $2a051a86cb6e4743$var$z1(e, n), $2a051a86cb6e4743$var$rg(n, e), $2a051a86cb6e4743$var$h1($2a051a86cb6e4743$var$Cl), $2a051a86cb6e4743$var$ao = !!$2a051a86cb6e4743$var$xl, $2a051a86cb6e4743$var$Cl = $2a051a86cb6e4743$var$xl = null, e.current = n, $2a051a86cb6e4743$var$B1(n), $2a051a86cb6e4743$var$v0(), $2a051a86cb6e4743$var$Z = a, $2a051a86cb6e4743$var$ee = o, $2a051a86cb6e4743$var$rt.transition = s;
    } else e.current = n;
    if ($2a051a86cb6e4743$var$js && ($2a051a86cb6e4743$var$js = !1, $2a051a86cb6e4743$var$fn = e, $2a051a86cb6e4743$var$ko = i1), s = e.pendingLanes, s === 0 && ($2a051a86cb6e4743$var$yn = null), $2a051a86cb6e4743$var$x0(n.stateNode), $2a051a86cb6e4743$var$Be(e, $2a051a86cb6e4743$var$pe()), t !== null) for(r = e.onRecoverableError, n = 0; n < t.length; n++)i1 = t[n], r(i1.value, {
        componentStack: i1.stack,
        digest: i1.digest
    });
    if ($2a051a86cb6e4743$var$Eo) throw $2a051a86cb6e4743$var$Eo = !1, e = $2a051a86cb6e4743$var$Bl, $2a051a86cb6e4743$var$Bl = null, e;
    return $2a051a86cb6e4743$var$ko & 1 && e.tag !== 0 && $2a051a86cb6e4743$var$Er(), s = e.pendingLanes, s & 1 ? e === $2a051a86cb6e4743$var$Hl ? $2a051a86cb6e4743$var$Ci++ : ($2a051a86cb6e4743$var$Ci = 0, $2a051a86cb6e4743$var$Hl = e) : $2a051a86cb6e4743$var$Ci = 0, $2a051a86cb6e4743$var$Pn(), null;
}
function $2a051a86cb6e4743$var$Er() {
    if ($2a051a86cb6e4743$var$fn !== null) {
        var e = $2a051a86cb6e4743$var$Hh($2a051a86cb6e4743$var$ko), t = $2a051a86cb6e4743$var$rt.transition, n = $2a051a86cb6e4743$var$ee;
        try {
            if ($2a051a86cb6e4743$var$rt.transition = null, $2a051a86cb6e4743$var$ee = 16 > e ? 16 : e, $2a051a86cb6e4743$var$fn === null) var r = !1;
            else {
                if (e = $2a051a86cb6e4743$var$fn, $2a051a86cb6e4743$var$fn = null, $2a051a86cb6e4743$var$ko = 0, $2a051a86cb6e4743$var$Z & 6) throw Error($2a051a86cb6e4743$var$j(331));
                var i1 = $2a051a86cb6e4743$var$Z;
                for($2a051a86cb6e4743$var$Z |= 4, $2a051a86cb6e4743$var$$ = e.current; $2a051a86cb6e4743$var$$ !== null;){
                    var s = $2a051a86cb6e4743$var$$, o = s.child;
                    if ($2a051a86cb6e4743$var$$.flags & 16) {
                        var a = s.deletions;
                        if (a !== null) {
                            for(var l = 0; l < a.length; l++){
                                var u = a[l];
                                for($2a051a86cb6e4743$var$$ = u; $2a051a86cb6e4743$var$$ !== null;){
                                    var c = $2a051a86cb6e4743$var$$;
                                    switch(c.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $2a051a86cb6e4743$var$wi(8, c, s);
                                    }
                                    var d = c.child;
                                    if (d !== null) d.return = c, $2a051a86cb6e4743$var$$ = d;
                                    else for(; $2a051a86cb6e4743$var$$ !== null;){
                                        c = $2a051a86cb6e4743$var$$;
                                        var f = c.sibling, m = c.return;
                                        if ($2a051a86cb6e4743$var$eg(c), c === u) {
                                            $2a051a86cb6e4743$var$$ = null;
                                            break;
                                        }
                                        if (f !== null) {
                                            f.return = m, $2a051a86cb6e4743$var$$ = f;
                                            break;
                                        }
                                        $2a051a86cb6e4743$var$$ = m;
                                    }
                                }
                            }
                            var v = s.alternate;
                            if (v !== null) {
                                var y = v.child;
                                if (y !== null) {
                                    v.child = null;
                                    do {
                                        var k = y.sibling;
                                        y.sibling = null, y = k;
                                    }while (y !== null);
                                }
                            }
                            $2a051a86cb6e4743$var$$ = s;
                        }
                    }
                    if (s.subtreeFlags & 2064 && o !== null) o.return = s, $2a051a86cb6e4743$var$$ = o;
                    else e: for(; $2a051a86cb6e4743$var$$ !== null;){
                        if (s = $2a051a86cb6e4743$var$$, s.flags & 2048) switch(s.tag){
                            case 0:
                            case 11:
                            case 15:
                                $2a051a86cb6e4743$var$wi(9, s, s.return);
                        }
                        var p = s.sibling;
                        if (p !== null) {
                            p.return = s.return, $2a051a86cb6e4743$var$$ = p;
                            break e;
                        }
                        $2a051a86cb6e4743$var$$ = s.return;
                    }
                }
                var h = e.current;
                for($2a051a86cb6e4743$var$$ = h; $2a051a86cb6e4743$var$$ !== null;){
                    o = $2a051a86cb6e4743$var$$;
                    var g = o.child;
                    if (o.subtreeFlags & 2064 && g !== null) g.return = o, $2a051a86cb6e4743$var$$ = g;
                    else e: for(o = h; $2a051a86cb6e4743$var$$ !== null;){
                        if (a = $2a051a86cb6e4743$var$$, a.flags & 2048) try {
                            switch(a.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $2a051a86cb6e4743$var$Wo(9, a);
                            }
                        } catch (P) {
                            $2a051a86cb6e4743$var$de(a, a.return, P);
                        }
                        if (a === o) {
                            $2a051a86cb6e4743$var$$ = null;
                            break e;
                        }
                        var E = a.sibling;
                        if (E !== null) {
                            E.return = a.return, $2a051a86cb6e4743$var$$ = E;
                            break e;
                        }
                        $2a051a86cb6e4743$var$$ = a.return;
                    }
                }
                if ($2a051a86cb6e4743$var$Z = i1, $2a051a86cb6e4743$var$Pn(), $2a051a86cb6e4743$var$bt && typeof $2a051a86cb6e4743$var$bt.onPostCommitFiberRoot == "function") try {
                    $2a051a86cb6e4743$var$bt.onPostCommitFiberRoot($2a051a86cb6e4743$var$Uo, e);
                } catch  {}
                r = !0;
            }
            return r;
        } finally{
            $2a051a86cb6e4743$var$ee = n, $2a051a86cb6e4743$var$rt.transition = t;
        }
    }
    return !1;
}
function $2a051a86cb6e4743$var$Vf(e, t, n) {
    t = $2a051a86cb6e4743$var$Vr(n, t), t = $2a051a86cb6e4743$var$Hp(e, t, 1), e = $2a051a86cb6e4743$var$mn(e, t, 1), t = $2a051a86cb6e4743$var$Ie(), e !== null && ($2a051a86cb6e4743$var$as(e, 1, t), $2a051a86cb6e4743$var$Be(e, t));
}
function $2a051a86cb6e4743$var$de(e, t, n) {
    if (e.tag === 3) $2a051a86cb6e4743$var$Vf(e, e, n);
    else for(; t !== null;){
        if (t.tag === 3) {
            $2a051a86cb6e4743$var$Vf(t, e, n);
            break;
        } else if (t.tag === 1) {
            var r = t.stateNode;
            if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && ($2a051a86cb6e4743$var$yn === null || !$2a051a86cb6e4743$var$yn.has(r))) {
                e = $2a051a86cb6e4743$var$Vr(n, e), e = $2a051a86cb6e4743$var$Vp(t, e, 1), t = $2a051a86cb6e4743$var$mn(t, e, 1), e = $2a051a86cb6e4743$var$Ie(), t !== null && ($2a051a86cb6e4743$var$as(t, 1, e), $2a051a86cb6e4743$var$Be(t, e));
                break;
            }
        }
        t = t.return;
    }
}
function $2a051a86cb6e4743$var$Y1(e, t, n) {
    var r = e.pingCache;
    r !== null && r.delete(t), t = $2a051a86cb6e4743$var$Ie(), e.pingedLanes |= e.suspendedLanes & n, $2a051a86cb6e4743$var$we === e && ($2a051a86cb6e4743$var$Ee & n) === n && ($2a051a86cb6e4743$var$ve === 4 || $2a051a86cb6e4743$var$ve === 3 && ($2a051a86cb6e4743$var$Ee & 130023424) === $2a051a86cb6e4743$var$Ee && 500 > $2a051a86cb6e4743$var$pe() - $2a051a86cb6e4743$var$zu ? $2a051a86cb6e4743$var$Hn(e, 0) : $2a051a86cb6e4743$var$$u |= n), $2a051a86cb6e4743$var$Be(e, t);
}
function $2a051a86cb6e4743$var$cg(e, t) {
    t === 0 && (e.mode & 1 ? (t = $2a051a86cb6e4743$var$Es, $2a051a86cb6e4743$var$Es <<= 1, !($2a051a86cb6e4743$var$Es & 130023424) && ($2a051a86cb6e4743$var$Es = 4194304)) : t = 1);
    var n = $2a051a86cb6e4743$var$Ie();
    e = $2a051a86cb6e4743$var$zt(e, t), e !== null && ($2a051a86cb6e4743$var$as(e, t, n), $2a051a86cb6e4743$var$Be(e, n));
}
function $2a051a86cb6e4743$var$q1(e) {
    var t = e.memoizedState, n = 0;
    t !== null && (n = t.retryLane), $2a051a86cb6e4743$var$cg(e, n);
}
function $2a051a86cb6e4743$var$G1(e, t) {
    var n = 0;
    switch(e.tag){
        case 13:
            var r = e.stateNode, i1 = e.memoizedState;
            i1 !== null && (n = i1.retryLane);
            break;
        case 19:
            r = e.stateNode;
            break;
        default:
            throw Error($2a051a86cb6e4743$var$j(314));
    }
    r !== null && r.delete(t), $2a051a86cb6e4743$var$cg(e, n);
}
var $2a051a86cb6e4743$var$fg;
$2a051a86cb6e4743$var$fg = function(e, t, n) {
    if (e !== null) {
        if (e.memoizedProps !== t.pendingProps || $2a051a86cb6e4743$var$$e.current) $2a051a86cb6e4743$var$Ue = !0;
        else {
            if (!(e.lanes & n) && !(t.flags & 128)) return $2a051a86cb6e4743$var$Ue = !1, $2a051a86cb6e4743$var$A1(e, t, n);
            $2a051a86cb6e4743$var$Ue = !!(e.flags & 131072);
        }
    } else $2a051a86cb6e4743$var$Ue = !1, $2a051a86cb6e4743$var$se && t.flags & 1048576 && $2a051a86cb6e4743$var$gp(t, $2a051a86cb6e4743$var$go, t.index);
    switch(t.lanes = 0, t.tag){
        case 2:
            var r = t.type;
            $2a051a86cb6e4743$var$Ks(e, t), e = t.pendingProps;
            var i1 = $2a051a86cb6e4743$var$$r(t, $2a051a86cb6e4743$var$Ne.current);
            $2a051a86cb6e4743$var$Cr(t, n), i1 = $2a051a86cb6e4743$var$Iu(null, t, r, e, i1, n);
            var s = $2a051a86cb6e4743$var$Fu();
            return t.flags |= 1, typeof i1 == "object" && i1 !== null && typeof i1.render == "function" && i1.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, $2a051a86cb6e4743$var$ze(r) ? (s = !0, $2a051a86cb6e4743$var$ho(t)) : s = !1, t.memoizedState = i1.state !== null && i1.state !== void 0 ? i1.state : null, $2a051a86cb6e4743$var$Nu(t), i1.updater = $2a051a86cb6e4743$var$Ko, t.stateNode = i1, i1._reactInternals = t, $2a051a86cb6e4743$var$Ll(t, r, e, n), t = $2a051a86cb6e4743$var$Il(null, t, r, !0, s, n)) : (t.tag = 0, $2a051a86cb6e4743$var$se && s && $2a051a86cb6e4743$var$Cu(t), $2a051a86cb6e4743$var$je(null, t, i1, n), t = t.child), t;
        case 16:
            r = t.elementType;
            e: {
                switch($2a051a86cb6e4743$var$Ks(e, t), e = t.pendingProps, i1 = r._init, r = i1(r._payload), t.type = r, i1 = t.tag = $2a051a86cb6e4743$var$J1(r), e = $2a051a86cb6e4743$var$lt(r, e), i1){
                    case 0:
                        t = $2a051a86cb6e4743$var$jl(null, t, r, e, n);
                        break e;
                    case 1:
                        t = $2a051a86cb6e4743$var$If(null, t, r, e, n);
                        break e;
                    case 11:
                        t = $2a051a86cb6e4743$var$Rf(null, t, r, e, n);
                        break e;
                    case 14:
                        t = $2a051a86cb6e4743$var$jf(null, t, r, $2a051a86cb6e4743$var$lt(r.type, e), n);
                        break e;
                }
                throw Error($2a051a86cb6e4743$var$j(306, r, ""));
            }
            return t;
        case 0:
            return r = t.type, i1 = t.pendingProps, i1 = t.elementType === r ? i1 : $2a051a86cb6e4743$var$lt(r, i1), $2a051a86cb6e4743$var$jl(e, t, r, i1, n);
        case 1:
            return r = t.type, i1 = t.pendingProps, i1 = t.elementType === r ? i1 : $2a051a86cb6e4743$var$lt(r, i1), $2a051a86cb6e4743$var$If(e, t, r, i1, n);
        case 3:
            e: {
                if ($2a051a86cb6e4743$var$Yp(t), e === null) throw Error($2a051a86cb6e4743$var$j(387));
                r = t.pendingProps, s = t.memoizedState, i1 = s.element, $2a051a86cb6e4743$var$xp(e, t), $2a051a86cb6e4743$var$vo(t, r, null, n);
                var o = t.memoizedState;
                if (r = o.element, s.isDehydrated) {
                    if (s = {
                        element: r,
                        isDehydrated: !1,
                        cache: o.cache,
                        pendingSuspenseBoundaries: o.pendingSuspenseBoundaries,
                        transitions: o.transitions
                    }, t.updateQueue.baseState = s, t.memoizedState = s, t.flags & 256) {
                        i1 = $2a051a86cb6e4743$var$Vr(Error($2a051a86cb6e4743$var$j(423)), t), t = $2a051a86cb6e4743$var$Ff(e, t, r, n, i1);
                        break e;
                    } else if (r !== i1) {
                        i1 = $2a051a86cb6e4743$var$Vr(Error($2a051a86cb6e4743$var$j(424)), t), t = $2a051a86cb6e4743$var$Ff(e, t, r, n, i1);
                        break e;
                    } else for($2a051a86cb6e4743$var$Qe = $2a051a86cb6e4743$var$gn(t.stateNode.containerInfo.firstChild), $2a051a86cb6e4743$var$Ke = t, $2a051a86cb6e4743$var$se = !0, $2a051a86cb6e4743$var$ht = null, n = $2a051a86cb6e4743$var$Sp(t, null, r, n), t.child = n; n;)n.flags = n.flags & -3 | 4096, n = n.sibling;
                } else {
                    if ($2a051a86cb6e4743$var$zr(), r === i1) {
                        t = $2a051a86cb6e4743$var$Bt(e, t, n);
                        break e;
                    }
                    $2a051a86cb6e4743$var$je(e, t, r, n);
                }
                t = t.child;
            }
            return t;
        case 5:
            return $2a051a86cb6e4743$var$Cp(t), e === null && $2a051a86cb6e4743$var$Ol(t), r = t.type, i1 = t.pendingProps, s = e !== null ? e.memoizedProps : null, o = i1.children, $2a051a86cb6e4743$var$El(r, i1) ? o = null : s !== null && $2a051a86cb6e4743$var$El(r, s) && (t.flags |= 32), $2a051a86cb6e4743$var$Wp(e, t), $2a051a86cb6e4743$var$je(e, t, o, n), t.child;
        case 6:
            return e === null && $2a051a86cb6e4743$var$Ol(t), null;
        case 13:
            return $2a051a86cb6e4743$var$qp(e, t, n);
        case 4:
            return $2a051a86cb6e4743$var$Tu(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = $2a051a86cb6e4743$var$Br(t, null, r, n) : $2a051a86cb6e4743$var$je(e, t, r, n), t.child;
        case 11:
            return r = t.type, i1 = t.pendingProps, i1 = t.elementType === r ? i1 : $2a051a86cb6e4743$var$lt(r, i1), $2a051a86cb6e4743$var$Rf(e, t, r, i1, n);
        case 7:
            return $2a051a86cb6e4743$var$je(e, t, t.pendingProps, n), t.child;
        case 8:
            return $2a051a86cb6e4743$var$je(e, t, t.pendingProps.children, n), t.child;
        case 12:
            return $2a051a86cb6e4743$var$je(e, t, t.pendingProps.children, n), t.child;
        case 10:
            e: {
                if (r = t.type._context, i1 = t.pendingProps, s = t.memoizedProps, o = i1.value, $2a051a86cb6e4743$var$te($2a051a86cb6e4743$var$mo, r._currentValue), r._currentValue = o, s !== null) {
                    if ($2a051a86cb6e4743$var$mt(s.value, o)) {
                        if (s.children === i1.children && !$2a051a86cb6e4743$var$$e.current) {
                            t = $2a051a86cb6e4743$var$Bt(e, t, n);
                            break e;
                        }
                    } else for(s = t.child, s !== null && (s.return = t); s !== null;){
                        var a = s.dependencies;
                        if (a !== null) {
                            o = s.child;
                            for(var l = a.firstContext; l !== null;){
                                if (l.context === r) {
                                    if (s.tag === 1) {
                                        l = $2a051a86cb6e4743$var$Mt(-1, n & -n), l.tag = 2;
                                        var u = s.updateQueue;
                                        if (u !== null) {
                                            u = u.shared;
                                            var c = u.pending;
                                            c === null ? l.next = l : (l.next = c.next, c.next = l), u.pending = l;
                                        }
                                    }
                                    s.lanes |= n, l = s.alternate, l !== null && (l.lanes |= n), $2a051a86cb6e4743$var$Nl(s.return, n, t), a.lanes |= n;
                                    break;
                                }
                                l = l.next;
                            }
                        } else if (s.tag === 10) o = s.type === t.type ? null : s.child;
                        else if (s.tag === 18) {
                            if (o = s.return, o === null) throw Error($2a051a86cb6e4743$var$j(341));
                            o.lanes |= n, a = o.alternate, a !== null && (a.lanes |= n), $2a051a86cb6e4743$var$Nl(o, n, t), o = s.sibling;
                        } else o = s.child;
                        if (o !== null) o.return = s;
                        else for(o = s; o !== null;){
                            if (o === t) {
                                o = null;
                                break;
                            }
                            if (s = o.sibling, s !== null) {
                                s.return = o.return, o = s;
                                break;
                            }
                            o = o.return;
                        }
                        s = o;
                    }
                }
                $2a051a86cb6e4743$var$je(e, t, i1.children, n), t = t.child;
            }
            return t;
        case 9:
            return i1 = t.type, r = t.pendingProps.children, $2a051a86cb6e4743$var$Cr(t, n), i1 = $2a051a86cb6e4743$var$it(i1), r = r(i1), t.flags |= 1, $2a051a86cb6e4743$var$je(e, t, r, n), t.child;
        case 14:
            return r = t.type, i1 = $2a051a86cb6e4743$var$lt(r, t.pendingProps), i1 = $2a051a86cb6e4743$var$lt(r.type, i1), $2a051a86cb6e4743$var$jf(e, t, r, i1, n);
        case 15:
            return $2a051a86cb6e4743$var$Qp(e, t, t.type, t.pendingProps, n);
        case 17:
            return r = t.type, i1 = t.pendingProps, i1 = t.elementType === r ? i1 : $2a051a86cb6e4743$var$lt(r, i1), $2a051a86cb6e4743$var$Ks(e, t), t.tag = 1, $2a051a86cb6e4743$var$ze(r) ? (e = !0, $2a051a86cb6e4743$var$ho(t)) : e = !1, $2a051a86cb6e4743$var$Cr(t, n), $2a051a86cb6e4743$var$Bp(t, r, i1), $2a051a86cb6e4743$var$Ll(t, r, i1, n), $2a051a86cb6e4743$var$Il(null, t, r, !0, e, n);
        case 19:
            return $2a051a86cb6e4743$var$Gp(e, t, n);
        case 22:
            return $2a051a86cb6e4743$var$Kp(e, t, n);
    }
    throw Error($2a051a86cb6e4743$var$j(156, t.tag));
};
function $2a051a86cb6e4743$var$dg(e, t) {
    return $2a051a86cb6e4743$var$Uh(e, t);
}
function $2a051a86cb6e4743$var$X1(e, t, n, r) {
    this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function $2a051a86cb6e4743$var$nt(e, t, n, r) {
    return new $2a051a86cb6e4743$var$X1(e, t, n, r);
}
function $2a051a86cb6e4743$var$Qu(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
}
function $2a051a86cb6e4743$var$J1(e) {
    if (typeof e == "function") return $2a051a86cb6e4743$var$Qu(e) ? 1 : 0;
    if (e != null) {
        if (e = e.$$typeof, e === $2a051a86cb6e4743$var$cu) return 11;
        if (e === $2a051a86cb6e4743$var$fu) return 14;
    }
    return 2;
}
function $2a051a86cb6e4743$var$Sn(e, t) {
    var n = e.alternate;
    return n === null ? (n = $2a051a86cb6e4743$var$nt(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext
    }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function $2a051a86cb6e4743$var$qs(e, t, n, r, i1, s) {
    var o = 2;
    if (r = e, typeof e == "function") $2a051a86cb6e4743$var$Qu(e) && (o = 1);
    else if (typeof e == "string") o = 5;
    else e: switch(e){
        case $2a051a86cb6e4743$var$sr:
            return $2a051a86cb6e4743$var$Vn(n.children, i1, s, t);
        case $2a051a86cb6e4743$var$uu:
            o = 8, i1 |= 8;
            break;
        case $2a051a86cb6e4743$var$tl:
            return e = $2a051a86cb6e4743$var$nt(12, n, t, i1 | 2), e.elementType = $2a051a86cb6e4743$var$tl, e.lanes = s, e;
        case $2a051a86cb6e4743$var$nl:
            return e = $2a051a86cb6e4743$var$nt(13, n, t, i1), e.elementType = $2a051a86cb6e4743$var$nl, e.lanes = s, e;
        case $2a051a86cb6e4743$var$rl:
            return e = $2a051a86cb6e4743$var$nt(19, n, t, i1), e.elementType = $2a051a86cb6e4743$var$rl, e.lanes = s, e;
        case $2a051a86cb6e4743$var$Ch:
            return $2a051a86cb6e4743$var$qo(n, i1, s, t);
        default:
            if (typeof e == "object" && e !== null) switch(e.$$typeof){
                case $2a051a86cb6e4743$var$wh:
                    o = 10;
                    break e;
                case $2a051a86cb6e4743$var$xh:
                    o = 9;
                    break e;
                case $2a051a86cb6e4743$var$cu:
                    o = 11;
                    break e;
                case $2a051a86cb6e4743$var$fu:
                    o = 14;
                    break e;
                case $2a051a86cb6e4743$var$Xt:
                    o = 16, r = null;
                    break e;
            }
            throw Error($2a051a86cb6e4743$var$j(130, e == null ? e : typeof e, ""));
    }
    return t = $2a051a86cb6e4743$var$nt(o, n, t, i1), t.elementType = e, t.type = r, t.lanes = s, t;
}
function $2a051a86cb6e4743$var$Vn(e, t, n, r) {
    return e = $2a051a86cb6e4743$var$nt(7, e, r, t), e.lanes = n, e;
}
function $2a051a86cb6e4743$var$qo(e, t, n, r) {
    return e = $2a051a86cb6e4743$var$nt(22, e, r, t), e.elementType = $2a051a86cb6e4743$var$Ch, e.lanes = n, e.stateNode = {
        isHidden: !1
    }, e;
}
function $2a051a86cb6e4743$var$Ra(e, t, n) {
    return e = $2a051a86cb6e4743$var$nt(6, e, null, t), e.lanes = n, e;
}
function $2a051a86cb6e4743$var$ja(e, t, n) {
    return t = $2a051a86cb6e4743$var$nt(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
    }, t;
}
function $2a051a86cb6e4743$var$Z1(e, t, n, r, i1) {
    this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = $2a051a86cb6e4743$var$ha(0), this.expirationTimes = $2a051a86cb6e4743$var$ha(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = $2a051a86cb6e4743$var$ha(0), this.identifierPrefix = r, this.onRecoverableError = i1, this.mutableSourceEagerHydrationData = null;
}
function $2a051a86cb6e4743$var$Ku(e, t, n, r, i1, s, o, a, l) {
    return e = new $2a051a86cb6e4743$var$Z1(e, t, n, a, l), t === 1 ? (t = 1, s === !0 && (t |= 8)) : t = 0, s = $2a051a86cb6e4743$var$nt(3, null, null, t), e.current = s, s.stateNode = e, s.memoizedState = {
        element: r,
        isDehydrated: n,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    }, $2a051a86cb6e4743$var$Nu(s), e;
}
function $2a051a86cb6e4743$var$eS(e, t, n) {
    var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
        $$typeof: $2a051a86cb6e4743$var$ir,
        key: r == null ? null : "" + r,
        children: e,
        containerInfo: t,
        implementation: n
    };
}
function $2a051a86cb6e4743$var$hg(e) {
    if (!e) return $2a051a86cb6e4743$var$Cn;
    e = e._reactInternals;
    e: {
        if ($2a051a86cb6e4743$var$Zn(e) !== e || e.tag !== 1) throw Error($2a051a86cb6e4743$var$j(170));
        var t = e;
        do {
            switch(t.tag){
                case 3:
                    t = t.stateNode.context;
                    break e;
                case 1:
                    if ($2a051a86cb6e4743$var$ze(t.type)) {
                        t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                        break e;
                    }
            }
            t = t.return;
        }while (t !== null);
        throw Error($2a051a86cb6e4743$var$j(171));
    }
    if (e.tag === 1) {
        var n = e.type;
        if ($2a051a86cb6e4743$var$ze(n)) return $2a051a86cb6e4743$var$hp(e, n, t);
    }
    return t;
}
function $2a051a86cb6e4743$var$pg(e, t, n, r, i1, s, o, a, l) {
    return e = $2a051a86cb6e4743$var$Ku(n, r, !0, e, i1, s, o, a, l), e.context = $2a051a86cb6e4743$var$hg(null), n = e.current, r = $2a051a86cb6e4743$var$Ie(), i1 = $2a051a86cb6e4743$var$vn(n), s = $2a051a86cb6e4743$var$Mt(r, i1), s.callback = t ?? null, $2a051a86cb6e4743$var$mn(n, s, i1), e.current.lanes = i1, $2a051a86cb6e4743$var$as(e, i1, r), $2a051a86cb6e4743$var$Be(e, r), e;
}
function $2a051a86cb6e4743$var$Go(e, t, n, r) {
    var i1 = t.current, s = $2a051a86cb6e4743$var$Ie(), o = $2a051a86cb6e4743$var$vn(i1);
    return n = $2a051a86cb6e4743$var$hg(n), t.context === null ? t.context = n : t.pendingContext = n, t = $2a051a86cb6e4743$var$Mt(s, o), t.payload = {
        element: e
    }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = $2a051a86cb6e4743$var$mn(i1, t, o), e !== null && ($2a051a86cb6e4743$var$gt(e, i1, o, s), $2a051a86cb6e4743$var$Hs(e, i1, o)), o;
}
function $2a051a86cb6e4743$var$_o(e) {
    if (e = e.current, !e.child) return null;
    switch(e.child.tag){
        case 5:
            return e.child.stateNode;
        default:
            return e.child.stateNode;
    }
}
function $2a051a86cb6e4743$var$Qf(e, t) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
        var n = e.retryLane;
        e.retryLane = n !== 0 && n < t ? n : t;
    }
}
function $2a051a86cb6e4743$var$Wu(e, t) {
    $2a051a86cb6e4743$var$Qf(e, t), (e = e.alternate) && $2a051a86cb6e4743$var$Qf(e, t);
}
function $2a051a86cb6e4743$var$tS() {
    return null;
}
var $2a051a86cb6e4743$var$gg = typeof reportError == "function" ? reportError : function(e) {
    console.error(e);
};
function $2a051a86cb6e4743$var$Yu(e) {
    this._internalRoot = e;
}
$2a051a86cb6e4743$var$Xo.prototype.render = $2a051a86cb6e4743$var$Yu.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null) throw Error($2a051a86cb6e4743$var$j(409));
    $2a051a86cb6e4743$var$Go(e, t, null, null);
};
$2a051a86cb6e4743$var$Xo.prototype.unmount = $2a051a86cb6e4743$var$Yu.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        $2a051a86cb6e4743$var$Xn(function() {
            $2a051a86cb6e4743$var$Go(null, e, null, null);
        }), t[$2a051a86cb6e4743$var$$t] = null;
    }
};
function $2a051a86cb6e4743$var$Xo(e) {
    this._internalRoot = e;
}
$2a051a86cb6e4743$var$Xo.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
        var t = $2a051a86cb6e4743$var$Kh();
        e = {
            blockedOn: null,
            target: e,
            priority: t
        };
        for(var n = 0; n < $2a051a86cb6e4743$var$en.length && t !== 0 && t < $2a051a86cb6e4743$var$en[n].priority; n++);
        $2a051a86cb6e4743$var$en.splice(n, 0, e), n === 0 && $2a051a86cb6e4743$var$Yh(e);
    }
};
function $2a051a86cb6e4743$var$qu(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function $2a051a86cb6e4743$var$Jo(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function $2a051a86cb6e4743$var$Kf() {}
function $2a051a86cb6e4743$var$nS(e, t, n, r, i1) {
    if (i1) {
        if (typeof r == "function") {
            var s = r;
            r = function() {
                var u = $2a051a86cb6e4743$var$_o(o);
                s.call(u);
            };
        }
        var o = $2a051a86cb6e4743$var$pg(t, r, e, 0, null, !1, !1, "", $2a051a86cb6e4743$var$Kf);
        return e._reactRootContainer = o, e[$2a051a86cb6e4743$var$$t] = o.current, $2a051a86cb6e4743$var$Mi(e.nodeType === 8 ? e.parentNode : e), $2a051a86cb6e4743$var$Xn(), o;
    }
    for(; i1 = e.lastChild;)e.removeChild(i1);
    if (typeof r == "function") {
        var a = r;
        r = function() {
            var u = $2a051a86cb6e4743$var$_o(l);
            a.call(u);
        };
    }
    var l = $2a051a86cb6e4743$var$Ku(e, 0, !1, null, null, !1, !1, "", $2a051a86cb6e4743$var$Kf);
    return e._reactRootContainer = l, e[$2a051a86cb6e4743$var$$t] = l.current, $2a051a86cb6e4743$var$Mi(e.nodeType === 8 ? e.parentNode : e), $2a051a86cb6e4743$var$Xn(function() {
        $2a051a86cb6e4743$var$Go(t, l, n, r);
    }), l;
}
function $2a051a86cb6e4743$var$Zo(e, t, n, r, i1) {
    var s = n._reactRootContainer;
    if (s) {
        var o = s;
        if (typeof i1 == "function") {
            var a = i1;
            i1 = function() {
                var l = $2a051a86cb6e4743$var$_o(o);
                a.call(l);
            };
        }
        $2a051a86cb6e4743$var$Go(t, o, e, i1);
    } else o = $2a051a86cb6e4743$var$nS(n, t, e, i1, r);
    return $2a051a86cb6e4743$var$_o(o);
}
$2a051a86cb6e4743$var$Vh = function(e) {
    switch(e.tag){
        case 3:
            var t = e.stateNode;
            if (t.current.memoizedState.isDehydrated) {
                var n = $2a051a86cb6e4743$var$fi(t.pendingLanes);
                n !== 0 && ($2a051a86cb6e4743$var$pu(t, n | 1), $2a051a86cb6e4743$var$Be(t, $2a051a86cb6e4743$var$pe()), !($2a051a86cb6e4743$var$Z & 6) && ($2a051a86cb6e4743$var$Qr = $2a051a86cb6e4743$var$pe() + 500, $2a051a86cb6e4743$var$Pn()));
            }
            break;
        case 13:
            $2a051a86cb6e4743$var$Xn(function() {
                var r = $2a051a86cb6e4743$var$zt(e, 1);
                if (r !== null) {
                    var i1 = $2a051a86cb6e4743$var$Ie();
                    $2a051a86cb6e4743$var$gt(r, e, 1, i1);
                }
            }), $2a051a86cb6e4743$var$Wu(e, 1);
    }
};
$2a051a86cb6e4743$var$gu = function(e) {
    if (e.tag === 13) {
        var t = $2a051a86cb6e4743$var$zt(e, 134217728);
        if (t !== null) {
            var n = $2a051a86cb6e4743$var$Ie();
            $2a051a86cb6e4743$var$gt(t, e, 134217728, n);
        }
        $2a051a86cb6e4743$var$Wu(e, 134217728);
    }
};
$2a051a86cb6e4743$var$Qh = function(e) {
    if (e.tag === 13) {
        var t = $2a051a86cb6e4743$var$vn(e), n = $2a051a86cb6e4743$var$zt(e, t);
        if (n !== null) {
            var r = $2a051a86cb6e4743$var$Ie();
            $2a051a86cb6e4743$var$gt(n, e, t, r);
        }
        $2a051a86cb6e4743$var$Wu(e, t);
    }
};
$2a051a86cb6e4743$var$Kh = function() {
    return $2a051a86cb6e4743$var$ee;
};
$2a051a86cb6e4743$var$Wh = function(e, t) {
    var n = $2a051a86cb6e4743$var$ee;
    try {
        return $2a051a86cb6e4743$var$ee = e, t();
    } finally{
        $2a051a86cb6e4743$var$ee = n;
    }
};
$2a051a86cb6e4743$var$hl = function(e, t, n) {
    switch(t){
        case "input":
            if ($2a051a86cb6e4743$var$ol(e, n), t = n.name, n.type === "radio" && t != null) {
                for(n = e; n.parentNode;)n = n.parentNode;
                for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++){
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                        var i1 = $2a051a86cb6e4743$var$Ho(r);
                        if (!i1) throw Error($2a051a86cb6e4743$var$j(90));
                        $2a051a86cb6e4743$var$kh(r), $2a051a86cb6e4743$var$ol(r, i1);
                    }
                }
            }
            break;
        case "textarea":
            $2a051a86cb6e4743$var$_h(e, n);
            break;
        case "select":
            t = n.value, t != null && $2a051a86cb6e4743$var$vr(e, !!n.multiple, t, !1);
    }
};
$2a051a86cb6e4743$var$jh = $2a051a86cb6e4743$var$Bu;
$2a051a86cb6e4743$var$Ih = $2a051a86cb6e4743$var$Xn;
var $2a051a86cb6e4743$var$rS = {
    usingClientEntryPoint: !1,
    Events: [
        $2a051a86cb6e4743$var$us,
        $2a051a86cb6e4743$var$ur,
        $2a051a86cb6e4743$var$Ho,
        $2a051a86cb6e4743$var$Lh,
        $2a051a86cb6e4743$var$Rh,
        $2a051a86cb6e4743$var$Bu
    ]
}, $2a051a86cb6e4743$var$oi = {
    findFiberByHostInstance: $2a051a86cb6e4743$var$Tn,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
}, $2a051a86cb6e4743$var$iS = {
    bundleType: $2a051a86cb6e4743$var$oi.bundleType,
    version: $2a051a86cb6e4743$var$oi.version,
    rendererPackageName: $2a051a86cb6e4743$var$oi.rendererPackageName,
    rendererConfig: $2a051a86cb6e4743$var$oi.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $2a051a86cb6e4743$var$Ht.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(e) {
        return e = $2a051a86cb6e4743$var$Ah(e), e === null ? null : e.stateNode;
    },
    findFiberByHostInstance: $2a051a86cb6e4743$var$oi.findFiberByHostInstance || $2a051a86cb6e4743$var$tS,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var $2a051a86cb6e4743$var$Is = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2a051a86cb6e4743$var$Is.isDisabled && $2a051a86cb6e4743$var$Is.supportsFiber) try {
        $2a051a86cb6e4743$var$Uo = $2a051a86cb6e4743$var$Is.inject($2a051a86cb6e4743$var$iS), $2a051a86cb6e4743$var$bt = $2a051a86cb6e4743$var$Is;
    } catch  {}
}
$2a051a86cb6e4743$var$Ye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $2a051a86cb6e4743$var$rS;
$2a051a86cb6e4743$var$Ye.createPortal = function(e, t) {
    var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!$2a051a86cb6e4743$var$qu(t)) throw Error($2a051a86cb6e4743$var$j(200));
    return $2a051a86cb6e4743$var$eS(e, t, null, n);
};
$2a051a86cb6e4743$var$Ye.createRoot = function(e, t) {
    if (!$2a051a86cb6e4743$var$qu(e)) throw Error($2a051a86cb6e4743$var$j(299));
    var n = !1, r = "", i1 = $2a051a86cb6e4743$var$gg;
    return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (i1 = t.onRecoverableError)), t = $2a051a86cb6e4743$var$Ku(e, 1, !1, null, null, n, !1, r, i1), e[$2a051a86cb6e4743$var$$t] = t.current, $2a051a86cb6e4743$var$Mi(e.nodeType === 8 ? e.parentNode : e), new $2a051a86cb6e4743$var$Yu(t);
};
$2a051a86cb6e4743$var$Ye.findDOMNode = function(e) {
    if (e == null) return null;
    if (e.nodeType === 1) return e;
    var t = e._reactInternals;
    if (t === void 0) throw typeof e.render == "function" ? Error($2a051a86cb6e4743$var$j(188)) : (e = Object.keys(e).join(","), Error($2a051a86cb6e4743$var$j(268, e)));
    return e = $2a051a86cb6e4743$var$Ah(t), e = e === null ? null : e.stateNode, e;
};
$2a051a86cb6e4743$var$Ye.flushSync = function(e) {
    return $2a051a86cb6e4743$var$Xn(e);
};
$2a051a86cb6e4743$var$Ye.hydrate = function(e, t, n) {
    if (!$2a051a86cb6e4743$var$Jo(t)) throw Error($2a051a86cb6e4743$var$j(200));
    return $2a051a86cb6e4743$var$Zo(null, e, t, !0, n);
};
$2a051a86cb6e4743$var$Ye.hydrateRoot = function(e, t, n) {
    if (!$2a051a86cb6e4743$var$qu(e)) throw Error($2a051a86cb6e4743$var$j(405));
    var r = n != null && n.hydratedSources || null, i1 = !1, s = "", o = $2a051a86cb6e4743$var$gg;
    if (n != null && (n.unstable_strictMode === !0 && (i1 = !0), n.identifierPrefix !== void 0 && (s = n.identifierPrefix), n.onRecoverableError !== void 0 && (o = n.onRecoverableError)), t = $2a051a86cb6e4743$var$pg(t, null, e, 1, n ?? null, i1, !1, s, o), e[$2a051a86cb6e4743$var$$t] = t.current, $2a051a86cb6e4743$var$Mi(e), r) for(e = 0; e < r.length; e++)n = r[e], i1 = n._getVersion, i1 = i1(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [
        n,
        i1
    ] : t.mutableSourceEagerHydrationData.push(n, i1);
    return new $2a051a86cb6e4743$var$Xo(t);
};
$2a051a86cb6e4743$var$Ye.render = function(e, t, n) {
    if (!$2a051a86cb6e4743$var$Jo(t)) throw Error($2a051a86cb6e4743$var$j(200));
    return $2a051a86cb6e4743$var$Zo(null, e, t, !1, n);
};
$2a051a86cb6e4743$var$Ye.unmountComponentAtNode = function(e) {
    if (!$2a051a86cb6e4743$var$Jo(e)) throw Error($2a051a86cb6e4743$var$j(40));
    return e._reactRootContainer ? ($2a051a86cb6e4743$var$Xn(function() {
        $2a051a86cb6e4743$var$Zo(null, null, e, !1, function() {
            e._reactRootContainer = null, e[$2a051a86cb6e4743$var$$t] = null;
        });
    }), !0) : !1;
};
$2a051a86cb6e4743$var$Ye.unstable_batchedUpdates = $2a051a86cb6e4743$var$Bu;
$2a051a86cb6e4743$var$Ye.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
    if (!$2a051a86cb6e4743$var$Jo(n)) throw Error($2a051a86cb6e4743$var$j(200));
    if (e == null || e._reactInternals === void 0) throw Error($2a051a86cb6e4743$var$j(38));
    return $2a051a86cb6e4743$var$Zo(e, t, n, !1, r);
};
$2a051a86cb6e4743$var$Ye.version = "18.3.1-next-f1338f8080-20240426";
function $2a051a86cb6e4743$var$mg() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2a051a86cb6e4743$var$mg);
    } catch (e) {
        console.error(e);
    }
}
$2a051a86cb6e4743$var$mg(), $2a051a86cb6e4743$var$mh.exports = $2a051a86cb6e4743$var$Ye;
var $2a051a86cb6e4743$var$sS = $2a051a86cb6e4743$var$mh.exports, $2a051a86cb6e4743$var$fs, $2a051a86cb6e4743$var$Wf = $2a051a86cb6e4743$var$sS;
$2a051a86cb6e4743$var$fs = $2a051a86cb6e4743$var$Wf.createRoot, $2a051a86cb6e4743$var$Wf.hydrateRoot;
window.aemOecdSearchAppConfiguration = window.aemOecdSearchAppConfiguration || {};
const $2a051a86cb6e4743$var$Yf = document.getElementById("oecd-searchbox");
$2a051a86cb6e4743$var$Yf && $2a051a86cb6e4743$var$fs($2a051a86cb6e4743$var$Yf).render($2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$I.StrictMode, {
    children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$e0, {})
}));
const $2a051a86cb6e4743$var$qf = document.getElementById("oecd-search-facet-rail");
$2a051a86cb6e4743$var$qf && $2a051a86cb6e4743$var$fs($2a051a86cb6e4743$var$qf).render($2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$I.StrictMode, {
    children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Tv, {})
}));
const $2a051a86cb6e4743$var$Gf = document.getElementById("oecd-faceted-search-results");
$2a051a86cb6e4743$var$Gf && $2a051a86cb6e4743$var$fs($2a051a86cb6e4743$var$Gf).render($2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$I.StrictMode, {
    children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Kv, {})
}));
const $2a051a86cb6e4743$var$Xf = document.getElementById("oecd-global-search-results");
$2a051a86cb6e4743$var$Xf && $2a051a86cb6e4743$var$fs($2a051a86cb6e4743$var$Xf).render($2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$I.StrictMode, {
    children: $2a051a86cb6e4743$var$S.jsx($2a051a86cb6e4743$var$Wv, {})
}));

});

})();
//# sourceMappingURL=dist.cc9f7cc3.js.map
